/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',
    'BlurAdmin.pages.services',
    'BlurAdmin.pages.config',
    'BlurAdmin.pages.main',
    'BlurAdmin.pages.dashboard',
    // 'BlurAdmin.pages.ui',
    //'BlurAdmin.pages.components',
    'BlurAdmin.pages.form',
    // 'BlurAdmin.pages.tables',
    // 'BlurAdmin.pages.charts',
    // 'BlurAdmin.pages.maps',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.authSignIn',
    'BlurAdmin.pages.authSignUp',
    'BlurAdmin.pages.system',
    'BlurAdmin.pages.account',
    'BlurAdmin.pages.usersetup',
    // 'BlurAdmin.pages.reports',
    'BlurAdmin.pages.msync',
    'BlurAdmin.pages.csync',
    'BlurAdmin.pages.invoices',
    'BlurAdmin.pages.partners',
    'BlurAdmin.pages.partneraccount',
    'BlurAdmin.pages.operational',
    'BlurAdmin.pages.online',
    'BlurAdmin.pages.machine',
    'BlurAdmin.pages.external',
    'BlurAdmin.pages.totalsales',
    'BlurAdmin.pages.collectors',
    'BlurAdmin.pages.shopstaff',
    'BlurAdmin.pages.supplier'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/authSignIn');

    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Pages',
    //   icon: 'ion-document',
    //   subMenu: [{
    //     title: 'Sign In',
    //     fixedHref: 'auth.html',
    //     blank: true
    //   }, {
    //     title: 'Sign Up',
    //     fixedHref: 'reg.html',
    //     blank: true
    //   }, {
    //     title: 'User Profile',
    //     stateRef: 'profile'
    //   }, {
    //     title: '404 Page',
    //     fixedHref: '404.html',
    //     blank: true
    //   }]
    // });
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Menu Level 1',
    //   icon: 'ion-ios-more',
    //   subMenu: [{
    //     title: 'Menu Level 1.1',
    //     disabled: true
    //   }, {
    //     title: 'Menu Level 1.2',
    //     subMenu: [{
    //       title: 'Menu Level 1.2.1',
    //       disabled: true
    //     }]
    //   }]
    // });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      // 'chart.js',
      'angular-chartist',
      // 'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account', [ 
    'ui.select',
    'BlurAdmin.pages.account.partner',
    'BlurAdmin.pages.account.collector',
    'BlurAdmin.pages.account.supplier',
	'BlurAdmin.pages.account.usermapping'

  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.account', {
          url: '/account',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Account Setup',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 102,
          },
          authRoles:[1,5],
          authenticate: true
        }).state('main.account.collector', {
          url: '/collector',
          templateUrl: 'app/pages/account/collector/collector.html',
          title: 'Collectors',
          controller: 'CollectorPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        }).state('main.account.partner', {
          url: '/partner',
          templateUrl: 'app/pages/account/partner/partner.html',
          title: 'Partners',
          controller: 'PartnerPageCtrl',
          sidebarMeta: {
            order: 3,
          },
          authenticate: true
        }).state('main.account.supplier', {
          url: '/supplier',
          templateUrl: 'app/pages/account/supplier/supplier.html',
          title: 'Suppliers',
          controller: 'SupplierPageCtrl',
          sidebarMeta: {
            order: 4,
          },
          authenticate: true
        });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignIn', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignIn', {
        url: '/authSignIn',
        templateUrl: 'app/pages/authSignIn/authSignIn.html',
        title: 'My Page',
        controller: 'authSignInCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignUp', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignUp', {
        url: '/authSignUp',
        templateUrl: 'app/pages/authSignUp/authSignUp.html',
        title: 'My Page',
        controller: 'authSignUpCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts', {
        url: '/charts',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        title: 'Charts',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 150,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors', [
      'BlurAdmin.pages.collectors.dailyinvoices',
      'BlurAdmin.pages.collectors.dailymachinesales'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.collectors', {
        url: '/collectors',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Collections',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 106,
        },
        authRoles: [7, 17],
        authenticate: true
      }).state('main.collectors.dailyinvoices', {
        url: '/collectors/dailyinvoices',
        templateUrl: 'app/pages/collectors/dailyinvoices/dailyinvoices.html',
        title: 'Daily Invoices',
        controller: 'dailyinvoicesCollectorPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.collectors.dailymachinesales', {
        url: '/collectors/dailymachinesales',
        templateUrl: 'app/pages/collectors/dailymachinesales/dailymachinesales.html',
        title: 'Daily Machine',
        controller: 'DailymachinesalesCollectorPageCtrl',
        sidebarMeta: {
          order: 1,
        },
        authenticate: true
      });
  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
      'BlurAdmin.pages.components.mail',
      'BlurAdmin.pages.components.timeline',
      'BlurAdmin.pages.components.tree',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components', {
        url: '/components',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Components',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 100,
        },
        authenticate: true
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync', [
  	'BlurAdmin.pages.csync.assigncollector'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.csync', {
          url: '/csync',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'cSync',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 201,
          },
          authRoles:[1,5,7],
          authenticate: true
        }).state('main.csync.assigncollector', {
          url: '/assigncollector',
          templateUrl: 'app/pages/csync/assigncollector/assigncollector.html',
          title: 'Assign Collector',
          controller: 'AssigncollectorPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'Dashboard',
        controller: 'DashboardPageCtrl',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        authRoles:[1,3,5],
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.external', [
    'BlurAdmin.pages.external.partnersales',
    // 'BlurAdmin.pages.external.suppliersales'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.external', {
          url: '/external',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'External',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 107,
          },
          authRoles:[1,5,6],
          authenticate: true
        }).state('main.external.partnersales', {
          url: '/partnersales',
          templateUrl: 'app/pages/external/partnersales/partnersales.html',
          title: 'Sales By Partner',
          controller: 'PartnersalesreportPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        // }).state('main.external.suppliersales', {
        //   url: '/suppliersales',
        //   templateUrl: 'app/pages/external/suppliersales/suppliersales.html',
        //   title: 'Sales By Supplier',
        //   controller: 'SuppliersalesreportPageCtrl',
        //   sidebarMeta: {
        //     order: 2,
        //   },
        //   authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select',
      'ngSanitize',
      'BlurAdmin.pages.form.onlinesales',
      'BlurAdmin.pages.form.machinesales'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.form', {
        url: '/form',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Input Sales',
        sidebarMeta: {
          icon: 'ion-compose',
          order: 103,
        },
        authRoles:[1,5,6],
        authenticate: true
      })
      // .state('main.form.inputs', {
      //   url: '/inputs',
      //   templateUrl: 'app/pages/form/inputs/inputs.html',
      //   title: 'Form Inputs',
      //   sidebarMeta: {
      //     order: 0,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.layouts', {
      //   url: '/layouts',
      //   templateUrl: 'app/pages/form/layouts/layouts.html',
      //   title: 'Form Layouts',
      //   sidebarMeta: {
      //     order: 100,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.wizard', {
      //   url: '/wizard',
      //   templateUrl: 'app/pages/form/wizard/wizard.html',
      //   controller: 'WizardCtrl',
      //   controllerAs: 'vm',
      //   title: 'Form Wizard',
      //   sidebarMeta: {
      //     order: 200,
      //   },
      //   authenticate: true
      // })
      .state('main.form.onlinesales', {
        url: '/onlinesales',
        templateUrl: 'app/pages/form/onlinesales/onlinesales.html',
        title: 'Online Sales',
        controller: 'OnlinesalesPageCtrl',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      }).state('main.form.machinesales', {
        url: '/machinesales',
        templateUrl: 'app/pages/form/machinesales/machinesales.html',
        title: 'Machine Sales',
        controller: 'MachinesalesPageCtrl',
        sidebarMeta: {
          order: 400,
        },
        authenticate: true
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.invoices', [
    //'BlurAdmin.pages.invoices.allinvoices',
    'BlurAdmin.pages.invoices.dailyinvoices',
    'BlurAdmin.pages.invoices.allinvoices'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.invoices', {
          url: '/invoices',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Invoices',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 106,
          },
          authRoles:[1,5,6],
          authenticate: true
        }).state('main.invoices.dailyinvoices', {
          url: '/dailyinvoices',
          templateUrl: 'app/pages/invoices/dailyinvoices/dailyinvoices.html',
          title: 'Daily Invoices',
          controller: 'DailyinvoicesPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.invoices.allinvoices', {
          url: '/allinvoices',
          templateUrl: 'app/pages/invoices/allinvoices/allinvoices.html',
          title: 'All Invoices',
          controller: 'AllinvoicesPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine', [
  'BlurAdmin.pages.machine.dailymachinesales',
	'BlurAdmin.pages.machine.dailymachineshop',  
	'BlurAdmin.pages.machine.machinesales'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.machine', {
          url: '/machine',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Machine',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 105,
          },
          authRoles:[1,5,6],
          authenticate: true
        }).state('main.machine.dailymachinesales', {
          url: '/dailymachinesales',
          templateUrl: 'app/pages/machine/dailymachinesales/dailymachinesales.html',
          title: 'Daily Machine',
          controller: 'DailymachinesalesreportPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.machine.dailymachineshop', {
          url: '/dailymachineshop',
          templateUrl: 'app/pages/machine/dailymachineshop/dailymachineshop.html',
          title: 'Machine By Shop',
          controller: 'DailymachineshopPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.machine.machinesales', {
          url: '/machinesales',
          templateUrl: 'app/pages/machine/machinesales/machinesales.html',
          title: 'All Machine',
          controller: 'MachinesalesreportPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        });
  }

})();

/**
 * @author dufrolabs
 * created on 29.07.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.main', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/pages/main/main.html',
        redirectTo: 'main.dashboard',
        authenticate: true


      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.maps', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.maps', {
        url: '/maps',
        templateUrl: 'app/pages/maps/maps.html',
        abstract: true,
        title: 'Maps',
        sidebarMeta: {
          icon: 'ion-ios-location-outline',
          order: 500,
        },
        authenticate: true
      })
      .state('main.maps.gmap', {
        url: '/gmap',
        templateUrl: 'app/pages/maps/google-maps/google-maps.html',
        controller: 'GmapPageCtrl',
        title: 'Google Maps',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      })
      .state('main.maps.leaflet', {
        url: '/leaflet',
        templateUrl: 'app/pages/maps/leaflet/leaflet.html',
        controller: 'LeafletPageCtrl',
        title: 'Leaflet Maps',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      })
      .state('main.maps.bubble', {
        url: '/bubble',
        templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
        controller: 'MapBubblePageCtrl',
        title: 'Bubble Maps',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      })
      .state('main.maps.line', {
        url: '/line',
        templateUrl: 'app/pages/maps/map-lines/map-lines.html',
        controller: 'MapLinesPageCtrl',
        title: 'Line Maps',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync', [
    'BlurAdmin.pages.msync.importofficers',
    'BlurAdmin.pages.msync.officers',
  	'BlurAdmin.pages.msync.paylist'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.msync', {
          url: '/msync',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'mSync',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 201,
          },
          authRoles:[1,12],
          authenticate: true
        }).state('main.msync.importofficers', {
          url: '/importofficers',
          templateUrl: 'app/pages/msync/importofficers/importofficers.html',
          title: 'Import Officers',
          controller: 'ImportofficersPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.msync.officers', {
          url: '/officers',
          templateUrl: 'app/pages/msync/officers/officers.html',
          title: 'Manage Officers',
          controller: 'OfficersPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.msync.paylist', {
          url: '/paylist',
          templateUrl: 'app/pages/msync/paylist/paylist.html',
          title: 'Manage Paylist',
          controller: 'PaylistPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online', [
  'BlurAdmin.pages.online.dailyonlinesales',
	'BlurAdmin.pages.online.dailyonlineshop',
	'BlurAdmin.pages.online.onlinesales',
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.online', {
          url: '/online',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Online',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 104,
          },
          authRoles:[1,5,6],
          authenticate: true
        }).state('main.online.dailyonlinesales', {
          url: '/dailyonlinesales',
          templateUrl: 'app/pages/online/dailyonlinesales/dailyonlinesales.html',
          title: 'Daily Online',
          controller: 'DailyonlinesalesreportPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.online.dailyonlineshop', {
          url: '/dailyonlineshop',
          templateUrl: 'app/pages/online/dailyonlineshop/dailyonlineshop.html',
          title: 'Online By Shop',
          controller: 'DailyonlineshopreportPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.online.onlinesales', {
          url: '/onlinesales',
          templateUrl: 'app/pages/online/onlinesales/onlinesales.html',
          title: 'All Online',
          controller: 'OnlinesalesreportPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational', [
	'BlurAdmin.pages.operational.machine',
	'BlurAdmin.pages.operational.shop',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.operational', {
          url: '/operational',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Operation Setup',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 101,
          },
          authRoles:[1,5,6,14],
          authenticate: true
        }).state('main.operational.machine', {
          url: '/machine',
          templateUrl: 'app/pages/operational/machine/machine.html',
          title: 'Machine',
          controller: 'MachinePageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.operational.shop', {
          url: '/shop',
          templateUrl: 'app/pages/operational/shop/shop.html',
          title: 'Shop',
          controller: 'ShopPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.partneraccount', [ 
    'BlurAdmin.pages.partneraccount.partnerusers',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.partneraccount', {
          url: '/partneraccount',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Partner Accounts',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 101,
          },
          authRoles:[9],
          authenticate: true
        }).state('main.partneraccount.users', {
          url: '/users',
          templateUrl: 'app/pages/partneraccount/partnerusers/partnerusers.html',
          title: 'Partner Users',
          controller: 'PartnerUsersPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.partners', [
      'BlurAdmin.pages.partners.partnerinvoice',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.partners', {
        url: '/partners',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Partners',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 103,
        },
        authRoles: [9, 13, 17],
        authenticate: true
      }).state('main.partners.partnerinvoice', {
        url: '/partnerinvoice',
        templateUrl: 'app/pages/partners/partnerinvoice/partnerinvoice.html',
        title: 'Invoice Report',
        controller: 'PartnerInvoicereportPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageCtrl',
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports', [
	// 'BlurAdmin.pages.reports.dailymachineshop',  
	// 'BlurAdmin.pages.reports.dailyonlineshop',
	// 'BlurAdmin.pages.reports.machinesales',
	// 'BlurAdmin.pages.reports.onlinesales',
	// 'BlurAdmin.pages.reports.dailymachinesales',
	// 'BlurAdmin.pages.reports.dailyonlinesales',
	// 'BlurAdmin.pages.reports.suppliersales',
	// 'BlurAdmin.pages.reports.partnersales',
	// 'BlurAdmin.pages.reports.collector',
	// 'BlurAdmin.pages.reports.marketing'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.reports', {
          url: '/reports',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Reports',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 103,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.reports.dailyonlineshop', {
          url: '/dailyonlineshop',
          templateUrl: 'app/pages/reports/dailyonlineshop/dailyonlineshop.html',
          title: 'Online Sales By Shop',
          controller: 'DailyonlineshopreportPageCtrl',
          sidebarMeta: {
            order: 3,
          },
          authenticate: true
        }).state('main.reports.dailymachineshop', {
          url: '/dailymachineshop',
          templateUrl: 'app/pages/reports/dailymachineshop/dailymachineshop.html',
          title: 'Mac Sales By Shop',
          controller: 'DailymachineshopPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        }).state('main.reports.machinesales', {
          url: '/machinesales',
          templateUrl: 'app/pages/reports/machinesales/machinesales.html',
          title: 'All Machine Sales',
          controller: 'MachinesalesreportPageCtrl',
          sidebarMeta: {
            order: 5,
          },
          authenticate: true
        }).state('main.reports.onlinesales', {
          url: '/onlinesales',
          templateUrl: 'app/pages/reports/onlinesales/onlinesales.html',
          title: 'All Online Sales',
          controller: 'OnlinesalesreportPageCtrl',
          sidebarMeta: {
            order: 4,
          },
          authenticate: true
        }).state('main.reports.dailymachinesales', {
          url: '/dailymachinesales',
          templateUrl: 'app/pages/reports/dailymachinesales/dailymachinesales.html',
          title: 'Daily Machine Sales',
          controller: 'DailymachinesalesreportPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.reports.dailyonlinesales', {
          url: '/dailyonlinesales',
          templateUrl: 'app/pages/reports/dailyonlinesales/dailyonlinesales.html',
          title: 'Daily Online Sales',
          controller: 'DailyonlinesalesreportPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.reports.suppliersales', {
          url: '/suppliersales',
          templateUrl: 'app/pages/reports/suppliersales/suppliersales.html',
          title: 'Sales By Supplier',
          controller: 'SuppliersalesreportPageCtrl',
          sidebarMeta: {
            order: 7,
          },
          authenticate: true
        }).state('main.reports.partnersales', {
          url: '/partnersales',
          templateUrl: 'app/pages/reports/partnersales/partnersales.html',
          title: 'Sales By Partner',
          controller: 'PartnersalesreportPageCtrl',
          sidebarMeta: {
            order: 6,
          },
          authenticate: true
        }).state('main.reports.collector', {
          url: '/collector',
          templateUrl: 'app/pages/reports/collector/collector.html',
          title: 'TS By Collector',
          controller: 'CollectorreportPageCtrl',
          sidebarMeta: {
            order: 8,
          },
          authenticate: true
        }).state('main.reports.marketing', {
          url: '/marketing',
          templateUrl: 'app/pages/reports/marketing/marketing.html',
          title: 'TS By Marketing',
          controller: 'MarketingreportPageCtrl',
          sidebarMeta: {
            order: 9,
          },
          authenticate: true
        });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff', [
    'BlurAdmin.pages.shopstaff.dailymachinesales'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.shopstaff', {
          url: '/shopstaff',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Machines',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 106,
          },
          authRoles:[15],
          authenticate: true
        }).state('main.shopstaff.dailymachinesales', {
          url: '/dailymachinesales',
          templateUrl: 'app/pages/shopstaff/dailymachinesales/dailymachinesales.html',
          title: 'Daily Machine',
          controller: 'DailymachinesalesShopStaffPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier', [
	'BlurAdmin.pages.supplier.machinesales'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.supplier', {
          url: '/supplier',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Supplier',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 105,
          },
          authRoles:[1,5,6,10],
          authenticate: true
        }).state('main.supplier.machinesales', {
          url: '/machinesales',
          templateUrl: 'app/pages/supplier/machinesales/machinesales.html',
          title: 'All Machine',
          controller: 'MachinesalesSupplierPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system', [
    'BlurAdmin.pages.system.states',
    'BlurAdmin.pages.system.areas',
    'BlurAdmin.pages.system.gamecategory',
	'BlurAdmin.pages.system.games',
	'BlurAdmin.pages.system.zones',
	'BlurAdmin.pages.system.site'

  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.system', {
          url: '/system',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'System Setup',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.system.states', {
          url: '/states',
          templateUrl: 'app/pages/system/states/states.html',
          title: 'States',
          controller: 'StatesPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.system.zones', {
          url: '/zones',
          templateUrl: 'app/pages/system/zones/zones.html',
          title: 'Zones',
          controller: 'ZonesPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.system.areas', {
          url: '/areas',
          templateUrl: 'app/pages/system/areas/areas.html',
          title: 'Areas',
          controller: 'AreasPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        }).state('main.system.site', {
          url: '/site',
          templateUrl: 'app/pages/system/site/site.html',
          title: 'Balai',
          controller: 'SitePageCtrl',
          sidebarMeta: {
            order: 3,
          },
          authenticate: true
        }).state('main.system.gamecategory', {
          url: '/gamecategory',
          templateUrl: 'app/pages/system/gamecategory/gamecategory.html',
          title: 'Game Category',
          controller: 'GamecategoryPageCtrl',
          sidebarMeta: {
            order: 4,
          },
          authenticate: true
        }).state('main.system.games', {
          url: '/games',
          templateUrl: 'app/pages/system/games/games.html',
          title: 'Games',
          controller: 'GamesPageCtrl',
          sidebarMeta: {
            order: 5,
          },
          authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.tables', {
        url: '/tables',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'TablesPageCtrl',
        title: 'Tables',
        sidebarMeta: {
          icon: 'ion-grid',
          order: 300,
        },
        authenticate: true
      }).state('main.tables.basic', {
        url: '/basic',
        templateUrl: 'app/pages/tables/basic/tables.html',
        title: 'Basic Tables',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.tables.smart', {
        url: '/smart',
        templateUrl: 'app/pages/tables/smart/tables.html',
        title: 'Smart Tables',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
    $urlRouterProvider.when('/main/tables', '/main/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales', [
	'BlurAdmin.pages.totalsales.collector',
	'BlurAdmin.pages.totalsales.marketing'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.totalsales', {
          url: '/totalsales',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Total Sales',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 108,
          },
          authRoles:[1,3,5,6,14],
          authenticate: true
        }).state('main.totalsales.collector', {
          url: '/collector',
          templateUrl: 'app/pages/totalsales/collector/collector.html',
          title: 'Collector',
          controller: 'CollectorreportPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.totalsales.marketing', {
          url: '/marketing',
          templateUrl: 'app/pages/totalsales/marketing/marketing.html',
          title: 'Marketing',
          controller: 'MarketingreportPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
      'BlurAdmin.pages.ui.typography',
      'BlurAdmin.pages.ui.buttons',
      'BlurAdmin.pages.ui.icons',
      'BlurAdmin.pages.ui.modals',
      'BlurAdmin.pages.ui.grid',
      'BlurAdmin.pages.ui.alerts',
      'BlurAdmin.pages.ui.progressBars',
      'BlurAdmin.pages.ui.notifications',
      'BlurAdmin.pages.ui.tabs',
      'BlurAdmin.pages.ui.slider',
      'BlurAdmin.pages.ui.panels',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui', {
        url: '/ui',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'UI Features',
        sidebarMeta: {
          icon: 'ion-android-laptop',
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup', [
      'ui.select',
      'BlurAdmin.pages.usersetup.roles',
      'BlurAdmin.pages.usersetup.users',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.usersetup', {
        url: '/usersetup',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'User Setup',
        sidebarMeta: {
          icon: 'ion-person',
          order: 102,
        },
        authRoles: [1],
        authenticate: true
      })
      .state('main.usersetup.roles', {
        url: '/roles',
        templateUrl: 'app/pages/usersetup/roles/roles.html',
        title: 'Roles',
        controller: 'RolesPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.usersetup.users', {
        url: '/users',
        templateUrl: 'app/pages/usersetup/users/users.html',
        title: 'Users',
        controller: 'UsersPageCtrl',
        sidebarMeta: {
          order: 1,
        },
        authenticate: true
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
    .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.amCharts', {
        url: '/amCharts',
        templateUrl: 'app/pages/charts/amCharts/charts.html',
        title: 'amCharts',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs', [])
    .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartJs', {
        url: '/chartJs',
        templateUrl: 'app/pages/charts/chartJs/chartJs.html',
        title: 'Chart.js',
        sidebarMeta: {
          order: 200
        },
        authenticate: true
      });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      chartColors: [
        layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight
      ],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 2500
      },
      scale: {
        gridLines: {
          color: layoutColors.border
        },
        scaleLabel: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          fontColor: layoutColors.defaultText,
          showLabelBackdrop: false
        }
      }
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
    // Configure all radar charts
    ChartJsProvider.setOptions('radar', {
      scale: {
        pointLabels: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          maxTicksLimit: 5,
          display: false
        }
      }
    });
    // Configure all bar charts
    ChartJsProvider.setOptions('bar', {
      tooltips: {
        enabled: false
      }
    });
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartist', {
        url: '/chartist',
        templateUrl: 'app/pages/charts/chartist/chartist.html',
        title: 'Chartist',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider) {
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.morris', {
        url: '/morris',
        templateUrl: 'app/pages/charts/morris/morris.html',
        title: 'Morris',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailyinvoices', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.components.mail', {
        url: '/mail',
        abstract: true,
        templateUrl: 'app/pages/components/mail/mail.html',
        controller: "MailTabCtrl",
        controllerAs: "tabCtrl",
        title: 'Mail',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.components.mail.label', {
        url: '/:label',
        templateUrl: 'app/pages/components/mail/list/mailList.html',
        title: 'Mail',
        controller: "MailListCtrl",
        controllerAs: "listCtrl",
        authenticate: true
      }).state('main.components.mail.detail', {
        url: '/:label/:id',
        templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
        title: 'Mail',
        controller: "MailDetailCtrl",
        controllerAs: "detailCtrl",
        authenticate: true
      });
    $urlRouterProvider.when('/main/components/mail', '/main/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
        title: 'Timeline',
        sidebarMeta: {
          icon: 'ion-ios-pulse',
          order: 100,
        },
        authenticate: true
      });
  }
})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function() {
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.tree', {
        url: '/tree',
        templateUrl: 'app/pages/components/tree/tree.html',
        title: 'Tree View',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync.assigncollector', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.external.partnersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.external.suppliersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.machinesales', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.allinvoices', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.dailyinvoices', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.machinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.officers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.paylist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.machine', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.shop', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () { 
  'use strict';

  angular.module('BlurAdmin.pages.partneraccount.partnerusers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/partneraccount/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.partners.partnerinvoice', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.collector', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.machinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.marketing', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.partnersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.suppliersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier.machinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.system.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.system.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.site', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.collector', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.marketing', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.alerts', {
        url: '/alerts',
        templateUrl: 'app/pages/ui/alerts/alerts.html',
        title: 'Alerts',
        sidebarMeta: {
          order: 500,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.buttons', {
        url: '/buttons',
        templateUrl: 'app/pages/ui/buttons/buttons.html',
        controller: 'ButtonPageCtrl',
        title: 'Buttons',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.grid', {
        url: '/grid',
        templateUrl: 'app/pages/ui/grid/grid.html',
        title: 'Grid',
        sidebarMeta: {
          order: 400,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.icons', {
        url: '/icons',
        templateUrl: 'app/pages/ui/icons/icons.html',
        controller: 'IconsPageCtrl',
        title: 'Icons',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.modals', {
        url: '/modals',
        templateUrl: 'app/pages/ui/modals/modals.html',
        controller: 'ModalsPageCtrl',
        title: 'Modals',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/ui/notifications/notifications.html',
        controller: 'NotificationsPageCtrl',
        title: 'Notifications',
        sidebarMeta: {
          order: 700,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.panels', {
        url: '/panels',
        templateUrl: 'app/pages/ui/panels/panels.html',
        controller: 'NotificationsPageCtrl',
        title: 'Panels',
        sidebarMeta: {
          order: 1100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.progressBars', {
        url: '/progressBars',
        templateUrl: 'app/pages/ui/progressBars/progressBars.html',
        title: 'Progress Bars',
        sidebarMeta: {
          order: 600,
        },
        authenticate: true
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.slider', {
        url: '/slider',
        templateUrl: 'app/pages/ui/slider/slider.html',
        title: 'Sliders',
        sidebarMeta: {
          order: 1000,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.tabs', {
        url: '/tabs',
        templateUrl: 'app/pages/ui/tabs/tabs.html',
        title: 'Tabs & Accordions',
        sidebarMeta: {
          order: 800,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.typography', {
        url: '/typography',
        templateUrl: 'app/pages/ui/typography/typography.html',
        title: 'Typography',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.roles', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () { 
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.users', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

'use strict';

angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'ngResource',
    'lbServices',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.exporter',
    'angular.filter',
    'AngularPrint',
    'ja.qr',
    'chart.js'
  ])
  .run(function ($locale) {
    var currencyPatterns = $locale.NUMBER_FORMATS.PATTERNS[1];
    currencyPatterns.negPre = '(\u00a4';
    currencyPatterns.negSuf = ')';
  })
  .config(function (LoopBackResourceProvider) {

    // Use a custom auth header instead of the default 'Authorization'
    LoopBackResourceProvider.setAuthHeader('X-Access-Token');

    // Change the URL where to access the LoopBack REST API server
    LoopBackResourceProvider.setUrlBase('https://api.thor.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.vipportal.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.thor.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.ironman.tswlab.com/api');
  })
  .run(function ($rootScope) {
    $rootScope.getTotal = function (items, key) {
      if (!items) return 0;

      if (!Array.isArray(items)) return 0;

      if (!!key) {
        return items
          .map(function (i) {
            return isNaN(i[key]) ? 0 : parseFloat(i[key]);
          })
          .reduce(function (a, c) {
            return a + c;
          }, 0);
      } else {
        return items.reduce(function (a, c) {
          return a + c;
        }, 0);
      }

    }
  });
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Role
 * @header lbServices.Role
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Roles/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role.principals.findById() instead.
            "prototype$__findById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.destroyById() instead.
            "prototype$__destroyById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.updateById() instead.
            "prototype$__updateById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Role.principals() instead.
            "prototype$__get__principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.create() instead.
            "prototype$__create__principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.destroyAll() instead.
            "prototype$__delete__principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.count() instead.
            "prototype$__count__principals": {
              url: urlBase + "/Roles/:id/principals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#create
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#createMany
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#upsert
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Roles",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#replaceOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Roles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#upsertWithWhere
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Roles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#exists
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Roles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#findById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Roles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#replaceById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Roles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#find
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#findOne
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Roles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#updateAll
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Roles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#deleteById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Roles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#count
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#prototype$updateAttributes
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Roles/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#createChangeStream
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Roles/change-stream",
              method: "POST",
            },

            // INTERNAL. Use RoleMapping.role() instead.
            "::get::RoleMapping::role": {
              url: urlBase + "/RoleMappings/:id/role",
              method: "GET",
            },

            // INTERNAL. Use User.roles.findById() instead.
            "::findById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roles.destroyById() instead.
            "::destroyById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.updateById() instead.
            "::updateById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.link() instead.
            "::link::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.unlink() instead.
            "::unlink::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.exists() instead.
            "::exists::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.roles() instead.
            "::get::User::roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use User.roles.create() instead.
            "::create::User::roles": {
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.createMany() instead.
            "::createMany::User::roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.destroyAll() instead.
            "::delete::User::roles": {
              url: urlBase + "/users/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.count() instead.
            "::count::User::roles": {
              url: urlBase + "/users/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use Rolemapping.role() instead.
            "::get::Rolemapping::role": {
              url: urlBase + "/Rolemappings/:id/role",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.findById() instead.
            "::findById::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.destroyById() instead.
            "::destroyById::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.updateById() instead.
            "::updateById::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.link() instead.
            "::link::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.unlink() instead.
            "::unlink::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.exists() instead.
            "::exists::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Usertransaction.roles() instead.
            "::get::Usertransaction::roles": {
              isArray: true,
              url: urlBase + "/Usertransactions/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.create() instead.
            "::create::Usertransaction::roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.roles.createMany() instead.
            "::createMany::Usertransaction::roles": {
              isArray: true,
              url: urlBase + "/Usertransactions/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.roles.destroyAll() instead.
            "::delete::Usertransaction::roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.count() instead.
            "::count::Usertransaction::roles": {
              url: urlBase + "/Usertransactions/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.role() instead.
            "::get::Usermapping::role": {
              url: urlBase + "/Usermappings/:id/role",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Role#patchOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Role#updateOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Role#patchOrCreateWithWhere
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Role#update
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Role#destroyById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Role#removeById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Role#patchAttributes
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Role#modelName
        * @propertyOf lbServices.Role
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role`.
        */
        R.modelName = "Role";

    /**
     * @ngdoc object
     * @name lbServices.Role.principals
     * @header lbServices.Role.principals
     * @object
     * @description
     *
     * The object `Role.principals` groups methods
     * manipulating `RoleMapping` instances related to `Role`.
     *
     * Call {@link lbServices.Role#principals Role.principals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Role#principals
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Queries principals of Role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::get::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#count
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Counts principals of Role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.principals.count = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::count::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#create
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Creates a new instance in principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.create = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::create::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#createMany
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Creates a new instance in principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.createMany = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::createMany::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#destroyAll
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Deletes all principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.principals.destroyAll = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::delete::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#destroyById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Delete a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.principals.destroyById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::destroyById::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#findById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Find a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.findById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::findById::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#updateById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Update a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.updateById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::updateById::Role::principals"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ACL
 * @header lbServices.ACL
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ACL` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ACL",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ACLs/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ACL#create
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ACLs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#createMany
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ACLs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#upsert
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/ACLs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#replaceOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ACLs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#upsertWithWhere
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ACLs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#exists
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ACLs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#findById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ACLs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#replaceById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ACLs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#find
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ACLs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#findOne
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ACLs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#updateAll
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ACLs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#deleteById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ACLs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#count
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ACLs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#prototype$updateAttributes
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ACL id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/ACLs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#createChangeStream
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ACLs/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ACL#patchOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#updateOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#patchOrCreateWithWhere
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#update
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#destroyById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#removeById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#patchAttributes
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ACL id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ACL#modelName
        * @propertyOf lbServices.ACL
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ACL`.
        */
        R.modelName = "ACL";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RoleMapping
 * @header lbServices.RoleMapping
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RoleMapping` model.
 *
 * **Details**
 *
 * Map principals to roles
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RoleMapping",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RoleMappings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RoleMapping.role() instead.
            "prototype$__get__role": {
              url: urlBase + "/RoleMappings/:id/role",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#create
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/RoleMappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#createMany
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/RoleMappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#upsert
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/RoleMappings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#replaceOrCreate
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/RoleMappings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#upsertWithWhere
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/RoleMappings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#exists
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/RoleMappings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#findById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/RoleMappings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#replaceById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/RoleMappings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#find
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RoleMappings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#findOne
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/RoleMappings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#updateAll
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/RoleMappings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#deleteById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/RoleMappings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#count
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/RoleMappings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#prototype$updateAttributes
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/RoleMappings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#createChangeStream
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/RoleMappings/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.findById() instead.
            "::findById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.destroyById() instead.
            "::destroyById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.updateById() instead.
            "::updateById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Role.principals() instead.
            "::get::Role::principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.create() instead.
            "::create::Role::principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.createMany() instead.
            "::createMany::Role::principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.destroyAll() instead.
            "::delete::Role::principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.count() instead.
            "::count::Role::principals": {
              url: urlBase + "/Roles/:id/principals/count",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.findById() instead.
            "::findById::User::rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.destroyById() instead.
            "::destroyById::User::rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.updateById() instead.
            "::updateById::User::rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rolemap() instead.
            "::get::User::rolemap": {
              isArray: true,
              url: urlBase + "/users/:id/rolemap",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.create() instead.
            "::create::User::rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "POST",
            },

            // INTERNAL. Use User.rolemap.createMany() instead.
            "::createMany::User::rolemap": {
              isArray: true,
              url: urlBase + "/users/:id/rolemap",
              method: "POST",
            },

            // INTERNAL. Use User.rolemap.destroyAll() instead.
            "::delete::User::rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.count() instead.
            "::count::User::rolemap": {
              url: urlBase + "/users/:id/rolemap/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#patchOrCreate
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#updateOrCreate
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#patchOrCreateWithWhere
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#update
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#destroyById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#removeById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#patchAttributes
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RoleMapping#modelName
        * @propertyOf lbServices.RoleMapping
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RoleMapping`.
        */
        R.modelName = "RoleMapping";


            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#role
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.role = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::RoleMapping::role"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AccessToken
 * @header lbServices.AccessToken
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AccessToken` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AccessToken",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AccessTokens/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AccessToken.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/AccessTokens/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#create
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/AccessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#createMany
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/AccessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#upsert
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/AccessTokens",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#replaceOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/AccessTokens/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#upsertWithWhere
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/AccessTokens/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#exists
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/AccessTokens/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#findById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/AccessTokens/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#replaceById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/AccessTokens/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#find
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/AccessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#findOne
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/AccessTokens/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#updateAll
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/AccessTokens/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#deleteById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/AccessTokens/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#count
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/AccessTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#prototype$updateAttributes
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/AccessTokens/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#createChangeStream
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/AccessTokens/change-stream",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.findById() instead.
            "::findById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.destroyById() instead.
            "::destroyById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.updateById() instead.
            "::updateById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "::get::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.create() instead.
            "::create::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.createMany() instead.
            "::createMany::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.destroyAll() instead.
            "::delete::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.count() instead.
            "::count::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#updateOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchOrCreateWithWhere
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#update
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#destroyById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#removeById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchAttributes
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AccessToken#modelName
        * @propertyOf lbServices.AccessToken
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AccessToken`.
        */
        R.modelName = "AccessToken";


            /**
             * @ngdoc method
             * @name lbServices.AccessToken#user
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::AccessToken::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use User.accessTokens.findById() instead.
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.destroyById() instead.
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.updateById() instead.
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.findById() instead.
            "prototype$__findById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roles.destroyById() instead.
            "prototype$__destroyById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.updateById() instead.
            "prototype$__updateById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.link() instead.
            "prototype$__link__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.unlink() instead.
            "prototype$__unlink__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.exists() instead.
            "prototype$__exists__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.useraccount.findById() instead.
            "prototype$__findById__useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.destroyById() instead.
            "prototype$__destroyById__useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.updateById() instead.
            "prototype$__updateById__useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rolemap.findById() instead.
            "prototype$__findById__rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.destroyById() instead.
            "prototype$__destroyById__rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.updateById() instead.
            "prototype$__updateById__rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.create() instead.
            "prototype$__create__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.destroyAll() instead.
            "prototype$__delete__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.count() instead.
            "prototype$__count__accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use User.roles() instead.
            "prototype$__get__roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use User.roles.create() instead.
            "prototype$__create__roles": {
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.destroyAll() instead.
            "prototype$__delete__roles": {
              url: urlBase + "/users/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.count() instead.
            "prototype$__count__roles": {
              url: urlBase + "/users/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount() instead.
            "prototype$__get__useraccount": {
              isArray: true,
              url: urlBase + "/users/:id/useraccount",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.create() instead.
            "prototype$__create__useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.destroyAll() instead.
            "prototype$__delete__useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.count() instead.
            "prototype$__count__useraccount": {
              url: urlBase + "/users/:id/useraccount/count",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap() instead.
            "prototype$__get__rolemap": {
              isArray: true,
              url: urlBase + "/users/:id/rolemap",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.create() instead.
            "prototype$__create__rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "POST",
            },

            // INTERNAL. Use User.rolemap.destroyAll() instead.
            "prototype$__delete__rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.count() instead.
            "prototype$__count__rolemap": {
              url: urlBase + "/users/:id/rolemap/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/users",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#exists
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findOne
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#updateAll
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/users/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createChangeStream
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#confirm
             * @methodOf lbServices.User
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            // INTERNAL. Use AccessToken.user() instead.
            "::get::AccessToken::user": {
              url: urlBase + "/AccessTokens/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Useraccount.fromuser() instead.
            "::get::Useraccount::fromuser": {
              url: urlBase + "/Useraccounts/:id/fromuser",
              method: "GET",
            },

            // INTERNAL. Use Employees.supervisor() instead.
            "::get::Employees::supervisor": {
              url: urlBase + "/Employees/:id/supervisor",
              method: "GET",
            },

            // INTERNAL. Use Employees.manager() instead.
            "::get::Employees::manager": {
              url: urlBase + "/Employees/:id/manager",
              method: "GET",
            },

            // INTERNAL. Use Employees.owner() instead.
            "::get::Employees::owner": {
              url: urlBase + "/Employees/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.user() instead.
            "::get::Usertransaction::user": {
              url: urlBase + "/Usertransactions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.transfer() instead.
            "::get::Usertransaction::transfer": {
              url: urlBase + "/Usertransactions/:id/transfer",
              method: "GET",
            },

            // INTERNAL. Use Supplier.user() instead.
            "::get::Supplier::user": {
              url: urlBase + "/Suppliers/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Partner.user() instead.
            "::get::Partner::user": {
              url: urlBase + "/Partners/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.user() instead.
            "::get::Usermapping::user": {
              url: urlBase + "/Usermappings/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Paylist.owner() instead.
            "::get::Paylist::owner": {
              url: urlBase + "/Paylists/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Paylist.shared() instead.
            "::get::Paylist::shared": {
              url: urlBase + "/Paylists/:id/shared",
              method: "GET",
            },

            // INTERNAL. Use Shop.user() instead.
            "::get::Shop::user": {
              url: urlBase + "/Shops/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.agent() instead.
            "::get::Machinesales::agent": {
              url: urlBase + "/Machinesales/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Invoice.agent() instead.
            "::get::Invoice::agent": {
              url: urlBase + "/Invoices/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Invoice.head() instead.
            "::get::Invoice::head": {
              url: urlBase + "/Invoices/:id/head",
              method: "GET",
            },

            // INTERNAL. Use Collector.user() instead.
            "::get::Collector::user": {
              url: urlBase + "/Collectors/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.head() instead.
            "::get::Collectormap::head": {
              url: urlBase + "/Collectormaps/:id/head",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.staff() instead.
            "::get::Collectormap::staff": {
              url: urlBase + "/Collectormaps/:id/staff",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.vip() instead.
            "::get::Collectormap::vip": {
              url: urlBase + "/Collectormaps/:id/vip",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#update
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.User#destroyById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#removeById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";

    /**
     * @ngdoc object
     * @name lbServices.User.accessTokens
     * @header lbServices.User.accessTokens
     * @object
     * @description
     *
     * The object `User.accessTokens` groups methods
     * manipulating `AccessToken` instances related to `User`.
     *
     * Call {@link lbServices.User#accessTokens User.accessTokens()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::get::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#count
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Counts accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.accessTokens.count = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::count::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#create
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.create = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::create::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#createMany
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.createMany = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::createMany::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#destroyAll
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accessTokens.destroyAll = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::delete::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#destroyById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accessTokens.destroyById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::destroyById::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#findById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.findById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::findById::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#updateById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.updateById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::updateById::User::accessTokens"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.roles
     * @header lbServices.User.roles
     * @object
     * @description
     *
     * The object `User.roles` groups methods
     * manipulating `Role` instances related to `User`.
     *
     * Call {@link lbServices.User#roles User.roles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#roles
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries roles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#count
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Counts roles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roles.count = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::count::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#create
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.create = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::create::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#createMany
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.createMany = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::createMany::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#destroyAll
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Deletes all roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyAll = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::delete::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#destroyById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Delete a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::destroyById::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#exists
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Check the existence of roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.exists = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::exists::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#findById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Find a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.findById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::findById::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#link
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Add a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.link = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::link::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#unlink
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Remove the roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.unlink = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::unlink::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#updateById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Update a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.updateById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::updateById::User::roles"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.useraccount
     * @header lbServices.User.useraccount
     * @object
     * @description
     *
     * The object `User.useraccount` groups methods
     * manipulating `Useraccount` instances related to `User`.
     *
     * Call {@link lbServices.User#useraccount User.useraccount()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#useraccount
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries useraccount of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::get::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#count
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Counts useraccount of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.useraccount.count = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::count::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#create
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Creates a new instance in useraccount of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.create = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::create::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#createMany
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Creates a new instance in useraccount of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.createMany = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::createMany::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#destroyAll
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Deletes all useraccount of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.useraccount.destroyAll = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::delete::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#destroyById
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Delete a related item by id for useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for useraccount
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.useraccount.destroyById = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::destroyById::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#findById
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Find a related item by id for useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for useraccount
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.findById = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::findById::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#updateById
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Update a related item by id for useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for useraccount
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.updateById = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::updateById::User::useraccount"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.rolemap
     * @header lbServices.User.rolemap
     * @object
     * @description
     *
     * The object `User.rolemap` groups methods
     * manipulating `Rolemapping` instances related to `User`.
     *
     * Call {@link lbServices.User#rolemap User.rolemap()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#rolemap
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries rolemap of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R.rolemap = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::get::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#count
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Counts rolemap of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.rolemap.count = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::count::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#create
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Creates a new instance in rolemap of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R.rolemap.create = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::create::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#createMany
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Creates a new instance in rolemap of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R.rolemap.createMany = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::createMany::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#destroyAll
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Deletes all rolemap of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.rolemap.destroyAll = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::delete::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#destroyById
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Delete a related item by id for rolemap.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rolemap
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.rolemap.destroyById = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::destroyById::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#findById
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Find a related item by id for rolemap.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rolemap
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R.rolemap.findById = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::findById::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#updateById
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Update a related item by id for rolemap.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rolemap
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R.rolemap.updateById = function() {
          var TargetResource = $injector.get("Rolemapping");
          var action = TargetResource["::updateById::User::rolemap"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Useraccount
 * @header lbServices.Useraccount
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Useraccount` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Useraccount",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Useraccounts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Useraccount.fromuser() instead.
            "prototype$__get__fromuser": {
              url: urlBase + "/Useraccounts/:id/fromuser",
              method: "GET",
            },

            // INTERNAL. Use Useraccount.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/Useraccounts/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#create
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Useraccounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#createMany
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Useraccounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#upsert
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Useraccounts",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#replaceOrCreate
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Useraccounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#upsertWithWhere
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Useraccounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#exists
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Useraccounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#findById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Useraccounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#replaceById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Useraccounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#find
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Useraccounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#findOne
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Useraccounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#updateAll
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Useraccounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#deleteById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Useraccounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#count
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Useraccounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#prototype$updateAttributes
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Useraccounts/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#createChangeStream
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Useraccounts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#tokenByRole
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roleId` – `{integer=}` -
             *
             *  - `realm` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "tokenByRole": {
              url: urlBase + "/Useraccounts/tokenByRole",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#getCategoryWiseReport
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userid` – `{string=}` -
             *
             *  - `month` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getCategoryWiseReport": {
              url: urlBase + "/Useraccounts/getCategoryWiseReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#getIncomeExpenseReport
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userid` – `{string=}` -
             *
             *  - `month` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getIncomeExpenseReport": {
              url: urlBase + "/Useraccounts/getIncomeExpenseReport",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.findById() instead.
            "::findById::User::useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.destroyById() instead.
            "::destroyById::User::useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.updateById() instead.
            "::updateById::User::useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.useraccount() instead.
            "::get::User::useraccount": {
              isArray: true,
              url: urlBase + "/users/:id/useraccount",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.create() instead.
            "::create::User::useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.createMany() instead.
            "::createMany::User::useraccount": {
              isArray: true,
              url: urlBase + "/users/:id/useraccount",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.destroyAll() instead.
            "::delete::User::useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.count() instead.
            "::count::User::useraccount": {
              url: urlBase + "/users/:id/useraccount/count",
              method: "GET",
            },

            // INTERNAL. Use Paylist.useraccount() instead.
            "::get::Paylist::useraccount": {
              url: urlBase + "/Paylists/:id/useraccount",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Useraccount#patchOrCreate
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#updateOrCreate
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#patchOrCreateWithWhere
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#update
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#destroyById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#removeById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#patchAttributes
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Useraccount#modelName
        * @propertyOf lbServices.Useraccount
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Useraccount`.
        */
        R.modelName = "Useraccount";


            /**
             * @ngdoc method
             * @name lbServices.Useraccount#fromuser
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Fetches belongsTo relation fromuser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.fromuser = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Useraccount::fromuser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#account
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Accounts");
          var action = TargetResource["::get::Useraccount::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Accounts
 * @header lbServices.Accounts
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Accounts` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Accounts",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Accounts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Accounts#create
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Accounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#createMany
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#upsert
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Accounts",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#replaceOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Accounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#upsertWithWhere
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Accounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#exists
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Accounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#findById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Accounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#replaceById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Accounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#find
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#findOne
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Accounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#updateAll
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Accounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#deleteById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Accounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#count
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Accounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#prototype$updateAttributes
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accounts id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Accounts/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#createChangeStream
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Accounts/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Useraccount.account() instead.
            "::get::Useraccount::account": {
              url: urlBase + "/Useraccounts/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.account() instead.
            "::get::Usertransaction::account": {
              url: urlBase + "/Usertransactions/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Paylist.account() instead.
            "::get::Paylist::account": {
              url: urlBase + "/Paylists/:id/account",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#updateOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchOrCreateWithWhere
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#update
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#destroyById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#removeById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchAttributes
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accounts id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Accounts#modelName
        * @propertyOf lbServices.Accounts
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Accounts`.
        */
        R.modelName = "Accounts";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.State
 * @header lbServices.State
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `State` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "State",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/States/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use State.areas.findById() instead.
            "prototype$__findById__areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.areas.destroyById() instead.
            "prototype$__destroyById__areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.updateById() instead.
            "prototype$__updateById__areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.sites.findById() instead.
            "prototype$__findById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.sites.destroyById() instead.
            "prototype$__destroyById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.updateById() instead.
            "prototype$__updateById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.areas() instead.
            "prototype$__get__areas": {
              isArray: true,
              url: urlBase + "/States/:id/areas",
              method: "GET",
            },

            // INTERNAL. Use State.areas.create() instead.
            "prototype$__create__areas": {
              url: urlBase + "/States/:id/areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.destroyAll() instead.
            "prototype$__delete__areas": {
              url: urlBase + "/States/:id/areas",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.count() instead.
            "prototype$__count__areas": {
              url: urlBase + "/States/:id/areas/count",
              method: "GET",
            },

            // INTERNAL. Use State.sites() instead.
            "prototype$__get__sites": {
              isArray: true,
              url: urlBase + "/States/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use State.sites.create() instead.
            "prototype$__create__sites": {
              url: urlBase + "/States/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.destroyAll() instead.
            "prototype$__delete__sites": {
              url: urlBase + "/States/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.count() instead.
            "prototype$__count__sites": {
              url: urlBase + "/States/:id/sites/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#create
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/States",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#createMany
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/States",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#upsert
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/States",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#replaceOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/States/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#upsertWithWhere
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/States/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#exists
             * @methodOf lbServices.State
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/States/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#findById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/States/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#replaceById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/States/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#find
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/States",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#findOne
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/States/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#updateAll
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/States/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#deleteById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/States/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#count
             * @methodOf lbServices.State
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/States/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#prototype$updateAttributes
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/States/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#createChangeStream
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/States/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Area.state() instead.
            "::get::Area::state": {
              url: urlBase + "/Areas/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Site.state() instead.
            "::get::Site::state": {
              url: urlBase + "/Sites/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Summon.state() instead.
            "::get::Summon::state": {
              url: urlBase + "/Summons/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Department.state() instead.
            "::get::Department::state": {
              url: urlBase + "/Departments/:id/state",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.State#patchOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.State#updateOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.State#patchOrCreateWithWhere
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.State#update
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.State#destroyById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.State#removeById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.State#patchAttributes
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.State#modelName
        * @propertyOf lbServices.State
        * @description
        * The name of the model represented by this $resource,
        * i.e. `State`.
        */
        R.modelName = "State";

    /**
     * @ngdoc object
     * @name lbServices.State.areas
     * @header lbServices.State.areas
     * @object
     * @description
     *
     * The object `State.areas` groups methods
     * manipulating `Area` instances related to `State`.
     *
     * Call {@link lbServices.State#areas State.areas()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.State#areas
             * @methodOf lbServices.State
             *
             * @description
             *
             * Queries areas of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#count
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Counts areas of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.areas.count = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::count::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#create
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Creates a new instance in areas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.create = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::create::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#createMany
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Creates a new instance in areas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.createMany = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::createMany::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#destroyAll
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Deletes all areas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.areas.destroyAll = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::delete::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#destroyById
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Delete a related item by id for areas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for areas
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.areas.destroyById = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::destroyById::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#findById
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Find a related item by id for areas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for areas
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.findById = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::findById::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#updateById
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Update a related item by id for areas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for areas
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.updateById = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::updateById::State::areas"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.State.sites
     * @header lbServices.State.sites
     * @object
     * @description
     *
     * The object `State.sites` groups methods
     * manipulating `Site` instances related to `State`.
     *
     * Call {@link lbServices.State#sites State.sites()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.State#sites
             * @methodOf lbServices.State
             *
             * @description
             *
             * Queries sites of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#count
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Counts sites of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sites.count = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::count::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#create
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.create = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::create::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#createMany
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.createMany = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::createMany::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#destroyAll
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Deletes all sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyAll = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::delete::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#destroyById
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Delete a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::destroyById::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#findById
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Find a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.findById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::findById::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#updateById
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Update a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.updateById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::updateById::State::sites"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Area
 * @header lbServices.Area
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Area` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Area",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Areas/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Area.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Areas/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.findById() instead.
            "prototype$__findById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.destroyById() instead.
            "prototype$__destroyById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.updateById() instead.
            "prototype$__updateById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Area.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Areas/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Area.sites() instead.
            "prototype$__get__sites": {
              isArray: true,
              url: urlBase + "/Areas/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.create() instead.
            "prototype$__create__sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use Area.sites.destroyAll() instead.
            "prototype$__delete__sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.count() instead.
            "prototype$__count__sites": {
              url: urlBase + "/Areas/:id/sites/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#create
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Areas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#createMany
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Areas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#upsert
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Areas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#replaceOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Areas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#upsertWithWhere
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Areas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#exists
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Areas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#findById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Areas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#replaceById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Areas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#find
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Areas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#findOne
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Areas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#updateAll
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Areas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#deleteById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Areas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#count
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Areas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#prototype$updateAttributes
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Areas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#createChangeStream
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Areas/change-stream",
              method: "POST",
            },

            // INTERNAL. Use State.areas.findById() instead.
            "::findById::State::areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.areas.destroyById() instead.
            "::destroyById::State::areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.updateById() instead.
            "::updateById::State::areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.areas() instead.
            "::get::State::areas": {
              isArray: true,
              url: urlBase + "/States/:id/areas",
              method: "GET",
            },

            // INTERNAL. Use State.areas.create() instead.
            "::create::State::areas": {
              url: urlBase + "/States/:id/areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.createMany() instead.
            "::createMany::State::areas": {
              isArray: true,
              url: urlBase + "/States/:id/areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.destroyAll() instead.
            "::delete::State::areas": {
              url: urlBase + "/States/:id/areas",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.count() instead.
            "::count::State::areas": {
              url: urlBase + "/States/:id/areas/count",
              method: "GET",
            },

            // INTERNAL. Use Site.area() instead.
            "::get::Site::area": {
              url: urlBase + "/Sites/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Summon.area() instead.
            "::get::Summon::area": {
              url: urlBase + "/Summons/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Employees.area() instead.
            "::get::Employees::area": {
              url: urlBase + "/Employees/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Department.area() instead.
            "::get::Department::area": {
              url: urlBase + "/Departments/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.area() instead.
            "::get::Usermapping::area": {
              url: urlBase + "/Usermappings/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Shop.area() instead.
            "::get::Shop::area": {
              url: urlBase + "/Shops/:id/area",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Area#patchOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Area#updateOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Area#patchOrCreateWithWhere
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Area#update
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Area#destroyById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Area#removeById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Area#patchAttributes
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Area#modelName
        * @propertyOf lbServices.Area
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Area`.
        */
        R.modelName = "Area";


            /**
             * @ngdoc method
             * @name lbServices.Area#state
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Area::state"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Area.sites
     * @header lbServices.Area.sites
     * @object
     * @description
     *
     * The object `Area.sites` groups methods
     * manipulating `Site` instances related to `Area`.
     *
     * Call {@link lbServices.Area#sites Area.sites()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Area#sites
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Queries sites of Area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#count
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Counts sites of Area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sites.count = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::count::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#create
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.create = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::create::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#createMany
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.createMany = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::createMany::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#destroyAll
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Deletes all sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyAll = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::delete::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#destroyById
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Delete a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::destroyById::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#findById
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Find a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.findById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::findById::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#updateById
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Update a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.updateById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::updateById::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area#zone
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Area::zone"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Site
 * @header lbServices.Site
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Site` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Site",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Sites/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Site.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Sites/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Site.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Sites/:id/area",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#create
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Sites",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#createMany
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Sites",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#upsert
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Sites",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#replaceOrCreate
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Sites/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#upsertWithWhere
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Sites/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#exists
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Sites/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#findById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Sites/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#replaceById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Sites/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#find
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Sites",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#findOne
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Sites/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#updateAll
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Sites/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#deleteById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Sites/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#count
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Sites/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#prototype$updateAttributes
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Sites/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#createChangeStream
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Sites/change-stream",
              method: "POST",
            },

            // INTERNAL. Use State.sites.findById() instead.
            "::findById::State::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.sites.destroyById() instead.
            "::destroyById::State::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.updateById() instead.
            "::updateById::State::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.sites() instead.
            "::get::State::sites": {
              isArray: true,
              url: urlBase + "/States/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use State.sites.create() instead.
            "::create::State::sites": {
              url: urlBase + "/States/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.createMany() instead.
            "::createMany::State::sites": {
              isArray: true,
              url: urlBase + "/States/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.destroyAll() instead.
            "::delete::State::sites": {
              url: urlBase + "/States/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.count() instead.
            "::count::State::sites": {
              url: urlBase + "/States/:id/sites/count",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.findById() instead.
            "::findById::Area::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.destroyById() instead.
            "::destroyById::Area::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.updateById() instead.
            "::updateById::Area::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Area.sites() instead.
            "::get::Area::sites": {
              isArray: true,
              url: urlBase + "/Areas/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.create() instead.
            "::create::Area::sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use Area.sites.createMany() instead.
            "::createMany::Area::sites": {
              isArray: true,
              url: urlBase + "/Areas/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use Area.sites.destroyAll() instead.
            "::delete::Area::sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.count() instead.
            "::count::Area::sites": {
              url: urlBase + "/Areas/:id/sites/count",
              method: "GET",
            },

            // INTERNAL. Use Projects.site() instead.
            "::get::Projects::site": {
              url: urlBase + "/Projects/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Summon.site() instead.
            "::get::Summon::site": {
              url: urlBase + "/Summons/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Employees.site() instead.
            "::get::Employees::site": {
              url: urlBase + "/Employees/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.site() instead.
            "::get::Usertransaction::site": {
              url: urlBase + "/Usertransactions/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Shop.site() instead.
            "::get::Shop::site": {
              url: urlBase + "/Shops/:id/site",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Site#patchOrCreate
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Site#updateOrCreate
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Site#patchOrCreateWithWhere
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Site#update
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Site#destroyById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Site#removeById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Site#patchAttributes
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Site#modelName
        * @propertyOf lbServices.Site
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Site`.
        */
        R.modelName = "Site";


            /**
             * @ngdoc method
             * @name lbServices.Site#state
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Site::state"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Site#area
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Site::area"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Projects
 * @header lbServices.Projects
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Projects` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Projects",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Projects/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Projects.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Projects/:id/site",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#create
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Projects",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#createMany
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Projects",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#upsert
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Projects",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#replaceOrCreate
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Projects/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#upsertWithWhere
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Projects/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#exists
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Projects/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#findById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Projects/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#replaceById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Projects/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#find
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Projects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#findOne
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Projects/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#updateAll
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Projects/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#deleteById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Projects/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#count
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Projects/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#prototype$updateAttributes
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Projects id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Projects/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#createChangeStream
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Projects/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Assets.project() instead.
            "::get::Assets::project": {
              url: urlBase + "/Assets/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Cctv.project() instead.
            "::get::Cctv::project": {
              url: urlBase + "/Cctvs/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Employees.project() instead.
            "::get::Employees::project": {
              url: urlBase + "/Employees/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.project() instead.
            "::get::Usertransaction::project": {
              url: urlBase + "/Usertransactions/:id/project",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Projects#patchOrCreate
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#updateOrCreate
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#patchOrCreateWithWhere
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#update
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#destroyById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#removeById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#patchAttributes
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Projects id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Projects#modelName
        * @propertyOf lbServices.Projects
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Projects`.
        */
        R.modelName = "Projects";


            /**
             * @ngdoc method
             * @name lbServices.Projects#site
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Projects id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Projects::site"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Assets
 * @header lbServices.Assets
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Assets` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Assets",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Assets/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Assets.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Assets/:id/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#create
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Assets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#createMany
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Assets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#upsert
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Assets",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#replaceOrCreate
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Assets/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#upsertWithWhere
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Assets/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#exists
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Assets/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#findById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Assets/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#replaceById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Assets/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#find
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Assets",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#findOne
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Assets/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#updateAll
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Assets/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#deleteById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Assets/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#count
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Assets/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#prototype$updateAttributes
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assets id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Assets/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#createChangeStream
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Assets/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Assets#patchOrCreate
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#updateOrCreate
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#patchOrCreateWithWhere
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#update
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#destroyById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#removeById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#patchAttributes
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assets id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Assets#modelName
        * @propertyOf lbServices.Assets
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Assets`.
        */
        R.modelName = "Assets";


            /**
             * @ngdoc method
             * @name lbServices.Assets#project
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assets id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Assets::project"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Cctv
 * @header lbServices.Cctv
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Cctv` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Cctv",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Cctvs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Cctv.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Cctvs/:id/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#create
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Cctvs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#createMany
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Cctvs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#upsert
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Cctvs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#replaceOrCreate
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Cctvs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#upsertWithWhere
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Cctvs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#exists
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Cctvs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#findById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Cctvs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#replaceById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Cctvs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#find
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Cctvs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#findOne
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Cctvs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#updateAll
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Cctvs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#deleteById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Cctvs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#count
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Cctvs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#prototype$updateAttributes
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cctv id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Cctvs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#createChangeStream
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Cctvs/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Cctv#patchOrCreate
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#updateOrCreate
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#patchOrCreateWithWhere
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#update
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#destroyById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#removeById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#patchAttributes
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cctv id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Cctv#modelName
        * @propertyOf lbServices.Cctv
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Cctv`.
        */
        R.modelName = "Cctv";


            /**
             * @ngdoc method
             * @name lbServices.Cctv#project
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cctv id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Cctv::project"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Emprate
 * @header lbServices.Emprate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Emprate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Emprate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emprates/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Emprate#create
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Emprates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#createMany
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Emprates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#upsert
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Emprates",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#replaceOrCreate
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Emprates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#upsertWithWhere
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Emprates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#exists
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Emprates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#findById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Emprates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#replaceById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Emprates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#find
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Emprates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#findOne
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Emprates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#updateAll
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Emprates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#deleteById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Emprates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#count
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Emprates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#prototype$updateAttributes
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Emprate id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Emprates/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#createChangeStream
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Emprates/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Employees.emprate() instead.
            "::get::Employees::emprate": {
              url: urlBase + "/Employees/:id/emprate",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Emprate#patchOrCreate
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#updateOrCreate
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#patchOrCreateWithWhere
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#update
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#destroyById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#removeById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#patchAttributes
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Emprate id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Emprate#modelName
        * @propertyOf lbServices.Emprate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Emprate`.
        */
        R.modelName = "Emprate";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Rolemapping
 * @header lbServices.Rolemapping
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Rolemapping` model.
 *
 * **Details**
 *
 * Map principals to roles
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Rolemapping",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Rolemappings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Rolemapping.role() instead.
            "prototype$__get__role": {
              url: urlBase + "/Rolemappings/:id/role",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#create
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Rolemappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#createMany
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Rolemappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#upsert
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Rolemappings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#replaceOrCreate
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Rolemappings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#upsertWithWhere
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Rolemappings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#exists
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Rolemappings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#findById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Rolemappings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#replaceById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Rolemappings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#find
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Rolemappings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#findOne
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Rolemappings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#updateAll
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Rolemappings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#deleteById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Rolemappings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#count
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Rolemappings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#prototype$updateAttributes
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Rolemapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Rolemappings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#createChangeStream
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Rolemappings/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#patchOrCreate
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#updateOrCreate
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#patchOrCreateWithWhere
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#update
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#destroyById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#removeById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#patchAttributes
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Rolemapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Rolemapping#modelName
        * @propertyOf lbServices.Rolemapping
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Rolemapping`.
        */
        R.modelName = "Rolemapping";


            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#role
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Rolemapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.role = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::Rolemapping::role"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Maincategory
 * @header lbServices.Maincategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Maincategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Maincategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Maincategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Maincategory.subs.findById() instead.
            "prototype$__findById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.destroyById() instead.
            "prototype$__destroyById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.updateById() instead.
            "prototype$__updateById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Maincategory.subs() instead.
            "prototype$__get__subs": {
              isArray: true,
              url: urlBase + "/Maincategories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.create() instead.
            "prototype$__create__subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.destroyAll() instead.
            "prototype$__delete__subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.count() instead.
            "prototype$__count__subs": {
              url: urlBase + "/Maincategories/:id/subs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#create
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Maincategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#createMany
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Maincategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#upsert
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Maincategories",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#replaceOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Maincategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#upsertWithWhere
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Maincategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#exists
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Maincategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#findById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Maincategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#replaceById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Maincategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#find
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Maincategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#findOne
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Maincategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#updateAll
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Maincategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#deleteById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Maincategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#count
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Maincategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#prototype$updateAttributes
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Maincategories/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#createChangeStream
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Maincategories/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Category.main() instead.
            "::get::Category::main": {
              url: urlBase + "/Categories/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.main() instead.
            "::get::Usertransaction::main": {
              url: urlBase + "/Usertransactions/:id/main",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#updateOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchOrCreateWithWhere
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#update
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#destroyById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#removeById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchAttributes
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Maincategory#modelName
        * @propertyOf lbServices.Maincategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Maincategory`.
        */
        R.modelName = "Maincategory";

    /**
     * @ngdoc object
     * @name lbServices.Maincategory.subs
     * @header lbServices.Maincategory.subs
     * @object
     * @description
     *
     * The object `Maincategory.subs` groups methods
     * manipulating `Category` instances related to `Maincategory`.
     *
     * Call {@link lbServices.Maincategory#subs Maincategory.subs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Maincategory#subs
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Queries subs of Maincategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#count
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Counts subs of Maincategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subs.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#create
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#createMany
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#destroyAll
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Deletes all subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#destroyById
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Delete a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#findById
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Find a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#updateById
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Update a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Maincategory::subs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Category
 * @header lbServices.Category
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Category` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Category",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Categories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Category.main() instead.
            "prototype$__get__main": {
              url: urlBase + "/Categories/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Category.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Categories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.findById() instead.
            "prototype$__findById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.destroyById() instead.
            "prototype$__destroyById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.updateById() instead.
            "prototype$__updateById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.subs() instead.
            "prototype$__get__subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.create() instead.
            "prototype$__create__subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.destroyAll() instead.
            "prototype$__delete__subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.count() instead.
            "prototype$__count__subs": {
              url: urlBase + "/Categories/:id/subs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#create
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Categories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createMany
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Categories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#upsert
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Categories",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Categories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#upsertWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Categories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#exists
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Categories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Categories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Categories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#find
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Categories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findOne
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Categories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#updateAll
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Categories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#deleteById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Categories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#count
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Categories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$updateAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Categories/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createChangeStream
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Categories/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.findById() instead.
            "::findById::Maincategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.destroyById() instead.
            "::destroyById::Maincategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.updateById() instead.
            "::updateById::Maincategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Maincategory.subs() instead.
            "::get::Maincategory::subs": {
              isArray: true,
              url: urlBase + "/Maincategories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.create() instead.
            "::create::Maincategory::subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.createMany() instead.
            "::createMany::Maincategory::subs": {
              isArray: true,
              url: urlBase + "/Maincategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.destroyAll() instead.
            "::delete::Maincategory::subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.count() instead.
            "::count::Maincategory::subs": {
              url: urlBase + "/Maincategories/:id/subs/count",
              method: "GET",
            },

            // INTERNAL. Use Category.parent() instead.
            "::get::Category::parent": {
              url: urlBase + "/Categories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.findById() instead.
            "::findById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.destroyById() instead.
            "::destroyById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.updateById() instead.
            "::updateById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.subs() instead.
            "::get::Category::subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.create() instead.
            "::create::Category::subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.createMany() instead.
            "::createMany::Category::subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.destroyAll() instead.
            "::delete::Category::subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.count() instead.
            "::count::Category::subs": {
              url: urlBase + "/Categories/:id/subs/count",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.category() instead.
            "::get::Usertransaction::category": {
              url: urlBase + "/Usertransactions/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.parent() instead.
            "::get::Usertransaction::parent": {
              url: urlBase + "/Usertransactions/:id/parent",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Category#updateOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreateWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Category#update
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Category#destroyById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#removeById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#patchAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Category#modelName
        * @propertyOf lbServices.Category
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Category`.
        */
        R.modelName = "Category";


            /**
             * @ngdoc method
             * @name lbServices.Category#main
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Fetches belongsTo relation main.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R.main = function() {
          var TargetResource = $injector.get("Maincategory");
          var action = TargetResource["::get::Category::main"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category#parent
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::parent"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Category.subs
     * @header lbServices.Category.subs
     * @object
     * @description
     *
     * The object `Category.subs` groups methods
     * manipulating `Category` instances related to `Category`.
     *
     * Call {@link lbServices.Category#subs Category.subs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Category#subs
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Queries subs of Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#count
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Counts subs of Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subs.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#create
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#createMany
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#destroyAll
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Deletes all subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#destroyById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Delete a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#findById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Find a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#updateById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Update a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Category::subs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Receipts
 * @header lbServices.Receipts
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Receipts` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Receipts",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Receipts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Receipts#create
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Receipts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#createMany
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Receipts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#upsert
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Receipts",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#replaceOrCreate
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Receipts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#upsertWithWhere
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Receipts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#exists
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Receipts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#findById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Receipts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#replaceById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Receipts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#find
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Receipts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#findOne
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Receipts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#updateAll
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Receipts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#deleteById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Receipts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#count
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Receipts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#prototype$updateAttributes
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipts id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Receipts/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#createChangeStream
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Receipts/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.receipt() instead.
            "::get::Usertransaction::receipt": {
              url: urlBase + "/Usertransactions/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.receipt() instead.
            "::get::Machinesales::receipt": {
              url: urlBase + "/Machinesales/:id/receipt",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Receipts#patchOrCreate
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#updateOrCreate
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#patchOrCreateWithWhere
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#update
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#destroyById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#removeById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#patchAttributes
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipts id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Receipts#modelName
        * @propertyOf lbServices.Receipts
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Receipts`.
        */
        R.modelName = "Receipts";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Summoncategory
 * @header lbServices.Summoncategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Summoncategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Summoncategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Summoncategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Summoncategory.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Summoncategories/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#create
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Summoncategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#createMany
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Summoncategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#upsert
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Summoncategories",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#replaceOrCreate
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Summoncategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#upsertWithWhere
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Summoncategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#exists
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Summoncategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#findById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Summoncategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#replaceById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Summoncategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#find
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Summoncategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#findOne
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Summoncategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#updateAll
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Summoncategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#deleteById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Summoncategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#count
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Summoncategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#prototype$updateAttributes
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summoncategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Summoncategories/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#createChangeStream
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Summoncategories/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Summoncategory.parent() instead.
            "::get::Summoncategory::parent": {
              url: urlBase + "/Summoncategories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.sumcat() instead.
            "::get::Usertransaction::sumcat": {
              url: urlBase + "/Usertransactions/:id/sumcat",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#patchOrCreate
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#updateOrCreate
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#patchOrCreateWithWhere
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#update
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#destroyById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#removeById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#patchAttributes
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summoncategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Summoncategory#modelName
        * @propertyOf lbServices.Summoncategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Summoncategory`.
        */
        R.modelName = "Summoncategory";


            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#parent
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summoncategory id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Summoncategory");
          var action = TargetResource["::get::Summoncategory::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Summon
 * @header lbServices.Summon
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Summon` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Summon",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Summons/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Summon.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Summons/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Summon.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Summons/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Summon.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Summons/:id/state",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#create
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Summons",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#createMany
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Summons",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#upsert
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Summons",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#replaceOrCreate
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Summons/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#upsertWithWhere
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Summons/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#exists
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Summons/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#findById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Summons/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#replaceById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Summons/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#find
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Summons",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#findOne
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Summons/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#updateAll
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Summons/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#deleteById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Summons/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#count
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Summons/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#prototype$updateAttributes
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Summons/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#createChangeStream
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Summons/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.summon() instead.
            "::get::Usertransaction::summon": {
              url: urlBase + "/Usertransactions/:id/summon",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Summon#patchOrCreate
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#updateOrCreate
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#patchOrCreateWithWhere
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#update
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#destroyById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#removeById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#patchAttributes
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Summon#modelName
        * @propertyOf lbServices.Summon
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Summon`.
        */
        R.modelName = "Summon";


            /**
             * @ngdoc method
             * @name lbServices.Summon#site
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Summon::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Summon#area
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Summon::area"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Summon#state
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Summon::state"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Employees
 * @header lbServices.Employees
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Employees` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Employees",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Employees/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Employees.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Employees/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Employees.emprate() instead.
            "prototype$__get__emprate": {
              url: urlBase + "/Employees/:id/emprate",
              method: "GET",
            },

            // INTERNAL. Use Employees.supervisor() instead.
            "prototype$__get__supervisor": {
              url: urlBase + "/Employees/:id/supervisor",
              method: "GET",
            },

            // INTERNAL. Use Employees.manager() instead.
            "prototype$__get__manager": {
              url: urlBase + "/Employees/:id/manager",
              method: "GET",
            },

            // INTERNAL. Use Employees.owner() instead.
            "prototype$__get__owner": {
              url: urlBase + "/Employees/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Employees.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Employees/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Employees.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Employees/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Employees.department() instead.
            "prototype$__get__department": {
              url: urlBase + "/Employees/:id/department",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#create
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Employees",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#createMany
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Employees",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#upsert
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Employees",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#replaceOrCreate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Employees/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#upsertWithWhere
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Employees/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#exists
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Employees/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#findById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Employees/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#replaceById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Employees/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#find
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Employees",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#findOne
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Employees/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#updateAll
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Employees/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#deleteById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Employees/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#count
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Employees/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#prototype$updateAttributes
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Employees/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#createChangeStream
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Employees/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummary
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummary": {
              url: urlBase + "/Employees/officerSummary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummaryL1
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummaryL1": {
              url: urlBase + "/Employees/officerSummaryL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummaryL2
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             *  - `areaid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummaryL2": {
              url: urlBase + "/Employees/officerSummaryL2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummaryL3
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             *  - `areaid` – `{string=}` -
             *
             *  - `siteid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummaryL3": {
              url: urlBase + "/Employees/officerSummaryL3",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.employee() instead.
            "::get::Usertransaction::employee": {
              url: urlBase + "/Usertransactions/:id/employee",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Employees#patchOrCreate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#updateOrCreate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#patchOrCreateWithWhere
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#update
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#destroyById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#removeById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#patchAttributes
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Employees#modelName
        * @propertyOf lbServices.Employees
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Employees`.
        */
        R.modelName = "Employees";


            /**
             * @ngdoc method
             * @name lbServices.Employees#project
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Employees::project"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#emprate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation emprate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R.emprate = function() {
          var TargetResource = $injector.get("Emprate");
          var action = TargetResource["::get::Employees::emprate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#supervisor
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation supervisor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.supervisor = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Employees::supervisor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#manager
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation manager.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.manager = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Employees::manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#owner
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation owner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.owner = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Employees::owner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#site
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Employees::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#area
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Employees::area"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#department
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.department = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::get::Employees::department"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Department
 * @header lbServices.Department
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Department` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Department",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Departments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Department.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Departments/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Department.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Departments/:id/area",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#create
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Departments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#createMany
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Departments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#upsert
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Departments",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#replaceOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Departments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#upsertWithWhere
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Departments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#exists
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Departments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#findById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Departments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#replaceById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Departments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#find
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Departments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#findOne
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Departments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#updateAll
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Departments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#deleteById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Departments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#count
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Departments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$updateAttributes
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Departments/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#createChangeStream
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Departments/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Employees.department() instead.
            "::get::Employees::department": {
              url: urlBase + "/Employees/:id/department",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Department#patchOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Department#updateOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Department#patchOrCreateWithWhere
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Department#update
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Department#destroyById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Department#removeById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Department#patchAttributes
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Department#modelName
        * @propertyOf lbServices.Department
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Department`.
        */
        R.modelName = "Department";


            /**
             * @ngdoc method
             * @name lbServices.Department#state
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Department::state"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department#area
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Department::area"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Usertransaction
 * @header lbServices.Usertransaction
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Usertransaction` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Usertransaction",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Usertransactions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usertransaction.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Usertransactions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Usertransactions/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.summon() instead.
            "prototype$__get__summon": {
              url: urlBase + "/Usertransactions/:id/summon",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Usertransactions/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/Usertransactions/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/Usertransactions/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.main() instead.
            "prototype$__get__main": {
              url: urlBase + "/Usertransactions/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Usertransactions/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Usertransactions/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.receipt() instead.
            "prototype$__get__receipt": {
              url: urlBase + "/Usertransactions/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.sumcat() instead.
            "prototype$__get__sumcat": {
              url: urlBase + "/Usertransactions/:id/sumcat",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.transfer() instead.
            "prototype$__get__transfer": {
              url: urlBase + "/Usertransactions/:id/transfer",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.findById() instead.
            "prototype$__findById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.destroyById() instead.
            "prototype$__destroyById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.updateById() instead.
            "prototype$__updateById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.link() instead.
            "prototype$__link__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.unlink() instead.
            "prototype$__unlink__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.exists() instead.
            "prototype$__exists__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Usertransaction.paylist() instead.
            "prototype$__get__paylist": {
              url: urlBase + "/Usertransactions/:id/paylist",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles() instead.
            "prototype$__get__roles": {
              isArray: true,
              url: urlBase + "/Usertransactions/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.create() instead.
            "prototype$__create__roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.roles.destroyAll() instead.
            "prototype$__delete__roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.count() instead.
            "prototype$__count__roles": {
              url: urlBase + "/Usertransactions/:id/roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#create
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Usertransactions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#createMany
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Usertransactions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#upsert
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Usertransactions",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#replaceOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Usertransactions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#upsertWithWhere
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Usertransactions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#exists
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Usertransactions/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#findById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Usertransactions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#replaceById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Usertransactions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#find
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Usertransactions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#findOne
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Usertransactions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#updateAll
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Usertransactions/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#deleteById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Usertransactions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#count
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Usertransactions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#prototype$updateAttributes
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Usertransactions/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#createChangeStream
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Usertransactions/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#updateOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchOrCreateWithWhere
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#update
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#destroyById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#removeById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchAttributes
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Usertransaction#modelName
        * @propertyOf lbServices.Usertransaction
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Usertransaction`.
        */
        R.modelName = "Usertransaction";


            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#user
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Usertransaction::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#project
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Usertransaction::project"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#summon
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation summon.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R.summon = function() {
          var TargetResource = $injector.get("Summon");
          var action = TargetResource["::get::Usertransaction::summon"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#employee
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employees");
          var action = TargetResource["::get::Usertransaction::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#account
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Accounts");
          var action = TargetResource["::get::Usertransaction::account"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#category
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Usertransaction::category"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#main
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation main.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R.main = function() {
          var TargetResource = $injector.get("Maincategory");
          var action = TargetResource["::get::Usertransaction::main"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#parent
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Usertransaction::parent"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#site
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Usertransaction::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#receipt
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R.receipt = function() {
          var TargetResource = $injector.get("Receipts");
          var action = TargetResource["::get::Usertransaction::receipt"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#sumcat
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation sumcat.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R.sumcat = function() {
          var TargetResource = $injector.get("Summoncategory");
          var action = TargetResource["::get::Usertransaction::sumcat"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#transfer
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation transfer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.transfer = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Usertransaction::transfer"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Usertransaction.roles
     * @header lbServices.Usertransaction.roles
     * @object
     * @description
     *
     * The object `Usertransaction.roles` groups methods
     * manipulating `Role` instances related to `Usertransaction`.
     *
     * Call {@link lbServices.Usertransaction#roles Usertransaction.roles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#roles
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Queries roles of Usertransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#count
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Counts roles of Usertransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roles.count = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::count::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#create
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.create = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::create::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#createMany
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.createMany = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::createMany::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#destroyAll
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Deletes all roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyAll = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::delete::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#destroyById
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Delete a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::destroyById::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#exists
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Check the existence of roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.exists = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::exists::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#findById
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Find a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.findById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::findById::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#link
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Add a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.link = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::link::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#unlink
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Remove the roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.unlink = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::unlink::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#updateById
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Update a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.updateById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::updateById::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#paylist
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation paylist.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R.paylist = function() {
          var TargetResource = $injector.get("Paylist");
          var action = TargetResource["::get::Usertransaction::paylist"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Gamecategory
 * @header lbServices.Gamecategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Gamecategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Gamecategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Gamecategories/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#create
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Gamecategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#createMany
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Gamecategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#upsert
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Gamecategories",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#replaceOrCreate
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Gamecategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#upsertWithWhere
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Gamecategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#exists
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Gamecategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#findById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Gamecategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#replaceById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Gamecategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#find
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Gamecategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#findOne
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Gamecategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#updateAll
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Gamecategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#deleteById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Gamecategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#count
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Gamecategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#prototype$updateAttributes
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Gamecategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Gamecategories/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#createChangeStream
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Gamecategories/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Games.gamecat() instead.
            "::get::Games::gamecat": {
              url: urlBase + "/Games/:id/gamecat",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#patchOrCreate
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#updateOrCreate
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#patchOrCreateWithWhere
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#update
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#destroyById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#removeById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#patchAttributes
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Gamecategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Gamecategory#modelName
        * @propertyOf lbServices.Gamecategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Gamecategory`.
        */
        R.modelName = "Gamecategory";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Games
 * @header lbServices.Games
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Games` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Games",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Games/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Games.gamecat() instead.
            "prototype$__get__gamecat": {
              url: urlBase + "/Games/:id/gamecat",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#create
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Games",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#createMany
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Games",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#upsert
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Games",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#replaceOrCreate
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Games/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#upsertWithWhere
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Games/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#exists
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Games/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#findById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Games/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#replaceById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Games/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#find
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Games",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#findOne
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Games/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#updateAll
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Games/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#deleteById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Games/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#count
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Games/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#prototype$updateAttributes
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Games id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Games/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#createChangeStream
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Games/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Onlineshop.game() instead.
            "::get::Onlineshop::game": {
              url: urlBase + "/Onlineshops/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Onlinesales.game() instead.
            "::get::Onlinesales::game": {
              url: urlBase + "/Onlinesales/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Machine.game() instead.
            "::get::Machine::game": {
              url: urlBase + "/Machines/:id/game",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Games#patchOrCreate
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Games#updateOrCreate
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Games#patchOrCreateWithWhere
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Games#update
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Games#destroyById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Games#removeById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Games#patchAttributes
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Games id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Games#modelName
        * @propertyOf lbServices.Games
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Games`.
        */
        R.modelName = "Games";


            /**
             * @ngdoc method
             * @name lbServices.Games#gamecat
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Fetches belongsTo relation gamecat.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Games id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R.gamecat = function() {
          var TargetResource = $injector.get("Gamecategory");
          var action = TargetResource["::get::Games::gamecat"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Zones
 * @header lbServices.Zones
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Zones` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Zones",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Zones/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Zones#create
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Zones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#createMany
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Zones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#upsert
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Zones",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#replaceOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Zones/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#upsertWithWhere
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Zones/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#exists
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Zones/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#findById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Zones/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#replaceById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Zones/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#find
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Zones",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#findOne
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Zones/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#updateAll
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Zones/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#deleteById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Zones/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#count
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Zones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#prototype$updateAttributes
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Zones/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#createChangeStream
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Zones/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Area.zone() instead.
            "::get::Area::zone": {
              url: urlBase + "/Areas/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.zone() instead.
            "::get::Usermapping::zone": {
              url: urlBase + "/Usermappings/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Machine.zone() instead.
            "::get::Machine::zone": {
              url: urlBase + "/Machines/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Shop.zone() instead.
            "::get::Shop::zone": {
              url: urlBase + "/Shops/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Invoice.zone() instead.
            "::get::Invoice::zone": {
              url: urlBase + "/Invoices/:id/zone",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Zones#patchOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#updateOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#patchOrCreateWithWhere
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#update
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#destroyById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#removeById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#patchAttributes
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Zones#modelName
        * @propertyOf lbServices.Zones
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Zones`.
        */
        R.modelName = "Zones";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Supplier
 * @header lbServices.Supplier
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Supplier` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Supplier",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Suppliers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Supplier.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Suppliers/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#create
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Suppliers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#createMany
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Suppliers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#upsert
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Suppliers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#replaceOrCreate
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Suppliers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#upsertWithWhere
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Suppliers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#exists
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Suppliers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#findById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Suppliers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#replaceById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Suppliers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#find
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Suppliers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#findOne
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Suppliers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#updateAll
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Suppliers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#deleteById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Suppliers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#count
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Suppliers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#prototype$updateAttributes
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Supplier id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Suppliers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#createChangeStream
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Suppliers/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Machineshop.supplier() instead.
            "::get::Machineshop::supplier": {
              url: urlBase + "/Machineshops/:id/supplier",
              method: "GET",
            },

            // INTERNAL. Use Machine.supplier() instead.
            "::get::Machine::supplier": {
              url: urlBase + "/Machines/:id/supplier",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Supplier#patchOrCreate
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#updateOrCreate
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#patchOrCreateWithWhere
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#update
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#destroyById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#removeById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#patchAttributes
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Supplier id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Supplier#modelName
        * @propertyOf lbServices.Supplier
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Supplier`.
        */
        R.modelName = "Supplier";


            /**
             * @ngdoc method
             * @name lbServices.Supplier#user
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Supplier id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Supplier::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Partner
 * @header lbServices.Partner
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Partner` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Partner",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Partners/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Partner.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Partners/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Partner.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Partners/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#create
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Partners",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#createMany
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Partners",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#upsert
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Partners",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#replaceOrCreate
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Partners/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#upsertWithWhere
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Partners/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#exists
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Partners/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#findById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Partners/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#replaceById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Partners/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#find
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Partners",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#findOne
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Partners/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#updateAll
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Partners/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#deleteById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Partners/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#count
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Partners/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#prototype$updateAttributes
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Partners/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#createChangeStream
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Partners/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Partner.parent() instead.
            "::get::Partner::parent": {
              url: urlBase + "/Partners/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Shop.partner() instead.
            "::get::Shop::partner": {
              url: urlBase + "/Shops/:id/partner",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Partner#patchOrCreate
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#updateOrCreate
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#patchOrCreateWithWhere
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#update
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#destroyById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#removeById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#patchAttributes
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Partner#modelName
        * @propertyOf lbServices.Partner
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Partner`.
        */
        R.modelName = "Partner";


            /**
             * @ngdoc method
             * @name lbServices.Partner#user
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Partner::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Partner#parent
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Partner");
          var action = TargetResource["::get::Partner::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Usermapping
 * @header lbServices.Usermapping
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Usermapping` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Usermapping",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Usermappings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usermapping.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Usermappings/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Usermappings/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.role() instead.
            "prototype$__get__role": {
              url: urlBase + "/Usermappings/:id/role",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Usermappings/:id/area",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#create
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Usermappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#createMany
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Usermappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#upsert
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Usermappings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#replaceOrCreate
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Usermappings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#upsertWithWhere
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Usermappings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#exists
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Usermappings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#findById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Usermappings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#replaceById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Usermappings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#find
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Usermappings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#findOne
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Usermappings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#updateAll
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Usermappings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#deleteById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Usermappings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#count
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Usermappings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#prototype$updateAttributes
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Usermappings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#createChangeStream
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Usermappings/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Usermapping#patchOrCreate
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#updateOrCreate
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#patchOrCreateWithWhere
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#update
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#destroyById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#removeById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#patchAttributes
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Usermapping#modelName
        * @propertyOf lbServices.Usermapping
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Usermapping`.
        */
        R.modelName = "Usermapping";


            /**
             * @ngdoc method
             * @name lbServices.Usermapping#zone
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Usermapping::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#user
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Usermapping::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#role
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.role = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::Usermapping::role"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#area
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Usermapping::area"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Onlineshop
 * @header lbServices.Onlineshop
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Onlineshop` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Onlineshop",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Onlineshops/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Onlineshop.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/Onlineshops/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Onlineshop.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Onlineshops/:id/shop",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#create
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Onlineshops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#createMany
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Onlineshops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#upsert
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Onlineshops",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#replaceOrCreate
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Onlineshops/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#upsertWithWhere
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Onlineshops/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#exists
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Onlineshops/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#findById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Onlineshops/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#replaceById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Onlineshops/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#find
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Onlineshops",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#findOne
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Onlineshops/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#updateAll
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Onlineshops/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#deleteById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Onlineshops/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#count
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Onlineshops/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#prototype$updateAttributes
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Onlineshops/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#createChangeStream
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Onlineshops/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#patchOrCreate
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#updateOrCreate
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#patchOrCreateWithWhere
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#update
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#destroyById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#removeById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#patchAttributes
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Onlineshop#modelName
        * @propertyOf lbServices.Onlineshop
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Onlineshop`.
        */
        R.modelName = "Onlineshop";


            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#game
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::Onlineshop::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#shop
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Onlineshop::shop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Machineshop
 * @header lbServices.Machineshop
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Machineshop` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Machineshop",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Machineshops/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Machineshop.supplier() instead.
            "prototype$__get__supplier": {
              url: urlBase + "/Machineshops/:id/supplier",
              method: "GET",
            },

            // INTERNAL. Use Machineshop.machine() instead.
            "prototype$__get__machine": {
              url: urlBase + "/Machineshops/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use Machineshop.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Machineshops/:id/shop",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#create
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Machineshops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#createMany
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Machineshops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#upsert
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Machineshops",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#replaceOrCreate
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Machineshops/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#upsertWithWhere
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Machineshops/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#exists
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Machineshops/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#findById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Machineshops/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#replaceById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Machineshops/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#find
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Machineshops",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#findOne
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Machineshops/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#updateAll
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Machineshops/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#deleteById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Machineshops/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#count
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Machineshops/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#prototype$updateAttributes
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Machineshops/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#createChangeStream
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Machineshops/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.findById() instead.
            "::findById::Machine::machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.destroyById() instead.
            "::destroyById::Machine::machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.updateById() instead.
            "::updateById::Machine::machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Machine.machineshop() instead.
            "::get::Machine::machineshop": {
              isArray: true,
              url: urlBase + "/Machines/:id/machineshop",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.create() instead.
            "::create::Machine::machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.createMany() instead.
            "::createMany::Machine::machineshop": {
              isArray: true,
              url: urlBase + "/Machines/:id/machineshop",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.destroyAll() instead.
            "::delete::Machine::machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.count() instead.
            "::count::Machine::machineshop": {
              url: urlBase + "/Machines/:id/machineshop/count",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machineshop() instead.
            "::get::Machinesales::machineshop": {
              url: urlBase + "/Machinesales/:id/machineshop",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Machineshop#patchOrCreate
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#updateOrCreate
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#patchOrCreateWithWhere
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#update
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#destroyById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#removeById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#patchAttributes
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Machineshop#modelName
        * @propertyOf lbServices.Machineshop
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Machineshop`.
        */
        R.modelName = "Machineshop";


            /**
             * @ngdoc method
             * @name lbServices.Machineshop#supplier
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Fetches belongsTo relation supplier.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R.supplier = function() {
          var TargetResource = $injector.get("Supplier");
          var action = TargetResource["::get::Machineshop::supplier"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#machine
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Fetches belongsTo relation machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R.machine = function() {
          var TargetResource = $injector.get("Machine");
          var action = TargetResource["::get::Machineshop::machine"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#shop
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Machineshop::shop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Onlinesales
 * @header lbServices.Onlinesales
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Onlinesales` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Onlinesales",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Onlinesales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Onlinesales.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/Onlinesales/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Onlinesales.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Onlinesales/:id/shop",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#create
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Onlinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#createMany
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Onlinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#upsert
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Onlinesales",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#replaceOrCreate
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Onlinesales/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#upsertWithWhere
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Onlinesales/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#exists
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Onlinesales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#findById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Onlinesales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#replaceById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Onlinesales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#find
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Onlinesales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#findOne
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Onlinesales/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#updateAll
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Onlinesales/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#deleteById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Onlinesales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#count
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Onlinesales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#prototype$updateAttributes
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Onlinesales/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#createChangeStream
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Onlinesales/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#grpShop
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpShop": {
              url: urlBase + "/Onlinesales/grpShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#generateInvoiceOnline
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "generateInvoiceOnline": {
              url: urlBase + "/Onlinesales/generateInvoiceOnline",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getDailyOnlinesales
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyOnlinesales": {
              url: urlBase + "/Onlinesales/getDailyOnlinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getAllOnlinesales
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllOnlinesales": {
              url: urlBase + "/Onlinesales/getAllOnlinesales",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#patchOrCreate
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#updateOrCreate
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#patchOrCreateWithWhere
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#update
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#destroyById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#removeById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#patchAttributes
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Onlinesales#modelName
        * @propertyOf lbServices.Onlinesales
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Onlinesales`.
        */
        R.modelName = "Onlinesales";


            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#game
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::Onlinesales::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#shop
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Onlinesales::shop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Paylist
 * @header lbServices.Paylist
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Paylist` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Paylist",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Paylists/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Paylist.owner() instead.
            "prototype$__get__owner": {
              url: urlBase + "/Paylists/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Paylist.shared() instead.
            "prototype$__get__shared": {
              url: urlBase + "/Paylists/:id/shared",
              method: "GET",
            },

            // INTERNAL. Use Paylist.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/Paylists/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Paylist.useraccount() instead.
            "prototype$__get__useraccount": {
              url: urlBase + "/Paylists/:id/useraccount",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#create
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Paylists",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#createMany
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Paylists",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#upsert
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Paylists",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#replaceOrCreate
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Paylists/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#upsertWithWhere
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Paylists/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#exists
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Paylists/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#findById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Paylists/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#replaceById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Paylists/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#find
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Paylists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#findOne
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Paylists/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#updateAll
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Paylists/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#deleteById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Paylists/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#count
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Paylists/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#prototype$updateAttributes
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Paylists/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#createChangeStream
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Paylists/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.paylist() instead.
            "::get::Usertransaction::paylist": {
              url: urlBase + "/Usertransactions/:id/paylist",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Paylist#patchOrCreate
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#updateOrCreate
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#patchOrCreateWithWhere
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#update
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#destroyById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#removeById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#patchAttributes
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Paylist#modelName
        * @propertyOf lbServices.Paylist
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Paylist`.
        */
        R.modelName = "Paylist";


            /**
             * @ngdoc method
             * @name lbServices.Paylist#owner
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation owner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.owner = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Paylist::owner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Paylist#shared
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation shared.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.shared = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Paylist::shared"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Paylist#account
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Accounts");
          var action = TargetResource["::get::Paylist::account"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Paylist#useraccount
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::get::Paylist::useraccount"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Machine
 * @header lbServices.Machine
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Machine` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Machine",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Machines/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Machine.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Machines/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Machine.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/Machines/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Machine.supplier() instead.
            "prototype$__get__supplier": {
              url: urlBase + "/Machines/:id/supplier",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.findById() instead.
            "prototype$__findById__machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.destroyById() instead.
            "prototype$__destroyById__machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.updateById() instead.
            "prototype$__updateById__machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Machine.machineshop() instead.
            "prototype$__get__machineshop": {
              isArray: true,
              url: urlBase + "/Machines/:id/machineshop",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.create() instead.
            "prototype$__create__machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.destroyAll() instead.
            "prototype$__delete__machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.count() instead.
            "prototype$__count__machineshop": {
              url: urlBase + "/Machines/:id/machineshop/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#create
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Machines",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#createMany
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Machines",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#upsert
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Machines",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#replaceOrCreate
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Machines/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#upsertWithWhere
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Machines/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#exists
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Machines/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#findById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Machines/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#replaceById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Machines/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#find
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Machines",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#findOne
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Machines/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#updateAll
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Machines/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#deleteById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Machines/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#count
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Machines/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#prototype$updateAttributes
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Machines/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#createChangeStream
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Machines/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Machineshop.machine() instead.
            "::get::Machineshop::machine": {
              url: urlBase + "/Machineshops/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machine() instead.
            "::get::Machinesales::machine": {
              url: urlBase + "/Machinesales/:id/machine",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Machine#patchOrCreate
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#updateOrCreate
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#patchOrCreateWithWhere
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#update
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#destroyById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#removeById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#patchAttributes
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Machine#modelName
        * @propertyOf lbServices.Machine
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Machine`.
        */
        R.modelName = "Machine";


            /**
             * @ngdoc method
             * @name lbServices.Machine#zone
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Machine::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine#game
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::Machine::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine#supplier
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation supplier.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R.supplier = function() {
          var TargetResource = $injector.get("Supplier");
          var action = TargetResource["::get::Machine::supplier"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Machine.machineshop
     * @header lbServices.Machine.machineshop
     * @object
     * @description
     *
     * The object `Machine.machineshop` groups methods
     * manipulating `Machineshop` instances related to `Machine`.
     *
     * Call {@link lbServices.Machine#machineshop Machine.machineshop()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Machine#machineshop
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Queries machineshop of Machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::get::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#count
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Counts machineshop of Machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.machineshop.count = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::count::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#create
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Creates a new instance in machineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.create = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::create::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#createMany
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Creates a new instance in machineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.createMany = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::createMany::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#destroyAll
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Deletes all machineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.machineshop.destroyAll = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::delete::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#destroyById
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Delete a related item by id for machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `fk` – `{*}` - Foreign key for machineshop
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.machineshop.destroyById = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::destroyById::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#findById
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Find a related item by id for machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `fk` – `{*}` - Foreign key for machineshop
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.findById = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::findById::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#updateById
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Update a related item by id for machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `fk` – `{*}` - Foreign key for machineshop
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.updateById = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::updateById::Machine::machineshop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Shop
 * @header lbServices.Shop
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Shop` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Shop",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Shops/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Shop.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Shops/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Shop.partner() instead.
            "prototype$__get__partner": {
              url: urlBase + "/Shops/:id/partner",
              method: "GET",
            },

            // INTERNAL. Use Shop.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Shops/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Shop.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Shops/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Shop.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Shops/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#create
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Shops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#createMany
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Shops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#upsert
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Shops",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#replaceOrCreate
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Shops/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#upsertWithWhere
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Shops/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#exists
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Shops/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#findById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Shops/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#replaceById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Shops/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#find
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Shops",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#findOne
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Shops/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#updateAll
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Shops/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#deleteById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Shops/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#count
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Shops/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#prototype$updateAttributes
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Shops/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#createChangeStream
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Shops/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#getShopsSummary
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `shopmap` – `{string=}` -
             *
             *  - `zonemap` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getShopsSummary": {
              url: urlBase + "/Shops/getShopsSummary",
              method: "POST",
            },

            // INTERNAL. Use Onlineshop.shop() instead.
            "::get::Onlineshop::shop": {
              url: urlBase + "/Onlineshops/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Machineshop.shop() instead.
            "::get::Machineshop::shop": {
              url: urlBase + "/Machineshops/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Onlinesales.shop() instead.
            "::get::Onlinesales::shop": {
              url: urlBase + "/Onlinesales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.shop() instead.
            "::get::Machinesales::shop": {
              url: urlBase + "/Machinesales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Invoice.shop() instead.
            "::get::Invoice::shop": {
              url: urlBase + "/Invoices/:id/shop",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Shop#patchOrCreate
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#updateOrCreate
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#patchOrCreateWithWhere
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#update
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#destroyById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#removeById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#patchAttributes
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Shop#modelName
        * @propertyOf lbServices.Shop
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Shop`.
        */
        R.modelName = "Shop";


            /**
             * @ngdoc method
             * @name lbServices.Shop#zone
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Shop::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#partner
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation partner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R.partner = function() {
          var TargetResource = $injector.get("Partner");
          var action = TargetResource["::get::Shop::partner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#area
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Shop::area"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#site
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Shop::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#user
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Shop::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Machinesales
 * @header lbServices.Machinesales
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Machinesales` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Machinesales",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Machinesales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Machinesales.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Machinesales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machine() instead.
            "prototype$__get__machine": {
              url: urlBase + "/Machinesales/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machineshop() instead.
            "prototype$__get__machineshop": {
              url: urlBase + "/Machinesales/:id/machineshop",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.receipt() instead.
            "prototype$__get__receipt": {
              url: urlBase + "/Machinesales/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.agent() instead.
            "prototype$__get__agent": {
              url: urlBase + "/Machinesales/:id/agent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#create
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Machinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#createMany
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Machinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#upsert
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Machinesales",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#replaceOrCreate
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Machinesales/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#upsertWithWhere
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Machinesales/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#exists
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Machinesales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#findById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Machinesales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#replaceById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Machinesales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#find
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Machinesales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#findOne
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Machinesales/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#updateAll
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Machinesales/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#deleteById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Machinesales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#count
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Machinesales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#prototype$updateAttributes
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Machinesales/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#createChangeStream
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Machinesales/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSupplier
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSupplier": {
              url: urlBase + "/Machinesales/grpSupplier",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpPartner
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpPartner": {
              url: urlBase + "/Machinesales/grpPartner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpByPartnerByShopC
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpByPartnerByShopC": {
              url: urlBase + "/Machinesales/grpByPartnerByShopC",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesByShopC
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `partnerId` – `{string=}` -
             *
             *  - `shopname` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesByShopC": {
              url: urlBase + "/Machinesales/grpSalesByShopC",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpByPartnerByShopM
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpByPartnerByShopM": {
              url: urlBase + "/Machinesales/grpByPartnerByShopM",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesByShopM
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `partnerId` – `{string=}` -
             *
             *  - `shopname` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesByShopM": {
              url: urlBase + "/Machinesales/grpSalesByShopM",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesOfSupplier
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `suppId` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesOfSupplier": {
              url: urlBase + "/Machinesales/grpSalesOfSupplier",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesOfPartner
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `partnerId` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesOfPartner": {
              url: urlBase + "/Machinesales/grpSalesOfPartner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpShop
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpShop": {
              url: urlBase + "/Machinesales/grpShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getAvailableMacByZone
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAvailableMacByZone": {
              url: urlBase + "/Machinesales/getAvailableMacByZone",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#generateInvoice
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "generateInvoice": {
              url: urlBase + "/Machinesales/generateInvoice",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDailyMachinesales
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             *  - `agentid` – `{string=}` -
             *
             *  - `daynight` – `{string=}` -
             *
             *  - `shopid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyMachinesales": {
              url: urlBase + "/Machinesales/getDailyMachinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getAllMachinesales
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             *  - `agentid` – `{string=}` -
             *
             *  - `daynight` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllMachinesales": {
              url: urlBase + "/Machinesales/getAllMachinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getAllSuppliersales
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             *  - `agentid` – `{string=}` -
             *
             *  - `daynight` – `{string=}` -
             *
             *  - `supplierid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllSuppliersales": {
              url: urlBase + "/Machinesales/getAllSuppliersales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDailyMachinesalesSummary
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             *  - `shopid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyMachinesalesSummary": {
              url: urlBase + "/Machinesales/getDailyMachinesalesSummary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDashboardV1
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDashboardV1": {
              url: urlBase + "/Machinesales/getDashboardV1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDashboardV2
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDashboardV2": {
              url: urlBase + "/Machinesales/getDashboardV2",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Machinesales#patchOrCreate
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#updateOrCreate
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#patchOrCreateWithWhere
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#update
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#destroyById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#removeById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#patchAttributes
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Machinesales#modelName
        * @propertyOf lbServices.Machinesales
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Machinesales`.
        */
        R.modelName = "Machinesales";


            /**
             * @ngdoc method
             * @name lbServices.Machinesales#shop
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Machinesales::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#machine
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R.machine = function() {
          var TargetResource = $injector.get("Machine");
          var action = TargetResource["::get::Machinesales::machine"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#machineshop
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::get::Machinesales::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#receipt
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R.receipt = function() {
          var TargetResource = $injector.get("Receipts");
          var action = TargetResource["::get::Machinesales::receipt"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#agent
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation agent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.agent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Machinesales::agent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Invoice
 * @header lbServices.Invoice
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Invoice` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Invoice",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Invoices/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Invoice.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Invoices/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Invoice.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Invoices/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Invoice.agent() instead.
            "prototype$__get__agent": {
              url: urlBase + "/Invoices/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Invoice.head() instead.
            "prototype$__get__head": {
              url: urlBase + "/Invoices/:id/head",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#create
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Invoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#createMany
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Invoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#upsert
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Invoices",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#replaceOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Invoices/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#upsertWithWhere
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Invoices/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#exists
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Invoices/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#findById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Invoices/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#replaceById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Invoices/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#find
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Invoices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#findOne
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Invoices/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#updateAll
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Invoices/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#deleteById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Invoices/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#count
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Invoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#prototype$updateAttributes
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Invoices/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#createChangeStream
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Invoices/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceWithSales
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             *  - `agentid` – `{string=}` -
             *
             *  - `ispaid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceWithSales": {
              url: urlBase + "/Invoices/getDailyInvoiceWithSales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getAllInvoiceWithSales
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             *  - `zoneid` – `{string=}` -
             *
             *  - `agentid` – `{string=}` -
             *
             *  - `ispaid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllInvoiceWithSales": {
              url: urlBase + "/Invoices/getAllInvoiceWithSales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceL1
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shopmap` – `{string=}` -
             *
             *  - `zonemap` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceL1": {
              url: urlBase + "/Invoices/getDailyInvoiceL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceL2
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shopmap` – `{string=}` -
             *
             *  - `zonemap` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceL2": {
              url: urlBase + "/Invoices/getDailyInvoiceL2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceL3
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `shopmap` – `{string=}` -
             *
             *  - `zonemap` – `{string=}` -
             *
             *  - `shoptype` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceL3": {
              url: urlBase + "/Invoices/getDailyInvoiceL3",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#updateOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchOrCreateWithWhere
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#update
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#destroyById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#removeById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchAttributes
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Invoice#modelName
        * @propertyOf lbServices.Invoice
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Invoice`.
        */
        R.modelName = "Invoice";


            /**
             * @ngdoc method
             * @name lbServices.Invoice#shop
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Invoice::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#zone
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Invoice::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#agent
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation agent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.agent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invoice::agent"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#head
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation head.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.head = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invoice::head"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collector
 * @header lbServices.Collector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collectors/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Collector.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Collectors/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Collector.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Collectors/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#create
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collectors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#createMany
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collectors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#upsert
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Collectors",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#replaceOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collectors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#upsertWithWhere
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collectors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#exists
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collectors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#findById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collectors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#replaceById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collectors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#find
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collectors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#findOne
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collectors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#updateAll
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collectors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#deleteById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collectors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#count
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collectors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#prototype$updateAttributes
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Collectors/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#createChangeStream
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collectors/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Collector.parent() instead.
            "::get::Collector::parent": {
              url: urlBase + "/Collectors/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.collector() instead.
            "::get::Collectormap::collector": {
              url: urlBase + "/Collectormaps/:id/collector",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collector#patchOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#updateOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#patchOrCreateWithWhere
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#update
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#destroyById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#removeById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#patchAttributes
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collector#modelName
        * @propertyOf lbServices.Collector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collector`.
        */
        R.modelName = "Collector";


            /**
             * @ngdoc method
             * @name lbServices.Collector#user
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collector::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collector#parent
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Collector");
          var action = TargetResource["::get::Collector::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collectormap
 * @header lbServices.Collectormap
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collectormap` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collectormap",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collectormaps/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Collectormap.head() instead.
            "prototype$__get__head": {
              url: urlBase + "/Collectormaps/:id/head",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.staff() instead.
            "prototype$__get__staff": {
              url: urlBase + "/Collectormaps/:id/staff",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.vip() instead.
            "prototype$__get__vip": {
              url: urlBase + "/Collectormaps/:id/vip",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.collector() instead.
            "prototype$__get__collector": {
              url: urlBase + "/Collectormaps/:id/collector",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#create
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collectormaps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#createMany
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collectormaps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#upsert
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Collectormaps",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#replaceOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collectormaps/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#upsertWithWhere
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collectormaps/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#exists
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collectormaps/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#findById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collectormaps/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#replaceById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collectormaps/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#find
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collectormaps",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#findOne
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collectormaps/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#updateAll
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collectormaps/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#deleteById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collectormaps/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#count
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collectormaps/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#prototype$updateAttributes
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Collectormaps/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#createChangeStream
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collectormaps/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#updateOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchOrCreateWithWhere
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#update
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#destroyById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#removeById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchAttributes
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collectormap#modelName
        * @propertyOf lbServices.Collectormap
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collectormap`.
        */
        R.modelName = "Collectormap";


            /**
             * @ngdoc method
             * @name lbServices.Collectormap#head
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation head.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.head = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collectormap::head"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#staff
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation staff.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.staff = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collectormap::staff"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#vip
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation vip.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.vip = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collectormap::vip"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#collector
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation collector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R.collector = function() {
          var TargetResource = $injector.get("Collector");
          var action = TargetResource["::get::Collectormap::collector"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(50)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignIn')
    .controller('authSignInCtrl', authSignInCtrl);

  /** @ngInject */
  function authSignInCtrl($scope, localStorage, $state, validationService,
  toastr, userService, $rootScope) {
    var vm = this;

    console.log("Inside authSignInCtrl");
    $scope.user={};

    init();

    function init() {
      localStorage.clear();
    }

    vm.logar = logar;



    function logar() {
      var dadosUser = {
        user: vm.user,
        passWord: vm.passWord
      };
      localStorage.setObject('dataUser', dadosUser);
      $state.go('main.dashboard');
    }

    $scope.login = function(user){
             console.log("Login  Tapped");
             //Performing Validations
             var isFormValidated = true;

             if (validationService.isEmptyOrNullValidation(user.username) &&
               validationService.isEmptyOrNullValidation(user.password)) {
                 //No More Checks
                 console.log("All Passed");
               } else {
               isFormValidated = false;
               toastr.error('Please fill all the Required Fields', 'ERROR');
             }

             if (isFormValidated) {
               var obj = {};
               obj.params = {};
               obj.params = user;
               console.log("LoginID is "+obj.params.username);
               console.log("Password is "+obj.params.password);

               obj.onSuccess = function (result){
               console.log("Inside SUCCESS Login");
               console.log(result);
               $rootScope.userData = {};
               $rootScope.userData = result.user;
               $rootScope.userData.tokenId = result.id;
               $rootScope.userData.roleId = result.roleId;
               var localUser = {};
              //  userData.roleId = result.roleId;
              localUser.tokenId = result.id;
              //  userData.name = result.user.credentials.name;
              //  userData.mobile = result.user.credentials.mobile;
               localStorage.setObject('userData', $rootScope.userData);

               $state.go('main.dashboard');
               };

               obj.onFailure = function (err){
                 console.log("Inside Failure");
                 console.log(err);
                 if (err.status === -1){
                   toastr.error('Service Unavailable. Please try again later', 'ERROR');
                 }else{
                   $scope.user = {};
                   toastr.error('Unauthorized Access', 'ERROR');
                 }
               };

               userService.userLogin(obj);
             }
           };
         }
       })();

(function() {
    'use strict';

    angular.module('BlurAdmin.pages.authSignUp')
      .controller('authSignUpCtrl', authSignUpCtrl);

    /** @ngInject */
    function authSignUpCtrl($scope, validationService, toastr,userService, $state) {
      var vm = this;
      console.log("Inside authSignUpCtrl");

      $scope.register = {};


      $scope.validateRegistration = function(register) {
        console.log("Inside validateRegistration");
        console.log("Name = " + register.name);
        console.log("username = " + register.username);
        console.log("mobile = " + register.mobile);
        console.log("mobile = " + register.password);

        //Performing Validations
        var isFormValidated = true;

        if (validationService.isEmptyOrNullValidation(register.name) &&
          validationService.isEmptyOrNullValidation(register.username) &&
          validationService.isEmptyOrNullValidation(register.password) &&
          validationService.isEmptyOrNullValidation(register.mobile)) {

          if (!validationService.verifyPhoneFormat(register.mobile)) {
            isFormValidated = false;
            console.log("Not a numer");
            toastr.error('Please enter a valid Mobile Nummber. Should be either 9 digits or 10 digits', 'ERROR');
          }

        } else {
          isFormValidated = false;
          console.log("Fill all required fields");
          toastr.error('Please fill all the Required Fields', 'ERROR');
        }

        if (isFormValidated) {

          var obj = {};
          obj.params = {};
          obj.params = register;
          obj.params.credentials={};
          obj.params.credentials.name=register.name;
          obj.params.credentials.mobile="+60"+register.mobile;

          console.log("username is " + obj.params.username);
          console.log("name is " + obj.params.name);
          console.log("mobile is " + obj.params.mobile);
          console.log("password is " + obj.params.password);

          obj.onSuccess = function(result) {
            console.log("Inside SUCCESS");
            console.log(result);
            $scope.register = {};
            toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
            $state.transitionTo("authSignIn");
          };

          obj.onFailure = function(err) {
            console.log("Inside Failure");
            console.log(err);

            if (err.status === -1) {
              toastr.error('Service Unavailable. Please try again later', 'ERROR');
            } else if (err.status === 422) {
              $scope.register = {};
              toastr.error('Username or Mobile Already Exists', 'ERROR');
            } else {
              $scope.register = {};
              toastr.error('Unauthorized Access', 'ERROR');
            }
          };

          userService.userSignup(obj);
        }
      };
    }
  })();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config')
    .run(stateChangeStart);

  /** @ngInject */
  function stateChangeStart($rootScope, $state, localStorage) {
    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $rootScope.userData = localStorage.getObject('userData');
      if (toState.authenticate && _.isEmpty($rootScope.userData)) {
        // User isn’t authenticated
        $state.transitionTo("authSignIn");
        event.preventDefault();
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
    .controller('DashboardPageCtrl', DashboardPageCtrl);

  /** @ngInject */
  function DashboardPageCtrl($scope, $filter, editableOptions, editableThemes,
    collectorreportService, zoneService, gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal,
    $rootScope, dashboardService) {
    console.log("Inside DashboardPageCtrl");


    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.getWeeklyData = function(zoneid) {
      console.log('Inside getWeeklyData');
      
      if (zoneid && $scope.dashboardV2List.length) {
        var weekMachineData =[];
        var weekOnlinbeData =[];
        var weeklyData = [];
        var selected = $filter('filter')($scope.dashboardV2List, {
          zoneid: zoneid
        },true);
        
        for (var index = 0; index < selected.length; index++) {
          weekMachineData.push(selected[index].mactotal);
          weekOnlinbeData.push(selected[index].ontotal);
        }
        weeklyData.push(weekMachineData);
        weeklyData.push(weekOnlinbeData);

        return weeklyData;
      }
    };
    
    $scope.dashboardV1List = [];
    $scope.getDashboardV1 = function () {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS getDashboardV1");
          console.log(result.result);
          if (result.result){
            $scope.dashboardV1List = result.result;
            $scope.getDashboardV2();
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        dashboardService.getDashboardV1(obj);
      }
    };

    
    $scope.dashboardV2List = [];
    $scope.getDashboardV2 = function () {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS getDashboardV2");
          console.log(result.result);
          if (result.result){
            $scope.dashboardV2List = result.result;
            $scope.weekLabels=[];
          for (var index = 0; index < 7; index++) {
            if ($scope.dashboardV2List[index]){
              $scope.weekLabels.push($scope.dashboardV2List[index].indate);
            }
          }
          if ($scope.dashboardV1List.length>0 && $scope.dashboardV2List.length>0){

            for (var i = 0; i < $scope.dashboardV1List.length; i++) {
              var weekMachineData =[];
              var weekOnlinbeData =[];
              var weekLabels=[];
             for (var j = 0; j < $scope.dashboardV2List.length; j++) {
              if ($scope.dashboardV1List[i].zoneid===$scope.dashboardV2List[j].zoneid){
                weekMachineData.push($scope.dashboardV2List[j].mactotal);
                weekOnlinbeData.push($scope.dashboardV2List[j].ontotal);
                weekLabels.push($scope.dashboardV2List[j].indate);

                $scope.dashboardV1List[i].weeklyData=[];
                $scope.dashboardV1List[i].weeklyData.push(weekMachineData);
                $scope.dashboardV1List[i].weeklyData.push(weekOnlinbeData); 
              }
              $scope.dashboardV1List[i].weekLabels=[];
              $scope.dashboardV1List[i].weekLabels=weekLabels;
             }
             
            }
          }
          console.log('$scope.weekLabels',$scope.weekLabels);
          console.log('$scope.dashboardV1List',$scope.dashboardV1List);

        }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        dashboardService.getDashboardV2(obj);
      }
    };

    $scope.init = function(){
      $scope.getDashboardV1();
    };

    $scope.init();

  /****************************************** */

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
           for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
             var zonelist = $filter('filter')(result, {
               id: $rootScope.userData.credentials.zonemap[index]
             }, true);
             console.log('zonelist',zonelist);
 
             $scope.manageZonesList.push(zonelist[0]);
           }
         }else{
           $scope.manageZonesList = result;
         }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.dateList.from = new Date();
    $scope.dateList.to = new Date();
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.reportFilter={};
    $scope.searchSales = function (reportFilter) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+(fd.getDate()-1);

        var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+(td.getDate()-1);
        
        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone){
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        } else{
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value="";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0){
                value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
              }else{
                value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
              }
            }
            value = value+")";
            obj.params.zoneid=value;
          }else{
            obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
          }
        }
        
        if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
          obj.params.shoptype=$rootScope.userData.credentials.shopType;
        }else{
          obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
        }


        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          if (result.result){
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            var mactotalData = [];
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              
              mactotalData.push($scope.managePartnersalesList[i].mactotal);

              var onmacTotal = parseFloat($scope.managePartnersalesList[i].ontotal)+ parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            console.log('mactotalData',mactotalData);
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };




    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;


    $scope.getTotalmactotal = function (items) {
      if (items){
        return items
        .map(function (x) { return x.mactotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalontotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.ontotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotaltotal = function (items) {
      if (items){
        var totalRevenue=0;
        for (var index = 0; index < items.length; index++) {
          totalRevenue = totalRevenue + parseFloat(items[index].mactotal);
          totalRevenue = totalRevenue + parseFloat(items[index].ontotal);
        }
        return totalRevenue;
      }
    };
    $scope.getTotalshops = function (items) {
      if (items){
      return items
        .map(function (x) { return x.shopcount; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };




   
    $scope.monthLabels =["May", "Jun", "Jul", "Aug", "Sep"];

    $scope.weekSeries = ['Machine (大机)', 'Online (网机)'];
    
    $scope.weeklyData = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.backgroundColor = ['#dfb81c','#2dacd1'];

    $scope.datasetOverride = [{
      fill: true,
      backgroundColor: [
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
      ]
    }, {
      fill: true,
      backgroundColor: [
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
      ]
    }
  ];

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
    .service('dashboardService', dashboardService);

  /** @ngInject */
  function dashboardService(Machinesales) {

    var getDashboardV1 = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
      //  var dailyDate = '2018-04-25';

      console.log('date',dailyDate);
  
      Machinesales.getDashboardV1({
        adate: dailyDate,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
  
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getDashboardV2 = function(obj) {

      var days = 10; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
      // var dailyDate = '2018-04-21';
      console.log('date',dailyDate);
  
      Machinesales.getDashboardV2({
        adate: dailyDate,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
  
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDashboardV1: getDashboardV1,
      getDashboardV2: getDashboardV2
    };

  }

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal,
    validationService, toastr, userService, $state, $rootScope, roleService) {

    console.log("Inside ProfilePageCtrl");

    //Getting Roles
    $scope.manageRoleList = [];
    $scope.initManageRole = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };

    $scope.initManageRole();

    $scope.manageProfile = {};
    $scope.manageProfile = $rootScope.userData;
    // $scope.manageProfile.id = $rootScope.userData.id;
    // $scope.manageProfile.name = $rootScope.userData.credentials.name;
    // $scope.manageProfile.mobile = $rootScope.userData.credentials.mobile;
    // $scope.manageProfile.role = $rootScope.userData.credentials.role;
    // $scope.manageProfile.credentials = $rootScope.userData.credentials;

    console.log($scope.manageProfile.id);


    $scope.udpateProfile = function (manageProfile) {
      console.log("Inside udpateProfile");
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(manageProfile.credentials.name) &&
        validationService.isEmptyOrNullValidation(manageProfile.password) &&
        validationService.isEmptyOrNullValidation(manageProfile.credentials.mobile)) {

        var phoneNumber = manageProfile.credentials.mobile;
        phoneNumber = phoneNumber.startsWith('+') ? phoneNumber.substring(2) : phoneNumber;

        if (!validationService.verifyPhoneFormat(phoneNumber)) {
          isFormValidated = false;
          console.log("Not a numer");
          toastr.error('Please enter a valid Mobile Nummber. Should be either 9 digits or 10 digits', 'ERROR');
        }

        if (manageProfile.password !== manageProfile.confirmPassword) {
          isFormValidated = false;
          console.log("Not a numer");
          toastr.error('Password does not match', 'ERROR');
        }

      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        toastr.error('Please fill all the Required Fields', 'ERROR');
      }

      if (isFormValidated) {
        console.log("All cOmpleted");

        var obj = {};
        obj.params = {};
        obj.params = $scope.manageProfile;
        //obj.params.credentials = manageProfile.credentials;
        //obj.params.id = manageProfile.userId;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.register = {};
          toastr.success('Your Profile is updated. Please Login again', 'SUCCESS');
          $state.transitionTo("authSignIn");
        };

        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);

          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else if (err.status === 422) {
            $scope.register = {};
            toastr.error('Username or Mobile Already Exists', 'ERROR');
          } else {
            $scope.register = {};
            toastr.error('Unauthorized Access', 'ERROR');
          }
        };
        userService.saveUser(obj);

      }

    };




    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [{
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
        item.href = link;
      });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
        .then(function (result) {
          $scope.picture = result;
        });
    };

    $scope.showRoles = function (role) {
      if (role && $scope.manageRoleList.length) {
        var selected = $filter('filter')($scope.manageRoleList, {
          id: role
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();
/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .factory('validationService', validationService);

  /** @ngInject */
  function validationService() {

        var obj = {};

        obj.verifyPhoneFormat = function (phoneNo) {
            //var expression1 = /^0\(?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            var expression1 = /^([0-9]{2})([0-9]{3})([0-9]{4}|[0-9]{5})$/;
            return expression1.test(phoneNo);

        };

        obj.verifyEmailFormat = function (email) {
            var expression2 = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            return expression2.test(email);
        };

        obj.verifyAliasName = function (value) {
            var expression3 = /^([a-zA-Z0-9\s]){1,20}$/;
            return expression3.test(value);
        };
        obj.isEmptyOrNullValidation = function (value) {
            if (value === undefined || value === "" || value === null || value === "null") {
                return false
            } else {
                return true;
            }
        };

        obj.hasSpaces = function (value) {
            var expression4 = /^[a-zA-Z0-9_\-]+$/;
            return expression4.test(value);
        };

        //Checks that a password has a minimum of 6 characters, at least 1 uppercase letter, 1 lowercase letter, and 1 number with no spaces.
        obj.verifyPasswordPolicy = function (value){
            var expression5 = /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{6,})\S$/;
            return expression5.test(value);
        };

        obj.verifyDate = function(value){
            // var expression6 = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
            // return expression6.test(value);
            return !isNaN( Date.parse( value ) );
        };

        obj.compareDates= function(value1,value2){
            return value1.getTime()<value2.getTime()? true:false;

        };

        return obj;

      }

      })();

/**
 * @author dufrolabs
 * created on 29/06/2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('localStorage', localStorage);

  /** @ngInject */
  function localStorage($window) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear
    }

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage ? $window.localStorage[key] || defaultValue : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = angular.toJson(value);
      } else {
        $window.localStorage[key] = angular.toJson(value);
      }
    }

    function getObject(key) {
      return !$window.fakeLocalStorage ? angular.fromJson($window.localStorage[key] || '{}') : angular.fromJson($window.fakeLocalStorage[key] || '{}');
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        $window.localStorage.clear();
      }
    }
  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('receiptService', receiptService);

  /** @ngInject */
  function receiptService(Receipts) {

  var getReceipts = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Receipts.find({
      filter: {
        where:{
          id: obj.params.receiptid
        }
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  return {
    getReceipts: getReceipts

  };
}

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('rolemappingService', rolemappingService);

  /** @ngInject */
  function rolemappingService(RoleMapping) {

    var getRoleMappings = function(obj) {
      RoleMapping.find({
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getRoleMappingsbyID = function (obj) {
      RoleMapping.find({
        filter: {
          where: {
            and: [
              { principalId: obj.params.principalid },
              { principalType: "RoleMapping.USER" }
            ],
            include: ["role"]
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };
  
    var createRoleMapping = function(obj) {
      var date = new Date();
  
      RoleMapping.create({
        principalType: "RoleMapping.USER",
        principalId: obj.params.userid,
        roleId:obj.params.roleid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
  
    var deleteRoleMapping = function(obj) {
  
      RoleMapping.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
    var saveRoleMapping = function(obj) {
      var date = new Date();
  
      RoleMapping.prototype$updateAttributes({
        id: obj.params.id,
        principalType: "RoleMapping.USER",
        principalId: obj.params.userid,
        roleId:obj.params.roleid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
    return {
      getRoleMappings: getRoleMappings,
      createRoleMapping: createRoleMapping,
      deleteRoleMapping: deleteRoleMapping,
      saveRoleMapping: saveRoleMapping,
      getRoleMappingsbyID:getRoleMappingsbyID
    };
}

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .factory('SheetJSExportService', SheetJSExportService);


  /** @ngInject */
    SheetJSExportService.inject = ['uiGridExporterService'];
        })();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('userService', userService);

  /** @ngInject */
  function userService(User) {

  var userLogin = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    User.login({
      username: obj.params.username,
      password: obj.params.password
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var userSignup = function(obj) {
    var date = new Date();
    User.create({
      realm: "vip",
      username: obj.params.username,
      password: obj.params.password,
      credentials: obj.params.credentials,
      email: obj.params.credentials.mobile + "@vip-portal.com",
      emailVerified: false,
      status: "Active",
      created: date,
      lastUpdated: date,
      challenges:obj.params.challenges?obj.params.challenges:null

    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  var partnerSignup = function(obj) {
    var date = new Date();
    User.create({
      realm: "vip",
      username: obj.params.username,
      password: obj.params.password,
      credentials: obj.params.credentials,
      email: obj.params.username + "@vip-portal.com",
      emailVerified: false,
      status: "Active",
      created: date,
      lastUpdated: date,
      challenges:obj.params.challenges?obj.params.challenges:null

    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  
  var collectorSignup = function(obj) {
    var date = new Date();
    User.create({
      realm: "vip",
      username: obj.params.username,
      password: obj.params.password,
      credentials: obj.params.credentials,
      email: obj.params.username + "@vip-portal.com",
      emailVerified: false,
      status: "Active",
      created: date,
      lastUpdated: date,
      challenges:obj.params.challenges?obj.params.challenges:null

    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  var userApproval = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    User.find({
      filter: {
        where: {
          emailVerified: false
        }
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data)

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err)
    })
  }

  var userAccessApproved = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    console.log(obj.params.userId, obj.params.userId);
    User.prototype$updateAttributes({
      id: obj.params.userId,
      emailVerified: true
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data)

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err)
    })
  }


  var getUsers = function(obj) {
    User.find({
      filter:{
        where:{
          realm:"vip"
        },
        include: ["roles"]
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  var getParterUsers = function(obj) {
    User.find({
      filter:{
        where:{
          and:[
            {realm:"vip"},
            {challenges: obj.params.parentid}
          ]
        },
        include: "roles"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };
//emailVerified: true
  var getUsersMSync = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    User.find({
      filter:{
        where:{
          and:[
            {realm: "msync"},
            {emailVerified: "true"}
          ]
        },
        include: "roles"
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);
    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var getUsersCSync = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    User.find({
      filter:{
        where:{
          and:[
            {realm: "csync"},
            {emailVerified: "true"}
          ]
        },
        include: "roles"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  var getUsersCSyncVIP = function(obj) {

    User.find({
      filter:{
        where:{
          and:[
            {or:[
              {realm: "csync"},
              {realm: "vip"}
            ]},
            {emailVerified: "true"}
          ]
        },
        include: "roles"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };


  var deleteUser = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    User.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };
  var saveUser = function(obj) {
    var date = new Date();

    User.prototype$updateAttributes({
      id: obj.params.id,
      password: obj.params.password,
      credentials: obj.params.credentials,
      emailVerified: obj.params.emailVerified,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  var resetPassword = function(obj) {
    var date = new Date();
    
    User.prototype$updateAttributes({
      id: obj.params.id,
      password: obj.params.password,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  var updateShopMap = function(obj) {
    var date = new Date();

    User.prototype$updateAttributes({
      id: obj.params.id,
      credentials: obj.params.credentials,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      ////$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var getUsersFromList = function(obj) {

    User.find({
      filter:{
        where:{
          and:[
            {realm:"csync"},
            {id:{inq:obj.params.userIDs}}
          ]          
        },
        include:["roles"]
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  return {
    userLogin: userLogin,
    userSignup: userSignup,
    userApproval: userApproval,
    userAccessApproved: userAccessApproved,
    getUsers: getUsers,
    getUsersMSync: getUsersMSync,
    getUsersCSync: getUsersCSync,
    deleteUser:deleteUser,
    updateShopMap: updateShopMap,
    saveUser:saveUser,
    getParterUsers: getParterUsers,
    partnerSignup: partnerSignup,
    resetPassword: resetPassword,
    getUsersCSyncVIP: getUsersCSyncVIP,
    collectorSignup: collectorSignup,
    getUsersFromList:getUsersFromList
    

  };
}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive("importSheetJs", [SheetJSImportDirective]);


  /** @ngInject */


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector')
    .controller('CollectorPageCtrl', CollectorPageCtrl);

  /** @ngInject */
  function CollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    collectorService, toastr, $uibModal, userService,zoneService, $rootScope) {
    console.log("Inside CollectorPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCollector(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Collector List
    $scope.manageParentCollectorList = [];
    $scope.initManageParentCollector = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentCollectorList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      collectorService.getParentCollector(obj);
    };
    
     $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            console.log('Inside Zonemap');
             for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
               var zonelist = $filter('filter')(result, {
                 id: $rootScope.userData.credentials.zonemap[index]
               }, true);
               console.log('zonelist',zonelist);
   
               $scope.manageZonesList.push(zonelist[0]);
             }
           }else{
             $scope.manageZonesList = result;
           }
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
  
    };
    $scope.init = function (){
      $scope.initManageParentCollector();
      $scope.initManageStates();

    };
    $scope.init();


    $scope.manageCollector = {};
    $scope.manageCollectorList = [];
    $scope.reportFilter={};
    $scope.initManageCollector = function (reportFilter) {
      $scope.initManageParentCollector();
      // $scope.initManageStates();
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCollectorList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      collectorService.getCollector(obj);
    };
    $scope.initManageCollector($scope.reportFilter);
    // $scope.initManageStates();
    
    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.manageCollectorList.push($scope.inserted);
    };

    $scope.createCollector = function (manageCollector) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createCollector");
      console.log(manageCollector);
      console.log(manageCollector.name);
      console.log(manageCollector.code);
      console.log(manageCollector.contact);
      //console.log(manageCollector.description);

      var obj = {};
      obj.params = {};
      obj.params.name = manageCollector.name;
      obj.params.code = manageCollector.code;
      obj.params.contact = manageCollector.contact;
      obj.params.parentid = manageCollector.parent?manageCollector.parent.id:null;
      obj.params.zones = manageCollector.zones?manageCollector.zones:null;
      // obj.params.isparent = manageCollector.isparent.value === 'Yes' ? true : false;
      obj.params.isparent = manageCollector.isparent;
      //obj.params.description = manageCollector.description;
      console.log('obj.params',obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCollector = {};
        toastr.success('New Collector has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Collector successfully created.");
        $scope.initManageCollector($scope.reportFilter);

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      collectorService.createCollector(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/account/collector/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteCollector = function (res) {
      console.log("Inside deleteCollector");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Collector has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageCollector($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        collectorService.deleteCollector(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (collector) {
      console.log("Inside editCollector");
      console.log(collector);
      // $scope.manageCollector.id = $scope.manageCollector.id;
      // $scope.manageCollector.name = state.name;
      // $scope.manageCollector.description = state.description;
      // $scope.manageCollector.created = state.created;
      // $scope.manageCollector.lastupdated = state.lastupdated;
      $scope.manageCollector = collector;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveCollector = function (manageCollector, id) {

      console.log("Inside saveCollector");
      console.log(manageCollector);
      console.log(id);

      if (id === undefined) {
        $scope.createCollector(manageCollector);
      } else {

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = manageCollector.name;
        obj.params.code = manageCollector.code;
        obj.params.contact = manageCollector.contact;
        obj.params.parentid = manageCollector.parent?manageCollector.parent.id:null;
        //obj.params.userid = manageCollector.userid?manageCollector.userid:null;
        obj.params.isparent = manageCollector.isparent;
        obj.params.zones = manageCollector.zones?manageCollector.zones:null;
        
        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageCollector = {};
          toastr.success('Collector has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageCollector($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        collectorService.saveCollector(obj);

      }

    };
    $scope.showStatus = function() {
      var selected = $filter('filter')($scope.statuses, {value: $scope.user.status});
      return ($scope.user.status && selected.length) ? selected[0].text : 'Not set';
    };

    $scope.userAccess = function(manageCollector){
      console.log('Inside userAccess');
      console.log('manageCollector',manageCollector);

      var obj = {};
      obj.params = {};
      obj.params.username = manageCollector.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=manageCollector.name;
      obj.params.credentials.mobile=manageCollector.contact?manageCollector.contact:null;
      obj.params.credentials.role = manageCollector.isparent?7:8;
      obj.params.credentials.collector = manageCollector;
      obj.params.challenges = manageCollector.parentid;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageCollector.userid = result.id;
        $scope.saveCollector(manageCollector,manageCollector.id);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.collectorSignup(obj);

      };
      
      $scope.showZones = function(zones) {
        if (zones && $scope.manageZonesList.length) {
          var selected = $filter('filter')($scope.manageZonesList, {
            id: zones
          },true);
          return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
        } else return 'Not set';
      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector')
    .service('collectorService', collectorService);

  /** @ngInject */
  function collectorService(Collector) {
    var getCollector = function (obj) {
      if (obj.params.zoneid != null) {
      Collector.find({
        filter: {
          where:{
            zoneid:obj.params.zoneid.length>0?{inq:obj.params.zoneid}:obj.params.zoneid
          },
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    } else {
      
      Collector.find({
        filter: {
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    }
  };
    var getParentCollector = function (obj) {

      Collector.find({
        filter: {
          where: {
            isparent: true
          },
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getCollectorStaff = function (obj) {

      Collector.find({
        filter: {
          where: {
            parentid: obj.params.parentid
          },
          include: ["user"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createCollector = function (obj) {
      var date = new Date();

      Collector.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid,
        zoneid: obj.params.zones

      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteCollector = function (obj) {

      Collector.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveCollector = function (obj) {
      var date = new Date();

      Collector.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid,
        zoneid: obj.params.zones
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var unbindCollector = function (obj) {
      var date = new Date();

      Collector.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getCollector: getCollector,
      createCollector: createCollector,
      deleteCollector: deleteCollector,
      saveCollector: saveCollector,
      getParentCollector: getParentCollector,
      unbindCollector: unbindCollector,
      getCollectorStaff: getCollectorStaff
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner')
    .controller('PartnerPageCtrl', PartnerPageCtrl);

  /** @ngInject */
  function PartnerPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnerService, toastr, $uibModal, userService, zoneService, $rootScope) {
    console.log("Inside PartnerPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deletePartner(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.reportFilter={};
    $scope.initManagePartner = function (reportFilter){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            console.log('Inside Zonemap');
             for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
               var zonelist = $filter('filter')(result, {
                 id: $rootScope.userData.credentials.zonemap[index]
               }, true);
               console.log('zonelist',zonelist);
   
               $scope.manageZonesList.push(zonelist[0]);
             }
           }else{
             $scope.manageZonesList = result;
           }
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManagePartner($scope.reportFilter);

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Partner List
    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentPartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getParentPartner(obj);
    };

    $scope.managePartner = {};
    $scope.managePartnerList = [];
    $scope.reportFilter={};
    $scope.initManagePartner = function (reportFilter) {
      $scope.initManageParentPartner();
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner($scope.reportFilter);

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.managePartnerList.push($scope.inserted);
    };

    $scope.createPartner = function (managePartner) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createPartner");
      console.log(managePartner);
      console.log(managePartner.name);
      console.log(managePartner.code);
      console.log(managePartner.contact);
      //console.log(managePartner.description);

      var obj = {};
      obj.params = {};
      obj.params.name = managePartner.name;
      obj.params.code = managePartner.code;
      obj.params.contact = managePartner.contact;
      obj.params.parentid = managePartner.parent?managePartner.parent.id:null;
      // obj.params.isparent = managePartner.isparent.value === 'Yes' ? true : false;
      obj.params.isparent = managePartner.isparent;
      obj.params.zoneid = managePartner.zoneid?managePartner.zoneid:null;
      //obj.params.name = managePartner.name?manageZones.name.zones:null;
      //obj.params.description = managePartner.description;
      console.log('obj.params',obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartner = {};
        toastr.success('New Partner has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Partner successfully created.");
        $scope.initManagePartner($scope.reportFilter);

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      partnerService.createPartner(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/account/partner/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deletePartner = function (res) {
      console.log("Inside deletePartner");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Partner has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManagePartner($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        partnerService.deletePartner(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (partner) {
      console.log("Inside editPartner");
      console.log(partner);
      // $scope.managePartner.id = $scope.managePartner.id;
      // $scope.managePartner.name = state.name;
      // $scope.managePartner.description = state.description;
      // $scope.managePartner.created = state.created;
      // $scope.managePartner.lastupdated = state.lastupdated;
      $scope.managePartner = partner;
      $scope.manageZones = zoneid;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.savePartner = function (managePartner, id) {

      console.log("Inside savePartner");
     // console.log("Inside saveZones");
      console.log(managePartner);
      console.log(id);

      if (id === undefined) {
        $scope.createPartner(managePartner);
        //$scope.createZones(manageZones);
      } else {

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = managePartner.name;
        //obj.params.name = manageZones.name;
        obj.params.code = managePartner.code;
        obj.params.contact = managePartner.contact;
        obj.params.parentid = managePartner.parent?managePartner.parent.id:null;
        //obj.params.userid = managePartner.userid?managePartner.userid:null;
        obj.params.isparent = managePartner.isparent;
        obj.params.zoneid = managePartner.zoneid?managePartner.zoneid:null;

        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartner = {};
          //$scope.manageZones = {};
          toastr.success('Partner has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManagePartner($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnerService.savePartner(obj);

      }

    }
    $scope.qrString = "";
    $scope.viewQRcode = function (code){
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/account/partner/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function(){
      window.print();
    };

    $scope.showStatus = function() {
      var selected = $filter('filter')($scope.statuses, {value: $scope.user.status});
      return ($scope.user.status && selected.length) ? selected[0].text : 'Not set';
    };

    $scope.userAccess = function(managePartner){
      console.log('Inside userAccess');
      console.log('managePartner',managePartner);

      var obj = {};
      obj.params = {};
      obj.params.username = managePartner.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=managePartner.name;
      obj.params.credentials.mobile=managePartner.contact?managePartner.contact:null;
      obj.params.credentials.role = managePartner.isparent?9:13;
      obj.params.credentials.partner = managePartner;
      obj.params.challenges = managePartner.parentid;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        managePartner.userid = result.id;
        $scope.savePartner(managePartner,managePartner.id);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

      };

      $scope.showZones = function(zones) {
        if (zones && $scope.manageZonesList.length) {
          var selected = $filter('filter')($scope.manageZonesList, {
            id: zones
          },true);
          return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
        } else return 'Not set';
      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner')
    .service('partnerService', partnerService);

  /** @ngInject */
  function partnerService(Partner) {
    var getPartner = function (obj) {
      if (obj.params.zoneid != null) {
      Partner.find({
        filter: {
          where:{
            zoneid:obj.params.zoneid.length>0?{inq:obj.params.zoneid}:obj.params.zoneid
          },
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    }else{      
      Partner.find({
      filter: {
        include: ["user","parent"]
      }
    }).$promise.then(function (data) {
      obj.onSuccess(data);
    }, function (err) {
      obj.onFailure(err);
    });

    }
    };

    var getParentPartner = function (obj) {

      Partner.find({
        filter: {
          where: {
            isparent: true
          },
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getPartnerStaff = function (obj) {

      Partner.find({
        filter: {
          where: {
            parentid: obj.params.parentid
          },
          include: ["user"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createPartner = function (obj) {
      var date = new Date();

      Partner.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deletePartner = function (obj) {

      Partner.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var savePartner = function (obj) {
      var date = new Date();

      Partner.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        zoneid: obj.params.zoneid



      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var unbindPartner = function (obj) {
      var date = new Date();

      Partner.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    return {
      getPartner: getPartner,
      createPartner: createPartner,
      deletePartner: deletePartner,
      savePartner: savePartner,
      getParentPartner: getParentPartner,
      unbindPartner: unbindPartner,
      getPartnerStaff: getPartnerStaff
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier')
    .controller('SupplierPageCtrl', SupplierPageCtrl);

  /** @ngInject */
  function SupplierPageCtrl($scope, $filter, editableOptions, editableThemes,
    supplierService, toastr, $uibModal,userService, zoneService, $rootScope) {
    console.log("Inside SupplierPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteSupplier(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.reportFilter={};
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            console.log('Inside Zonemap');
             for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
               var zonelist = $filter('filter')(result, {
                 id: $rootScope.userData.credentials.zonemap[index]
               }, true);
               console.log('zonelist',zonelist);
   
               $scope.manageZonesList.push(zonelist[0]);
             }
           }else{
             $scope.manageZonesList = result;
           }
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates($scope.reportFilter);

   
    $scope.manageSupplier = {};
    $scope.manageSupplierList = [];
    $scope.reportFilter={};
    $scope.initManageStates = function(reportFilter) {
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
        }
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates($scope.reportFilter);

    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.manageSupplierList.push($scope.inserted);
    };

    $scope.createSupplier = function(manageSupplier) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createSupplier");
      console.log(manageSupplier);
      console.log(manageSupplier.name);
      console.log(manageSupplier.code);
      console.log(manageSupplier.contact);
      //console.log(manageSupplier.description);

      var obj = {};
      obj.params = {};
      obj.params.name = manageSupplier.name;
      obj.params.code = manageSupplier.code;
      obj.params.contact = manageSupplier.contact;
      obj.params.rate = manageSupplier.rate;
      obj.params.zones = manageSupplier.zones?manageSupplier.zones:null;
      //obj.params.description = manageSupplier.description;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplier = {};
        toastr.success('New Supplier has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Supplier successfully created.");
        $scope.initManageStates($scope.reportFilter);

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      supplierService.createSupplier(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/account/supplier/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteSupplier = function(res) {
      console.log("Inside deleteSupplier");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Supplier has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageStates($scope.reportFilter);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.deleteSupplier(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(supplier) {
      console.log("Inside editSupplier");
      console.log(supplier);
      // $scope.manageSupplier.id = $scope.manageSupplier.id;
      // $scope.manageSupplier.name = state.name;
      // $scope.manageSupplier.description = state.description;
      // $scope.manageSupplier.created = state.created;
      // $scope.manageSupplier.lastupdated = state.lastupdated;
      $scope.manageSupplier = supplier;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveSupplier = function(manageSupplier, id) {

      console.log("Inside saveSupplier");
      console.log(manageSupplier);
      console.log(id);

      if (id === undefined && manageSupplier.id === undefined) {
        $scope.createSupplier(manageSupplier);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSupplier;
        obj.params.id = id?id:manageSupplier.id;
        obj.params.zones = manageSupplier.zones?manageSupplier.zones:null;
        //obj.params.contact = manageSupplier.contact;
        // obj.params.name = $scope.manageSupplier.name;
        // obj.params.description = $scope.manageSupplier.description;
        //obj.params.created = $scope.manageSupplier.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates($scope.reportFilter);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.saveSupplier(obj);

        //$scope.modal.hide();
      }

    };

    $scope.userAccess = function(manageSupplier){
      console.log('Inside userAccess');
      console.log('manageSupplier',manageSupplier);

      var obj = {};
      obj.params = {};
      obj.params.username = manageSupplier.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=manageSupplier.name;
      obj.params.credentials.mobile=manageSupplier.contact?manageSupplier.contact:null;
      obj.params.credentials.role = 10; //Supplier Role id
      obj.params.credentials.supplier = manageSupplier;
      //obj.params.challenges = manageSupplier.id;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageSupplier.userid = result.id;
        $scope.saveSupplier(manageSupplier);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

      };

      $scope.showZones = function(zones) {
        if (zones && $scope.manageZonesList.length) {
          var selected = $filter('filter')($scope.manageZonesList, {
            id: zones
          },true);
          return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
        } else return 'Not set';
      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier')
    .service('supplierService', supplierService);

  /** @ngInject */
  function supplierService(Supplier) {
    var getSupplier = function(obj) {
      if (obj.params.zoneid != null && typeof obj.params.zoneid !== "undefined") {
      Supplier.find({
        filter: {
          where:{
            zoneid:obj.params.zoneid.length>0?{inq:obj.params.zoneid}:obj.params.zoneid
          },
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    }else{
      Supplier.find({
        filter: {
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });

    }
  };

    var createSupplier = function(obj) {
      var date = new Date();

      Supplier.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        rate: obj.params.rate,
        zoneid: obj.params.zones

      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };


    var deleteSupplier = function(obj) {

      Supplier.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveSupplier = function(obj) {
      var date = new Date();

      Supplier.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        rate: obj.params.rate,
        userid: obj.params.userid,
        zoneid: obj.params.zones
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var unbindSupplier = function (obj) {
      var date = new Date();

      Supplier.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getSupplier: getSupplier,
      createSupplier: createSupplier,
      deleteSupplier: deleteSupplier,
      saveSupplier: saveSupplier,
      unbindSupplier:unbindSupplier
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping')
    .controller('UsermappingPageCtrl', UsermappingPageCtrl);

  /** @ngInject */
  function UsermappingPageCtrl($scope, $filter, editableOptions, editableThemes,
    usermappingService, toastr, $uibModal, userService, roleService, zoneService, areaService) {
    console.log("Inside UsermappingPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUsermapping(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //Getting States
    $scope.manageUserList = [];
	$scope.manageRoleList = [];
	$scope.manageAreaList = [];
    $scope.manageZonesList = [];
    
	$scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsers(obj);
    };

    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
	
	$scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
	
	$scope.initManageArea = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageUsermappingList = [];
    $scope.manageUsermapping = {};
    $scope.initManageUsermapping = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsermappingList = result;
        $scope.initManageUser();
		$scope.initManageRole();
		$scope.initManageArea();
        $scope.initManageZones();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      usermappingService.getUsermapping(obj);
    };
    $scope.initManageUsermapping();

    $scope.addUsermapping = function() {
      //genericModalService.show('modules/modals/addUsermapping.html',$scope);
      $scope.inserted = {
        //name: null,
        //description: null,
      };
      $scope.manageUsermappingList.push($scope.inserted);
    };

    $scope.createUsermapping = function(manageUsermapping) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUsermapping");
      console.log(manageUsermapping);

      var obj = {};
      obj.params = {};
      obj.params = manageUsermapping;
      // obj.params.name = manageUsermapping.name;
      // obj.params.description = manageUsermapping.description;
      // obj.params.zoneid = manageUsermapping.zones
      // obj.params.stateid = manageUsermapping.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsermapping = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageUsermapping();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      usermappingService.createUsermapping(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/account/usermapping/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteUsermapping = function(res) {
      console.log("Inside deleteUsermapping");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          $scope.initManageUsermapping();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        usermappingService.deleteUsermapping(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(usermapping) {
      console.log("Inside editArea");
      console.log(usermapping);
      // $scope.manageUsermapping.id = $scope.manageUsermapping.id;
      // $scope.manageUsermapping.name = state.name;
      // $scope.manageUsermapping.description = state.description;
      // $scope.manageUsermapping.created = state.created;
      // $scope.manageUsermapping.lastupdated = state.lastupdated;
      $scope.manageUsermapping = state;
      genericModalService.show('modules/modals/addUsermapping.html', $scope);
    }

    $scope.saveUsermapping = function(manageUsermapping, id) {

      console.log("Inside saveUsermapping");
      console.log(manageUsermapping);
      console.log(id);

      console.log(manageUsermapping.zones);
      console.log(manageUsermapping.role);
	  console.log(manageUsermapping.user);
	  console.log(manageUsermapping.area);


      if (id === undefined) {
        $scope.createUsermapping(manageUsermapping);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageUsermapping;
        obj.params.id = id;
        // obj.params.name = $scope.manageUsermapping.name;
        // obj.params.description = $scope.manageUsermapping.description;
        //obj.params.created = $scope.manageUsermapping.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsermapping = {};
          toastr.success('Area has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageUsermapping();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        usermappingService.saveUsermapping(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showUsers = function(user) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (user && $scope.manageUserList.length) {
        var selected = $filter('filter')($scope.manageUserList, {
          id: user.id
        },true);
        return selected.length ? selected[0].username : 'Not set';
      } else return 'Not set'
    };
	
	$scope.showRoles = function(role) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (role && $scope.manageRoleList.length) {
        var selected = $filter('filter')($scope.manageRoleList, {
          id: role.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };
	
	$scope.showAreas = function(area) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (area && $scope.manageAreaList.length) {
        var selected = $filter('filter')($scope.manageAreaList, {
          id: area.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping')
    .service('usermappingService', usermappingService);

  /** @ngInject */
  function usermappingService(Usermapping) {
    var getUsermapping = function(obj) {

    Usermapping.find({
      filter:{
        include:["user","zone","role","area"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var createUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Usermapping.create({
      userid: obj.params.user,
	  zoneid: obj.params.zone,
	  areaid: obj.params.area,
	  roleid: obj.params.role
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Usermapping.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});


    Usermapping.prototype$updateAttributes({
      id: obj.params.id,
      userid: obj.params.user,
	  zoneid: obj.params.zone,
	  areaid: obj.params.area,
	  roleid: obj.params.role
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getUsermapping: getUsermapping,
      createUsermapping: createUsermapping,
      deleteUsermapping: deleteUsermapping,
      saveUsermapping: saveUsermapping
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailyinvoices')
    .service('dailyInvoiceCollectorService', dailyInvoiceCollectorService);

  /** @ngInject */
  function dailyInvoiceCollectorService(Invoice) {
    var getInvoice = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);
      
      Invoice.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getDailyInvoiceWithSales = function(obj) {

      var days = obj.params.days?obj.params.days:1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);
      
      Invoice.getDailyInvoiceWithSales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        ispaid: obj.params.ispaid?obj.params.ispaid:null

      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getInvoiceByZone = function(obj) {     
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);
      
      Invoice.find({
        filter: {
          where:{
            and:[
              {indate: {gte: dailyDate}},
              {zoneid: obj.params.zoneselection}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
          
    var getInvoiceByKey = function(obj) {

      Invoice.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          }
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createInvoice = function(obj) {

      var date = new Date();

      Invoice.createMany(
        obj.params
      
      ).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };


    var deleteInvoice = function(obj) {
      Invoice.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveInvoice = function(obj) {
      var date = new Date();

      Invoice.prototype$updateAttributes({
        id: obj.params.id,
        onlineshorts: obj.params.onlineshorts,
        machineshorts: obj.params.machineshorts,
        lastupdated: date
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var payInvoice = function(obj) {

      var date = new Date();

      Invoice.prototype$updateAttributes({
        id: obj.params.id,
        ispaid: true,
        lastupdated: date,
        pdate: date,
        agentid: obj.params.agentid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getInvoice: getInvoice,
      getInvoiceByZone: getInvoiceByZone,
      getInvoiceByKey: getInvoiceByKey,
      createInvoice: createInvoice,
      deleteInvoice: deleteInvoice,
      saveInvoice: saveInvoice,
      getDailyInvoiceWithSales:getDailyInvoiceWithSales,
      payInvoice: payInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailyinvoices')
    .controller('dailyinvoicesCollectorPageCtrl', dailyinvoicesCollectorPageCtrl);

  /** @ngInject */
  function dailyinvoicesCollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailyInvoiceCollectorService, onlineShopService, gameService, shopService, zoneService, partnerService, 
    dailyonlinesalesreportService, dailymachinesalesreportService, toastr, $uibModal, userService, $rootScope,assigncollectorService) {
    console.log("Inside dailyinvoicesCollectorPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteInvoice(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.total = {};
    // $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];
    $scope.paidFilter = [{value:'PAID'},{value:'UNPAID'}];
    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    //get zone table data
    // $scope.zoneselection = -99;


    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();


    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.manageUsersList = [];
    $scope.initManageUsers = function() {

      if ($rootScope.userData.roleId===7){
        console.log('Inside initManageOfficers');
        console.log('$rootScope.userData.id', $rootScope.userData.id);
  
        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;
  
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);
  
          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log('userIDs', userIDs);
  
            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;
  
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageUsersList = result;
              console.log($scope.manageCollectorsList);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);
  
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      }else{
        var obj = {};
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsersList = result;
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSyncVIP(obj);
      }

    };
    $scope.initManageUsers();

    $scope.initManageInvoice = function () {
      $scope.isEdit = false;
    };

    $scope.manageDailyinvoices = {};
    $scope.manageDailyinvoicesList = [];
    $scope.totalSalesLabel = 0;
    $scope.reportFilter={};

    $scope.searchAllinvoices = function (reportFilter) {
      console.log("Inside searchAllinvoices");
      console.log('reportFilter',reportFilter);
      
      var obj = {};
      obj.params={};
      obj.params.ispaid=reportFilter.ispaid?reportFilter.ispaid.value:null;
      obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;

      if (typeof $rootScope.userData.credentials.days !== "undefined") {
        console.log('$rootScope.userData.credentials.days',$rootScope.userData.credentials.days);
        obj.params.days=$rootScope.userData.credentials.days?$rootScope.userData.credentials.days:1;
      }

      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }

      obj.onSuccess = function (result) {
        console.log("Inside getAllZoneSales SUCCESS");
       
        $scope.manageDailyinvoicesList = result.result;
        console.log('$scope.manageDailyinvoicesList', $scope.manageDailyinvoicesList);
        $scope.totalSalesLabelFooter = 0;
        $scope.mSalesTotal = 0;
        $scope.oSalesTotal = 0;
        if ($scope.manageDailyinvoicesList){
          for (var index = 0; index < $scope.manageDailyinvoicesList.length; index++) {
            $scope.manageDailyinvoicesList[index].totalsales = parseFloat($scope.manageDailyinvoicesList[index].mcsales) + parseFloat($scope.manageDailyinvoicesList[index].ocsales);
            $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat( $scope.manageDailyinvoicesList[index].totalsales);
            $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.manageDailyinvoicesList[index].mactotal);
            $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.manageDailyinvoicesList[index].ontotal);
          }
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside getAllZoneSales Failure");
        console.log(err);
      };
      dailyInvoiceCollectorService.getDailyInvoiceWithSales(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/collectors/dailyinvoices/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteInvoice = function (res) {
      console.log("Inside deleteInvoice");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Invoice has been deleted successfully!', 'SUCCESS');
          //$scope.initManageStates();
          $scope.initManageInvoice();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyInvoiceCollectorService.deleteInvoice(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isEdit = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      console.log($scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices);

    };

    $scope.saveInvoice = function (id) {
      console.log("Inside saveInvoice");
      //console.log(itemInvoice);
      console.log(id);
        var obj = {};
        obj.params = {};
        obj.params.machineshorts = $scope.manageDailyinvoices.machineshorts;
        obj.params.onlineshorts = $scope.manageDailyinvoices.onlineshorts;
        obj.params.id = id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageDailyinvoices = result;
          toastr.success('Invoice has been updated successfully!', 'SUCCESS');
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyInvoiceCollectorService.saveInvoice(obj);
    }

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.onlineInvoiceDetails = result;

        if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
          console.log('Inside Empty MachineShop');
          $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        }
        $scope.total.online = 0;
        $scope.total.onlineST = 0;
        var online = 0;
        if ($scope.onlineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
            online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
          }
          $scope.total.online = online;
          $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    }
    $scope.ddmmyyyy = function(date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('');
    };
    $scope.getMachineSales = function (manageDailyinvoices) {
      
      var obj = {};
      obj.params = {};
      // if (manageDailyinvoices.shop.shoptype==="100%"){
      //   var date = new Date(manageDailyinvoices.indate);
      //   var d = $scope.ddmmyyyy(date);
      //   var tempikey = manageDailyinvoices.shop.id+''+d
      //   console.log('tempikey',tempikey);
      //   obj.params.ikey = tempikey;
      // }else{
      //   obj.params.ikey = manageDailyinvoices.ikey;
      // }
      obj.params.ikey = manageDailyinvoices.ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
          console.log('Inside Empty OnlineShop');
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }
        $scope.total.machine = 0;
        $scope.total.machineST = 0;
        var machine = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse($scope.machineInvoiceDetails[i].receipt.content);
          }
          $scope.total.machine = machine;
          $scope.total.machineST = machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      }

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }
    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageDailyinvoices) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageDailyinvoices.shop && $scope.managePartnerList.length) {
        console.log($scope.manageDailyinvoices);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageDailyinvoices.shop.partnerid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };

    $scope.saveShorts = function(){
      console.log($scope.manageDailyinvoices.machineshorts);
      console.log($scope.total.machineST);

      console.log($scope.manageDailyinvoices.onlineshorts);
      console.log($scope.total.onlineST);
      $scope.saveInvoice($scope.manageDailyinvoices.id);
      //$scope.total.machineST = $scope.total.machine + parseFloat($scope.manageDailyinvoices.machineshorts);
      //console.log($scope.total.machineST);
      $scope.initManageInvoice();
      $scope.manageDailyinvoices = {};

    }

    $scope.print = function () {
      window.print();
    };

    $scope.showUserById = function (userid) {
      if (userid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: userid
        }, true);
        if (selected.length)
        return selected.length ? (selected[0].credentials.name ? selected[0].credentials.name : selected[0].credentials.firstName+" "+selected[0].credentials.lastName) : '';
        
        // selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return '';
    };

    $scope.openPayNow = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.payInvoice(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.payNowId = null;
    $scope.confirmPayNow = function (id) {
      $scope.openPayNow('app/pages/collectors/dailyinvoices/modals/PayNowModal.html');
      $scope.payNowId = id;
    };

    $scope.payInvoice = function(res){
      console.log("Inside payInvoice");
      if (res) {
        console.log('Sure!');
        console.log($scope.payNowId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.payNowId;
        obj.params.agentid = $rootScope.userData.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS payInvoice");
          toastr.success('Invoice Payment Received', 'SUCCESS');
          $scope.searchAllinvoices($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure payInvoice");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyInvoiceCollectorService.payInvoice(obj);
      } else {
        console.log('Not sure!');
      }
    };

        //Group Totals
        $scope.getTotalmcsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.mcsales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotalocsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.ocsales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotaltotalsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.totalsales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotalpsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.psales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotalcsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.csales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };


  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailymachinesales')
    .controller('DailymachinesalesCollectorPageCtrl', DailymachinesalesCollectorPageCtrl);

  /** @ngInject */
  function DailymachinesalesCollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachinesalesCollectorService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, 
    $uibModal, receiptService,  $rootScope, zoneService, userService) {
    console.log("Inside DailymachinesalesCollectorPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageGames");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure initManageGames");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.init = function(){
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
    };
    $scope.init();
    $scope.reportFilter={};
    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.getDailyMachinesales = function(reportFilter) {
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }
      if (reportFilter.agent){
        obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
      }
      if (reportFilter.daynight){
        obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
      }
      if (typeof $rootScope.userData.credentials.days !== "undefined") {
        obj.params.days=$rootScope.userData.credentials.days?$rootScope.userData.credentials.days:1;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.totalSalesLabel = 0;
        $scope.manageMachinesalesList = result.result;
        for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesCollectorService.getDailyMachinesales(obj);
    };
    //$scope.getDailyMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/collectors/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachinesalesCollectorService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        dailymachinesalesCollectorService.saveMachinesales(obj);
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function(manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code){
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/collectors/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function(gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function(machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function(manageMachinesales) {
      if (manageMachinesales&& $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        },true);
        return selected.length ? selected[0].code+', '+selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };
    

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate,1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);
             
              console.log('checkInDate',checkInDate);
              console.log('resultInDate',resultInDate);

              if (checkInDate>=resultInDate){
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else{
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesCollectorService.generateInvoice(obj);
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

  }

})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailymachinesales')
    .service('dailymachinesalesCollectorService', dailymachinesalesCollectorService);

  /** @ngInject */
  function dailymachinesalesCollectorService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();
  
    //   var dailyDate = year+'-'+month+'-'+day;
  
    //   console.log('date',dailyDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };


    var getDailyMachinesales = function(obj) {

      var days = obj.params.days?obj.params.days:1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.getDailyMachinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        shopid: obj.params.shopid?obj.params.shopid:null,
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync.assigncollector')
    .controller('AssigncollectorPageCtrl', AssigncollectorPageCtrl);

  /** @ngInject */
  function AssigncollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    assigncollectorService, toastr, $uibModal, userService, shopService, validationService, $rootScope) {
    console.log("Inside AssigncollectorPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


    $scope.smartTablePageSize = 100;
    $scope.totalSalesLabel = 0;
    $scope.isAgentView = false;

    $scope.manageCollector = {};
    $scope.manageCollectorsList = [];
    // $scope.initManageOfficers = function() {
    //   var obj = {};

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageCollectorsList = result;
    //     $scope.initManageShops();
    //     $scope.isEdit = false;
    //     $scope.isAssignNewShop = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   userService.getUsersCSync(obj);
    // };
    $scope.initManageOfficers = function () {
      console.log('Inside initManageOfficers');
      console.log('$rootScope.userData.id', $rootScope.userData.id);

      if ($rootScope.userData.roleId === 1 || $rootScope.userData.roleId === 5) {
        var obj = {};

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageCollectorsList = result;
          //$scope.initManageShops();
          $scope.isEdit = false;
          $scope.isAssignNewShop = false;
          $scope.isAgentView = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSync(obj);
      } else {
        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);

          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log('userIDs', userIDs);

            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageCollectorsList = result;
              console.log($scope.manageCollectorsList);
              //$scope.initManageShops();
              $scope.isEdit = false;
              $scope.isAssignNewShop = false;
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);

          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      }


    };
    

    $scope.manageShop = {};
    $scope.manageShopsList = [];

    $scope.initManageShops = function () {
      var obj = {};
      obj.params={};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopsList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.Filter = {};

    $scope.addOfficer = function () {
      //genericModalService.show('modules/modals/addOfficer.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageCollectorsList.push($scope.inserted);
    };

    $scope.selectedShopList = [];
    $scope.notSelectedShopList = [];
    $scope.viewCollectorDetails = function (manageCollector) {
      console.log("Inside editMachine");
      $scope.isEdit = true;

      $scope.manageCollector = manageCollector;
      console.log($scope.manageCollector)
      $scope.selectedShopList = [];
      $scope.notSelectedShopList = [];
      $scope.getSelectedShops(manageCollector);
      console.log($scope.selectedShopList);
      $scope.getNotSelectedShops(manageCollector);
      console.log($scope.notSelectedShopList);
    };

    $scope.getSelectedShops = function (manageCollector) {
      if (manageCollector.credentials.shopmap) {
        var obj = {};
        obj.params = {};
        obj.params.shopmap = manageCollector.credentials.shopmap;
        console.log(manageCollector.credentials.shopmap);

        obj.onSuccess = function (result) {
          console.log("Inside getSelectedShops SUCCESS");
          console.log(result);
          $scope.selectedShopList = result;

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        shopService.findAssignedShop(obj);
      }
    };

    $scope.getNotSelectedShops = function (manageCollector) {

      if ($rootScope.userData.roleId === 1 || $rootScope.userData.roleId === 5) {
        var obj = {};
        obj.params = {};
        obj.params.shopmap = manageCollector.credentials.shopmap?manageCollector.credentials.shopmap:[];

        console.log('obj.params', obj.params);
  
        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedShops SUCCESS");
          console.log(result);
          $scope.notSelectedShopList = result;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        shopService.findNotAssignedShopForAdmin(obj);
      }else{
        var obj = {};
        obj.params = {};
        obj.params.shopmap = manageCollector.credentials.shopmap;
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        }
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zonemap = $rootScope.userData.credentials.zonemap;
        }
  
        console.log('obj.params', obj.params);
  
        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedShops SUCCESS");
          console.log(result);
          $scope.notSelectedShopList = result;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        shopService.findNotAssignedShop(obj);
      }
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/areas/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.removeShop = function (res) {
      console.log("Inside removeShop");
      console.log(res.id);

      if (res) {

        var arr = $scope.manageCollector.credentials.shopmap;
        var index = arr.indexOf(res.id);
        if (index > -1) {
          arr.splice(index, 1);
        }
        $scope.manageCollector.credentials.shopmap = arr;
        //        console.log($scope.manageCollector.credentials.shopmap)
        console.log($scope.manageCollector.credentials)

        var obj = {};
        obj.params = {};
        obj.params.credentials = {};
        obj.params.id = $scope.manageCollector.id
        obj.params.credentials = $scope.manageCollector.credentials
        //obj.params.credentials.shopmap = $scope.manageCollector.credentials.shopmap;
        obj.onSuccess = function (result) {
          console.log("Inside removeShop SUCCESS");
          console.log(result);
          toastr.success('Shop has been deleted successfully!', 'SUCCESS');
          $scope.viewCollectorDetails($scope.manageCollector)
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.updateShopMap(obj);
      } else {
        console.log('Not sure!');
      }
    }
    $scope.addShop = function () {
      $scope.isAssignNewShop = true;
    };

    $scope.assignShop = function (res) {
      console.log("Inside assignShop");
      console.log(res.id);

      if (res) {


        var arr = $scope.manageCollector.credentials.shopmap ? $scope.manageCollector.credentials.shopmap : [];
        arr.push(res.id);
        $scope.manageCollector.credentials.shopmap = arr;
        //      console.log($scope.manageCollector.credentials.shopmap)
        console.log($scope.manageCollector.credentials)
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.manageCollector.id;
        obj.params.credentials = $scope.manageCollector.credentials;
        //obj.params.credentials.shopmap = $scope.manageCollector.credentials.shopmap;
        obj.onSuccess = function (result) {
          console.log("Inside assignShop SUCCESS");
          console.log(result);
          toastr.success('Shop has been added successfully!', 'SUCCESS');
          $scope.viewCollectorDetails($scope.manageCollector)
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.updateShopMap(obj);
      } else {
        console.log('Not sure!');
      }
    }

    $scope.editArea = function (state) {
      console.log("Inside editArea");
      console.log(state);
      $scope.manageOfficer = state;
      genericModalService.show('modules/modals/addOfficer.html', $scope);
    };

    $scope.viewAgents = function (items){
      $scope.isAgentView = true;
      $scope.manageCollectorsList = items;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.init = function(){
      $scope.initManageOfficers();
    };

    $scope.init();

  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync.assigncollector')
    .service('assigncollectorService', assigncollectorService);

  /** @ngInject */
  function assigncollectorService(Collectormap) {

    var getCollectormaps = function(obj) {

      Collectormap.find({
        filter:{
          where: {
            vipid:obj.params.headid
          },
          include: ["head","staff"],
        }
      }).$promise.then(function(data) {
        //obj.onSuccess(data);
        Collectormap.find({
          filter:{
            where: {
              headid:data[0].headid
            },
            include: ["head","staff"],
          }
        }).$promise.then(function(data) {
          obj.onSuccess(data);
        }, function(err) {
          obj.onFailure(err);
        });
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return{
      getCollectormaps: getCollectormaps
    };

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var date = new Date();
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month'
      },
      selectable: false,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'Today',
          start: date,
          color: dashboardColors.silverTree,
          allDay: true
        }
        // {
        //   title: 'Long Event',
        //   start: '2016-03-07',
        //   end: '2016-03-10',
        //   color: dashboardColors.blueStone
        // },
        // {
        //   title: 'Dinner',
        //   start: '2016-03-14T20:00:00',
        //   color: dashboardColors.surfieGreen
        // },
        // {
        //   title: 'Birthday Party',
        //   start: '2016-04-01T07:00:00',
        //   color: dashboardColors.gossipDark
        // }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.partnersales')
    .controller('PartnersalesreportPageCtrl', PartnersalesreportPageCtrl);

  /** @ngInject */
  function PartnersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnersalesreportService, gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal, dailyonlinesalesreportService, dailymachinesalesreportService, $rootScope,zoneService,receiptService) {
    console.log("Inside PartnersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
           for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
             var zonelist = $filter('filter')(result, {
               id: $rootScope.userData.credentials.zonemap[index]
             }, true);
             console.log('zonelist',zonelist);
 
             $scope.manageZonesList.push(zonelist[0]);
           }
         }else{
           $scope.manageZonesList = result;
         }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();


$scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentPartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getParentPartner(obj);
    };
    $scope.initManageParentPartner();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.reportFilter={};
    $scope.searchMachinesales = function (reportFilter) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        // td.setHours(23);
        // td.setMinutes(59);
        // td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        console.log('From',fd);
        console.log('TO',td);
        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone){
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        } else{
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value="";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0){
                value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
              }else{
                value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
              }
            }
            value = value+")";
            obj.params.zoneid=value;
          }else{
            obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
          }
        }
        
        if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
          obj.params.shoptype=$rootScope.userData.credentials.shopType;
        }else{
          obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
        }


        if (typeof $rootScope.userData.credentials.parent !== "undefined"){
          obj.params.parentid=$rootScope.userData.credentials.parent;
        }else{
          obj.params.parentid=reportFilter.parent?reportFilter.parent.id:null;
        }



        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          if (result.result){
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              var onmacTotal = parseFloat($scope.managePartnersalesList[i].ontotal)+ parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        partnersalesreportService.getGrpMacSalesInRange(obj);
      }
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner();

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
//        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.managePartnersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/external/partnersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(managePartnersales, id) {

      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      if (managePartnersales.id === undefined) {
        $scope.createMachinesales(managePartnersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = managePartnersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      $scope.getMachineSalesOfPartner(managePartnersales.partnerid);
    //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getMachineSalesOfPartner = function(partnerid) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = "("+partnerid+")";
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.mPSalesTotal = 0;
        $scope.mCSalesTotal = 0;
        $scope.mSalesTotal = 0;
        $scope.npTotal = 0;
        $scope.oPSalesTotal = 0;
        $scope.oCSalesTotal = 0;
        $scope.oSalesTotal = 0;
        $scope.shopTotal = 0;
        $scope.compTotal = 0;
        $scope.shopOverTotal = 0;
        $scope.compOverTotal = 0;

        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
          $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
          $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
          $scope.mSalesTotal = $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
          $scope.npTotal = $scope.npTotal + parseFloat(result.result[i].netpurchase);
          $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
          $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
          $scope.oSalesTotal = $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
          $scope.machineSalesOfPartnerList.result[i].shopTotal = parseFloat(result.result[i].mpsales)+ parseFloat(result.result[i].opsales);
          $scope.machineSalesOfPartnerList.result[i].compTotal = parseFloat(result.result[i].mcsales)+ parseFloat(result.result[i].ocsales);
          $scope.shopOverTotal = $scope.shopOverTotal + $scope.machineSalesOfPartnerList.result[i].shopTotal;
          $scope.compOverTotal = $scope.compOverTotal + $scope.machineSalesOfPartnerList.result[i].compTotal;

        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      partnersalesreportService.getMachinesalesByPartner(obj);
    }

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function (managePartnersales) {
      if (managePartnersales.shop && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.managePartnersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.manageDailyinvoices={};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

     $scope.viewInvoice = function (manageDailyinvoices) {
       console.log("Inside viewInvoice");
       $scope.isInvoice = true;
       $scope.manageDailyinvoices = manageDailyinvoices;
       if ($scope.manageDailyinvoices.ikey){
        $scope.manageDailyinvoices.invoicedate = $scope.dateFormater($scope.manageDailyinvoices.ikey);
       }
       console.log($scope.manageDailyinvoices);
 
       $scope.onlineInvoiceDetails = {};
       $scope.machineInvoiceDetails = {};
       $scope.shopInvoiceDetails = {};
       $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
       $scope.getMachineSales($scope.manageDailyinvoices.ikey);
 
     };
 
     $scope.getOnlineSales = function (ikey) {
       var obj = {};
       obj.params = {};
       obj.params.ikey = ikey;
       obj.onSuccess = function (result) {
         console.log("Inside Online SUCCESS");
         console.log(result);
         console.log($scope.manageDailyinvoices);
         $scope.onlineInvoiceDetails = result;
 
         if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
           console.log('Inside Empty MachineShop');
           $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
         }

         var online = 0;
         $scope.total.onlineST=0;
         if ($scope.onlineInvoiceDetails.length > 0) {
           for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
             online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
           }
           $scope.total.online = parseFloat(online);
           $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
         }
       }
       obj.onFailure = function (err) {
         console.log("Inside Failure");
       }
       dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
     };
 
     $scope.getMachineSales = function (ikey) {
       var obj = {};
       obj.params = {};
       obj.params.ikey = ikey;
       obj.onSuccess = function (result) {
         console.log("Inside Machine SUCCESS");
         console.log(result);
         console.log($scope.manageDailyinvoices);
         $scope.machineInvoiceDetails = result;
 
         if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
           console.log('Inside Empty OnlineShop');
           $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
         }

         var machine = 0;
         $scope.total.machineST=0;
         if ($scope.machineInvoiceDetails.length > 0) {
           for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
             machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
             $scope.machineInvoiceDetails[i].receipt.content = JSON.parse($scope.machineInvoiceDetails[i].receipt.content);
           }
           $scope.total.machine = parseFloat(machine);
           $scope.total.machineST = machine + parseFloat($scope.manageDailyinvoices.machineshorts);
         }
       }
 
       obj.onFailure = function (err) {
         console.log("Inside Failure");
       }
       dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
     };
 
     $scope.shopInvoiceDetails = {};
     $scope.getManageShop = function (shopid) {
       var obj = {};
       obj.params = {};
       obj.params.shopid = shopid;
       obj.onSuccess = function (result) {
         console.log("Inside SUCCESS getManageShop");
         console.log(result);
         $scope.shopInvoiceDetails = result;
       };
       obj.onFailure = function (err) {
         console.log("Inside Failure getManageShop");
         console.log(err);
       };
       shopService.getShopById(obj);
     };

     $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };
    $scope.print = function () {
      window.print();
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) { return x.mpsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) { return x.mcsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) { return x.mactotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) { return x.opsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalnetpurhase = function (items) {
      return items
        .map(function (x) { return x.netpurchase; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) { return x.ocsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) { return x.ontotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) { return x.shopTotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) { return x.compTotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };

    $scope.getShopSalesOfPartner = function(salesOfPartnerList) {

      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = false;
      $scope.shopSalesOfPartnerList = {};
      $scope.shopSalesOfPartnerList = salesOfPartnerList;
      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.npTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 = parseFloat($scope.shopSalesOfPartnerList[i].ontotal)+ parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.npTotal = $scope.npTotal + parseFloat($scope.shopSalesOfPartnerList[i].netpurchase);
        $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal = parseFloat($scope.shopSalesOfPartnerList[i].mpsales)+ parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal = parseFloat($scope.shopSalesOfPartnerList[i].mcsales)+ parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.shopOverTotal = $scope.shopOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal = $scope.compOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].compTotal);

      }
    };    
    
    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
    console.log('receiptid',receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open('app/pages/invoices/dailyinvoices/modals/receiptModal.html');
          
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);

    };
}
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.partnersales')
    .service('partnersalesreportService', partnersalesreportService);

  /** @ngInject */
  function partnersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid,
        parentid: obj.params.parentid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesByPartner = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesByPartner: getMachinesalesByPartner,
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.suppliersales')
    .controller('SuppliersalesreportPageCtrl', SuppliersalesreportPageCtrl);

  /** @ngInject */
  function SuppliersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    suppliersalesreportService, machineShopService,gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal) {
    console.log("Inside SuppliersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      

      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        // td.setHours(23);
        // td.setMinutes(59);
        // td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = date1;
        obj.params.bdate = date2;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);

          $scope.totalSalesLabel = 0;
          $scope.totalSalesLabelFooter = 0;
          for (var i = 0; i < result.result.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.manageSuppliersalesList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        suppliersalesreportService.getGrpMacSalesInRange(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageSuppliersales = {};
    $scope.manageSuppliersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.manageSuppliersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      suppliersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/external/suppliersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageSuppliersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.saveMachinesales = function(manageSuppliersales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageSuppliersales);
      console.log(manageSuppliersales.id);

      if (manageSuppliersales.id === undefined) {
        $scope.createMachinesales(manageSuppliersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSuppliersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSuppliersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageSuppliersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.manageSuppliersales = manageSuppliersales;
      console.log($scope.manageSuppliersales.id);

      $scope.getMachineSalesOfSupplier(manageSuppliersales.id);
    };

    $scope.getMachineSalesOfSupplier = function(suppId) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfSupplier = {};
      $scope.machineSalesOfSupplierList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = fd;
      obj.params.bdate = td;
      obj.params.suppId = suppId;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfSupplier SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(result.result[i].totalsales);
        }
        console.log($scope.totalSalesLabelFooter);
        $scope.machineSalesOfSupplierList = result;
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfSupplier Failure");
      }
      suppliersalesreportService.getMachinesalesBySupplier(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageSuppliersales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageSuppliersales.shop && $scope.managePartnerList.length) {
        //console.log($scope.manageSuppliersales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageSuppliersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.suppliersales')
    .service('suppliersalesreportService', suppliersalesreportService);

  /** @ngInject */
  function suppliersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      var newDate  = new Date(date);
      console.log('date',newDate);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": newDate}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesBySupplier = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        suppId: obj.params.suppId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };
    
    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesBySupplier: getMachinesalesBySupplier,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      getAvailableMachineByZone: getAvailableMachineByZone,
//      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales
  //    saveMachinesales: saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.form.machinesales')
    .controller('MachinesalesPageCtrl', MachinesalesPageCtrl);

  /** @ngInject */
  function MachinesalesPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesService, toastr, $uibModal, SheetJSExportService,
    machineShopService, machineService, shopService, validationService) {
    console.log("Inside MachinesalesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


    //    $scope.dateList = {};
    //    $scope.dpOpenStatus = {};
    //    $scope.setDpOpenStatus = function(id) {
    //      $scope.dpOpenStatus[id] = true;
    //    };

    $scope.smartTablePageSize = 100;
    $scope.manageMachinesales = {};

    $scope.manageMachinesalesList = []; // temp line
    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded?
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getAllMachine(obj);
    };

    $scope.initManageMachinesales = function () {

      $scope.initManageShop();
      $scope.initManageMachineShop();
      $scope.initManageMachine();
      $scope.manageMachinesales = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageMachinesales();

    $scope.passOnlinesales = function (manageMachinesales) {
      console.log("Inside passOnlinesales");
      console.log(manageMachinesales);
    };

    $scope.ddmmyyyy = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('');
    };

    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.createMachinesales = function (manageMachinesales) {
      console.log("Inside manageMachinesales");
      var isFormValidated = true;
      //console.log($scope.dateList.from)
      //if (validationService.isEmptyOrNullValidation($scope.dateList.from) && $scope.gridOptions.data.length) {
      if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please choose a Date and File to Upload', 'ERROR');
        toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          var date = new Date();
          var indate = new Date();
          record.mid = $scope.gridOptions.data[i].machineid; //machine code
          record.cmIn = $scope.gridOptions.data[i].cmin ? $scope.gridOptions.data[i].cmin.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.cmOut = $scope.gridOptions.data[i].cmout ? $scope.gridOptions.data[i].cmout.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.bmIn = $scope.gridOptions.data[i].bmin ? $scope.gridOptions.data[i].bmin.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.bmOut = $scope.gridOptions.data[i].bmout ? $scope.gridOptions.data[i].bmout.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          var localMachine = $scope.getMachineDetails(record.mid);
          console.log(localMachine);

          var diffCmIn = 0,
            diffCmOut = 0,
            diffBmIn = 0,
            diffBmOut = 0;

          var localMachineShop = {};
          if (localMachine) {
            localMachineShop = $scope.getMachineShopDetails(localMachine.id);
            console.log("inside localMachine");
            diffCmIn = ((record.cmIn - localMachine.cmIn) * parseFloat(localMachine.cmRate)).toFixed(2);
            diffCmOut = ((record.cmOut - localMachine.cmOut) * parseFloat(localMachine.cmRate)).toFixed(2);
            diffBmIn = ((record.bmIn - localMachine.bmIn) * parseFloat(localMachine.bmRate)).toFixed(2);
            diffBmOut = ((record.bmOut - localMachine.bmOut) * parseFloat(localMachine.bmRate)).toFixed(2);
            record.cmInP = localMachine.cmIn;
            record.cmOutP = localMachine.cmOut;
            record.bmInP = localMachine.bmIn;
            record.bmOutP = localMachine.bmOut;
            record.totalsalesp = 0;

            var cmTotalSales = diffCmIn - diffCmOut;
            var bmTotalSales = diffBmIn - diffBmOut;

            if (localMachine.calby)
              record.totalsales = cmTotalSales.toFixed(2);
            else {
              record.totalsales = bmTotalSales.toFixed(2);
            }

            record.machineid = localMachine.id;
          }
          if (localMachineShop) {
            console.log("Inside localMachineShop");
            console.log(localMachineShop);
            record.csales = (record.totalsales * localMachineShop.macrate / 100).toFixed(2);
            record.psales = (record.totalsales - record.csales).toFixed(2);
            record.vcmsales = (record.totalsales * localMachineShop.macvirtual / 100).toFixed(2);
            record.vpmsales = (record.totalsales - record.vcmsales).toFixed(2);
            record.shopid = localMachineShop.shopid;
            record.machineid = localMachineShop.machineid;
            record.machineshopid = localMachineShop.id;
            if (localMachineShop.shop.shoptype == '100%') {
              var d = $scope.ddmmyyyy(date, 0);
              record.ikey = localMachineShop.shopid + '' + d;
              record.indate = $scope.getInDate(indate, 0);
              console.log(record.ikey);
            } else if (localMachineShop.shop.shoptype == '5/5') {
              var d = $scope.ddmmyyyy(date, 1);
              record.ikey = localMachineShop.shopid + '' + d;
              record.indate = $scope.getInDate(indate, 1);
              console.log(record.ikey);
            }

          }
          record.created = cdate;

          //record.created = $scope.dateList.from;
          record.lastupdated = cdate;

          console.log(record);

          obj.params.push(record);
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};
          //$scope.dateList = {};
          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          $scope.initManageMachinesales();
          toastr.success('New Machine Sales has been saved successfully!', 'SUCCESS');
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {

            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.machineid = err.config.data[i].mid;
                data.cmin = err.config.data[i].cmIn;
                data.cmout = err.config.data[i].cmOut;
                data.bmin = err.config.data[i].bmIn;
                data.bmout = err.config.data[i].bmOut;
                if (typeof err.config.data[i].mid === 'undefined') {
                  data.ERROR = 'Blank Machine Code';
                } else if (typeof err.config.data[i].shopid === 'undefined') {
                  data.ERROR = 'No Shop Reference';
                } else if (typeof err.config.data[i].machineid === 'undefined') {
                  data.ERROR = 'No Machine Reference';
                } else if (err.config.data[i].shopid === null) {
                  data.ERROR = 'No Shop Reference';
                }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        };
        machinesalesService.createMachinesales(obj);
      }
    };

    $scope.getMachineShopDetails = function (mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function (mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.machinesales')
    .service('machinesalesService', machinesalesService);

  /** @ngInject */
  function machinesalesService(Machinesales) {

    var getMachinesales = function(obj) {
      //read data from gridoptions
      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var today = y+'-'+m+'-'+d.getUTCDate();
      //var today  = new Date(date);
      console.log('date',today);
      //var yesterday = new Date(today);
      //yesterday.setDate(today.getUTCDate() - 1);
      var today = y+'-'+m+'-'+(d.getUTCDate()-1);
      console.log('date', yesterday);

      Machinesales.find({
        filter: {
          where:{
            and:[
              {created: {gte: yesterday}},
              {created: {lt:today}}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Machinesales.createMany(
        obj.params

        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getMachinesales: getMachinesales,
      saveMachinesales: saveMachinesales,
      createMachinesales: createMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.form.onlinesales')
    .controller('OnlinesalesPageCtrl', OnlinesalesPageCtrl);

  /** @ngInject */
  function OnlinesalesPageCtrl($scope, $filter, editableOptions, editableThemes,
    onlinesalesService, toastr, $uibModal, SheetJSExportService, gameService,
    onlineShopService, shopService, validationService) {
    console.log("Inside OnlinesalesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    //    $scope.dateList = {};
    //    $scope.dpOpenStatus = {};
    //    $scope.setDpOpenStatus = function(id) {
    //      $scope.dpOpenStatus[id] = true;
    //    };
    $scope.smartTablePageSize = 100;
    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageOnlineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlineShopService.getAllOnlineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.initManageOnlinesales = function () {
      console.log($scope.manageOnlinesales.import);
      $scope.initManageGames();
      $scope.initManageShop();
      $scope.initManageOnlineShop();
      $scope.manageOnlinesales = {};
      $scope.gridOptions = {};
      //      $scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageOnlinesales();
    $scope.passOnlinesales = function (manageOnlinesales) {
      console.log("Inside passOnlinesales");
      console.log(manageOnlinesales);
    }


    $scope.getShopId = function (playtechid) {
      if (playtechid && $scope.manageOnlineShopList.length) {
        var selected = $filter('filter')($scope.manageOnlineShopList, {
          playtechid: playtechid
        }, true);
        return selected.length ? selected[0].shopid : null;
      } else return null;
    };

    $scope.getShopDetails = function (shopid) {
      if (shopid && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shopid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.createOnlinesales = function (manageOnlinesales) {
      console.log("Inside manageOnlinesales");
      console.log($scope.gridOptions.data);
      //      console.log($scope.dateList.from);
      var isFormValidated = true;

      //      if (validationService.isEmptyOrNullValidation(manageOnlinesales.game) && validationService.isEmptyOrNullValidation($scope.dateList.from) &&
      if (validationService.isEmptyOrNullValidation(manageOnlinesales.game) &&
        ($scope.gridOptions.data.length)) {
        //No Furhter Validations

      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please select a Game, Date and choose a file to Upload', 'ERROR');
        toastr.error('Please select a Game and choose a file to Upload', 'ERROR');
      }


      if (isFormValidated) {

        // To update custom date by invoices.
        // edit date below.
        // var uploadDate = moment('08-19-2019', 'MM-DD-YYYY');
        var uploadDate = moment();

        var cdate = moment();
        var indate = moment(uploadDate, 'DD-MM-YYYY').add(uploadDate.utcOffset(), 'minutes').subtract(1, 'days');

        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};

          record.playtechid = $scope.gridOptions.data[i].Kiosk;
          var localShopid = $scope.getShopId(record.playtechid);
          record.pshare = $scope.gridOptions.data[i].PS ? $scope.gridOptions.data[i].PS.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.pwin = $scope.gridOptions.data[i].PW ? $scope.gridOptions.data[i].PW.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.netpurchase = $scope.gridOptions.data[i].NP ? $scope.gridOptions.data[i].NP.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.netgaming = $scope.gridOptions.data[i].NG ? $scope.gridOptions.data[i].NG.replace('MYR', '').replace(',', '').replace('$', '') : 0;

          //var totalPSPW = parseFloat(record.pshare) + parseFloat(record.pwin);
          //record.totalsales = parseFloat(record.netpurchase - totalPSPW).toFixed(2);

          record.totalsales = ((parseFloat(record.netpurchase) - parseFloat(record.pshare)) + parseFloat(record.pwin)).toFixed(2);

          var localShop = $scope.getShopDetails(localShopid);

          if (localShop) {
            record.csales = parseFloat(record.totalsales * parseFloat(localShop.onrate / 100))
            record.psales = parseFloat(record.totalsales - record.csales).toFixed(2);
          }
          record.csales = ((record.csales + parseFloat(record.pshare)) - parseFloat(record.pwin)).toFixed(2); //bug fix code share by udit in sync with Ms lee

          record.shopid = localShopid;
          record.gameid = manageOnlinesales.game ? manageOnlinesales.game.id : null;
          record.created = cdate.toDate();
          record.lastupdated = cdate.toDate();
          record.indate = indate.toDate();

          var ikeyDateFormat = indate.utc().format('DDMMYYYY');
          record.ikey = localShopid + '' + ikeyDateFormat;
          console.log(record.ikey);

          obj.params.push(record);
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};
          //$scope.dateList = {};
          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          toastr.success('New Online Sales has been saved successfully!', 'SUCCESS');
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {
            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.Kiosk = err.config.data[i].playtechid;
                data.PS = err.config.data[i].pshare;
                data.PW = err.config.data[i].pwin;
                data.NP = err.config.data[i].netpurchase;
                data.NG = err.config.data[i].netgaming;
                if (typeof err.config.data[i].playtechid === 'undefined') {
                  data.ERROR = 'Blank Kiosk';
                } else if (err.config.data[i].shopid === null) {
                  data.ERROR = 'No Shop Reference';
                }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        }
        onlinesalesService.createOnlinesales(obj);
      }
    };

    $scope.confirmDelete = function (id) {
      if (confirm('Remove record?')) {
        $scope.gridOptions.data.splice(id, 1);
      }
    }

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.onlinesales')
    .service('onlinesalesService', onlinesalesService);

  /** @ngInject */
  function onlinesalesService(Onlinesales) {

    var getOnlinesales = function(obj) {
      //read data from gridoptions
      Onlinesales.find({
        filter: {
          include: ["onlineshop","shop","game"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Onlinesales.createMany(
        obj.params
        // id: obj.params.id,
        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getOnlinesales: getOnlinesales,
      saveOnlinesales: saveOnlinesales,
      createOnlinesales: createOnlinesales
    };

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.allinvoices')
    .controller('AllinvoicesPageCtrl', AllinvoicesPageCtrl);

  /** @ngInject */
  function AllinvoicesPageCtrl($scope, $filter, editableOptions, editableThemes,
    allInvoiceService, onlineShopService, validationService, zoneService, gameService, shopService, partnerService, dailyonlinesalesreportService, dailymachinesalesreportService, toastr, $uibModal, userService, $rootScope,assigncollectorService,receiptService) {
    console.log("Inside AllinvoicesPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteInvoice(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.total = {};
    // $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];
    $scope.paidFilter = [{ value: 'PAID' }, { value: 'UNPAID' }];
    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    //get zone table data
    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.initManageZones = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          // $scope.manageZonesList = result;
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            console.log('Inside Zonemap');
             for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
               var zonelist = $filter('filter')(result, {
                 id: $rootScope.userData.credentials.zonemap[index]
               }, true);
               console.log('zonelist',zonelist);
   
               $scope.manageZonesList.push(zonelist[0]);
             }
           }else{
             $scope.manageZonesList = result;
           }
           console.log('$scope.manageZonesList',$scope.manageZonesList);

        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
    };
    //Get the zone list before search is initiated.
    $scope.initManageZones();

    $scope.manageUsersList = [];
    $scope.initManageUsers = function() {

      if ($rootScope.userData.roleId===7){
        console.log('Inside initManageOfficers');
        console.log('$rootScope.userData.id', $rootScope.userData.id);
  
        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;
  
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);
  
          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log('userIDs', userIDs);
  
            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;
  
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageUsersList = result;
              console.log($scope.manageCollectorsList);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);
  
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      }else{
        var obj = {};
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsersList = result;
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSyncVIP(obj);
      }

    };
    $scope.initManageUsers();

    $scope.totalSalesLabel = 0;
    $scope.reportFilter={};
    $scope.searchAllinvoices = function (reportFilter) {
      console.log("Inside searchAllinvoices");
      console.log($scope.dateList);

      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        console.log('reportFilter',reportFilter);
      
        var obj = {};
        obj.params={};
        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        obj.params.ispaid=reportFilter.ispaid?reportFilter.ispaid.value:null;

        if (reportFilter.zone){
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        } else{
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value="";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0){
                value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
              }else{
                value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
              }
            }
            value = value+")";
            obj.params.zoneid=value;
          }else{
            obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
          }
        }
        
        if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
          obj.params.shoptype=$rootScope.userData.credentials.shopType;
        }else{
          obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
        }
      
  
        obj.onSuccess = function (result) {
          console.log("Inside getAllZoneSales SUCCESS");
         
          $scope.manageAllinvoicesList = result.result;
          console.log('$scope.manageAllinvoicesList', $scope.manageAllinvoicesList);
          $scope.totalSalesLabelFooter = 0;
          $scope.mSalesTotal = 0;
          $scope.oSalesTotal = 0;
          for (var index = 0; index < $scope.manageAllinvoicesList.length; index++) {
            $scope.manageAllinvoicesList[index].totalsales = parseFloat($scope.manageAllinvoicesList[index].mcsales) + parseFloat($scope.manageAllinvoicesList[index].ocsales);
            $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat( $scope.manageAllinvoicesList[index].totalsales);
            $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.manageAllinvoicesList[index].mcsales);
            $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.manageAllinvoicesList[index].ocsales);
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside getAllZoneSales Failure");
          console.log(err);
        };
        allInvoiceService.getAllInvoiceWithSales(obj);
      }
    };

  $scope.getAllZoneSales = function (dateList) {
    var obj = {};
    obj.params = {};
    obj.params.fromDt = $scope.dateList.from;
    obj.params.toDt = $scope.dateList.to;

    obj.onSuccess = function (result) {
      console.log("Inside getAllZoneSalesSUCCESS");
      console.log(result);
      $scope.manageAllinvoicesList = result;
    };
    obj.onFailure = function (err) {
      console.log("Inside getAllZoneSales Failure");
      console.log(err);
    };
    allInvoiceService.getBetweenDatesInvoices(obj)
  }

  $scope.getInvoiceByZone = function (dateList, zoneid) {
    var obj = {};
    obj.params = {};

    obj.params.fromDt = $scope.dateList.from;
    obj.params.toDt = $scope.dateList.to;
    obj.params.zoneselection = zoneid;
    
    obj.onSuccess = function (result) {
      console.log("Inside getInvoiceByZone SUCCESS");
      console.log(result);
      $scope.manageAllinvoicesList = result;
    };
    obj.onFailure = function (err) {
      console.log("Inside getInvoiceByZone Failure");
      console.log(err);
    };
    allInvoiceService.getInvoiceByZoneBetweenDates(obj);
  }
    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    // $scope.manageShopList = [];
    // $scope.initManageShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   shopService.getShop(obj);
    // };

    $scope.manageAllinvoices = {};
    $scope.manageAllinvoicesList = [];

    $scope.initManageInvoice = function () {
      $scope.isEdit = false;
    };

    // $scope.initManageInvoice = function() {
    //   var obj = {};
    //   obj.params = {};
    //   obj.params.fromDt = $scope.dateList.from;
    //   obj.params.toDt = $scope.dateList.to;

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageAllinvoicesList = result;
    //     $scope.isEdit = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   allInvoiceService.getBetweenDatesInvoices(obj);
    // };
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageAllinvoicesList.push($scope.inserted);
        };
    */
    $scope.createInvoice = function(manageAllinvoices) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createInvoice");
      //console.log(manageAllinvoices.name);
      //console.log(manageAllinvoices.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageAllinvoices.id;
      obj.params.playtechid = manageAllinvoices.playtechid;
      obj.params.pshare = manageAllinvoices.pshare;
      obj.params.pwin = manageAllinvoices.pwin;
      obj.params.netpurchase = manageAllinvoices.netpurchase;
      obj.params.netgaming = manageAllinvoices.netgaming;
      obj.params.totalsales = manageAllinvoices.totalsales;
      obj.params.csales = manageAllinvoices.csales;
      obj.params.psales = manageAllinvoices.psales;

      //obj.params.description = manageAllinvoices.description;
      console.log(manageAllinvoices);
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAllinvoices = {};
        toastr.success('New Invoice has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Invoice successfully created.");
        $scope.initManageInvoice();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      allInvoiceService.createInvoice(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/invoices/dailyinvoices/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteInvoice = function(res) {
      console.log("Inside deleteInvoice");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Invoice has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Invoice successfully deleted.");
          $scope.initManageInvoice();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        allInvoiceService.deleteInvoice(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(invoice) {
      // console.log("Inside editInvoice");
      // console.log(invoice);
      $scope.manageAllinvoices = invoice;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.viewInvoice = function(manageAllinvoices) {
      console.log("Inside viewInvoice");
      $scope.isEdit = true;
      $scope.manageAllinvoices = manageAllinvoices;
      console.log($scope.manageAllinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageAllinvoices.ikey);
      $scope.getMachineSales($scope.manageAllinvoices);
    };

    $scope.saveInvoice = function (id) {
      console.log("Inside saveInvoice");
      //console.log(itemInvoice);
      console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.machineshorts = $scope.manageAllinvoices.machineshorts;
        obj.params.onlineshorts = $scope.manageAllinvoices.onlineshorts;
        obj.params.id = id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageAllinvoices = result;
          $scope.managePartner = {};
          toastr.success('Invoice has been updated successfully!', 'SUCCESS');
//          $scope.initManageStates();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        allInvoiceService.saveInvoice(obj);

    }

    $scope.getOnlineSales = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        $scope.onlineInvoiceDetails = result;
        
        if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
          console.log('Inside Empty MachineShop');
          $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        }
        $scope.total.online = 0; 
        $scope.total.onlineST = 0;
        var online = 0;     
        if ($scope.onlineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
            online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
          }
          console.log($scope.manageAllinvoices.onlineshorts);
          $scope.total.online = online;
          $scope.total.onlineST = online + parseFloat($scope.manageAllinvoices.onlineshorts);
        }
      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      }
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.getMachineSales = function(manageDailyinvoices) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = manageDailyinvoices.ikey;
      obj.onSuccess = function(result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.machineInvoiceDetails = result;
        if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
          console.log('Inside Empty OnlineShop');
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }
        $scope.total.machine = 0; 
        $scope.total.machineST = 0;
        var machine = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse($scope.machineInvoiceDetails[i].receipt.content);
          }
          console.log($scope.manageAllinvoices.machineshorts);
          $scope.total.machine = machine;
          $scope.total.machineST = machine + parseFloat($scope.manageAllinvoices.machineshorts);
        }  
      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }
    $scope.showGames = function(game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    // $scope.showShops = function(shop) {
    //   //console.log("Inside showGames = "+JSON.stringify(game));
    //   if (shop && $scope.manageShopList.length) {
    //     var selected = $filter('filter')($scope.manageGamesList, {
    //       id: game.id
    //     },true);
    //     return selected.length ? selected[0].name : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function(manageAllinvoices) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageAllinvoices.shop && $scope.managePartnerList.length) {
        console.log($scope.manageAllinvoices);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageAllinvoices.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    
    $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST
      return total;
    };

    $scope.saveShorts = function(){
      console.log($scope.manageAllinvoices.machineshorts);
      console.log($scope.total.machineST);

      console.log($scope.manageAllinvoices.onlineshorts);
      console.log($scope.total.onlineST);
      $scope.saveInvoice($scope.manageAllinvoices.id);
      //$scope.total.machineST = $scope.total.machine + parseFloat($scope.manageDailyinvoices.machineshorts);
      //console.log($scope.total.machineST);
      //$scope.initManageStates();
      $scope.initManageInvoice();
      $scope.manageAllinvoices = {};
    }

    $scope.print = function(){
      window.print();
    };

    $scope.showUserById = function (userid) {
      if (userid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: userid
        }, true);
        if (selected.length)
        console.log('selected[0].credentials',selected[0].credentials);
        
        return selected.length ? (selected[0].credentials.name ? selected[0].credentials.name : selected[0].credentials.firstName+" "+selected[0].credentials.lastName) : '';
        
        // selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return '';
    };

    $scope.openPayNow = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.payInvoice(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.payNowId = null;
    $scope.confirmPayNow = function (id) {
      $scope.openPayNow('app/pages/invoices/dailyinvoices/modals/PayNowModal.html');
      $scope.payNowId = id;
    };

    $scope.payInvoice = function(res){
      console.log("Inside payInvoice");
      if (res) {
        console.log('Sure!');
        console.log($scope.payNowId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.payNowId;
        obj.params.agentid = $rootScope.userData.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS payInvoice");
          toastr.success('Invoice Payment Received', 'SUCCESS');
          $scope.searchAllinvoices($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure payInvoice");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(err.data.error.detail, 'Error');
          }
        };
        allInvoiceService.payInvoice(obj);
      } else {
        console.log('Not sure!');
      }
    };

     //Group Totals
     $scope.getTotalmcsales = function (items) {
      if(items.length>0){
      return items
        .map(function (x) { return x.mcsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalocsales = function (items) {
      if(items.length>0){
      return items
        .map(function (x) { return x.ocsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotaltotalsales = function (items) {
      if(items.length>0){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if(items.length>0){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if(items.length>0){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
    console.log('receiptid',receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open('app/pages/invoices/dailyinvoices/modals/receiptModal.html');
          
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.allinvoices')
    .service('allInvoiceService', allInvoiceService);

  /** @ngInject */
  function allInvoiceService(Invoice) {
    var getBetweenDatesInvoices = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y+'-'+m+'-'+td.getDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Invoice.find({
              filter: {
                where:{
                  and:[
                    {indate: {gte: date1}},
                    {indate: {lte:date2}}
                  ]
                },
                include: ["shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var getInvoiceByZoneBetweenDates = function(obj) {     
      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y+'-'+m+'-'+td.getDate();
      console.log('date1',date1);
      console.log('date2',date2);
      
      Invoice.find({
        filter: {
          where:{
            and:[
              {indate: {gte: date1}},
              {indate: {lte: date2}},
              {zoneid: obj.params.zoneselection}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createInvoice = function(obj) {

      var date = new Date();

      Invoice.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };


    var deleteInvoice = function(obj) {

      Invoice.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveInvoice = function(obj) {
      var date = new Date();

      Invoice.prototype$updateAttributes({
        id: obj.params.id,
        onlineshorts: obj.params.onlineshorts,
        machineshorts: obj.params.machineshorts,
        lastupdated: date
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllInvoiceWithSales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y+'-'+m+'-'+td.getDate();
      console.log('date1',date1);
      console.log('date2',date2);
      
      Invoice.getAllInvoiceWithSales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        ispaid: obj.params.ispaid?obj.params.ispaid:null

      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var payInvoice = function(obj) {

      var date = new Date();

      Invoice.prototype$updateAttributes({
        id: obj.params.id,
        ispaid: true,
        lastupdated: date,
        pdate: date,
        agentid: obj.params.agentid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getBetweenDatesInvoices: getBetweenDatesInvoices,
      getInvoiceByZoneBetweenDates: getInvoiceByZoneBetweenDates,
      createInvoice: createInvoice,
      deleteInvoice: deleteInvoice,
      saveInvoice: saveInvoice,
      getAllInvoiceWithSales: getAllInvoiceWithSales,
      payInvoice: payInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.dailyinvoices')
    .controller('DailyinvoicesPageCtrl', DailyinvoicesPageCtrl);

  /** @ngInject */
  function DailyinvoicesPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailyInvoiceService, onlineShopService, gameService, shopService, zoneService, partnerService, 
    dailyonlinesalesreportService, dailymachinesalesreportService, toastr, $uibModal, userService, $rootScope,assigncollectorService,receiptService) {
    console.log("Inside DailyinvoicesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteInvoice(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.total = {};
    // $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];
    $scope.paidFilter = [{value:'PAID'},{value:'UNPAID'}];
    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    //get zone table data
    // $scope.zoneselection = -99;


    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();


    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.manageUsersList = [];
    $scope.initManageUsers = function() {

      if ($rootScope.userData.roleId===7){
        console.log('Inside initManageOfficers');
        console.log('$rootScope.userData.id', $rootScope.userData.id);
  
        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;
  
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);
  
          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log('userIDs', userIDs);
  
            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;
  
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageUsersList = result;
              console.log($scope.manageCollectorsList);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);
  
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      }else{
        var obj = {};
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsersList = result;
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSyncVIP(obj);
      }

    };
    $scope.initManageUsers();

    $scope.initManageInvoice = function () {
      $scope.isEdit = false;
    };

    $scope.manageDailyinvoices = {};
    $scope.manageDailyinvoicesList = [];
    $scope.totalSalesLabel = 0;
    $scope.reportFilter={};

    $scope.searchAllinvoices = function (reportFilter) {
      console.log("Inside searchAllinvoices");
      console.log('reportFilter',reportFilter);
      
      var obj = {};
      obj.params={};
      obj.params.ispaid=reportFilter.ispaid?reportFilter.ispaid.value:null;
      obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;

      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }

      obj.onSuccess = function (result) {
        console.log("Inside getAllZoneSales SUCCESS");
       
        $scope.manageDailyinvoicesList = result.result;
        console.log('$scope.manageDailyinvoicesList', $scope.manageDailyinvoicesList);
        $scope.totalSalesLabelFooter = 0;
        $scope.mSalesTotal = 0;
        $scope.oSalesTotal = 0;
        if ($scope.manageDailyinvoicesList){
          for (var index = 0; index < $scope.manageDailyinvoicesList.length; index++) {
            $scope.manageDailyinvoicesList[index].totalsales = parseFloat($scope.manageDailyinvoicesList[index].mcsales) + parseFloat($scope.manageDailyinvoicesList[index].ocsales);
            $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat( $scope.manageDailyinvoicesList[index].totalsales);
            $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.manageDailyinvoicesList[index].mactotal);
            $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.manageDailyinvoicesList[index].ontotal);
          }
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside getAllZoneSales Failure");
        console.log(err);
      };
      dailyInvoiceService.getDailyInvoiceWithSales(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/invoices/dailyinvoices/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteInvoice = function (res) {
      console.log("Inside deleteInvoice");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Invoice has been deleted successfully!', 'SUCCESS');
          //$scope.initManageStates();
          $scope.initManageInvoice();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyInvoiceService.deleteInvoice(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isEdit = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      console.log($scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices);

    };

    $scope.saveInvoice = function (id) {
      console.log("Inside saveInvoice");
      //console.log(itemInvoice);
      console.log(id);
        var obj = {};
        obj.params = {};
        obj.params.machineshorts = $scope.manageDailyinvoices.machineshorts;
        obj.params.onlineshorts = $scope.manageDailyinvoices.onlineshorts;
        obj.params.id = id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageDailyinvoices = result;
          toastr.success('Invoice has been updated successfully!', 'SUCCESS');
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyInvoiceService.saveInvoice(obj);
    }

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.onlineInvoiceDetails = result;

        if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
          console.log('Inside Empty MachineShop');
          $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        }
        $scope.total.online = 0;
        $scope.total.onlineST = 0;
        var online = 0;
        if ($scope.onlineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
            online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
          }
          $scope.total.online = online;
          $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    }
    $scope.ddmmyyyy = function(date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('');
    };
    $scope.getMachineSales = function (manageDailyinvoices) {
      
      var obj = {};
      obj.params = {};
      // if (manageDailyinvoices.shop.shoptype==="100%"){
      //   var date = new Date(manageDailyinvoices.indate);
      //   var d = $scope.ddmmyyyy(date);
      //   var tempikey = manageDailyinvoices.shop.id+''+d
      //   console.log('tempikey',tempikey);
      //   obj.params.ikey = tempikey;
      // }else{
      //   obj.params.ikey = manageDailyinvoices.ikey;
      // }
      obj.params.ikey = manageDailyinvoices.ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
          console.log('Inside Empty OnlineShop');
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }
        $scope.total.machine = 0;
        $scope.total.machineST = 0;
        var machine = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse($scope.machineInvoiceDetails[i].receipt.content);
          }
          $scope.total.machine = machine;
          $scope.total.machineST = machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      }

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }
    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageDailyinvoices) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageDailyinvoices.shop && $scope.managePartnerList.length) {
        console.log($scope.manageDailyinvoices);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageDailyinvoices.shop.partnerid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };

    $scope.saveShorts = function(){
      console.log($scope.manageDailyinvoices.machineshorts);
      console.log($scope.total.machineST);

      console.log($scope.manageDailyinvoices.onlineshorts);
      console.log($scope.total.onlineST);
      $scope.saveInvoice($scope.manageDailyinvoices.id);
      //$scope.total.machineST = $scope.total.machine + parseFloat($scope.manageDailyinvoices.machineshorts);
      //console.log($scope.total.machineST);
      $scope.initManageInvoice();
      $scope.manageDailyinvoices = {};

    }

    $scope.print = function () {
      window.print();
    };

    $scope.showUserById = function (userid) {
      if (userid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: userid
        }, true);
        if (selected.length)
        return selected.length ? (selected[0].credentials.name ? selected[0].credentials.name : selected[0].credentials.firstName+" "+selected[0].credentials.lastName) : '';
        
        // selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return '';
    };

    $scope.openPayNow = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.payInvoice(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.payNowId = null;
    $scope.confirmPayNow = function (id) {
      $scope.openPayNow('app/pages/invoices/dailyinvoices/modals/PayNowModal.html');
      $scope.payNowId = id;
    };

    $scope.payInvoice = function(res){
      console.log("Inside payInvoice");
      if (res) {
        console.log('Sure!');
        console.log($scope.payNowId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.payNowId;
        obj.params.agentid = $rootScope.userData.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS payInvoice");
          toastr.success('Invoice Payment Received', 'SUCCESS');
          $scope.searchAllinvoices($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure payInvoice");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyInvoiceService.payInvoice(obj);
      } else {
        console.log('Not sure!');
      }
    };

        //Group Totals
        $scope.getTotalmcsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.mcsales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotalocsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.ocsales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotaltotalsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.totalsales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotalpsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.psales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };
        $scope.getTotalcsales = function (items) {
          if(items.length>0){
          return items
            .map(function (x) { return x.csales; })
            .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
          }
        };

        $scope.viewReceipts = {};
        $scope.imageString = "";
        $scope.zoomReceipts = function (receiptid) {
        console.log('receiptid',receiptid);

          var obj = {};
          obj.params = {};
          obj.params.receiptid = receiptid;
          obj.onSuccess = function (result) {
            console.log("Inside SUCCESS");
            if (result[0]) {
              // $scope.viewReceipts = JSON.parse(result[0].content);
              // console.log($scope.viewReceipts);
              //console.log('Inside zoomReceipts', code);
              $scope.viewReceipts = JSON.parse(result[0].content);
              console.log($scope.imageString);
              //$scope.open('app/pages/invoices/dailyinvoices/modals/receiptModal.html');
              
            }
          }
          obj.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            if (err.status === -1) {
              toastr.error('NO INTERNET CONNECTION', 'Error');
            } else {
              var errdetails = [];
              errdetails = err.data.error.detail;
            }
          };
          receiptService.getReceipts(obj);

        };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.dailyinvoices')
    .service('dailyInvoiceService', dailyInvoiceService);

  /** @ngInject */
  function dailyInvoiceService(Invoice) {
    var getInvoice = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);
      
      Invoice.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getDailyInvoiceWithSales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);
      
      Invoice.getDailyInvoiceWithSales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        ispaid: obj.params.ispaid?obj.params.ispaid:null

      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getInvoiceByZone = function(obj) {     
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);
      
      Invoice.find({
        filter: {
          where:{
            and:[
              {indate: {gte: dailyDate}},
              {zoneid: obj.params.zoneselection}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
          
    var getInvoiceByKey = function(obj) {

      Invoice.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          }
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createInvoice = function(obj) {

      var date = new Date();

      Invoice.createMany(
        obj.params
      
      ).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };


    var deleteInvoice = function(obj) {
      Invoice.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveInvoice = function(obj) {
      var date = new Date();

      Invoice.prototype$updateAttributes({
        id: obj.params.id,
        onlineshorts: obj.params.onlineshorts,
        machineshorts: obj.params.machineshorts,
        lastupdated: date
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var payInvoice = function(obj) {

      var date = new Date();

      Invoice.prototype$updateAttributes({
        id: obj.params.id,
        ispaid: true,
        lastupdated: date,
        pdate: date,
        agentid: obj.params.agentid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getInvoice: getInvoice,
      getInvoiceByZone: getInvoiceByZone,
      getInvoiceByKey: getInvoiceByKey,
      createInvoice: createInvoice,
      deleteInvoice: deleteInvoice,
      saveInvoice: saveInvoice,
      getDailyInvoiceWithSales:getDailyInvoiceWithSales,
      payInvoice: payInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachinesales')
    .controller('DailymachinesalesreportPageCtrl', DailymachinesalesreportPageCtrl);

  /** @ngInject */
  function DailymachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr,
    $uibModal, receiptService, $rootScope, zoneService, userService, machineService) {
    console.log("Inside DailymachinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageMachineList = [];
    $scope.initManageMachine = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getAllMachine(obj);
    };


    $scope.manageUsersList = [];
    $scope.initAgents = function () {
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageGames");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initManageGames");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
      $scope.initManageMachine();
    };
    $scope.init();
    $scope.reportFilter = {};
    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.getDailyMachinesales = function (reportFilter) {
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0) {
              value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
      }
      if (reportFilter.agent) {
        obj.params.agentid = reportFilter.agent ? reportFilter.agent.id : null;
      }
      if (reportFilter.daynight) {
        obj.params.daynight = reportFilter.daynight ? reportFilter.daynight.value : null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.totalSalesLabel = 0;
        $scope.manageMachinesalesList = result.result;
        for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.getDailyMachinesales(obj);
    };
    //$scope.getDailyMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/machine/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveCorrection = function (manageMachinesales) {
      console.log('Inside saveMachineRead');
      
      var record = {};

      if (manageMachinesales && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: manageMachinesales.mid
        }, true);

        var localMachine = selected.length ? selected[0] : null;

        if (localMachine){
          if (localMachine && $scope.manageMachineShopList.length) {
            var selected1 = $filter('filter')($scope.manageMachineShopList, {
              machineid: localMachine.id, status:true
            },true);

            var localMachineShop = selected1.length ? selected1[0] : null;

            var diffCmIn = ((manageMachinesales.cm_in - manageMachinesales.cm_in_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffCmOut = ((manageMachinesales.cm_out - manageMachinesales.cm_out_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffBmIn = ((manageMachinesales.bm_in - manageMachinesales.bm_in_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var diffBmOut = ((manageMachinesales.bm_out - manageMachinesales.bm_out_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var cmTotalSales = diffCmIn - diffCmOut;
            var bmTotalSales = diffBmIn - diffBmOut;
    
            if (localMachine.calby)
              record.totalsales = cmTotalSales.toFixed(2);
            else {
              record.totalsales = bmTotalSales.toFixed(2);
            }

            if (localMachineShop){
              record.csales = (record.totalsales * localMachineShop.macrate / 100).toFixed(2);
              record.psales = (record.totalsales - record.csales).toFixed(2);
              record.vcmsales = (record.totalsales * localMachineShop.macvirtual / 100).toFixed(2);
              record.vpmsales = (record.totalsales - record.vcmsales).toFixed(2);
            }

            var obj = {};
            obj.params = {};
            obj.params.id = manageMachinesales.id;
            obj.params.cmin = manageMachinesales.cm_in;
            obj.params.cmout = manageMachinesales.cm_out;
            obj.params.bmin = manageMachinesales.bm_in;
            obj.params.bmout = manageMachinesales.bm_out;
            obj.params.csales = record.csales;
            obj.params.psales = record.psales;
            obj.params.totalsales = record.totalsales;
            obj.params.vcmsales = record.vcmsales;
            obj.params.vpmsales = record.vpmsales;

              console.log('obj.params', obj.params);
              
              obj.onSuccess = function (result) {
                console.log("Inside SUCCESS saveMachineRead");
                console.log(result);
                toastr.success('Machine Sales has been updated successfully!', 'SUCCESS');
                $scope.getDailyMachinesales($scope.reportFilter);
              };
            obj.onFailure = function (err) {
              console.log("Inside Failure initAgents");
              console.log(err);
            };
            dailymachinesalesreportService.saveMachinesales(obj);

        }
      } else {
        toastr.error('Something went wrong. Please try again', 'ERROR');
      }
    }
  };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
      obj.params = {};
      obj.params.receiptid = manageMachinesales.receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          $scope.viewReceipts = JSON.parse(result[0].content);
          console.log($scope.viewReceipts);
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code) {
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/machine/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid, status:true
        }, true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function (manageMachinesales) {
      if (manageMachinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function (agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        }, true);
        return selected.length ? selected[0].credentials.firstName + " " + selected[0].credentials.lastName : '';
      } else return 'Not set';
    };


    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate, 2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate, 0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate, 1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate, 0);

              console.log('checkInDate', checkInDate);
              console.log('resultInDate', resultInDate);

              if (checkInDate >= resultInDate) {
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)) {
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length) {
            dailyInvoiceService.createInvoice(objInvoice);
          } else {
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else {
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.generateInvoice(obj);
    };

    $scope.getTotaltotalsales = function (items) {
      if (items) {
        return items
          .map(function (x) { return x.totalsales; })
          .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items) {
        return items
          .map(function (x) { return x.csales; })
          .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items) {
        return items
          .map(function (x) { return x.psales; })
          .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };



}
})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachinesales')
    .service('dailymachinesalesreportService', dailymachinesalesreportService);

  /** @ngInject */
  function dailymachinesalesreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();
  
    //   var dailyDate = year+'-'+month+'-'+day;
  
    //   console.log('date',dailyDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };


    var getDailyMachinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.getDailyMachinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        shopid: obj.params.shopid?obj.params.shopid:null,
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine","receipt"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveMachinesales = function(obj) {
      var date = new Date();

      Machinesales.prototype$updateAttributes({
        id: obj.params.id,
        cmIn: obj.params.cmin,
        cmOut: obj.params.cmout,
        bmIn: obj.params.bmin,
        bmOut: obj.params.bmout,
        csales: obj.params.csales,
        psales: obj.params.psales,
        totalsales: obj.params.totalsales,
        vcmsales: obj.params.vcmsales,
        vpmsales: obj.params.vpmsales,
        lastupdated: date
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice,
      saveMachinesales:saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachineshop')
    .controller('DailymachineshopPageCtrl', DailymachineshopPageCtrl);

  /** @ngInject */
  function DailymachineshopPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachineshopService, dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, $uibModal, $rootScope, zoneService) {
    console.log("Inside DailymachineshopPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    // $scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };



    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      //$scope.initManageGames();
      $scope.initManageMachineShop();
    };
    $scope.init();

    $scope.totalSalesLabel = 0;
    $scope.manageDailymachineshop = {};
    $scope.manageDailymachineshopList = [];
    $scope.reportFilter = {};
    $scope.getDailyGroupedMachinesales = function (reportFilter) {

      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0) {
              value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        $scope.totalSalesLabel = 0;
        //$scope.initManagePrevMachineReading();
        $scope.manageDailymachineshopList = result.result;
        for (var i = 0; i < $scope.manageDailymachineshopList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageDailymachineshopList[i].totalsales);
        }
        console.log($scope.manageDailymachineshopList);
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //dailymachineshopService.getDailyMachinesales(obj);
      dailymachineshopService.getDailyGroupedMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.getDailyGroupedMachinesales();

    $scope.deleteId = null;
    /*
        $scope.confirmDelete = function(id) {
          $scope.open('app/pages/machine/dailymachineshop/modals/dangerModal.html');
          $scope.deleteId = id;
        };
    
        $scope.deleteMachinesales = function(res) {
          console.log("Inside deleteMachinesales");
          if (res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function(result) {
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
              //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
              $scope.getDailyGroupedMachinesales();
            };
            obj.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else {
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            };
            dailymachineshopService.deleteMachinesales(obj);
          } else {
            console.log('Not sure!');
          }
    
        };
    */

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageDailymachineshop = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function (manageDailymachineshop, id) {

      console.log("Inside saveMachinesales");
      console.log(manageDailymachineshop);
      console.log(manageDailymachineshop.id);

      if (manageDailymachineshop.id === undefined) {
        $scope.createMachinesales(manageDailymachineshop);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageDailymachineshop;
        /*        obj.params.id = manageDailymachineshop.id;
                obj.params.playtechid= manageDailymachineshop.playtechid;
                obj.params.pshare= manageDailymachineshop.pshare;
                obj.params.pwin= manageDailymachineshop.pwin;
                obj.params.netpurchase= manageDailymachineshop.netpurchase;
                obj.params.netgaming= manageDailymachineshop.netgaming;
                obj.params.totalsales= manageDailymachineshop.totalsales;
                obj.params.csales= manageDailymachineshop.csales;
                obj.params.psales= manageDailymachineshop.psales;
                obj.params.shopid= manageDailymachineshop.shopid;
                obj.params.gameid= manageDailymachineshop.gameid;
                // obj.params.name = $scope.manageDailymachineshop.name;
                // obj.params.description = $scope.manageDailymachineshop.description;
                //obj.params.created = $scope.manageDailymachineshop.created;
        */
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          //console.log(result);
          $scope.manageDailymachineshop = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.getDailyGroupedMachinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailymachineshopService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.salesNumbers = {};
    $scope.viewMachinesales = function (manageDailymachineshop) {
      console.log("Inside viewMachinesales");
      console.log(manageDailymachineshop);
      $scope.isEdit = true;
      $scope.manageDailymachineshop = manageDailymachineshop;

      console.log(manageDailymachineshop.ikey);
      $scope.machineSalesInvoice = {};
      $scope.getMachineInvoiceDetails(manageDailymachineshop.ikey);
      console.log($scope.machineSalesInvoice);
      $scope.getMachineSales(manageDailymachineshop.ikey);
      console.log($scope.machineSalesDetails);
    };

    $scope.getMachineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.getMachineSales = function (ikey) {
      var obj = {};
      $scope.machineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.machineSalesDetails = result;
        var data = {};
        var shopDetails = $scope.getShopDetails($scope.machineSalesDetails[0].shopid);
        console.log(shopDetails)
        console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById(shopDetails.shop.partnerid);
        data.created = shopDetails.shop.created;
        $scope.salesNumbers.data = data;
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }

    $scope.getTotalAmount = function (items) {
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseInt(a) + parseInt(b); });
    };

    $scope.showPartnerById = function (partnerid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (partnerid && $scope.managePartnerList.length) {
        //console.log($scope.manageDailymachineshop);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partnerid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getShopDetails = function (shopid) {
      if (shopid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          shopid: shopid
        }, true);
        console.log(selected);
        return selected.length ? selected[0] : null;
      } else return null;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachineshop')
    .service('dailymachineshopService', dailymachineshopService);

  /** @ngInject */
  function dailymachineshopService(Machinesales) {
    var getDailyMachinesales = function (obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.find({
        filter: {
          where: {
            indate: {
              "gte": dailyDate
            }
          },
          include: ["machine", "shop"]
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyGroupedMachinesales = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('dailyDate ',dailyDate);
      Machinesales.grpShop({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function (obj) {
      Machinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          }
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    /*  var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
*/
    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyGroupedMachinesales: getDailyGroupedMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey
      //      createMachinesales: createMachinesales,
      //      deleteMachinesales: deleteMachinesales
      //    saveMachinesales: saveMachinesales
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.machinesales')
    .controller('MachinesalesreportPageCtrl', MachinesalesreportPageCtrl);

  /** @ngInject */
  function MachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesreportService, machineShopService, gameService, shopService, partnerService, machinesalesService, dailyInvoiceService, validationService, toastr, $uibModal, $rootScope, zoneService, receiptService, userService, machineService,dailymachinesalesreportService) {
    console.log("Inside MachinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.manageMachineList = [];
    $scope.initManageMachine = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getAllMachine(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
      $scope.initManageMachine();
    }
    $scope.init();

    $scope.reportFilter = {};
    $scope.searchMachinesales = function (reportFilter) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0) {
                value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
          }
        }
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }
        if (reportFilter.agent){
          obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        }
        if (reportFilter.daynight){
          obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
        }
        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          $scope.manageMachinesalesList = result.result;
          for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          // $scope.initManagePartner();
          // $scope.initManageGames();
          // $scope.initManageMachineShop();
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machinesalesreportService.getBetweenDatesMachinesales(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    // $scope.searchMachinesales = function() {
    //   var obj = {};
    //   obj.params = {};
    //   obj.params.fromDt = $scope.dateList.from;
    //   obj.params.toDt = $scope.dateList.to;

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.initManagePartner();
    //     $scope.initManageGames();
    //     $scope.initManageMachineShop();
    //     //$scope.initManagePrevMachineReading();
    //     $scope.manageMachinesalesList = result;
    //     $scope.isEdit = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machinesalesreportService.getBetweenDatesMachinesales(obj);
    //   //$scope.$broadcast('scroll.refreshComplete');
    // };
    //$scope.searchMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/machine/machinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.searchMachinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function (manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.searchMachinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      console.log(manageMachinesales);
      $scope.manageMachinesales = manageMachinesales;
      
      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
          $scope.getMachineInvoiceDetails(manageMachinesales.ikey);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);
      
    };

    // $scope.dateformater = function(ikey) {
    //   var strikey = ikey.toString()
    //   var date = strikey.substring(strikey.length - 8);
    //   return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
    // };

    $scope.getMachineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.machineSalesInvoice = {};
      obj.onSuccess = function (result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid, status:true
        }, true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function (manageMachinesales) {
      if (manageMachinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };




    $scope.saveCorrection = function (manageMachinesales) {
      console.log('Inside saveMachineRead');
      
      var record = {};

      if (manageMachinesales && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: manageMachinesales.mid
        }, true);

        var localMachine = selected.length ? selected[0] : null;

        if (localMachine){
          if (localMachine && $scope.manageMachineShopList.length) {
            var selected1 = $filter('filter')($scope.manageMachineShopList, {
              machineid: localMachine.id, status:true
            },true);

            var localMachineShop = selected1.length ? selected1[0] : null;

            var diffCmIn = ((manageMachinesales.cm_in - manageMachinesales.cm_in_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffCmOut = ((manageMachinesales.cm_out - manageMachinesales.cm_out_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffBmIn = ((manageMachinesales.bm_in - manageMachinesales.bm_in_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var diffBmOut = ((manageMachinesales.bm_out - manageMachinesales.bm_out_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var cmTotalSales = diffCmIn - diffCmOut;
            var bmTotalSales = diffBmIn - diffBmOut;
    
            if (localMachine.calby)
              record.totalsales = cmTotalSales.toFixed(2);
            else {
              record.totalsales = bmTotalSales.toFixed(2);
            }

            if (localMachineShop){
              record.csales = (record.totalsales * localMachineShop.macrate / 100).toFixed(2);
              record.psales = (record.totalsales - record.csales).toFixed(2);
              record.vcmsales = (record.totalsales * localMachineShop.macvirtual / 100).toFixed(2);
              record.vpmsales = (record.totalsales - record.vcmsales).toFixed(2);
            }

            var obj = {};
            obj.params = {};
            obj.params.id = manageMachinesales.id;
            obj.params.cmin = manageMachinesales.cm_in;
            obj.params.cmout = manageMachinesales.cm_out;
            obj.params.bmin = manageMachinesales.bm_in;
            obj.params.bmout = manageMachinesales.bm_out;
            obj.params.csales = record.csales;
            obj.params.psales = record.psales;
            obj.params.totalsales = record.totalsales;
            obj.params.vcmsales = record.vcmsales;
            obj.params.vpmsales = record.vpmsales;

              console.log('obj.params', obj.params);
              
              obj.onSuccess = function (result) {
                console.log("Inside SUCCESS saveMachineRead");
                console.log(result);
                toastr.success('Machine Sales has been updated successfully!', 'SUCCESS');
                $scope.searchMachinesales($scope.reportFilter);
              };
            obj.onFailure = function (err) {
              console.log("Inside Failure initAgents");
              console.log(err);
            };
            dailymachinesalesreportService.saveMachinesales(obj);

        }
      } else {
        toastr.error('Something went wrong. Please try again', 'ERROR');
      }
    }
  };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.machinesales')
    .service('machinesalesreportService', machinesalesreportService);

  /** @ngInject */
  function machinesalesreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getUTCDate();
    //   //var newDate  = new Date(date);
    //   console.log('date',date);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": date}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   td.setHours(23);
    //   td.setMinutes(59);
    //   td.setSeconds(59);
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('client from date',fd);
    //   console.log('client from date1',date1); 
    //   console.log('client to date',td);
    //   console.log('client to date2',date2); 

    //   Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {indate: {gte: date1}},
    //                 {indate: {lte: date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    var getBetweenDatesMachinesales = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Machinesales.getAllMachinesales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var deleteMachinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      // getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales,
     getAvailableMachineByZone:getAvailableMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.msync.importofficers')
    .controller('ImportofficersPageCtrl', ImportofficersPageCtrl);

  /** @ngInject */
  function ImportofficersPageCtrl($scope, $filter, editableOptions, editableThemes,
    importofficersService, toastr, $uibModal, SheetJSExportService, areaService, emprateService, departmentService,
    userService, validationService, siteService, $rootScope) {
    console.log("Inside ImportofficersPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 100;
    $scope.manageImportofficers = {
      user: $rootScope.userData,
    };
    $scope.manageImportofficersList = [];
    $scope.manageUser = {};
    $scope.manageUserList = [];
    $scope.initManageUser = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsersMSync(obj);
    };

    $scope.manageAreasList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageEmprateList = [];
    $scope.initManageEmprate = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageEmprateList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      emprateService.getEmprate(obj);
    };

    $scope.manageDepartmentList = [];
    $scope.initManageDepartments = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDepartmentList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      departmentService.getDepartments(obj);
    };


    $scope.initManageImportofficers = function () {
      console.log($scope.manageImportofficers.import);
      $scope.initManageDepartments();
      $scope.initManageEmprate();
      $scope.initManageAreas();
      $scope.initManageUser();
      $scope.initManageSite();
      $scope.manageImportofficers = {
        user: $rootScope.userData,
      };
      $scope.gridOptions = {};

      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageImportofficers();
    $scope.passOnlinesales = function (manageImportofficers) {
      console.log("Inside passOnlinesales");
      console.log(manageImportofficers);
    }

    $scope.getDepartmentId = function (deptName) {
      if (deptName && $scope.manageDepartmentList.length) {
        var selected = $filter('filter')($scope.manageDepartmentList, {
          name: deptName
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.getEmprateId = function (emprate) {
      if (emprate && $scope.manageEmprateList.length) {
        var selected = $filter('filter')($scope.manageEmprateList, {
          name: emprate
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.getAreaId = function (area) {
      if (area && $scope.manageAreasList.length) {
        var selected = $filter('filter')($scope.manageAreasList, {
          name: area
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.getSiteId = function (site) {
      if (site && $scope.manageSiteList.length) {
        var selected = $filter('filter')($scope.manageSiteList, {
          name: site
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.createImportofficers = function () {
      console.log("Inside manageImportofficers");
      console.log($scope.gridOptions.data);
      var isFormValidated = true;

      if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        toastr.error('Please select file to Upload', 'ERROR');
      }

      if (isFormValidated) {

        var date = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          if ($scope.gridOptions.data[i].post && $scope.gridOptions.data[i].name && $scope.gridOptions.data[i].area) {
            console.log('$scope.gridOptions.data[i]', $scope.gridOptions.data[i]);

            record.emprateid = $scope.getEmprateId(($scope.gridOptions.data[i].post).trim());
            record.firstname = $scope.gridOptions.data[i].name;
            record.sprate = $scope.gridOptions.data[i].rate ? ($scope.gridOptions.data[i].rate).trim() : 0;
            record.sprate1 = $scope.gridOptions.data[i].rate1 ? ($scope.gridOptions.data[i].rate1).trim() : 0;
            record.departmentid = $scope.gridOptions.data[i].department ? $scope.getDepartmentId(($scope.gridOptions.data[i].department).trim()) : null;
            record.areaid = $scope.getAreaId(($scope.gridOptions.data[i].area).trim());
            record.siteid = $scope.gridOptions.data[i].balai ? $scope.getSiteId(($scope.gridOptions.data[i].balai).trim()) : null;
            record.managerid = $scope.manageImportofficers.user.id;
            record.ownerid = $scope.manageImportofficers.user.id;
            record.created = date;
            record.lastupdated = date;
            console.log(record);
            obj.params.push(record);
          }
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};

          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          toastr.success('New Officer Details has been saved successfully!', 'SUCCESS');
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {
            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.rate = err.config.data[i].emprateid;
                data.name = err.config.data[i].firstname;
                data.rate = err.config.data[i].sprate;
                data.rate1 = err.config.data[i].sprate1;
                data.department = err.config.data[i].departmentid;
                data.area = err.config.data[i].areaid;
                if (typeof err.config.data[i].firstname === 'undefined') {
                  data.ERROR = 'Blank Officer Name';
                } else if (typeof err.config.data[i].departmentid === 'undefined') {
                  data.ERROR = 'Blank Department';
                }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        }
        importofficersService.createImportofficers(obj);
      }
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers')
    .service('departmentService', departmentService);

  /** @ngInject */

  function departmentService(Department) {

    var getDepartments = function(obj) {
      
          Department.find({
            filter:{
              include:["area"]
            }
          }).$promise.then(function(data) {
            console.log(data);
            obj.onSuccess(data);
      
          }, function(err) {
            //$ionicLoading.hide();
            obj.onFailure(err);
          });
        };
    return {
      getDepartments: getDepartments
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers')
    .service('emprateService', emprateService);

  /** @ngInject */

  function emprateService(Emprate) {

    var getEmprate = function(obj) {
      Emprate.find().$promise.then(function(data) {
            console.log(data);
            obj.onSuccess(data);
      
          }, function(err) {
            //$ionicLoading.hide();
            obj.onFailure(err);
          });
        };
    return {
      getEmprate: getEmprate
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers')
    .service('importofficersService', importofficersService);

  /** @ngInject */

  function importofficersService(Employees) {

    var createImportofficers = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Employees.createMany(
        obj.params
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      createImportofficers: createImportofficers
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.officers')
    .controller('OfficersPageCtrl', OfficersPageCtrl);

  /** @ngInject */
  function OfficersPageCtrl($scope, $filter, editableOptions, editableThemes,
    officersService, toastr, $uibModal, userService,emprateService, departmentService, areaService, validationService, siteService) {
    console.log("Inside OfficersPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.manageAreasList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    
    $scope.manageEmprateList = [];
    $scope.initManageEmprate = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageEmprateList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      emprateService.getEmprate(obj);
    };

    $scope.manageDepartmentList = [];
    $scope.initManageDepartments = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDepartmentList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      departmentService.getDepartments(obj);
    };

    $scope.smartTablePageSize = 100;

    
    $scope.manageOfficersList = [];
    $scope.manageOfficer = {};
    $scope.initManageOfficers = function() {
      var obj = {};
      obj.params = {};
//      $scope.manageOfficer.user = user.credentials.firstName;
      obj.params.firstname = $scope.manageOfficer.userSearch;
      console.log($scope.manageOfficer.userSearch);
      

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOfficersList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      officersService.getOfficers(obj);
    };

    //$scope.initManageOfficers();

    $scope.manageUser = {};
    $scope.manageUserList = [];
    $scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsersMSync(obj);
    };

    $scope.initManageUser();
    $scope.initManageAreas();
    $scope.initManageEmprate();
    $scope.initManageDepartments();
    $scope.initManageSite();

    $scope.searchOfficers = function (userid) {
      var obj = {};
      obj.params = {};
      //$scope.manageOfficer.userSearch = user.credentials.firstName;
      obj.params.ownerid = userid;
      console.log(userid);
      $scope.manageOfficer.userSearch = userid;
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(userid)) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please select a Game, Date and choose a file to Upload', 'ERROR');
        toastr.error('Please select Mobile User', 'ERROR');
      }

      if (isFormValidated) {
        obj.onSuccess = function (result) {
          console.log("Inside searchOfficers SUCCESS");
          console.log(result);
          $scope.totalAmount = 0;
          $scope.totalAmount1 = 0;
          for (var i = 0; i < result.length; i++) {
            $scope.totalAmount =  $scope.totalAmount + parseFloat(result[i].sprate);
            $scope.totalAmount1 =  $scope.totalAmount1 + parseFloat(result[i].sprate1);
          }
          $scope.manageOfficersList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside searchOfficers Failure");
          console.log(err);
        };
        officersService.getOfficers(obj);
      }
    }

    $scope.addOfficer = function() {
      //genericModalService.show('modules/modals/addOfficer.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageOfficersList.push($scope.inserted);
    };

    $scope.createOfficer = function(manageOfficer) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOfficer");
      console.log(manageOfficer);

      var obj = {};
      obj.params = {};
      obj.params = manageOfficer;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOfficer = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        //$scope.initManageOfficers();
        $scope.searchOfficers($scope.manageOfficer.userSearch);

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      officersService.createOfficer(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/msync/officers/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOfficer = function(res) {
      console.log("Inside deleteOfficer");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          //$scope.initManageOfficers();
          $scope.searchOfficers($scope.manageOfficer.userSearch);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        officersService.deleteOfficer(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageOfficer.id = $scope.manageOfficer.id;
      // $scope.manageOfficer.name = state.name;
      // $scope.manageOfficer.description = state.description;
      // $scope.manageOfficer.created = state.created;
      // $scope.manageOfficer.lastupdated = state.lastupdated;
      $scope.manageOfficer = state;
      genericModalService.show('modules/modals/addOfficer.html', $scope);
    }

    $scope.saveOfficer = function(manageOfficer, id,ownerid) {

      console.log("Inside saveOfficer");
      console.log(manageOfficer);
      console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.sprate = manageOfficer.sprate;
        obj.params.sprate1 = manageOfficer.sprate1;
        obj.params.emprateid = manageOfficer.emprateid;
        obj.params.firstname = manageOfficer.firstname;
        obj.params.departmentid = manageOfficer.departmentid;
        obj.params.siteid = manageOfficer.siteid;
        obj.params.areaid = manageOfficer.areaid;
        obj.params.id = id;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOfficer = {};
          toastr.success('Officer record has been saved successfully!', 'SUCCESS');
          $scope.searchOfficers(ownerid);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        officersService.saveOfficer(obj);
    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getDepartmentId = function(deptName) {
      if (deptName &&  $scope.manageDepartmentList.length){
        var selected = $filter('filter')($scope.manageDepartmentList, {id : deptName
        },true);
        return selected.length ? selected[0].name : null;
      }else return null;
    };

    $scope.getEmprateId = function(emprate) {
      if(emprate && $scope.manageEmprateList.length) {
        var selected = $filter('filter')($scope.manageEmprateList, {id : emprate
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };
    
    $scope.getAreaId = function(area) {
      if(area && $scope.manageAreasList.length) {
        var selected = $filter('filter')($scope.manageAreasList, {id: area
        });
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    $scope.getSiteId = function(site) {
      if(site && $scope.manageSiteList.length) {
        var selected = $filter('filter')($scope.manageSiteList, {id: site
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.officers')
    .service('officersService', officersService);

  /** @ngInject */
  function officersService(Employees) {
    var getOfficers = function(obj) {

    Employees.find({
      filter: {
        where:{
          ownerid:obj.params.ownerid,
        },
        include: ["project", "emprate", "supervisor", "manager","owner", "site", "area", "department"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var getUnAssingnedOfficers = function(obj) {

    Employees.find({
      filter: {
        where:{
          ownerid:obj.params.ownerid,
        },
        include: ["project", "emprate", "supervisor", "manager","owner", "site", "area", "department"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  // var createOfficer = function(obj) {
  //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

  //   var date = new Date();

  //   Employees.create({
  //     name:obj.params.name,
  //     description:obj.params.description?obj.params.description:null,
  //     stateid: obj.params.state,
	//      zoneid: obj.params.zone,
  //     created: date,
  //     lastupdated: date
  //   }).$promise.then(function(data) {
  //     //$ionicLoading.hide();
  //     //console.log(data);
  //     obj.onSuccess(data);

  //   }, function(err) {
  //     //$ionicLoading.hide();
  //     //console.log(err)
  //     obj.onFailure(err);
  //   });
  // };


  var deleteOfficer = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Employees.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveOfficer = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Employees.prototype$updateAttributes({
      id: obj.params.id,
      emprateid: obj.params.emprateid,
      firstname: obj.params.firstname,
      sprate: obj.params.sprate?obj.params.sprate:0,
      sprate1: obj.params.sprate1?obj.params.sprate1:0,
      departmentid: obj.params.departmentid,
      siteid: obj.params.siteid,
      areaid: obj.params.areaid,
      //supid: obj.params.supid,
      //managerid: obj.params.managerid,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getOfficers: getOfficers,
//      createOfficer: createOfficer,
      deleteOfficer: deleteOfficer,
      saveOfficer: saveOfficer,
      getUnAssingnedOfficers:getUnAssingnedOfficers
    };

  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.paylist')
    .service('paylistService', paylistService);

  /** @ngInject */
  function paylistService(Paylist) {
    var getPaylist = function(obj) {

    Paylist.find({
      filter: {
        where:{
          ownerid:obj.params.ownerid,
        },
        include:["owner","shared","useraccount","account"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  // var createOfficer = function(obj) {
  //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

  //   var date = new Date();

  //   Paylist.create({
  //     name:obj.params.name,
  //     description:obj.params.description?obj.params.description:null,
  //     stateid: obj.params.state,
	//      zoneid: obj.params.zone,
  //     created: date,
  //     lastupdated: date
  //   }).$promise.then(function(data) {
  //     //$ionicLoading.hide();
  //     //console.log(data);
  //     obj.onSuccess(data);

  //   }, function(err) {
  //     //$ionicLoading.hide();
  //     //console.log(err)
  //     obj.onFailure(err);
  //   });
  // };


  var deleteOfficer = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Paylist.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var createPaylist = function(obj) {
    var date = new Date();

    Paylist.create({
      name:obj.params.name,
      ownerid:obj.params.ownerid,
      shareid:obj.params.shared,
      useraccountid: obj.params.useraccountid,
      accountid: obj.params.accountid,
      amount: obj.params.amount,
      plist: obj.params.plist,
      entrydate: date,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };


  var savePaylist = function(obj) {
    var date = new Date();

    Paylist.prototype$updateAttributes({
      id: obj.params.id,
      name:obj.params.name,
      ownerid:obj.params.ownerid,
      shareid:obj.params.shared,
      useraccountid: obj.params.useraccountid,
      accountid: obj.params.accountid,
      amount: obj.params.amount,
      plist: obj.params.plist,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

    return{
      getPaylist: getPaylist,
      createPaylist:createPaylist,
      deleteOfficer: deleteOfficer,
      savePaylist: savePaylist
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.paylist')
    .controller('PaylistPageCtrl', PaylistPageCtrl);

  /** @ngInject */
  function PaylistPageCtrl($scope, $filter, editableOptions, editableThemes,
    paylistService, toastr, $uibModal, userService,emprateService, departmentService, areaService, validationService, siteService,officersService) {
    console.log("Inside PaylistPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.manageAreasList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    
    $scope.manageEmprateList = [];
    $scope.initManageEmprate = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageEmprateList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      emprateService.getEmprate(obj);
    };

    $scope.manageDepartmentList = [];
    $scope.initManageDepartments = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDepartmentList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      departmentService.getDepartments(obj);
    };

    $scope.smartTablePageSize = 100;

    
    $scope.managePaylistList = [];
    $scope.manageOfficer = {};
    $scope.initManagePaylist = function() {
      
      var obj = {};
      obj.params = {};
//      $scope.manageOfficer.user = user.credentials.firstName;
      obj.params.firstname = $scope.manageOfficer.userSearch;
      console.log($scope.manageOfficer.userSearch);
      

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePaylistList = result;
       
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      paylistService.getPaylist(obj);
    };

    //$scope.initManagePaylist();

    $scope.manageUser = {};
    $scope.manageUserList = [];
    $scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsersMSync(obj);
    };

    $scope.initManageUser();
    $scope.initManageAreas();
    $scope.initManageEmprate();
    $scope.initManageDepartments();
    $scope.initManageSite();

    $scope.searchPaylist = function (userid) {
      var obj = {};
      obj.params = {};
      //$scope.manageOfficer.userSearch = user.credentials.firstName;
      obj.params.ownerid = userid;
      console.log(userid);
      $scope.manageOfficer.userSearch = userid;
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(userid)) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please select a Game, Date and choose a file to Upload', 'ERROR');
        toastr.error('Please select Mobile User', 'ERROR');
      }

      if (isFormValidated) {
        obj.onSuccess = function (result) {
          console.log("Inside searchPaylist SUCCESS");
          console.log(result);
          $scope.totalAmount = 0;
          $scope.totalAmount1 = 0;
          for (var i = 0; i < result.length; i++) {
            $scope.totalAmount =  $scope.totalAmount + parseFloat(result[i].sprate);
            $scope.totalAmount1 =  $scope.totalAmount1 + parseFloat(result[i].sprate1);
          }
          $scope.managePaylistList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside searchPaylist Failure");
          console.log(err);
        };
        paylistService.getPaylist(obj);
      }
    }

    $scope.addPaylist = function() {
      //genericModalService.show('modules/modals/addOfficer.html',$scope);
      // $scope.inserted = {
      //   name: null,
      //   description: null,
      // };
      // $scope.managePaylistList.push($scope.inserted);
      $scope.isEdit = true;
    };

    $scope.assignOfficer = function (item) {
      if (item.issprate){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) + parseFloat(item.sprate);
      }
      if (item.issprate1){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) + parseFloat(item.sprate1);
      }
      $scope.manageOfficer.plist.push(item);
    };
    $scope.removeOfficer = function (item) {
      if (item.issprate){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) - parseFloat(item.sprate);
      }
      if (item.issprate1){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) - parseFloat(item.sprate1);
      }
      $scope.manageOfficer.plist = $scope.manageOfficer.plist.filter(function(el){return el.id!=item.id;});
    };
    $scope.selectAmount = function(item,issprate,issprate1){
      item.issprate = null;
      item.issprate1 = null;
      if (issprate){
        item.issprate= true;
        item.issprate1= null;
      }
      if (issprate1){
        item.issprate1= true;
        item.issprate= null;
      }
    };

    $scope.createOfficer = function(manageOfficer) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOfficer");
      console.log(manageOfficer);

      var obj = {};
      obj.params = {};
      obj.params = manageOfficer;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOfficer = {};
        toastr.success('New Paylist has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Playlist successfully created.");
        //$scope.initManagePaylist();
        $scope.searchPaylist($scope.manageOfficer.userSearch);

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      paylistService.createOfficer(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/msync/paylist/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOfficer = function(res) {
      console.log("Inside deleteOfficer");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Paylist has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Paylist successfully deleted.");
          //$scope.initManagePaylist();
          $scope.searchPaylist($scope.manageOfficer.userSearch);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        paylistService.deleteOfficer(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.notSelectedOfficerList = [];
    $scope.editPaylist = function(item) {
      console.log("Inside editPaylist");
      $scope.isEdit = true;
      $scope.manageOfficer = item;
      $scope.notSelectedOfficerList = [];
      //genericModalService.show('modules/modals/addOfficer.html', $scope);
      $scope.getNotSelectedOfficers(item);
    };

    $scope.addOfficer = function () {
      $scope.isAssignNewOfficer = true;
    };
    $scope.closeOfficer = function () {
      $scope.isAssignNewOfficer = false;
    };

    $scope.getNotSelectedOfficers = function (item) {

        var obj = {};
        obj.params = {};
        obj.params.ownerid = item.ownerid;
  
        console.log('obj.params', obj.params);
  
        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedShops SUCCESS");
          console.log(result);
          $scope.notSelectedOfficerList = result;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        officersService.getUnAssingnedOfficers(obj);
    };

    $scope.savePaylist = function(managePaylist) {

      console.log("Inside savePaylist");
      console.log(managePaylist);
      //console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.id = managePaylist.id?managePaylist.id:null;
        obj.params.name = managePaylist.name;
        obj.params.ownerid = managePaylist.ownerid;
        obj.params.shared = managePaylist.shared;
        obj.params.useraccountid = managePaylist.useraccountid;
        obj.params.accountid = managePaylist.accountid;
        obj.params.amount = managePaylist.amount;
        obj.params.plist = managePaylist.plist;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Officer record has been saved successfully!', 'SUCCESS');
          $scope.searchPaylist($scope.manageOfficer.ownerid);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        paylistService.savePaylist(obj);
    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getDepartmentId = function(deptName) {
      if (deptName &&  $scope.manageDepartmentList.length){
        var selected = $filter('filter')($scope.manageDepartmentList, {id : deptName
        },true);
        return selected.length ? selected[0].name : null;
      }else return null;
    };

    $scope.getEmprateId = function(emprate) {
      if(emprate && $scope.manageEmprateList.length) {
        var selected = $filter('filter')($scope.manageEmprateList, {id : emprate
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };
    
    $scope.getAreaId = function(area) {
      if(area && $scope.manageAreasList.length) {
        var selected = $filter('filter')($scope.manageAreasList, {id: area
        });
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    $scope.getSiteId = function(site) {
      if(site && $scope.manageSiteList.length) {
        var selected = $filter('filter')($scope.manageSiteList, {id: site
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.getTotaltotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.amount; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlinesales')
    .controller('DailyonlinesalesreportPageCtrl', DailyonlinesalesreportPageCtrl);

  /** @ngInject */
  function DailyonlinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailyonlinesalesreportService, onlineShopService, gameService, shopService, partnerService, toastr, $uibModal,
    dailyInvoiceService, $rootScope, zoneService) {
    console.log("Inside DailyonlinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{
        value: $rootScope.userData.credentials.shopType
      }];
    } else {
      $scope.shopTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };
    $scope.reportFilter = {};
    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.totalSalesLabel = 0;

    $scope.getDailyOnlinesales = function (reportFilter) {
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0) {
              value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        // $scope.initManageShop();
        $scope.totalSalesLabel = 0;
        $scope.manageOnlinesalesList = result.result;
        for (var i = 0; i < $scope.manageOnlinesalesList.length; i++) {
          //$scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageOnlinesalesList[i].netpurchase) + parseFloat($scope.manageOnlinesalesList[i].pshare) + parseFloat($scope.manageOnlinesalesList[i].pwin);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlinesalesreportService.getOnlinesales(obj);
    };
    //$scope.getDailyOnlinesales();
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageOnlinesalesList.push($scope.inserted);
        };
    */
    $scope.createOnlinesales = function (manageOnlinesales) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlinesales.name);
      //console.log(manageOnlinesales.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageOnlinesales.id;
      obj.params.playtechid = manageOnlinesales.playtechid;
      obj.params.pshare = manageOnlinesales.pshare;
      obj.params.pwin = manageOnlinesales.pwin;
      obj.params.netpurchase = manageOnlinesales.netpurchase;
      obj.params.netgaming = manageOnlinesales.netgaming;
      obj.params.totalsales = manageOnlinesales.totalsales;
      obj.params.csales = manageOnlinesales.csales;
      obj.params.psales = manageOnlinesales.psales;

      //obj.params.description = manageOnlinesales.description;
      console.log(manageOnlinesales);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlinesales = {};
        toastr.success('New Onlinesales has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.getDailyOnlinesales($scope.reportFilter);

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      dailyonlinesalesreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/online/dailyonlinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function (res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.getDailyOnlinesales($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyonlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveOnlinesales = function (manageOnlinesales, id) {

      console.log("Inside saveOnlinesales");
      console.log(manageOnlinesales);
      console.log(manageOnlinesales.id);

      if (manageOnlinesales.id === undefined) {
        $scope.createOnlinesales(manageOnlinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageOnlinesales;
        obj.params.id = manageOnlinesales.id;
        obj.params.playtechid = manageOnlinesales.playtechid;
        obj.params.pshare = manageOnlinesales.pshare;
        obj.params.pwin = manageOnlinesales.pwin;
        obj.params.netpurchase = manageOnlinesales.netpurchase;
        obj.params.netgaming = manageOnlinesales.netgaming;
        obj.params.totalsales = manageOnlinesales.totalsales;
        obj.params.csales = manageOnlinesales.csales;
        obj.params.psales = manageOnlinesales.psales;
        obj.params.shopid = manageOnlinesales.shopid;
        obj.params.gameid = manageOnlinesales.gameid;
        // obj.params.name = $scope.manageOnlinesales.name;
        // obj.params.description = $scope.manageOnlinesales.description;
        //obj.params.created = $scope.manageOnlinesales.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlinesales = {};
          toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.getDailyOnlinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyonlinesalesreportService.saveOnlinesales(obj);

        //$scope.modal.hide();
      }

    }

    /*
        $scope.datePickerPopup = function(onlinesales) {
            $scope.open = open;
            $scope.opened = false;
            $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
            $scope.format = $scope.formats[0];
            $scope.options = {
                showWeeks: false
            };

            function open() {
                $scope.opened = true;
            }
        }
    */
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function (manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      console.log($scope.manageOnlinesales);
    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageOnlinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.getInDate = function (date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    // $scope.genIvoiceOnlinesales =function (manageOnlinesalesList){
    //   console.log('Inside genIvoiceOnlinesales');
    //   console.log(manageOnlinesalesList);


    //   if (manageOnlinesalesList.length){
    //     var date = new Date();
    //     //var invoiceDate = new Date();
    //     //invoiceDate.setDate(date.getDate() - 1);

    //     var objInvoice = {};
    //     objInvoice.params=[];
    //     for (var index = 0; index < manageOnlinesalesList.length; index++) {
    //       var recordInvoice = {};

    //       var ikeyString = manageOnlinesalesList[index].ikey.toString();
    //       var ikeyDate = ikeyString.substring(ikeyString.length - 8);
    //       var shopid = parseInt(ikeyString.substring(0, ikeyString.length - 8));
    //       console.log('ikeyDate',ikeyDate);

    //       var tempDate = ikeyDate.substring(2,4)+'/'+ikeyDate.substring(0,2)+'/'+ikeyDate.substring(4,8);

    //       var invoiceDate = new Date(tempDate);
    //       var indate = new Date();
    //       // indate.setDate(indate.getDate()-1);
    //       console.log('invoiceDate',invoiceDate);

    //       recordInvoice.invoicedate = invoiceDate;
    //       recordInvoice.indate = $scope.getInDate(indate);
    //       recordInvoice.created = date;
    //       recordInvoice.lastupdated = date;
    //       recordInvoice.ikey = manageOnlinesalesList[index].ikey;
    //       recordInvoice.shopid = shopid;
    //       recordInvoice.zoneid = manageOnlinesalesList[index].shop.zoneid;
    //       objInvoice.params.push(recordInvoice);
    //     }
    //     console.log(objInvoice.params);

    //     objInvoice.onSuccess = function (result) {
    //       console.log("Inside SUCCESS genIvoiceOnlinesales");
    //       console.log(result);
    //       toastr.success('New Invoice has been generated successfully!', 'SUCCESS');


    //     }
    //     objInvoice.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
    //     };

    //     dailyInvoiceService.createInvoice(objInvoice);
    //   }

    // }
    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceOnlinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      // var adate = new Date('10/24/2018');
      var adate = new Date();

      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate, 2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            var newInDate = new Date(invoiceList[index].indate);
            var resultInDate = $scope.getInDate(newInDate, 0);

            recordInvoice.invoicedate = resultInDate;
            recordInvoice.indate = resultInDate;
            recordInvoice.created = date;
            recordInvoice.lastupdated = date;
            recordInvoice.ikey = invoiceList[index].ikey;
            recordInvoice.shopid = invoiceList[index].shopid;
            recordInvoice.zoneid = invoiceList[index].zoneid;

            if (!_.isEmpty(recordInvoice)) {
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length) {
            dailyInvoiceService.createInvoice(objInvoice);
          } else {
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else {
          toastr.error('No Pending Invoices', 'ERROR');
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlinesalesreportService.generateInvoiceOnline(obj);
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlinesales')
    .service('dailyonlinesalesreportService', dailyonlinesalesreportService);

  /** @ngInject */
  function dailyonlinesalesreportService(Onlinesales) {
    // var getOnlinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();

    //   var dailyDate = year+'-'+month+'-'+day;

    //   console.log('date',dailyDate);

    //   Onlinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["game","shop"]
    //     }
    //   }).$promise.then(function(data) {
    // //  Onlinesales.find().$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getOnlinesales = function (obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      // To generate custom date invoice, edit date below.
      var dailyDate = year + '-' + month + '-' + day;

      console.log('dailyDate ', dailyDate);

      Onlinesales.getDailyOnlinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };



    var getDailyOnlinesalesByKey = function (obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoiceOnline = function (obj) {

      Onlinesales.generateInvoiceOnline({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      generateInvoiceOnline: generateInvoiceOnline
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlineshop')
    .controller('DailyonlineshopreportPageCtrl', DailyonlineshopreportPageCtrl);

  /** @ngInject */
  function DailyonlineshopreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailyonlineshopreportService, dailyonlinesalesreportService, onlineShopService, gameService, shopService, partnerService, toastr, $uibModal,dailyInvoiceService,$rootScope,zoneService) {
    console.log("Inside DailyonlineshopreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    // $scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getOnlineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageShopList = [];
    // $scope.initManageShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   shopService.getShop(obj);
    // };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageOnlineshop = {};
    $scope.manageOnlineshopList = [];
    $scope.totalSalesLabel = 0;
    $scope.reportFilter={};
    $scope.getAllOnlinesales = function(reportFilter) {

      var obj = {};
      obj.params = {};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        //$scope.initManageGames();
        //$scope.initManageShop();
        $scope.totalSalesLabel = 0;
        $scope.manageOnlineshopList = result.result;
        for (var i=0; i< $scope.manageOnlineshopList.length;i++){
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageOnlineshopList[i].netpurchase) + parseFloat($scope.manageOnlineshopList[i].pshare) + parseFloat($scope.manageOnlineshopList[i].pwin);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlineshopreportService.getDailyGroupedOnlinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.getAllOnlinesales();

    $scope.deleteId = null;
    // $scope.confirmDelete = function(id) {
    //   $scope.open('app/pages/online/dailyonlinesales/modals/dangerModal.html');
    //   $scope.deleteId = id;
    // };

    // $scope.deleteOnlinesales = function(res) {
    //   console.log("Inside deleteOnlinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
    //       $scope.getAllOnlinesales();
    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.deleteOnlinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // }

    $scope.editState = function(onlinesales) {
      console.log("Inside viewOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlineshop.id = $scope.manageOnlineshop.id;
      // $scope.manageOnlineshop.name = state.name;
      // $scope.manageOnlineshop.description = state.description;
      // $scope.manageOnlineshop.created = state.created;
      // $scope.manageOnlineshop.lastupdated = state.lastupdated;
      $scope.manageOnlineshop = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    // $scope.saveOnlinesales = function(manageOnlineshop, id) {

    //   console.log("Inside saveOnlinesales");
    //   console.log(manageOnlineshop);
    //   console.log(manageOnlineshop.id);

    //   if (manageOnlineshop.id === undefined) {
    //     $scope.createOnlinesales(manageOnlineshop);
    //   } else {

    //     var obj = {};
    //     obj.params = {};
    //     obj.params = manageOnlineshop;
    //     obj.params.id = manageOnlineshop.id;
    //     obj.params.playtechid= manageOnlineshop.playtechid;
    //     obj.params.pshare= manageOnlineshop.pshare;
    //     obj.params.pwin= manageOnlineshop.pwin;
    //     obj.params.netpurchase= manageOnlineshop.netpurchase;
    //     obj.params.netgaming= manageOnlineshop.netgaming;
    //     obj.params.totalsales= manageOnlineshop.totalsales;
    //     obj.params.csales= manageOnlineshop.csales;
    //     obj.params.psales= manageOnlineshop.psales;
    //     obj.params.shopid= manageOnlineshop.shopid;
    //     obj.params.gameid= manageOnlineshop.gameid;
    //     // obj.params.name = $scope.manageOnlineshop.name;
    //     // obj.params.description = $scope.manageOnlineshop.description;
    //     //obj.params.created = $scope.manageOnlineshop.created;


    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageOnlineshop = {};
    //       toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
    //       //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
    //       $scope.getAllOnlinesales();

    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //         toastr.error('NO INTERNET CONNECTION', 'Error');
    //       } else {
    //         var errdetails = [];
    //         errdetails = err.data.error.detail;
    //         toastr.error(errdetails, 'ERROR');
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.saveOnlinesales(obj);
    //     //$scope.modal.hide();
    //   }
    // }

/*
    $scope.datePickerPopup = function(onlinesales) {
        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
*/
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewOnlinesales = function (manageOnlineshop) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlineshop = manageOnlineshop;
      console.log($scope.manageOnlineshop);
      console.log(manageOnlineshop.ikey);
      $scope.onlineSalesInvoice = {};
      $scope.getOnlineInvoiceDetails(manageOnlineshop.ikey);
      console.log($scope.onlineSalesInvoice);
      $scope.getOnlineSales(manageOnlineshop.ikey);
      console.log($scope.onlineSalesDetails);
    };

    $scope.getOnlineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }
    $scope.lookupDetails = {};
    $scope.getOnlineSales = function(ikey) {
      var obj = {};
      $scope.onlineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.onlineSalesDetails = result;
        var data = {};
        //var shopDetails = $scope.getShopDetails($scope.onlineSalesDetails[0].shopid);
        //console.log(shopDetails)
        //console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById($scope.onlineSalesDetails[0].shop.partnerid);
        data.created = $scope.onlineSalesDetails[0].shop.created;
        $scope.lookupDetails.data = data;
      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      }
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (partnerid) {
      if (partnerid && $scope.managePartnerList.length) {

        var selected = $filter('filter')($scope.managePartnerList, {
          id: partnerid
        },true);
        return selected.length ? selected[0].code+', '+selected[0].name: 'Not set';
      } else return 'Not set'
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlineshop')
    .service('dailyonlineshopreportService', dailyonlineshopreportService);

  /** @ngInject */
  function dailyonlineshopreportService(Onlinesales) {
    var getOnlinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Onlinesales.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

	var getDailyGroupedOnlinesales = function (obj) {
    var days = 1; // Days you want to subtract
    var td = new Date();
    var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    var day =fd.getDate();
    var month=fd.getMonth()+1;
    var year=fd.getFullYear();

    var dailyDate = year+'-'+month+'-'+day;

    console.log('dailyDate ',dailyDate);
      Onlinesales.grpShop({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

	
    var getDailyOnlinesalesByKey = function(obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey:obj.params.ikey
          }
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      getDailyGroupedOnlinesales: getDailyGroupedOnlinesales
  //    getByDateOnlinesales: getByDateOnlinesales,
      //createOnlinesales: createOnlinesales,
      //deleteOnlinesales: deleteOnlinesales,
      //saveOnlinesales: saveOnlinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.online.onlinesales')
    .controller('OnlinesalesreportPageCtrl', OnlinesalesreportPageCtrl);

  /** @ngInject */
  function OnlinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    onlinesalesreportService, onlineShopService, gameService, shopService, partnerService,dailyInvoiceService,
    toastr, $uibModal,validationService,$rootScope, zoneService) {
    console.log("Inside OnlinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    $scope.totalSalesLabel = 0;
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();



    $scope.dateList = {};
    $scope.reportFilter={};
    $scope.searchOnlinesales = function (reportFilter) {
      console.log("Inside searchOnlinesales");
      console.log($scope.dateList);

      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone){
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        } else{
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value="";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0){
                value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
              }else{
                value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
              }
            }
            value = value+")";
            obj.params.zoneid=value;
          }else{
            obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
          }
        }
        if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
          obj.params.shoptype=$rootScope.userData.credentials.shopType;
        }else{
          obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
        }
        
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          $scope.totalSalesLabel = 0;
          $scope.manageOnlinesalesList = result.result;
          for (var i=0; i<$scope.manageOnlinesalesList.length;i++){
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageOnlinesalesList[i].netpurchase) + parseFloat($scope.manageOnlinesalesList[i].pshare) + parseFloat($scope.manageOnlinesalesList[i].pwin);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.isEdit = false;
          $scope.initManagePartner();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      }
      };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    
    $scope.getOnlineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.onlineSalesInvoice = {};
      obj.onSuccess = function(result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.params={};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        for (var i=0; i<result.length;i++){
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      //onlinesalesreportService.getOnlinesales(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
//    $scope.initManageStates();
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageOnlinesalesList.push($scope.inserted);
        };
    */
    // $scope.createOnlinesales = function(manageOnlinesales) {
    //   //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
    //   console.log("Inside createOnlinesales");
    //   //console.log(manageOnlinesales.name);
    //   //console.log(manageOnlinesales.description);

    //   var obj = {};
    //   obj.params = {};

    //   obj.params.id = manageOnlinesales.id;
    //   obj.params.playtechid = manageOnlinesales.playtechid;
    //   obj.params.pshare = manageOnlinesales.pshare;
    //   obj.params.pwin = manageOnlinesales.pwin;
    //   obj.params.netpurchase = manageOnlinesales.netpurchase;
    //   obj.params.netgaming = manageOnlinesales.netgaming;
    //   obj.params.totalsales = manageOnlinesales.totalsales;
    //   obj.params.csales = manageOnlinesales.csales;
    //   obj.params.psales = manageOnlinesales.psales;

    //   //obj.params.description = manageOnlinesales.description;
    //   console.log(manageOnlinesales);
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageOnlinesales = {};
    //     toastr.success('New Onlinesales has been saved successfully!', 'SUCCESS');
    //     //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
    //     $scope.initManageStates();

    //   }
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //     if (err.status === -1) {
    //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //     } else {

    //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //     }
    //   }
    //   onlinesalesreportService.createOnlinesales(obj);

    //   //$scope.modal.hide();
    // };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/online/onlinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function(res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.initManageStates();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        onlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    // $scope.saveOnlinesales = function(manageOnlinesales, id) {

    //   console.log("Inside saveOnlinesales");
    //   console.log(manageOnlinesales);
    //   console.log(manageOnlinesales.id);

    //   if (manageOnlinesales.id === undefined) {
    //     $scope.createOnlinesales(manageOnlinesales);
    //   } else {

    //     var obj = {};
    //     obj.params = {};
    //     obj.params = manageOnlinesales;
    //     obj.params.id = manageOnlinesales.id;
    //     obj.params.playtechid = manageOnlinesales.playtechid;
    //     obj.params.pshare = manageOnlinesales.pshare;
    //     obj.params.pwin = manageOnlinesales.pwin;
    //     obj.params.netpurchase = manageOnlinesales.netpurchase;
    //     obj.params.netgaming = manageOnlinesales.netgaming;
    //     obj.params.totalsales = manageOnlinesales.totalsales;
    //     obj.params.csales = manageOnlinesales.csales;
    //     obj.params.psales = manageOnlinesales.psales;
    //     obj.params.shopid = manageOnlinesales.shopid;
    //     obj.params.gameid = manageOnlinesales.gameid;
    //     // obj.params.name = $scope.manageOnlinesales.name;
    //     // obj.params.description = $scope.manageOnlinesales.description;
    //     //obj.params.created = $scope.manageOnlinesales.created;


    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageOnlinesales = {};
    //       toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
    //       //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
    //       $scope.initManageStates();

    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //         toastr.error('NO INTERNET CONNECTION', 'Error');
    //       } else {
    //         var errdetails = [];
    //         errdetails = err.data.error.detail;
    //         toastr.error(errdetails, 'ERROR');
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     onlinesalesreportService.saveOnlinesales(obj);

    //     //$scope.modal.hide();
    //   }

    // }

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function(manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      $scope.getOnlineInvoiceDetails(manageOnlinesales.ikey);
      console.log($scope.manageOnlinesales);
    }

    $scope.showGames = function(game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showShops = function(shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function(manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: manageOnlinesales.partnerid
        },true);
        return selected.length ? selected[0].code+', '+selected[0].name : 'Not set';
      } else return 'Not set';
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.online.onlinesales')
    .service('onlinesalesreportService', onlinesalesreportService);

  /** @ngInject */
  function onlinesalesreportService(Onlinesales) {
    // var getOnlinesales = function(obj) {

    //   Onlinesales.find({
    //     filter: {
    //       include: ["game","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     obj.onSuccess(data);
    //   }, function(err) {
    //     obj.onFailure(err);
    //   });
    // };

    // var getDailyOnlinesales = function(obj) {
    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth();
    //   var date = y+'-'+m+'-'+d.getUTCDate();
    //   console.log('date',date);

    //         Onlinesales.find({
    //           filter: {
    //             where:{
    //               created: date
    //             },
    //             include: ["game","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });
    // };

    // var getBetweenDatesOnlinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   td.setHours(23);
    //   td.setMinutes(59);
    //   td.setSeconds(59);
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('client from date',fd);
    //   console.log('client from date1',date1); 
    //   console.log('client to date',td);
    //   console.log('client to date2',date2); 
      
    //         Onlinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {indate: {gte: date1}},
    //                 {indate: {lte: date2}}
    //               ]
    //             },
    //             include: ["game","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };


    var getBetweenDatesOnlinesales = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Onlinesales.getAllOnlinesales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var createOnlinesales = function(obj) {

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      // getOnlinesales: getOnlinesales,
  //    getByDateOnlinesales: getByDateOnlinesales,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      // getDailyOnlinesales:getDailyOnlinesales,
      getBetweenDatesOnlinesales: getBetweenDatesOnlinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.machine')
    .controller('MachinePageCtrl', MachinePageCtrl);

  /** @ngInject */
  function MachinePageCtrl($scope, $filter, editableOptions, editableThemes,
    machineService, toastr, $uibModal, gameService, machineShopService, zoneService, $state,
    supplierService,shopService, $rootScope) {
    console.log("Inside MachinePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size

      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachine(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No"
    };




    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
           for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
             var zonelist = $filter('filter')(result, {
               id: $rootScope.userData.credentials.zonemap[index]
             }, true);
             console.log('zonelist',zonelist);
 
             $scope.manageZonesList.push(zonelist[0]);
           }
         }else{
           $scope.manageZonesList = result;
         }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };


    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.manageActiveMachineList = [];
    $scope.initManageActiveMachine = function () {
      var obj = {};
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageActiveMachine");
        console.log(result);
        $scope.manageActiveMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function(zoneid) {
      var obj = {};
      obj.params={};
      obj.params.zoneid = zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShopByZone(obj);

    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function (manageMachineid) {
      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};
        obj.params.machineid = manageMachineid;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageMachineShop");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshopByMachineId(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };

    $scope.init = function (){
      $scope.initManageZones();
      $scope.initManageGames();
      $scope.initManageSupplier();
      $scope.initManageActiveMachine();
    };
    $scope.init();

    $scope.manageMachine = {};
    $scope.manageMachineList = [];
    $scope.reportFilter={};
    $scope.initManageMachine = function (reportFilter) {
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineList = result;

        if ($scope.manageMachineList.length>0){
          for (var index = 0; index < $scope.manageMachineList.length; index++) {
            if ( $scope.manageMachineList[index].machineshop.length>0){
              for (var nloop = 0; nloop < $scope.manageMachineList[index].machineshop.length; nloop++) {
                if ($scope.manageMachineList[index].machineshop[nloop].status == true){
                  $scope.manageMachineList[index].shop = $scope.manageMachineList[index].machineshop[nloop].shop;
                }
              }
            }
          }
        }


        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initManageMachine($scope.reportFilter);

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageMachineList.push($scope.inserted);
    };

    $scope.createMachine = function (manageMachine) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createMachine");
      console.log(manageMachine);

      var obj = {};
      obj.params = {};
      obj.params.code = manageMachine.code;
      obj.params.gameid = manageMachine.game.id;
      obj.params.zoneid = manageMachine.zone.id;
      obj.params.supplierid = manageMachine.supplier? manageMachine.supplier.id:null;
      obj.params.isjackpot = manageMachine.isjackpot;
      obj.params.calby = manageMachine.calby;
      obj.params.cm_in = manageMachine.cmIn;
      obj.params.cm_out = manageMachine.cmOut;
      obj.params.bm_in = manageMachine.bmIn;
      obj.params.bm_out = manageMachine.bmOut;
      obj.params.cm_rate = manageMachine.cmRate;
      obj.params.bm_rate = manageMachine.bmRate;
      obj.params.status = manageMachine.status;
      obj.params.remarks = manageMachine.remarks;

      //obj.params.description = manageMachine.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachine = {};
        $scope.isEditSupplier = false;
        toastr.success('New Machine has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Machine successfully created.");
        $scope.initManageMachine($scope.reportFilter);

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      machineService.createMachine(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/operational/machine/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachine = function (res) {
      console.log("Inside deleteMachine");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageMachine($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.deleteMachine(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (machine) {
      console.log("Inside editMachine");
      console.log(machine);
      // $scope.manageMachine.id = $scope.manageMachine.id;
      // $scope.manageMachine.name = state.name;
      // $scope.manageMachine.description = state.description;
      // $scope.manageMachine.created = state.created;
      // $scope.manageMachine.lastupdated = state.lastupdated;
      $scope.manageMachine = machine;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveMachine = function (manageMachine) {

      console.log("Inside saveMachine");
      console.log(manageMachine);

      console.log(manageMachine.zones);
      console.log(manageMachine.games);

      if (manageMachine.id === undefined) {
        $scope.createMachine(manageMachine);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageMachine
        obj.params.id = manageMachine.id;
        obj.params.code = manageMachine.code;
        obj.params.gameid = manageMachine.game.id;
        obj.params.zoneid = manageMachine.zone.id;
        obj.params.supplierid = manageMachine.supplier?manageMachine.supplier.id:null;
        obj.params.isjackpot = manageMachine.isjackpot;
        obj.params.calby = manageMachine.calby;
        obj.params.cm_in = manageMachine.cmIn;
        obj.params.cm_out = manageMachine.cmOut;
        obj.params.bm_in = manageMachine.bmIn;
        obj.params.bm_out = manageMachine.bmOut;
        obj.params.cm_rate = manageMachine.cmRate;
        obj.params.bm_rate = manageMachine.bmRate;
        obj.params.status = manageMachine.status;
        obj.params.remarks = manageMachine.remarks;
        // obj.params.name = $scope.manageMachine.name;
        // obj.params.description = $scope.manageMachine.description;
        //obj.params.created = $scope.manageMachine.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachine = {};
          $scope.isEditSupplier = false;
          toastr.success('Machine has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.saveMachine(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    //manageActiveMachineList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveMachineList.length) {
        var selected = $filter('filter')($scope.manageActiveMachineList, {
          machineid: id
        },true);
        return selected.length ? selected[0] : null;
      }else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editMachine = function (manageMachine) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = manageMachine;
      console.log($scope.manageMachine);
      //$scope.manageMachine.shopDetails = $scope.showShopDetails(manageMachine.id)
      $scope.initManageMachineShop(manageMachine.id);
      $scope.initManageShop(manageMachine.zoneid);

    };

    $scope.addMachine = function () {
      console.log("Inside addMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = {};
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;    
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;    
    };

    $scope.saveSupplierDetails = function (manageSupplier) {
      console.log("Inside saveSupplierDetails");
      console.log($scope.manageSupplier);
        var obj = {};
        obj.params = {};
        obj.params = manageSupplier
        //obj.params.created = $scope.manageSupplier.created;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          $scope.initManageSupplier();          
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          $scope.isEditSupplier = false;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.createSupplier(obj);
    }

    $scope.qrString = "";
    $scope.viewQRcode = function (code){
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/operational/machine/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function(){
      window.print();
    };

    $scope.addMachineShop = function() {
      $scope.inserted = {
        shopid: null,
        machineid: $scope.manageMachine.id,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function(supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showShop = function(shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shop.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop',manageMachineshop);

      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.saveMachineshop = function(manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code==="23505"){
            toastr.error('This Machine is already assigned.', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.openDeleteMachineshop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function(id) {
      $scope.openDeleteMachineshop('app/pages/operational/machine/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function(res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        obj.params.status = false;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.operational.machine')
    .service('machineService', machineService);

  /** @ngInject */
  function machineService(Machine) {
    var getMachine = function (obj) {

      if (obj.params.zoneid != null) {
        Machine.find({
          filter: {
            where:{
              zoneid:obj.params.zoneid.length>0?{inq:obj.params.zoneid}:obj.params.zoneid
            },
            include: ["game", "zone", "supplier", {
              "relation": "machineshop",
              "scope": {
                "include": ["shop"]
              }
            }
            ]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      } else {
        Machine.find({
          filter: {
            include: ["game", "zone", "supplier", {
              "relation": "machineshop",
              "scope": {
                "include": ["shop"]
              }
            }
            ]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }
    };

    var getAllMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachineByZone = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          where: {
            zoneid: obj.params.zoneid
          },
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.create({
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.prototype$updateAttributes({
        id: obj.params.id,
        //description: obj.params.description,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks,

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getMachine: getMachine,
      getAllMachine: getAllMachine,
      createMachine: createMachine,
      deleteMachine: deleteMachine,
      saveMachine: saveMachine,
      getMachineByZone: getMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.shop')
    .controller('ShopPageCtrl', ShopPageCtrl);

  /** @ngInject */
  function ShopPageCtrl($scope, $filter, editableOptions, editableThemes,
    shopService, toastr, $uibModal, partnerService, zoneService, $state,
    gameService, onlineShopService, machineShopService, machineService,
    machinesalesreportService, supplierService, areaService, siteService, $rootScope, userService) {
    console.log("Inside ShopPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteShop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{
        value: $rootScope.userData.credentials.shopType
      }];
    } else {
      $scope.shopTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    if (typeof $rootScope.userData.credentials.operational !== "undefined") {
      $scope.operationalFilter = [{
        value: $rootScope.userData.credentials.operational
      }];
    } else {
      $scope.operationalFilter = [{
        value: 'Live'
      }, {
        value: 'Danger'
      }, {
        value: 'Warning'
      }];
    }

    if (typeof $rootScope.userData.credentials.status !== "undefined") {
      $scope.statusFilter = [{
        value: $rootScope.userData.credentials.status
      }];
    } else {
      $scope.statusFilter = [{
        value: 'Active'
      }, {
        value: 'Inactive'
      }];
    }



    $scope.openDeleteOnlineShop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlineShop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.openDeleteMachineshop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;


    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlineShopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlineShopService.getOnlineshop(obj);
      } else {
        $scope.manageOnlineShopList = [];
      }
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageAreaList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSites = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshop(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };
    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };
    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid) // ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result.result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //machineService.getMachineByZone(obj);
      machinesalesreportService.getAvailableMachineByZone(obj);
    };

    $scope.manageMachineListZone = [];
    $scope.initManageMachineZone = function () {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid) // ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineListZone = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachineByZone(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageAreas();
      $scope.initManageGames();
      $scope.initManageSupplier();
      $scope.initManageSites();
    };
    $scope.init();

    $scope.manageShop = {};
    $scope.manageShopList = [];
    $scope.reportFilter = {};
    $scope.initManageShop = function (reportFilter) {
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        } else {
          obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
      }

      if (typeof $rootScope.userData.credentials.status !== "undefined") {
        $rootScope.userData.credentials.status = true;
      } else {
        obj.params.status = !!reportFilter.status &&
          !!reportFilter.status.value ?
          (reportFilter.status.value == 'Active' ? true : false) :
          null;
      }

      if (typeof $rootScope.userData.credentials.operational !== "undefined") {
        obj.params.operational = $rootScope.userData.credentials.operational;
      } else {
        obj.params.operational = reportFilter.operational ? reportFilter.operational.value : null;
      }

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
        //$scope.initManageOnlineShop();
        $scope.isEdit = false;
        for (var i = 0; i < result.length; i++) {
          if ($scope.manageShopList[i].contact1) {
            $scope.manageShopList[i].contact1 = JSON.parse($scope.manageShopList[i].contact1);
          }
          if ($scope.manageShopList[i].contact2) {
            $scope.manageShopList[i].contact2 = JSON.parse($scope.manageShopList[i].contact2);
          }
          if ($scope.manageShopList[i].contact3) {
            $scope.manageShopList[i].contact3 = JSON.parse($scope.manageShopList[i].contact3);
          }

        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);

    };
    $scope.initManageShop($scope.reportFilter);



    $scope.createShop = function (manageShop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createShop");
      console.log(manageShop);

      var obj = {};
      obj.params = {};
      obj.params.code = manageShop.code;
      obj.params.name = manageShop.name;
      obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;

      obj.params.zoneid = manageShop.zone ? manageShop.zone.id : null;
      obj.params.areaid = manageShop.area ? manageShop.area.id : null;
      obj.params.siteid = manageShop.site ? manageShop.site.id : null;
      obj.params.onrate = manageShop.onrate;
      obj.params.macrate = manageShop.macrate;
      obj.params.onvirtual = manageShop.onvirtual;
      obj.params.ontips = manageShop.ontips;
      obj.params.creditlimit = manageShop.creditlimit;
      obj.params.shoptype = manageShop.shoptype ? manageShop.shoptype.value : null;
      obj.params.operational = manageShop.operational ? manageShop.operational.value : null;

      obj.params.address = manageShop.address;
      obj.params.status = manageShop.status;
      obj.params.contact1 = JSON.stringify(manageShop.contact1);
      obj.params.contact2 = JSON.stringify(manageShop.contact2);
      obj.params.contact3 = JSON.stringify(manageShop.contact3);
      obj.params.remarks = manageShop.remarks;
      obj.params.onrebate = manageShop.onrebate;
      obj.params.macrebate = manageShop.macrebate;
      obj.params.mactips = manageShop.mactips;
      obj.params.macvirtual = manageShop.macvirtual;

      //obj.params.description = manageShop.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShop = {};
        toastr.success('New Shop has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Shop successfully created.");
        $scope.initManageShop($scope.reportFilter);

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };
      shopService.createShop(obj);

      //$scope.modal.hide();
    };
    $scope.remarks = "";
    $scope.viewRemarks = function (remarks) {
      console.log('Inside viewRemarks', remarks);
      $scope.open('app/pages/operational/shop/modals/viewRemarks.html');
      $scope.remarks = remarks;
    };


    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/operational/shop/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteShop = function (res) {
      console.log("Inside deleteShop");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Shop has been deleted successfully!', 'SUCCESS');

          $scope.initManageShop($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        shopService.deleteShop(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (shop) {
      console.log("Inside editShop");
      console.log(shop);
      // $scope.manageShop.id = $scope.manageShop.id;
      // $scope.manageShop.name = state.name;
      // $scope.manageShop.description = state.description;
      // $scope.manageShop.created = state.created;
      // $scope.manageShop.lastupdated = state.lastupdated;
      $scope.manageShop = shop;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveShop = function (manageShop) {

      console.log("Inside saveShop");
      console.log(manageShop);

      console.log(manageShop.zone);
      console.log(manageShop.partner);

      if (manageShop.id === undefined) {
        $scope.createShop(manageShop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = manageShop.id;
        obj.params.code = manageShop.code;
        obj.params.name = manageShop.name;
        obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;
        obj.params.zoneid = manageShop.zone ? manageShop.zone.id : null;
        obj.params.areaid = manageShop.area ? manageShop.area.id : null;
        obj.params.siteid = manageShop.site ? manageShop.site.id : null;
        obj.params.onrate = manageShop.onrate;
        obj.params.macrate = manageShop.macrate;
        obj.params.onvirtual = manageShop.onvirtual;
        obj.params.ontips = manageShop.ontips;
        obj.params.creditlimit = manageShop.creditlimit;
        obj.params.shoptype = manageShop.shoptype ? manageShop.shoptype.value : null;
        obj.params.operational = manageShop.operational ? manageShop.operational.value : null;
        obj.params.address = manageShop.address;
        obj.params.status = manageShop.status;
        obj.params.contact1 = JSON.stringify(manageShop.contact1);
        obj.params.contact2 = JSON.stringify(manageShop.contact2);
        obj.params.contact3 = JSON.stringify(manageShop.contact3);

        obj.params.remarks = manageShop.remarks;
        obj.params.onrebate = manageShop.onrebate;
        obj.params.macrebate = manageShop.macrebate;
        obj.params.mactips = manageShop.mactips;
        obj.params.macvirtual = manageShop.macvirtual;
        obj.params.userid = manageShop.userid;


        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageShop = {};
          toastr.success('Shop has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageShop($scope.reportFilter);

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        shopService.saveShop(obj);
      }

    };

    $scope.showPartner = function (partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    editableOptions.theme = 'bs3';
    editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editShop = function (manageShop) {
      console.log("Inside editShop");
      $scope.isEdit = true;
      $scope.manageShop = manageShop;
      $scope.initManageMachine();
      $scope.initManageMachineZone();
      $scope.initManageOnlineShop();
      $scope.initManageMachineShop();
      console.log($scope.manageShop);
    };

    $scope.addShop = function () {
      console.log("Inside addShop");
      $scope.isEdit = true;
      $scope.manageShop = {};
      $scope.manageOnlineShopList = [];
      $scope.manageMachineshopList = [];
      console.log($scope.manageZonesList);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    //Online Games

    $scope.addOnlineShop = function () {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        gameid: null,
        playtechid: null
      };
      $scope.manageOnlineShopList.push($scope.inserted);
    };

    $scope.saveOnlineShop = function (manageOnlineShop, id) {

      console.log("Inside saveOnlineShop");
      console.log(manageOnlineShop);
      console.log(id);

      if (id === undefined) {
        $scope.createOnlineShop(manageOnlineShop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Online Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageOnlineShop();

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.saveOnlineshop(obj);
      }

    };

    $scope.createOnlineShop = function (manageOnlineShop) {

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been saved successfully!', 'SUCCESS');
          $scope.initManageOnlineShop();

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.createOnlineshop(obj);
      } else {
        $scope.initManageOnlineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Online Games.', 'Error');
      }
    };

    $scope.deleteOnlineShopId = null;
    $scope.confirmOnlineShopDelete = function (item) {
      $scope.openDeleteOnlineShop('app/pages/operational/shop/modals/dangerOnlineGameModal.html');
      $scope.selectedOnlineShop = item;
    };

    $scope.deleteOnlineShop = function (res) {
      console.log("Inside deleteOnlineShop");
      if (res) {
        console.log('Sure!');
        console.log($scope.selectedOnlineShop);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.selectedOnlineShop.id;
        obj.params.shopid = null;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been deleted successfully!', 'SUCCESS');

          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.saveOnlineshop(obj);
        $scope.selectedOnlineShop = null;
      }
    };

    //Machine Shop
    $scope.showMachine = function (machine) {
      if (machine && $scope.manageMachineListZone.length) {
        var selected = $filter('filter')($scope.manageMachineListZone, {
          id: machine.id
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.addMachineShop = function () {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        machineid: null,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.saveMachineshop = function (manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        //obj.params.supplierid = manageOnlineShop.supplier;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machineid;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();
          $scope.initManageMachineShop();

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }
          if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop', manageMachineshop);

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop();
          $scope.initManageMachine();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }
          if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function (id) {
      $scope.openDeleteMachineshop('app/pages/operational/shop/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function (res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        //console.log($scope.deleteMachineshopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        // obj.params.shopid = $scope.manageShop.id;
        // obj.params.machineid = manageMachineshop.machineid;
        // obj.params.macrate = manageMachineshop.macrate;
        // obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = false;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showSupplierComm = function (machine) {
      if (machine && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: machine.supplierid
        }, true);
        return selected.length ? selected[0].rate : 'Not set';
      } else return 'Not set';
    };

    $scope.userAccess = function (manageShop) {
      console.log('Inside userAccess');
      console.log('manageShop', manageShop);

      var obj = {};
      obj.params = {};
      obj.params.username = manageShop.code;
      obj.params.password = "password";
      obj.params.credentials = {};
      obj.params.credentials.name = manageShop.name;
      obj.params.credentials.mobile = null;
      obj.params.credentials.role = 15; //Shop Staff Role id
      obj.params.credentials.shop = manageShop;
      obj.params.challenges = manageShop.id;

      console.log('obj.params', obj.params);


      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageShop.userid = result.id;
        $scope.saveShop(manageShop);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

    };
  }

})();
/**
 * @author udit.jain
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.operational.shop')
    .service('machineShopService', machineShopService);

  /** @ngInject */
  function machineShopService(Machineshop) {
    var getMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {shopid: obj.params.shopid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getMachineshopByMachineId = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {machineid: obj.params.machineid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            status: obj.params.status
          },
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshopWithoutStatus = function(obj) {
      
      Machineshop.find({
        filter: {
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var createMachineshop = function(obj) {
      var date = new Date();

      Machineshop.create({
        created: date,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    // var deleteMachineshop = function(obj) {

    //   Machineshop.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     obj.onSuccess(data);
    //   }, function(err) {
    //     obj.onFailure(err);
    //   });
    // };

    var deleteMachineshop = function(obj) {
      var date = new Date();
      Machineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        status: obj.params.status
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var saveMachineshop = function(obj) {

      var date = new Date();

      Machineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
        
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getMachineshop: getMachineshop,
      getAllMachineshop:getAllMachineshop,
      getAllMachineshopWithoutStatus: getAllMachineshopWithoutStatus,
      createMachineshop: createMachineshop,
      deleteMachineshop: deleteMachineshop,
      saveMachineshop: saveMachineshop,
      getMachineshopByMachineId: getMachineshopByMachineId
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.operational.shop')
    .service('onlineShopService', onlineShopService);

  /** @ngInject */
  function onlineShopService(Onlineshop) {
    var getOnlineshop = function(obj) {

      Onlineshop.find({
        filter: {
          where:{
            shopid:obj.params.shopid
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllOnlineshop = function(obj) {
      
            Onlineshop.find({
              filter: {
                include: ["game", "shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });
          };
    var createOnlineshop = function(obj) {
      var date = new Date();

      Onlineshop.create({
        created: date,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var deleteOnlineshop = function(obj) {

      Onlineshop.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveOnlineshop = function(obj) {

      var date = new Date();

      Onlineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getOnlineshop: getOnlineshop,
      createOnlineshop: createOnlineshop,
      deleteOnlineshop: deleteOnlineshop,
      saveOnlineshop: saveOnlineshop,
      getAllOnlineshop:getAllOnlineshop
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.shop')
    .service('shopService', shopService);

  /** @ngInject */
  function shopService(Shop) {
    var getShop = function (obj) {

      if (obj.params.zoneid != null && obj.params.shoptype != null) {
        console.log('Inside Both',obj.params.shoptype);
        Shop.find({
          filter: {
            where: {
              and: [
                { shoptype: obj.params.shoptype },
                { zoneid: obj.params.zoneid.length > 0 ? { inq: obj.params.zoneid } : obj.params.zoneid }
              ],

            },
            include: ["partner", "zone", "area", "site", "shop"]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      } else {
        if (
          obj.params.zoneid != null ||
          obj.params.operational != null ||
          obj.params.status != null
        ) {
          var where = {};
          if(obj.params.zoneid != null) {
            where.zoneid = obj.params.zoneid.length > 0 ? { inq: obj.params.zoneid } : obj.params.zoneid;
          }
          if(obj.params.operational != null) {
            where.operational = obj.params.operational;
          }
          if(obj.params.status != null) {
            where.status = obj.params.status;
          }
          Shop.find({
            filter: {
              where: where,
              include: ["partner", "zone", "area", "site"]
            }
          }).$promise.then(function (data) {
            obj.onSuccess(data);
          }, function (err) {
            obj.onFailure(err);
          });
        } else {
          Shop.find({
            filter: {
              include: ["partner", "zone", "area", "site"]
            }
          }).$promise.then(function (data) {
            obj.onSuccess(data);
          }, function (err) {
            obj.onFailure(err);
          });
        }
      }
    };

    var getShopById = function (obj) {
      Shop.findById({
        id: obj.params.shopid,
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopByZone = function (obj) {
      Shop.find({
        filter: {
          where: {
            and: [
              { zoneid: obj.params.zoneid },
              { status: true }
            ]
          },
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createShop = function (obj) {
      var date = new Date();

      Shop.create({
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        operational:obj.params.operational,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteShop = function (obj) {

      Shop.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveShop = function (obj) {
      var date = new Date();

      Shop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        operational:obj.params.operational,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual,
        userid: obj.params.userid

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findAssignedShop = function (obj) {
      Shop.find({
        filter: {
          where: {
            id: {
              inq: obj.params.shopmap
            }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findNotAssignedShop = function (obj) {
      if (obj.params.shopmap) {
        Shop.find({
          filter: {
            where: {
              and: [
                { id: { nin: obj.params.shopmap } },
                { shoptype: obj.params.shoptype },
                { zoneid: { inq: obj.params.zonemap } }
              ]
            }
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      } else {
        Shop.find({
          filter: {
            where: {
              and: [
                { shoptype: obj.params.shoptype },
                { zoneid: { inq: obj.params.zonemap } }
              ]
            }
          }
        }
        ).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }

    };

    var findNotAssignedShopForAdmin = function (obj) {
      Shop.find({
        filter: {
          where: {
            id: { nin: obj.params.shopmap }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var unbindShopStaff = function (obj) {
      var date = new Date();

      Shop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getShop: getShop,
      createShop: createShop,
      deleteShop: deleteShop,
      saveShop: saveShop,
      findAssignedShop: findAssignedShop,
      findNotAssignedShop: findNotAssignedShop,
      getShopById: getShopById,
      getShopByZone: getShopByZone,
      findNotAssignedShopForAdmin: findNotAssignedShopForAdmin,
      unbindShopStaff:unbindShopStaff
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.partneraccount.partnerusers')
    .controller('PartnerUsersPageCtrl', PartnerUsersPageCtrl);

  /** @ngInject */
  function PartnerUsersPageCtrl($scope, $filter, editableOptions, editableThemes,
    userService, toastr, $uibModal, zoneService, roleService, $rootScope, rolemappingService, partnerService) {
    console.log("Inside PartnerUsersPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUser(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;
    $scope.status = [{value:'Active'},{value:'Inactive'}];
    $scope.emailVerified = [{value:'Yes'},{value:'No'}];

    //Getting Zones
    $scope.manageZonesList = [];
    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    //Getting Roles
    $scope.manageRoleList=[];
    $scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
    //Getting Partners
    $scope.managePartnerList=[];
    $scope.initManagePartner = function (){
        var obj ={};
        obj.params={};
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=null;
        }
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnerList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        partnerService.getPartner(obj);
    };
    //Getting Users   
    $scope.manageUsersList = [];
    $scope.manageUser = {};
    $scope.initManageUsers = function() {
      console.log('$rootScope.userData',$rootScope.userData);
      var obj = {};
      obj.params = {};
      obj.params.parentid = $rootScope.userData.credentials.partner.id;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsersList = result;
        $scope.initManageZones();
        $scope.initManageRole();
        $scope.initManagePartner();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getParterUsers(obj); 
    };
    $scope.initManageUsers();

    $scope.addUser = function() {
      //genericModalService.show('modules/modals/addUser.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageUsersList.push($scope.inserted);
    };

    $scope.createUser = function(manageUser) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUser");
      console.log(manageUser);

      var obj = {};
      obj.params = {};
      obj.params = manageUser;
      // obj.params.name = manageUser.name;
      // obj.params.description = manageUser.description;
      // obj.params.zoneid = manageUser.zones
      // obj.params.stateid = manageUser.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('New User has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New User successfully created.");
        $scope.initManageUsers();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      userService.createUser(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/partneraccount/users/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteUser = function(res) {
      console.log("Inside deleteUser");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('User has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","User successfully deleted.");
          $scope.initManageUsers();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.deleteUser(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editUser = function(state) {
      console.log("Inside editUser");
      console.log(state);
      // $scope.manageUser.id = $scope.manageUser.id;
      // $scope.manageUser.name = state.name;
      // $scope.manageUser.description = state.description;
      // $scope.manageUser.created = state.created;
      // $scope.manageUser.lastupdated = state.lastupdated;
      $scope.manageUser = state;
      genericModalService.show('modules/modals/addUser.html', $scope);
    };

    $scope.getPartnersForSave = function(user) {
      console.log('getPartnersForSave',user);
      if (user && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          code: user.username
        },true);

        if (selected.length){
          $scope.savePartner(user,selected[0].id);
        }
      }
    };

    $scope.savePartner = function (managePartner, id) {

      console.log("Inside savePartner");
      console.log(managePartner);
      console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = managePartner.credentials.name;
        obj.params.contact = managePartner.credentials.mobile;
        
        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartner = {};
          toastr.success('Partner has been saved successfully!', 'SUCCESS');
          $scope.initManageUsers();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnerService.savePartner(obj);

    };

    $scope.saveUser = function(manageUser, userid) {

      console.log("Inside saveUser");
      console.log(manageUser);
      console.log(userid);

      if (userid === undefined) {
        $scope.createUser(manageUser);
      } else {

        var objRoleMap = {};
        objRoleMap.params = {};
        objRoleMap.params.principalid = userid;
        objRoleMap.params.roleid = manageUser.role;

  
        objRoleMap.onSuccess = function(result) {
          console.log("Inside SUCCESS objRoleMap");
          console.log(result);
         
            var objUpdateRole = {};
            objUpdateRole.params = {};
            if (result[0]){
            objUpdateRole.params.id = result[0].id;
            }
            objUpdateRole.params.userid = userid;
            objUpdateRole.params.roleid = manageUser.role;
            objUpdateRole.onSuccess = function(result) {
              console.log("Inside SUCCESS objUpdateRole");
              console.log(result);

              var obj = {};
              obj.params = {};
              obj.params.id = userid;
              obj.params.credentials ={};
              obj.params.credentials.name = manageUser.name;
              obj.params.credentials.mobile = manageUser.mobile;
              obj.params.credentials.zonemap = manageUser.zonemap;
              obj.params.credentials.role = manageUser.role;
              obj.params.credentials.partner = manageUser.partner;
              obj.params.emailVerified = manageUser.emailVerified.value==='Yes'?true:false;

              console.log(obj.params);
      
              obj.onSuccess = function(result) {
                console.log("Inside SUCCESS");
                console.log(result);
                $scope.manageUser = {};
                $scope.getPartnersForSave(result);
                //toastr.success('User has been updated successfully!', 'SUCCESS');

      
              }
              obj.onFailure = function(err) {
                console.log("Inside Failure");
                console.log(err);
                if (err.status === -1) {
                  toastr.error('NO INTERNET CONNECTION', 'Error');
                } else {
                  toastr.error(err.data.error.message, 'Error');
                }
              }
              userService.saveUser(obj);
            }
            objUpdateRole.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                toastr.error('NO INTERNET CONNECTION', 'Error');
              } else {
                toastr.error(err.data.error.message, 'Error');
              }
            };
            rolemappingService.saveRoleMapping(objUpdateRole);
        };
        objRoleMap.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(err.data.error.message, 'Error');
          }
        };
        rolemappingService.getRoleMappingsbyID(objRoleMap);
      }
    }

    $scope.showStatus = function(status) {
        var selected = [];
        if(typeof status==="object") {
          //selected = $filter('filter')($scope.status, {value: status.value});
          return status.value ? status.value : 'Not set';
        }else{
            return status;
        }
      };

      $scope.showAccess = function(emailVerified) {
          var selected = [];
          if(typeof emailVerified==="object") {
            //selected = $filter('filter')($scope.status, {value: status.value});
            return emailVerified.value? emailVerified.value : 'No';
          }else{
              return emailVerified?'Yes' : 'No';
          }
        };

        $scope.showRoles = function(role) {
          if (role && $scope.manageRoleList.length) {
            var selected = $filter('filter')($scope.manageRoleList, {
              id: role
            },true);
            return selected.length ? selected[0].name : 'Not set';
          } else return 'Not set';
        };

        $scope.showZones = function(zone) {
          if (zone && $scope.manageZonesList.length) {
            var selected = $filter('filter')($scope.manageZonesList, {
              id: zone
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.showPartners = function(partner) {
          if (partner && $scope.managePartnerList.length) {
            var selected = $filter('filter')($scope.managePartnerList, {
              id: partner
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.generatePassword = function() {
          var length = 8,
              charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
              retVal = "";
          for (var i = 0, n = charset.length; i < length; ++i) {
              retVal += charset.charAt(Math.floor(Math.random() * n));
          }
          return retVal;
      };

      $scope.newPassword="";

      $scope.openPassword = function(page, size) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope: $scope,
          size: size
        });
        modalInstance.result.then(function(selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteUser(selectedItem);
          console.log("hurry = " + selectedItem);
        }, function() {
          console.log('Modal dismissed at: ' + new Date());
        });
      };

    $scope.resetPassword = function (userid) {
      console.log('userid', userid);
      $scope.newPassword = $scope.generatePassword();
      console.log('newPassword',$scope.newPassword);

      var obj = {};
      obj.params = {};
      obj.params.id = userid;
      obj.params.password = $scope.newPassword;

      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('User has been updated successfully!', 'SUCCESS');
        $scope.initManageUsers();
        $scope.openPassword('app/pages/account/users/modals/passwordModal.html');

      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          toastr.error(err.data.error.message, 'Error');
        }
      };
      userService.resetPassword(obj);

    };
        
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.partners.partnerinvoice')
    .controller('PartnerInvoicereportPageCtrl', PartnerInvoicereportPageCtrl);

  /** @ngInject */
  function PartnerInvoicereportPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnerinvoicereportService, /*machineShopService,*/ gameService, shopService, partnerService, machinesalesService, validationService, toastr, $uibModal, dailyonlinesalesreportService, dailymachinesalesreportService, $rootScope, receiptService) {
    console.log("Inside PartnerInvoicereportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {
      to: '',
      from: '',
      staff: '',
    };
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

      } else {
        isFormValidated = true;
        //toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {
        $scope.isEdit = false;
        $scope.isInvoice = false;
        var date1 = "";
        var date2 = "";

        if (dateList.from != "" && dateList.to != "") {
          var fd = new Date(dateList.from),
            y = fd.getFullYear(),
            m = fd.getMonth() + 1;
          date1 = y + '-' + m + '-' + fd.getDate();
          var td = new Date(dateList.to);
          y = td.getFullYear();
          m = td.getMonth() + 1;
          date2 = y + '-' + m + '-' + td.getDate();
        } else {
          var days = 60; // Days you want to subtract
          var td1 = new Date();
          var y1 = td1.getFullYear();
          var m1 = td1.getMonth() + 1;
          date2 = y1 + '-' + m1 + '-' + td1.getDate();

          var fd1 = new Date(td1.getTime() - (days * 24 * 60 * 60 * 1000));
          var day = fd1.getDate();
          var month = fd1.getMonth() + 1;
          var year = fd1.getFullYear();
          date1 = year + '-' + month + '-' + day;
        }

        console.log('date1', date1);
        console.log('date2', date2);

        $scope.machineSalesOfPartner = {};
        $scope.machineSalesOfPartnerList = {};

        var obj = {};
        obj.params = {};
        obj.params.adate = date1;
        obj.params.bdate = date2;
        if (dateList.staff) {
          obj.params.partnerId = "(" + dateList.staff.id + ")";
        } else {
          if ($rootScope.userData.roleId == 9) {
            if ($scope.managePartnerList.length > 0) {
              var staffList = "";
              for (var index = 0; index < $scope.managePartnerList.length; index++) {
                if (index == 0) {
                  staffList = "('" + $scope.managePartnerList[index].id + "'";
                } else {
                  staffList = staffList + ",'" + $scope.managePartnerList[index].id + "'";
                }
              }
              staffList = staffList + ")";
              console.log('staffList', staffList);
              obj.params.partnerId = staffList;
            } else {
              obj.params.partnerId = "(" + $rootScope.userData.credentials.partner.id + ")";
            }
          } else {
            obj.params.partnerId = "(" + $rootScope.userData.credentials.partner.id + ")";
          }
        }
        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside searchMachinesales SUCCESS");
          console.log(result);
          $scope.totalSalesLabelFooter = 0;
          $scope.mPSalesTotal = 0;
          $scope.mCSalesTotal = 0;
          $scope.mSalesTotal = 0;
          $scope.npTotal = 0;
          $scope.oPSalesTotal = 0;
          $scope.oCSalesTotal = 0;
          $scope.oSalesTotal = 0;
          $scope.shopTotal = 0;
          $scope.compTotal = 0;
          $scope.shopOverTotal = 0;
          $scope.compOverTotal = 0;

          $scope.machineSalesOfPartnerList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onMacTotalL2 = parseFloat(result.result[i].ontotal) + parseFloat(result.result[i].mactotal);
            $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
            $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
            $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
            $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
            $scope.mSalesTotal = $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
            $scope.npTotal = $scope.npTotal + parseFloat(result.result[i].netpurchase);
            $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
            $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
            $scope.oSalesTotal = $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
            $scope.machineSalesOfPartnerList.result[i].shopTotal = parseFloat(result.result[i].mpsales) + parseFloat(result.result[i].opsales);
            $scope.machineSalesOfPartnerList.result[i].compTotal = parseFloat(result.result[i].mcsales) + parseFloat(result.result[i].ocsales);
            $scope.shopOverTotal = $scope.shopOverTotal + parseFloat($scope.machineSalesOfPartnerList.result[i].shopTotal);
            $scope.compOverTotal = $scope.compOverTotal + parseFloat($scope.machineSalesOfPartnerList.result[i].compTotal);

          }
          console.log($scope.totalSalesLabelFooter);
        }
        obj.onFailure = function (err) {
          console.log("Inside searchMachinesales Failure");
        }
        partnerinvoicereportService.getMachinesalesByPartner(obj);


      }
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm + '/' + dd + '/' + yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      // obj.params = {};
      obj.params.parentid = $rootScope.userData.credentials.partner.id;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
        $scope.managePartnerList.push($rootScope.userData.credentials.partner);
        $scope.searchMachinesales($scope.dateList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      if ($rootScope.userData.roleId == 9) {
        partnerService.getPartnerStaff(obj);
      } else if ($rootScope.userData.roleId == 17) {
        obj.params.parentid = null;
        obj.params.zoneid = null;

        partnerService.getPartnerStaff(obj);
      } else {
        partnerService.getPartner(obj);
      }
    };
    $scope.initManagePartner();

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      //$scope.getMachineSalesOfPartner(managePartnersales.partnerid);
      //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.manageDailyinvoices = {};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isInvoice = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      $scope.manageDailyinvoices.invoicedate = $scope.dateFormater($scope.manageDailyinvoices.ikey);
      console.log($scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices.ikey);

    };

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.onlineInvoiceDetails = result;

        if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
          console.log('Inside Empty MachineShop');
          $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        }

        var online = 0;
        $scope.total.onlineST = 0;
        if ($scope.onlineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
            online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
          }
          $scope.total.online = online;
          $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.getMachineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
          console.log('Inside Empty OnlineShop');
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }

        var machine = 0;
        $scope.total.machineST = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse($scope.machineInvoiceDetails[i].receipt.content);
          }
          $scope.total.machine = machine;
          $scope.total.machineST = machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      }

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.getTotal = function () {
      var total = 0;
      total = parseFloat($scope.total.onlineST) + parseFloat($scope.total.machineST);
      return total;
    };
    $scope.print = function () {
      window.print();
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) {
          return x.mpsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) {
          return x.mcsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) {
          return x.mactotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) {
          return x.opsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalnetpurhase = function (items) {
      return items
        .map(function (x) {
          return x.netpurchase;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) {
          return x.ocsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) {
          return x.ontotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) {
          return x.shopTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) {
          return x.compTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) {
          return x.totalsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.shopFilter = "";
    $scope.viewShopInvoice = function (shopCode) {
      $scope.isEdit = true;
      $scope.shopFilter = shopCode;
    };

    $scope.getShopSalesOfPartner = function (shopSalesOfPartner) {
      $scope.isEdit = true;
      $scope.isInvoice = false;

      var obj = {};
      obj.params = {};
      //$scope.machineSalesOfPartner = {};
      $scope.shopSalesOfPartnerList = {};

      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.npTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      $scope.shopSalesOfPartnerList = shopSalesOfPartner;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 = parseFloat($scope.shopSalesOfPartnerList[i].ontotal) + parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.npTotal = $scope.npTotal + parseFloat($scope.shopSalesOfPartnerList[i].netpurchase);
        $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal = parseFloat($scope.shopSalesOfPartnerList[i].mpsales) + parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal = parseFloat($scope.shopSalesOfPartnerList[i].mcsales) + parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.shopOverTotal = $scope.shopOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal = $scope.compOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].compTotal);

      }
      console.log($scope.totalSalesLabelFooter);
    };

    $scope.showPartner = function (shopid) {
      if (shopid && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shopid
        }, true);
        return selected.length ? selected[0].partner.code + ", " + selected[0].partner.name : 'Not set';
      } else return 'Not set';
    };
    $scope.showPartners = function (partner) {
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner
        }, true);
        return selected.length ? selected[0].code + ", " + selected[0].name : 'Not Set';
      } else return 'Not set';
    };
    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
      console.log('receiptid', receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open('app/pages/invoices/dailyinvoices/modals/receiptModal.html');

        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);

    };
  }
})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.partners.partnerinvoice')
    .service('partnerinvoicereportService', partnerinvoicereportService);

  /** @ngInject */
  function partnerinvoicereportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesByPartner = function (obj) {
      
      Machinesales.grpSalesOfPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesByPartner: getMachinesalesByPartner,
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.collector')
    .controller('CollectorreportPageCtrl', CollectorreportPageCtrl);

  /** @ngInject */
  function CollectorreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    collectorreportService, zoneService, gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal) {
    console.log("Inside CollectorreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];

    $scope.searchSales = function (dateList) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        console.log('dateList.zone',dateList.zone);
        console.log('dateList.shoptype',dateList.shoptype);
        
        obj.params.adate = date1;
        obj.params.bdate = date2;
        obj.params.shoptype = dateList.shoptype?dateList.shoptype.value:null;
        obj.params.zoneid = dateList.zone?dateList.zone.id:null;


        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          $scope.totalSalesLabel = 0;

          $scope.managePartnersalesList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onmacTotal = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
            $scope.managePartnersalesList.result[i].total = onmacTotal;
            $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
          }
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };

    $scope.initManageCollector = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
//     $scope.initManageStates = function() {
//       var obj = {};
//       obj.params = {};
//       obj.params.fromDt = $scope.dateList.from;
//       obj.params.toDt = $scope.dateList.to;

//       obj.onSuccess = function(result) {
//         console.log("Inside SUCCESS");
//         console.log(result);
//         $scope.initManagePartner();
//         $scope.initManageGames();
// //        $scope.initManageMachineShop();
//         //$scope.initManagePrevMachineReading();
//         $scope.managePartnersalesList = result;
//         $scope.isEdit = false;
//       };
//       obj.onFailure = function(err) {
//         console.log("Inside Failure");
//         console.log(err);
//       };
//       collectorreportService.getBetweenDatesMachinesales(obj);
//       //$scope.$broadcast('scroll.refreshComplete');
//     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/partnersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     collectorreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(managePartnersales, id) {

      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      // if (managePartnersales.id === undefined) {
      //   $scope.createMachinesales(managePartnersales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = managePartnersales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.managePartnersales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   collectorreportService.saveMachinesales(obj);

      //   //$scope.modal.hide();
      // }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      console.log($scope.managePartnersales.sname);
      $scope.getSalesOfShop(managePartnersales.partnerid,managePartnersales.shopid );
    //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getSalesOfShop = function(partnerid,sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      collectorreportService.getGrpSalesForShopInRange(obj);
    }

    // $scope.showGameById = function (gid) {
    //   if (gid && $scope.manageGamesList.length) {
    //     var selected = $filter('filter')($scope.manageGamesList, {
    //       id: gid
    //     },true);
    //     return selected.length ? selected[0].name : 'Not set';
    //   } else return 'Not set';
    // };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    // $scope.showPartnerById = function (managePartnersales) {
    //   if (managePartnersales.shop && $scope.managePartnerList.length) {
    //     var selected = $filter('filter')($scope.managePartnerList, {
    //       id: $scope.managePartnersales.shop.partnerid
    //     },true);
    //     return selected.length ? selected[0].code : 'Not set';
    //   } else return 'Not set'
    // };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.collector')
    .service('collectorreportService', collectorreportService);

  /** @ngInject */
  function collectorreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachinesales')
    .controller('DailymachinesalesreportPageCtrl', DailymachinesalesreportPageCtrl);

  /** @ngInject */
  function DailymachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, 
    $uibModal, receiptService) {
    console.log("Inside DailymachinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        $scope.totalSalesLabel = 0;
        for (var i = 0; i < result.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageMachinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.getDailyMachinesales(obj);
    };
    $scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.initManageStates();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        dailymachinesalesreportService.saveMachinesales(obj);
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function(manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code){
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/reports/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function(gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function(machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function(manageMachinesales) {
      if (manageMachinesales.shop && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate,1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);
             
              console.log('checkInDate',checkInDate);
              console.log('resultInDate',resultInDate);

              if (checkInDate>=resultInDate){
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else{
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.generateInvoice(obj);
    };

  }

})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachinesales')
    .service('dailymachinesalesreportService', dailymachinesalesreportService);

  /** @ngInject */
  function dailymachinesalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachineshop')
    .controller('DailymachineshopPageCtrl', DailymachineshopPageCtrl);

  /** @ngInject */
  function DailymachineshopPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachineshopService, dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, $uibModal) {
    console.log("Inside DailymachineshopPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    // $scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    //get previous days machine sales readings from machine sales table
    /*
    $scope.managePrevMachineReadingList = [];
    $scope.initManagePrevMachineReading = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManagePrevMachineReading");
        console.log(result);
        $scope.managePrevMachineReadingList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machinesalesService.getMachinesales(obj);
    };
    */

    //machinesalesService.getMachinesales(obj);
    $scope.totalSalesLabel = 0;
    $scope.manageDailymachineshop = {};
    $scope.manageDailymachineshopList = [];
    $scope.initManageStates = function() {

      var d = new Date(); 
      // convert browser timestamp to UTC so that its in sync with your db date/time and zone
      var m = d.getUTCMonth() + 1;
      var date = d.getUTCFullYear() + '-' + m + '-' + d.getUTCDate();
      console.log('date', date);

      var obj = {};
      obj.params = {};
      obj.params.adate = date;
      console.log('obj', obj);
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        $scope.initManagePartner();
        //$scope.initManageGames();
        $scope.initManageMachineShop();
        $scope.totalSalesLabel = 0;
        //$scope.initManagePrevMachineReading();
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
        }
        $scope.manageDailymachineshopList = result;
        console.log($scope.manageDailymachineshopList);
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //dailymachineshopService.getDailyMachinesales(obj);
      dailymachineshopService.getDailyGroupedMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.deleteId = null;
/*
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/dailymachineshop/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailymachineshopService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };
*/

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageDailymachineshop = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageDailymachineshop, id) {

      console.log("Inside saveMachinesales");
      console.log(manageDailymachineshop);
      console.log(manageDailymachineshop.id);

      if (manageDailymachineshop.id === undefined) {
        $scope.createMachinesales(manageDailymachineshop);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageDailymachineshop;
        /*        obj.params.id = manageDailymachineshop.id;
                obj.params.playtechid= manageDailymachineshop.playtechid;
                obj.params.pshare= manageDailymachineshop.pshare;
                obj.params.pwin= manageDailymachineshop.pwin;
                obj.params.netpurchase= manageDailymachineshop.netpurchase;
                obj.params.netgaming= manageDailymachineshop.netgaming;
                obj.params.totalsales= manageDailymachineshop.totalsales;
                obj.params.csales= manageDailymachineshop.csales;
                obj.params.psales= manageDailymachineshop.psales;
                obj.params.shopid= manageDailymachineshop.shopid;
                obj.params.gameid= manageDailymachineshop.gameid;
                // obj.params.name = $scope.manageDailymachineshop.name;
                // obj.params.description = $scope.manageDailymachineshop.description;
                //obj.params.created = $scope.manageDailymachineshop.created;
        */
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          //console.log(result);
          $scope.manageDailymachineshop = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailymachineshopService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.salesNumbers = {};
    $scope.viewMachinesales = function(manageDailymachineshop) {
      console.log("Inside viewMachinesales");
      console.log(manageDailymachineshop);
      $scope.isEdit = true;
      $scope.manageDailymachineshop = manageDailymachineshop;
            
      console.log(manageDailymachineshop.ikey);
      $scope.machineSalesInvoice = {};
      $scope.getMachineInvoiceDetails(manageDailymachineshop.ikey);
      console.log($scope.machineSalesInvoice);
      $scope.getMachineSales(manageDailymachineshop.ikey);
      console.log($scope.machineSalesDetails);
    };

    $scope.getMachineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.getMachineSales = function(ikey) {
      var obj = {};
      $scope.machineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.machineSalesDetails = result;
        var data = {};
        var shopDetails = $scope.getShopDetails($scope.machineSalesDetails[0].shopid);
        console.log(shopDetails)
        console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById(shopDetails.shop.partnerid);
        data.created = shopDetails.shop.created;
        $scope.salesNumbers.data = data;
      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }

    $scope.getTotalAmount = function(items) {
      return items
          .map(function(x) { return x.totalsales; })
          .reduce(function(a, b) { return parseInt(a) + parseInt(b); });
    };
    
    $scope.showPartnerById = function(partnerid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (partnerid && $scope.managePartnerList.length) {
        //console.log($scope.manageDailymachineshop);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getShopDetails = function(shopid) {
      if (shopid &&  $scope.manageMachineShopList.length){
        var selected = $filter('filter')($scope.manageMachineShopList, {shopid: shopid
        },true);
        console.log(selected);
        return selected.length ? selected[0] : null;
      }else return null;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachineshop')
    .service('dailymachineshopService', dailymachineshopService);

  /** @ngInject */
  function dailymachineshopService(Machinesales) {
    var getDailyMachinesales = function (obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.find({
        filter: {
          where: {
            indate: {
              "gte": dailyDate
            }
          },
          include: ["machine", "shop"]
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyGroupedMachinesales = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpShop({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function (obj) {
      Machinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          }
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    /*  var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
*/
    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyGroupedMachinesales: getDailyGroupedMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey
      //      createMachinesales: createMachinesales,
      //      deleteMachinesales: deleteMachinesales
      //    saveMachinesales: saveMachinesales
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlinesales')
    .controller('DailyonlinesalesreportPageCtrl', DailyonlinesalesreportPageCtrl);

  /** @ngInject */
  function DailyonlinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailyonlinesalesreportService, onlineShopService, gameService, shopService, partnerService, toastr, $uibModal,dailyInvoiceService) {
    console.log("Inside DailyonlinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.params={};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.totalSalesLabel = 0;
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        $scope.totalSalesLabel = 0;
        for (var i=0; i<result.length;i++){
          //$scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].netpurchase) + parseFloat(result[i].pshare) + parseFloat(result[i].pwin);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlinesalesreportService.getOnlinesales(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();
/*
    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageOnlinesalesList.push($scope.inserted);
    };
*/
    $scope.createOnlinesales = function(manageOnlinesales) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlinesales.name);
      //console.log(manageOnlinesales.description);

      var obj = {};
      obj.params = {};

      obj.params.id= manageOnlinesales.id;
      obj.params.playtechid= manageOnlinesales.playtechid;
      obj.params.pshare= manageOnlinesales.pshare;
      obj.params.pwin= manageOnlinesales.pwin;
      obj.params.netpurchase= manageOnlinesales.netpurchase;
      obj.params.netgaming= manageOnlinesales.netgaming;
      obj.params.totalsales= manageOnlinesales.totalsales;
      obj.params.csales= manageOnlinesales.csales;
      obj.params.psales= manageOnlinesales.psales;

      //obj.params.description = manageOnlinesales.description;
      console.log(manageOnlinesales);
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlinesales = {};
        toastr.success('New Onlinesales has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.initManageStates();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      dailyonlinesalesreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/dailyonlinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function(res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.initManageStates();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyonlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveOnlinesales = function(manageOnlinesales, id) {

      console.log("Inside saveOnlinesales");
      console.log(manageOnlinesales);
      console.log(manageOnlinesales.id);

      if (manageOnlinesales.id === undefined) {
        $scope.createOnlinesales(manageOnlinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageOnlinesales;
        obj.params.id = manageOnlinesales.id;
        obj.params.playtechid= manageOnlinesales.playtechid;
        obj.params.pshare= manageOnlinesales.pshare;
        obj.params.pwin= manageOnlinesales.pwin;
        obj.params.netpurchase= manageOnlinesales.netpurchase;
        obj.params.netgaming= manageOnlinesales.netgaming;
        obj.params.totalsales= manageOnlinesales.totalsales;
        obj.params.csales= manageOnlinesales.csales;
        obj.params.psales= manageOnlinesales.psales;
        obj.params.shopid= manageOnlinesales.shopid;
        obj.params.gameid= manageOnlinesales.gameid;
        // obj.params.name = $scope.manageOnlinesales.name;
        // obj.params.description = $scope.manageOnlinesales.description;
        //obj.params.created = $scope.manageOnlinesales.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlinesales = {};
          toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        dailyonlinesalesreportService.saveOnlinesales(obj);

        //$scope.modal.hide();
      }

    }

/*
    $scope.datePickerPopup = function(onlinesales) {
        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
*/
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function (manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      console.log($scope.manageOnlinesales);
    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales.shop && $scope.managePartnerList.length) {
        console.log($scope.manageOnlinesales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageOnlinesales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getInDate = function(date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    // $scope.genIvoiceOnlinesales =function (manageOnlinesalesList){
    //   console.log('Inside genIvoiceOnlinesales');
    //   console.log(manageOnlinesalesList);
      

    //   if (manageOnlinesalesList.length){
    //     var date = new Date();
    //     //var invoiceDate = new Date();
    //     //invoiceDate.setDate(date.getDate() - 1);
        
    //     var objInvoice = {};
    //     objInvoice.params=[];
    //     for (var index = 0; index < manageOnlinesalesList.length; index++) {
    //       var recordInvoice = {};

    //       var ikeyString = manageOnlinesalesList[index].ikey.toString();
    //       var ikeyDate = ikeyString.substring(ikeyString.length - 8);
    //       var shopid = parseInt(ikeyString.substring(0, ikeyString.length - 8));
    //       console.log('ikeyDate',ikeyDate);

    //       var tempDate = ikeyDate.substring(2,4)+'/'+ikeyDate.substring(0,2)+'/'+ikeyDate.substring(4,8);
          
    //       var invoiceDate = new Date(tempDate);
    //       var indate = new Date();
    //       // indate.setDate(indate.getDate()-1); 
    //       console.log('invoiceDate',invoiceDate);

    //       recordInvoice.invoicedate = invoiceDate;
    //       recordInvoice.indate = $scope.getInDate(indate);
    //       recordInvoice.created = date;
    //       recordInvoice.lastupdated = date;
    //       recordInvoice.ikey = manageOnlinesalesList[index].ikey;
    //       recordInvoice.shopid = shopid;
    //       recordInvoice.zoneid = manageOnlinesalesList[index].shop.zoneid;
    //       objInvoice.params.push(recordInvoice);
    //     }
    //     console.log(objInvoice.params);

    //     objInvoice.onSuccess = function (result) {
    //       console.log("Inside SUCCESS genIvoiceOnlinesales");
    //       console.log(result);
    //       toastr.success('New Invoice has been generated successfully!', 'SUCCESS');


    //     }
    //     objInvoice.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
    //     };

    //     dailyInvoiceService.createInvoice(objInvoice);
    //   }

    // }
    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceOnlinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            var newInDate = new Date(invoiceList[index].indate);
            var resultInDate = $scope.getInDate(newInDate,0);

            recordInvoice.invoicedate = resultInDate;
            recordInvoice.indate = resultInDate;
            recordInvoice.created = date;
            recordInvoice.lastupdated = date;
            recordInvoice.ikey = invoiceList[index].ikey;
            recordInvoice.shopid = invoiceList[index].shopid;
            recordInvoice.zoneid = invoiceList[index].zoneid;

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else {
          toastr.error('No Pending Invoices', 'ERROR');
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlinesalesreportService.generateInvoiceOnline(obj);
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlinesales')
    .service('dailyonlinesalesreportService', dailyonlinesalesreportService);

  /** @ngInject */
  function dailyonlinesalesreportService(Onlinesales) {
    var getOnlinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Onlinesales.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["game","shop"]
        }
      }).$promise.then(function(data) {
    //  Onlinesales.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
/*    var getByDateOnlinesales = function(obj) {
      Onlinesales.find({
//  Post.find({where: {and: [{title: 'My Post'}, {content: 'Hello'}]}},
//          function (err, posts)

        filter: {
          where: {
            and: [

            ]
          include: "gamecat"
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);
      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    }; */

    var getDailyOnlinesalesByKey = function(obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey:obj.params.ikey
          },
          include: ["game","shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoiceOnline = function (obj) {

      Onlinesales.generateInvoiceOnline({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      generateInvoiceOnline:generateInvoiceOnline
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlineshop')
    .controller('DailyonlineshopreportPageCtrl', DailyonlineshopreportPageCtrl);

  /** @ngInject */
  function DailyonlineshopreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailyonlineshopreportService, dailyonlinesalesreportService, onlineShopService, gameService, shopService, partnerService, toastr, $uibModal,dailyInvoiceService) {
    console.log("Inside DailyonlineshopreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.params={};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlineshop = {};
    $scope.manageOnlineshopList = [];
    $scope.totalSalesLabel = 0;
    $scope.initManageStates = function() {
      var d = new Date(); 
      // convert local date to UTC date so that its in sync with your db date/time and zone

      var m = d.getUTCMonth() + 1;
      var date = d.getUTCFullYear() + '-' + m + '-' + d.getUTCDate();
      console.log('date', date);

      var obj = {};
      obj.params = {};
      obj.params.adate = date;
      console.log('obj', obj);

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        $scope.totalSalesLabel = 0;
        //console.log(result.result.length)
        for (var i=0; i<result.result.length;i++){
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlineshopList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlineshopreportService.getDailyGroupedOnlinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();
/*
    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageOnlineshopList.push($scope.inserted);
    };
*/
    $scope.createOnlinesales = function(manageOnlineshop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlineshop.name);
      //console.log(manageOnlineshop.description);

      var obj = {};
      obj.params = {};

      obj.params.id= manageOnlineshop.id;
      obj.params.playtechid= manageOnlineshop.playtechid;
      obj.params.pshare= manageOnlineshop.pshare;
      obj.params.pwin= manageOnlineshop.pwin;
      obj.params.netpurchase= manageOnlineshop.netpurchase;
      obj.params.netgaming= manageOnlineshop.netgaming;
      obj.params.totalsales= manageOnlineshop.totalsales;
      obj.params.csales= manageOnlineshop.csales;
      obj.params.psales= manageOnlineshop.psales;

      //obj.params.description = manageOnlineshop.description;
      console.log(manageOnlineshop);
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlineshop = {};
        toastr.success('New Onlinesales has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.initManageStates();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      dailyonlineshopreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    // $scope.confirmDelete = function(id) {
    //   $scope.open('app/pages/reports/dailyonlinesales/modals/dangerModal.html');
    //   $scope.deleteId = id;
    // };

    // $scope.deleteOnlinesales = function(res) {
    //   console.log("Inside deleteOnlinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
    //       $scope.initManageStates();
    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.deleteOnlinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // }

    $scope.editState = function(onlinesales) {
      console.log("Inside viewOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlineshop.id = $scope.manageOnlineshop.id;
      // $scope.manageOnlineshop.name = state.name;
      // $scope.manageOnlineshop.description = state.description;
      // $scope.manageOnlineshop.created = state.created;
      // $scope.manageOnlineshop.lastupdated = state.lastupdated;
      $scope.manageOnlineshop = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    // $scope.saveOnlinesales = function(manageOnlineshop, id) {

    //   console.log("Inside saveOnlinesales");
    //   console.log(manageOnlineshop);
    //   console.log(manageOnlineshop.id);

    //   if (manageOnlineshop.id === undefined) {
    //     $scope.createOnlinesales(manageOnlineshop);
    //   } else {

    //     var obj = {};
    //     obj.params = {};
    //     obj.params = manageOnlineshop;
    //     obj.params.id = manageOnlineshop.id;
    //     obj.params.playtechid= manageOnlineshop.playtechid;
    //     obj.params.pshare= manageOnlineshop.pshare;
    //     obj.params.pwin= manageOnlineshop.pwin;
    //     obj.params.netpurchase= manageOnlineshop.netpurchase;
    //     obj.params.netgaming= manageOnlineshop.netgaming;
    //     obj.params.totalsales= manageOnlineshop.totalsales;
    //     obj.params.csales= manageOnlineshop.csales;
    //     obj.params.psales= manageOnlineshop.psales;
    //     obj.params.shopid= manageOnlineshop.shopid;
    //     obj.params.gameid= manageOnlineshop.gameid;
    //     // obj.params.name = $scope.manageOnlineshop.name;
    //     // obj.params.description = $scope.manageOnlineshop.description;
    //     //obj.params.created = $scope.manageOnlineshop.created;


    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageOnlineshop = {};
    //       toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
    //       //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
    //       $scope.initManageStates();

    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //         toastr.error('NO INTERNET CONNECTION', 'Error');
    //       } else {
    //         var errdetails = [];
    //         errdetails = err.data.error.detail;
    //         toastr.error(errdetails, 'ERROR');
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.saveOnlinesales(obj);
    //     //$scope.modal.hide();
    //   }
    // }

/*
    $scope.datePickerPopup = function(onlinesales) {
        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
*/
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewOnlinesales = function (manageOnlineshop) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlineshop = manageOnlineshop;
      console.log($scope.manageOnlineshop);
      console.log(manageOnlineshop.ikey);
      $scope.onlineSalesInvoice = {};
      $scope.getOnlineInvoiceDetails(manageOnlineshop.ikey);
      console.log($scope.onlineSalesInvoice);
      $scope.getOnlineSales(manageOnlineshop.ikey);
      console.log($scope.onlineSalesDetails);
    };

    $scope.getOnlineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }
    $scope.lookupDetails = {};
    $scope.getOnlineSales = function(ikey) {
      var obj = {};
      $scope.onlineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.onlineSalesDetails = result;
        var data = {};
        //var shopDetails = $scope.getShopDetails($scope.onlineSalesDetails[0].shopid);
        //console.log(shopDetails)
        //console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById($scope.onlineSalesDetails[0].shop.partnerid);
        data.created = $scope.onlineSalesDetails[0].shop.created;
        $scope.lookupDetails.data = data;
      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      }
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (partnerid) {
      if (partnerid && $scope.managePartnerList.length) {

        var selected = $filter('filter')($scope.managePartnerList, {
          id: partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.genIvoiceOnlinesales =function (manageOnlineshopList){
      console.log('Inside genIvoiceOnlinesales');
      console.log(manageOnlineshopList);
      

      if (manageOnlineshopList.length){
        var date = new Date();
        var invoiceDate = new Date();
        invoiceDate.setDate(date.getDate() - 1);
        
        var objInvoice = {};
        objInvoice.params=[];
        for (var index = 0; index < manageOnlineshopList.length; index++) {
          var recordInvoice = {};

          recordInvoice.invoicedate = invoiceDate;
          recordInvoice.created = date;
          recordInvoice.lastupdated = date;
          recordInvoice.ikey = manageOnlineshopList[index].ikey;

          objInvoice.params.push(recordInvoice);
        }
        console.log(objInvoice.params);

        objInvoice.onSuccess = function (result) {
          console.log("Inside SUCCESS genIvoiceOnlinesales");
          console.log(result);
          toastr.success('New Invoice has been generated successfully!', 'SUCCESS');


        }
        objInvoice.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
        };

        dailyInvoiceService.createInvoice(objInvoice);
      }

    }

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlineshop')
    .service('dailyonlineshopreportService', dailyonlineshopreportService);

  /** @ngInject */
  function dailyonlineshopreportService(Onlinesales) {
    var getOnlinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Onlinesales.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function(data) {
    //  Onlinesales.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
/*    var getByDateOnlinesales = function(obj) {
      Onlinesales.find({
//  Post.find({where: {and: [{title: 'My Post'}, {content: 'Hello'}]}},
//          function (err, posts)

        filter: {
          where: {
            and: [

            ]
          include: "gamecat"
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);
      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    }; */

	var getDailyGroupedOnlinesales = function (obj) {
      Onlinesales.grpShop({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

	
    var getDailyOnlinesalesByKey = function(obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey:obj.params.ikey
          }
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      getDailyGroupedOnlinesales: getDailyGroupedOnlinesales
  //    getByDateOnlinesales: getByDateOnlinesales,
      //createOnlinesales: createOnlinesales,
      //deleteOnlinesales: deleteOnlinesales,
      //saveOnlinesales: saveOnlinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.machinesales')
    .controller('MachinesalesreportPageCtrl', MachinesalesreportPageCtrl);

  /** @ngInject */
  function MachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesreportService, machineShopService,gameService, shopService, partnerService,machinesalesService, dailyInvoiceService, validationService, toastr, $uibModal) {
    console.log("Inside MachinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.initManageGames();
          $scope.initManagePartner();
          $scope.initManageGames();
          $scope.totalSalesLabel = 0;
          for (var i=0; i<result.length;i++){
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.initManageMachineShop();
          //$scope.initManagePrevMachineReading();
          $scope.manageMachinesalesList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machinesalesreportService.getBetweenDatesMachinesales(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.manageMachinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machinesalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/machinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      console.log(manageMachinesales);
      $scope.manageMachinesales = manageMachinesales;
      $scope.getMachineInvoiceDetails(manageMachinesales.ikey);
    };

    // $scope.dateformater = function(ikey) {
    //   var strikey = ikey.toString()
    //   var date = strikey.substring(strikey.length - 8);
    //   return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
    // };

    $scope.getMachineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.machineSalesInvoice = {};
      obj.onSuccess = function(result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }
    
    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid, shopid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {machineid: machineid } && {shopid:shopid }
        ,true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageMachinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageMachinesales.shop && $scope.managePartnerList.length) {
        //console.log($scope.manageMachinesales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.machinesales')
    .service('machinesalesreportService', machinesalesreportService);

  /** @ngInject */
  function machinesalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      console.log('client from date',fd);
      console.log('client from date1',date1); 
      console.log('client to date',td);
      console.log('client to date2',date2); 

      Machinesales.find({
              filter: {
                where:{
                  and:[
                    {indate: {gte: date1}},
                    {indate: {lte: date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
//      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales
  //    saveMachinesales: saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.marketing')
    .controller('MarketingreportPageCtrl', MarketingreportPageCtrl);

  /** @ngInject */
  function MarketingreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    marketingreportService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal, zoneService) {
    console.log("Inside MarketingreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.manageMarketingsales = {};
    $scope.manageMarketingsalesList = [];

    $scope.searchSales = function (dateList) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = date1;
        obj.params.bdate = date2;
        obj.params.shoptype = dateList.shoptype?dateList.shoptype.value:null;
        obj.params.zoneid = dateList.zone?dateList.zone.id:null;

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          $scope.totalSalesLabel = 0;

          $scope.manageMarketingsalesList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onmacTotal = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
            $scope.manageMarketingsalesList.result[i].total = onmacTotal;
            $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
          }
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        marketingreportService.getGrpSalesInRange(obj)
      }
    };

    $scope.initManageMarketing = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
//     $scope.initManageStates = function() {
//       var obj = {};
//       obj.params = {};
//       obj.params.fromDt = $scope.dateList.from;
//       obj.params.toDt = $scope.dateList.to;

//       obj.onSuccess = function(result) {
//         console.log("Inside SUCCESS");
//         console.log(result);
//         $scope.initManagePartner();
//         $scope.initManageGames();
// //        $scope.initManageMachineShop();
//         //$scope.initManagePrevMachineReading();
//         $scope.manageMarketingsalesList = result;
//         $scope.isEdit = false;
//       };
//       obj.onFailure = function(err) {
//         console.log("Inside Failure");
//         console.log(err);
//       };
//       marketingreportService.getBetweenDatesMachinesales(obj);
//       //$scope.$broadcast('scroll.refreshComplete');
//     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/marketing/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     marketingreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewSales");
      console.log(onlinesales);

      $scope.manageMarketingsales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveSales = function(manageMarketingsales, id) {

      console.log("Inside saveSales");
      console.log(manageMarketingsales);
      console.log(manageMarketingsales.id);

      // if (manageMarketingsales.id === undefined) {
      //   $scope.createMachinesales(manageMarketingsales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = manageMarketingsales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.manageMarketingsales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   marketingreportService.saveSales(obj);

      //   //$scope.modal.hide();
      // }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewSales = function (manageMarketingsales) {
      console.log("Inside viewSales");
      $scope.isEdit = true;
      $scope.manageMarketingsales = manageMarketingsales;
      console.log($scope.manageMarketingsales.partnerid);
      console.log($scope.manageMarketingsales.sname);
      $scope.getSalesOfShop(manageMarketingsales.partnerid,manageMarketingsales.shopid );
    //  $scope.getMachineSalesPrevReadings(manageMarketingsales.mid);
    };

    $scope.getSalesOfShop = function(partnerid,sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;

      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      marketingreportService.getGrpSalesForShopInRange(obj);
    }

    // $scope.showGameById = function (gid) {
    //   if (gid && $scope.manageGamesList.length) {
    //     var selected = $filter('filter')($scope.manageGamesList, {
    //       id: gid
    //     },true);
    //     return selected.length ? selected[0].name : 'Not set';
    //   } else return 'Not set';
    // };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    // $scope.showPartnerById = function (manageMarketingsales) {
    //   if (manageMarketingsales.shop && $scope.managePartnerList.length) {
    //     var selected = $filter('filter')($scope.managePartnerList, {
    //       id: $scope.manageMarketingsales.shop.partnerid
    //     },true);
    //     return selected.length ? selected[0].code : 'Not set';
    //   } else return 'Not set'
    // };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.marketing')
    .service('marketingreportService', marketingreportService);

  /** @ngInject */
  function marketingreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.onlinesales')
    .controller('OnlinesalesreportPageCtrl', OnlinesalesreportPageCtrl);

  /** @ngInject */
  function OnlinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    onlinesalesreportService, onlineShopService, gameService, shopService, partnerService,dailyInvoiceService,
    toastr, $uibModal,validationService) {
    console.log("Inside OnlinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    $scope.totalSalesLabel = 0;
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };

    //user.birthday = new Date(user.birthday);
    $scope.dateList = {};
    $scope.searchOnlinesales = function (dateList) {
      console.log("Inside searchOnlinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          //console.log(result);
          $scope.totalSalesLabel = 0;
          for (var i=0; i<result.length;i++){
            //$scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].netpurchase) + parseFloat(result[i].pshare) + parseFloat(result[i].pwin);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.manageOnlinesalesList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlinesalesreportService.getBetweenDatesOnlinesales(obj)
      }
      };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    
    $scope.getOnlineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.onlineSalesInvoice = {};
      obj.onSuccess = function(result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.params={};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        for (var i=0; i<result.length;i++){
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      //onlinesalesreportService.getOnlinesales(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
//    $scope.initManageStates();
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageOnlinesalesList.push($scope.inserted);
        };
    */
    $scope.createOnlinesales = function(manageOnlinesales) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlinesales.name);
      //console.log(manageOnlinesales.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageOnlinesales.id;
      obj.params.playtechid = manageOnlinesales.playtechid;
      obj.params.pshare = manageOnlinesales.pshare;
      obj.params.pwin = manageOnlinesales.pwin;
      obj.params.netpurchase = manageOnlinesales.netpurchase;
      obj.params.netgaming = manageOnlinesales.netgaming;
      obj.params.totalsales = manageOnlinesales.totalsales;
      obj.params.csales = manageOnlinesales.csales;
      obj.params.psales = manageOnlinesales.psales;

      //obj.params.description = manageOnlinesales.description;
      console.log(manageOnlinesales);
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlinesales = {};
        toastr.success('New Onlinesales has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.initManageStates();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      onlinesalesreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/onlinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function(res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.initManageStates();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        onlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveOnlinesales = function(manageOnlinesales, id) {

      console.log("Inside saveOnlinesales");
      console.log(manageOnlinesales);
      console.log(manageOnlinesales.id);

      if (manageOnlinesales.id === undefined) {
        $scope.createOnlinesales(manageOnlinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageOnlinesales;
        obj.params.id = manageOnlinesales.id;
        obj.params.playtechid = manageOnlinesales.playtechid;
        obj.params.pshare = manageOnlinesales.pshare;
        obj.params.pwin = manageOnlinesales.pwin;
        obj.params.netpurchase = manageOnlinesales.netpurchase;
        obj.params.netgaming = manageOnlinesales.netgaming;
        obj.params.totalsales = manageOnlinesales.totalsales;
        obj.params.csales = manageOnlinesales.csales;
        obj.params.psales = manageOnlinesales.psales;
        obj.params.shopid = manageOnlinesales.shopid;
        obj.params.gameid = manageOnlinesales.gameid;
        // obj.params.name = $scope.manageOnlinesales.name;
        // obj.params.description = $scope.manageOnlinesales.description;
        //obj.params.created = $scope.manageOnlinesales.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlinesales = {};
          toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        onlinesalesreportService.saveOnlinesales(obj);

        //$scope.modal.hide();
      }

    }

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function(manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      $scope.getOnlineInvoiceDetails(manageOnlinesales.ikey);
      console.log($scope.manageOnlinesales);
    }

    $scope.showGames = function(game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showShops = function(shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function(manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales.shop && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: manageOnlinesales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.onlinesales')
    .service('onlinesalesreportService', onlinesalesreportService);

  /** @ngInject */
  function onlinesalesreportService(Onlinesales) {
    var getOnlinesales = function(obj) {

      Onlinesales.find({
        filter: {
          include: ["game","shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getDailyOnlinesales = function(obj) {
      var d = new Date(), y = d.getFullYear(), m = d.getMonth();
      var date = y+'-'+m+'-'+d.getUTCDate();
      console.log('date',date);

            Onlinesales.find({
              filter: {
                where:{
                  created: date
                },
                include: ["game","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });
    };

    var getBetweenDatesOnlinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      console.log('client from date',fd);
      console.log('client from date1',date1); 
      console.log('client to date',td);
      console.log('client to date2',date2); 
      
            Onlinesales.find({
              filter: {
                where:{
                  and:[
                    {indate: {gte: date1}},
                    {indate: {lte: date2}}
                  ]
                },
                include: ["game","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var createOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getOnlinesales: getOnlinesales,
  //    getByDateOnlinesales: getByDateOnlinesales,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      getDailyOnlinesales:getDailyOnlinesales,
      getBetweenDatesOnlinesales: getBetweenDatesOnlinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.partnersales')
    .controller('PartnersalesreportPageCtrl', PartnersalesreportPageCtrl);

  /** @ngInject */
  function PartnersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnersalesreportService, /*machineShopService,*/gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal, dailyonlinesalesreportService, dailymachinesalesreportService) {
    console.log("Inside PartnersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        // td.setHours(23);
        // td.setMinutes(59);
        // td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        console.log('From',fd);
        console.log('TO',td);
        obj.params.adate = date1;
        obj.params.bdate = date2;

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;

          $scope.managePartnersalesList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onmacTotal = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
            $scope.managePartnersalesList.result[i].total = onmacTotal;
            $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
          }
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        partnersalesreportService.getGrpMacSalesInRange(obj);
      }
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
//        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.managePartnersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/partnersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(managePartnersales, id) {

      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      if (managePartnersales.id === undefined) {
        $scope.createMachinesales(managePartnersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = managePartnersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      $scope.getMachineSalesOfPartner(managePartnersales.partnerid);
    //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getMachineSalesOfPartner = function(partnerid) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = "("+partnerid+")";
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.mPSalesTotal = 0;
        $scope.mCSalesTotal = 0;
        $scope.mSalesTotal = 0;
        $scope.oPSalesTotal = 0;
        $scope.oCSalesTotal = 0;
        $scope.oSalesTotal = 0;
        $scope.shopTotal = 0;
        $scope.compTotal = 0;
        $scope.shopOverTotal = 0;
        $scope.compOverTotal = 0;

        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
          $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
          $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
          $scope.mSalesTotal = $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
          $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
          $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
          $scope.oSalesTotal = $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
          $scope.machineSalesOfPartnerList.result[i].shopTotal = parseFloat(result.result[i].mpsales)+ parseFloat(result.result[i].opsales);
          $scope.machineSalesOfPartnerList.result[i].compTotal = parseFloat(result.result[i].mcsales)+ parseFloat(result.result[i].ocsales);
          $scope.shopOverTotal = $scope.shopOverTotal + $scope.machineSalesOfPartnerList.result[i].shopTotal;
          $scope.compOverTotal = $scope.compOverTotal + $scope.machineSalesOfPartnerList.result[i].compTotal;

        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      partnersalesreportService.getMachinesalesByPartner(obj);
    }

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function (managePartnersales) {
      if (managePartnersales.shop && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.managePartnersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.manageDailyinvoices={};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

     $scope.viewInvoice = function (manageDailyinvoices) {
       console.log("Inside viewInvoice");
       $scope.isInvoice = true;
       $scope.manageDailyinvoices = manageDailyinvoices;
       if ($scope.manageDailyinvoices.ikey){
        $scope.manageDailyinvoices.invoicedate = $scope.dateFormater($scope.manageDailyinvoices.ikey);
       }
       console.log($scope.manageDailyinvoices);
 
       $scope.onlineInvoiceDetails = {};
       $scope.machineInvoiceDetails = {};
       $scope.shopInvoiceDetails = {};
       $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
       $scope.getMachineSales($scope.manageDailyinvoices.ikey);
 
     };
 
     $scope.getOnlineSales = function (ikey) {
       var obj = {};
       obj.params = {};
       obj.params.ikey = ikey;
       obj.onSuccess = function (result) {
         console.log("Inside Online SUCCESS");
         console.log(result);
         console.log($scope.manageDailyinvoices);
         $scope.onlineInvoiceDetails = result;
 
         if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
           console.log('Inside Empty MachineShop');
           $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
         }

         var online = 0;
         $scope.total.onlineST=0;
         if ($scope.onlineInvoiceDetails.length > 0) {
           for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
             online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
           }
           $scope.total.online = parseFloat(online);
           $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
         }
       }
       obj.onFailure = function (err) {
         console.log("Inside Failure");
       }
       dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
     };
 
     $scope.getMachineSales = function (ikey) {
       var obj = {};
       obj.params = {};
       obj.params.ikey = ikey;
       obj.onSuccess = function (result) {
         console.log("Inside Machine SUCCESS");
         console.log(result);
         console.log($scope.manageDailyinvoices);
         $scope.machineInvoiceDetails = result;
 
         if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
           console.log('Inside Empty OnlineShop');
           $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
         }

         var machine = 0;
         $scope.total.machineST=0;
         if ($scope.machineInvoiceDetails.length > 0) {
           for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
             machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
           }
           $scope.total.machine = parseFloat(machine);
           $scope.total.machineST = machine + parseFloat($scope.manageDailyinvoices.machineshorts);
         }
       }
 
       obj.onFailure = function (err) {
         console.log("Inside Failure");
       }
       dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
     };
 
     $scope.shopInvoiceDetails = {};
     $scope.getManageShop = function (shopid) {
       var obj = {};
       obj.params = {};
       obj.params.shopid = shopid;
       obj.onSuccess = function (result) {
         console.log("Inside SUCCESS getManageShop");
         console.log(result);
         $scope.shopInvoiceDetails = result;
       };
       obj.onFailure = function (err) {
         console.log("Inside Failure getManageShop");
         console.log(err);
       };
       shopService.getShopById(obj);
     };

     $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };
    $scope.print = function () {
      window.print();
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) { return x.mpsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) { return x.mcsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) { return x.mactotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) { return x.opsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) { return x.ocsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) { return x.ontotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) { return x.shopTotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) { return x.compTotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };

    $scope.getShopSalesOfPartner = function(salesOfPartnerList) {

      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = false;
      $scope.shopSalesOfPartnerList = {};
      $scope.shopSalesOfPartnerList = salesOfPartnerList;
      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 = parseFloat($scope.shopSalesOfPartnerList[i].ontotal)+ parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal = parseFloat($scope.shopSalesOfPartnerList[i].mpsales)+ parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal = parseFloat($scope.shopSalesOfPartnerList[i].mcsales)+ parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.shopOverTotal = $scope.shopOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal = $scope.compOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].compTotal);

      }

      // var obj = {};
      // obj.params = {};
      // //$scope.machineSalesOfPartner = {};


      // // var days = 60; // Days you want to subtract
      // // var td = new Date();
      // // var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      // // var day =fd.getDate();
      // // var month=fd.getMonth()+1;
      // // var year=fd.getFullYear();

      // var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      // var date1 = y+'-'+m+'-'+fd.getUTCDate();
      // var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      // td.setHours(23);
      // td.setMinutes(59);
      // td.setSeconds(59);
      // var date2 = y+'-'+m+'-'+td.getUTCDate();

      // console.log(fd);
      // console.log(td);

      // obj.params.adate = fd;
      // obj.params.bdate = td;
      // obj.params.partnerId = $scope.managePartnersales.partnerid;
      // console.log(obj.params);

      // obj.onSuccess = function(result) {
      //   console.log("Inside getShopSalesOfPartner SUCCESS");
      //   console.log(result);
      //   $scope.totalSalesLabelFooter = 0;
      //   $scope.mPSalesTotal = 0;
      //   $scope.mCSalesTotal = 0;
      //   $scope.mSalesTotal = 0;
      //   $scope.oPSalesTotal = 0;
      //   $scope.oCSalesTotal = 0;
      //   $scope.oSalesTotal = 0;
      //   $scope.shopTotal = 0;
      //   $scope.compTotal = 0;
      //   $scope.shopOverTotal = 0;
      //   $scope.compOverTotal = 0;

      //   //$scope.shopSalesOfPartnerList = result.result;
      //   console.log('scope.getShopSalesOfPartner', $scope.shopSalesOfPartnerList);
      //   $scope.shopSalesOfPartnerList = $filter('filter')(result.result, {
      //     code: shopCode
      //   },true);
      //   console.log('scope.getShopSalesOfPartner', $scope.shopSalesOfPartnerList);

      //   console.log($scope.totalSalesLabelFooter);
      // }
      // obj.onFailure = function(err) {
      //   console.log("Inside getMachineSalesOfPartner Failure");
      // }
      // partnersalesreportService.getMachinesalesByPartner(obj);
    };    
    

}
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.partnersales')
    .service('partnersalesreportService', partnersalesreportService);

  /** @ngInject */
  function partnersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesByPartner = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesByPartner: getMachinesalesByPartner,
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.suppliersales')
    .controller('SuppliersalesreportPageCtrl', SuppliersalesreportPageCtrl);

  /** @ngInject */
  function SuppliersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    suppliersalesreportService, machineShopService,gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal) {
    console.log("Inside SuppliersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      

      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getUTCDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getUTCDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = fd;
        obj.params.bdate = td;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);

          $scope.totalSalesLabel = 0;
          $scope.totalSalesLabelFooter = 0;
          for (var i = 0; i < result.result.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.manageSuppliersalesList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        suppliersalesreportService.getGrpMacSalesInRange(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageSuppliersales = {};
    $scope.manageSuppliersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.manageSuppliersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      suppliersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/suppliersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageSuppliersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.saveMachinesales = function(manageSuppliersales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageSuppliersales);
      console.log(manageSuppliersales.id);

      if (manageSuppliersales.id === undefined) {
        $scope.createMachinesales(manageSuppliersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSuppliersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSuppliersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageSuppliersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.manageSuppliersales = manageSuppliersales;
      console.log($scope.manageSuppliersales.id);

      $scope.getMachineSalesOfSupplier(manageSuppliersales.id);
    };

    $scope.getMachineSalesOfSupplier = function(suppId) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfSupplier = {};
      $scope.machineSalesOfSupplierList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = fd;
      obj.params.bdate = td;
      obj.params.suppId = suppId;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfSupplier SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(result.result[i].totalsales);
        }
        console.log($scope.totalSalesLabelFooter);
        $scope.machineSalesOfSupplierList = result;
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfSupplier Failure");
      }
      suppliersalesreportService.getMachinesalesBySupplier(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageSuppliersales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageSuppliersales.shop && $scope.managePartnerList.length) {
        //console.log($scope.manageSuppliersales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageSuppliersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.suppliersales')
    .service('suppliersalesreportService', suppliersalesreportService);

  /** @ngInject */
  function suppliersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      var newDate  = new Date(date);
      console.log('date',newDate);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": newDate}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesBySupplier = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        suppId: obj.params.suppId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };
    
    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesBySupplier: getMachinesalesBySupplier,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      getAvailableMachineByZone: getAvailableMachineByZone,
//      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales
  //    saveMachinesales: saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff.dailymachinesales')
    .controller('DailymachinesalesShopStaffPageCtrl', DailymachinesalesShopStaffPageCtrl);

  /** @ngInject */
  function DailymachinesalesShopStaffPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachineShopStaffService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, 
    $uibModal, receiptService,  $rootScope, zoneService, userService) {
    console.log("Inside DailymachinesalesShopStaffPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageGames");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure initManageGames");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.init = function(){
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
    };
    $scope.init();
    $scope.reportFilter={};
    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];

    $scope.getDailyMachinesales = function(reportFilter) {
      console.log('Inside getDailyMachinesales');
      console.log('$rootScope.userData',$rootScope.userData);
      
      
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }
      if (reportFilter.agent){
        obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
      }
      if (reportFilter.daynight){
        obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
      }
      if (typeof $rootScope.userData.credentials.days !== "undefined") {
        obj.params.days=$rootScope.userData.credentials.days?$rootScope.userData.credentials.days:1;
      }
      if (typeof $rootScope.userData.credentials.shop !== "undefined") {
        console.log('Inside $rootScope.userData.credentials.shop');
        obj.params.shopid=$rootScope.userData.credentials.shop?$rootScope.userData.credentials.shop.id:null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.totalSalesLabel = 0;
        $scope.manageMachinesalesList = result.result;
        for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachineShopStaffService.getDailyMachinesales(obj);
    };
    //$scope.getDailyMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/shopstaff/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachineShopStaffService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        dailymachineShopStaffService.saveMachinesales(obj);
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function(manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code){
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/shopstaff/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function(gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function(machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function(manageMachinesales) {
      if (manageMachinesales&& $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        },true);
        return selected.length ? selected[0].code+', '+selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };
    

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate,1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);
             
              console.log('checkInDate',checkInDate);
              console.log('resultInDate',resultInDate);

              if (checkInDate>=resultInDate){
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else{
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachineShopStaffService.generateInvoice(obj);
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

  }

})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff.dailymachinesales')
    .service('dailymachineShopStaffService', dailymachineShopStaffService);

  /** @ngInject */
  function dailymachineShopStaffService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();
  
    //   var dailyDate = year+'-'+month+'-'+day;
  
    //   console.log('date',dailyDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };


    var getDailyMachinesales = function(obj) {

      var days = obj.params.days?obj.params.days:1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.getDailyMachinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        shopid: obj.params.shopid?obj.params.shopid:null,
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier.machinesales')
    .controller('MachinesalesSupplierPageCtrl', MachinesalesSupplierPageCtrl);

  /** @ngInject */
  function MachinesalesSupplierPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesSupplierService, machineShopService, gameService, shopService, partnerService, machinesalesService, dailyInvoiceService, validationService, toastr, $uibModal, $rootScope, zoneService, receiptService, userService, supplierService) {
    console.log("Inside MachinesalesSupplierPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
      $scope.initManageSupplier();
    };
    $scope.init();

    $scope.reportFilter = {};
    $scope.searchMachinesales = function (reportFilter) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0) {
                value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
          }
        }
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }
        if (reportFilter.agent){
          obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        }
        if (reportFilter.daynight){
          obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
        }
        if (reportFilter.supplier) {
          obj.params.supplierid=reportFilter.supplier?reportFilter.supplier.id:null;
        } else {
        if (typeof $rootScope.userData.credentials.supplier !== "undefined") {
          obj.params.supplierid = $rootScope.userData.credentials.supplier?$rootScope.userData.credentials.supplier.id:null;
        }
      }
        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          $scope.totalCommissionLabel = 0;
          $scope.manageMachinesalesList = result.result;
          for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
            $scope.manageMachinesalesList[i].commission = parseFloat($scope.manageMachinesalesList[i].totalsales) * parseFloat($scope.manageMachinesalesList[i].suprate/100);
            $scope.totalCommissionLabel = $scope.totalCommissionLabel + parseFloat($scope.manageMachinesalesList[i].commission);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          // $scope.initManagePartner();
          // $scope.initManageGames();
          // $scope.initManageMachineShop();
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machinesalesSupplierService.getBetweenDatesMachinesales(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    // $scope.searchMachinesales = function() {
    //   var obj = {};
    //   obj.params = {};
    //   obj.params.fromDt = $scope.dateList.from;
    //   obj.params.toDt = $scope.dateList.to;

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.initManagePartner();
    //     $scope.initManageGames();
    //     $scope.initManageMachineShop();
    //     //$scope.initManagePrevMachineReading();
    //     $scope.manageMachinesalesList = result;
    //     $scope.isEdit = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machinesalesSupplierService.getBetweenDatesMachinesales(obj);
    //   //$scope.$broadcast('scroll.refreshComplete');
    // };
    //$scope.searchMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/supplier/machinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.searchMachinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesSupplierService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function (manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.searchMachinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesSupplierService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      console.log(manageMachinesales);
      $scope.manageMachinesales = manageMachinesales;
      
      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
          $scope.getMachineInvoiceDetails(manageMachinesales.ikey);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);
      
    };

    // $scope.dateformater = function(ikey) {
    //   var strikey = ikey.toString()
    //   var date = strikey.substring(strikey.length - 8);
    //   return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
    // };

    $scope.getMachineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.machineSalesInvoice = {};
      obj.onSuccess = function (result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        }, true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function (manageMachinesales) {
      if (manageMachinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcommission = function (items) {
      if (items){
      return items
        .map(function (x) { return x.commission; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier.machinesales')
    .service('machinesalesSupplierService', machinesalesSupplierService);

  /** @ngInject */
  function machinesalesSupplierService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getUTCDate();
    //   //var newDate  = new Date(date);
    //   console.log('date',date);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": date}
    //       },
    //       include: ["supplier","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   td.setHours(23);
    //   td.setMinutes(59);
    //   td.setSeconds(59);
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('client from date',fd);
    //   console.log('client from date1',date1); 
    //   console.log('client to date',td);
    //   console.log('client to date2',date2); 

    //   Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {indate: {gte: date1}},
    //                 {indate: {lte: date2}}
    //               ]
    //             },
    //             include: ["supplier","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    var getBetweenDatesMachinesales = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Machinesales.getAllSuppliersales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        supplierid: obj.params.supplierid?obj.params.supplierid:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var deleteMachinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      // getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales,
     getAvailableMachineByZone:getAvailableMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas')
    .controller('AreasPageCtrl', AreasPageCtrl);

  /** @ngInject */
  function AreasPageCtrl($scope, $filter, editableOptions, editableThemes,
    areaService, toastr, $uibModal, stateService, zoneService) {
    console.log("Inside AreasPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteArea(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    //Getting States
    $scope.manageStatesList = [];
    $scope.manageZonesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };

    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };




    $scope.manageAreasList = [];
    $scope.manageArea = {};
    $scope.initManageAreas = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
        $scope.initManageStates();
        $scope.initManageZones();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };
    $scope.initManageAreas();

    $scope.addArea = function() {
      //genericModalService.show('modules/modals/addArea.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageAreasList.push($scope.inserted);
    };

    $scope.createArea = function(manageArea) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createArea");
      console.log(manageArea);

      var obj = {};
      obj.params = {};
      obj.params = manageArea;
      // obj.params.name = manageArea.name;
      // obj.params.description = manageArea.description;
      // obj.params.zoneid = manageArea.zones
      // obj.params.stateid = manageArea.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageArea = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageAreas();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      areaService.createArea(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/areas/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteArea = function(res) {
      console.log("Inside deleteArea");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          $scope.initManageAreas();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        areaService.deleteArea(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageArea.id = $scope.manageArea.id;
      // $scope.manageArea.name = state.name;
      // $scope.manageArea.description = state.description;
      // $scope.manageArea.created = state.created;
      // $scope.manageArea.lastupdated = state.lastupdated;
      $scope.manageArea = state;
      genericModalService.show('modules/modals/addArea.html', $scope);
    }

    $scope.saveArea = function(manageArea, id) {

      console.log("Inside saveArea");
      console.log(manageArea);
      console.log(id);

      console.log(manageArea.zones);
      console.log(manageArea.state);


      if (id === undefined) {
        $scope.createArea(manageArea);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageArea;
        obj.params.id = id;
        // obj.params.name = $scope.manageArea.name;
        // obj.params.description = $scope.manageArea.description;
        //obj.params.created = $scope.manageArea.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageArea = {};
          toastr.success('Area has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageAreas();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        areaService.saveArea(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas')
    .service('areaService', areaService);

  /** @ngInject */
  function areaService(Area) {
    var getAreas = function(obj) {

    Area.find({
      filter:{
        include:["state","zone"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var createArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Area.create({
      name:obj.params.name,
      description:obj.params.description?obj.params.description:null,
      stateid: obj.params.state,
	     zoneid: obj.params.zone,
      created: date,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Area.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Area.prototype$updateAttributes({
      id: obj.params.id,
      name: obj.params.name,
      description: obj.params.description?obj.params.description:null,
      stateid: obj.params.state,
	    zoneid: obj.params.zone,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getAreas: getAreas,
      createArea: createArea,
      deleteArea: deleteArea,
      saveArea: saveArea
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory')
      .controller('GamecategoryPageCtrl', GamecategoryPageCtrl);

  /** @ngInject */
  function GamecategoryPageCtrl($scope, $filter, editableOptions, editableThemes,
    gamecategoryService,toastr,$uibModal ) {
    console.log("Inside GamecategoryPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteGamecategory(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageGamecategory={};
    $scope.manageGamecategoryList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageGamecategoryList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        gamecategoryService.getGamecategory(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageGamecategoryList.push($scope.inserted);
    };

    $scope.createGamecategory = function(manageGamecategory) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createGamecategory");
      console.log(manageGamecategory.name);
      //console.log(manageGamecategory.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageGamecategory.name;
      //obj.params.description = manageGamecategory.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategory = {};
        toastr.success('New Gamecategory has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Gamecategory successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gamecategoryService.createGamecategory(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/gamecategory/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteGamecategory = function (res){
      console.log("Inside deleteGamecategory");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Gamecategory has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            gamecategoryService.deleteGamecategory(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (gamecategory){
      console.log("Inside editGamecategory");
      console.log(gamecategory);
      // $scope.manageGamecategory.id = $scope.manageGamecategory.id;
      // $scope.manageGamecategory.name = state.name;
      // $scope.manageGamecategory.description = state.description;
      // $scope.manageGamecategory.created = state.created;
      // $scope.manageGamecategory.lastupdated = state.lastupdated;
      $scope.manageGamecategory = gamecategory;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveGamecategory = function (manageGamecategory, id){

      console.log("Inside saveGamecategory");
      console.log(manageGamecategory);
      console.log(id);

      if (id===undefined){
        $scope.createGamecategory(manageGamecategory);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageGamecategory
      obj.params.id = id;
      // obj.params.name = $scope.manageGamecategory.name;
      // obj.params.description = $scope.manageGamecategory.description;
      //obj.params.created = $scope.manageGamecategory.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategory = {};
        toastr.success('Gamecategory has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gamecategoryService.saveGamecategory(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory')
    .service('gamecategoryService', gamecategoryService);
 
  /** @ngInject */
  function gamecategoryService(Gamecategory) {
    var getGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Gamecategory.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Gamecategory.create({
        name:obj.params.name,
       // description:obj.params.description,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Gamecategory.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Gamecategory.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getGamecategory: getGamecategory,
      createGamecategory: createGamecategory,
      deleteGamecategory: deleteGamecategory,
      saveGamecategory: saveGamecategory
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games')
    .controller('GamesPageCtrl', GamesPageCtrl);

  /** @ngInject */
  function GamesPageCtrl($scope, $filter, editableOptions, editableThemes,
    gameService, toastr, $uibModal, gamecategoryService) {
    console.log("Inside GamesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteGame(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;
    $scope.status = [{
      value: 'Active'
    }, {
      value: 'Inactive'
    }];

    //Getting States
    $scope.manageGamecategoryList = [];
    $scope.initManageGamecategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategoryList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gamecategoryService.getGamecategory(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };






    $scope.manageGamesList = [];
    $scope.manageArea = {};
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
        $scope.initManageGamecategory();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };
    $scope.initManageGames();

    $scope.addArea = function () {
      //genericModalService.show('modules/modals/addArea.html',$scope);
      $scope.inserted = {
        name: null,
        //description:null,
        gamecatid: null,
        status: null,
      };
      $scope.manageGamesList.push($scope.inserted);
    };

    $scope.createGame = function (manageArea) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createGame");
      console.log(manageArea.name);
      console.log(manageArea.status);

      var obj = {};
      obj.params = {};
      obj.params.name = manageArea.name;
      obj.params.gamecatid = manageArea.gamecategory;
      obj.params.status = manageArea.status.value;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageArea = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageGames();
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gameService.createGame(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/games/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteGame = function (res) {
      console.log("Inside deleteGame");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Game has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Game successfully deleted.");
          $scope.initManageGames();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        gameService.deleteGame(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function (state) {
      console.log("Inside editGame");
      console.log(state);
      // $scope.manageArea.id = $scope.manageArea.id;
      // $scope.manageArea.name = state.name;
      // $scope.manageArea.description = state.description;
      // $scope.manageArea.created = state.created;
      // $scope.manageArea.lastupdated = state.lastupdated;
      $scope.manageArea = state;
      genericModalService.show('modules/modals/addArea.html', $scope);
    }

    $scope.saveGame = function (manageArea, id) {

      console.log("Inside saveGame");
      console.log(manageArea);
      console.log(id);

      if (id === undefined) {
        $scope.createGame(manageArea);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageArea
        obj.params.id = id;
        obj.params.gamecatid = manageArea.gamecategory;
        obj.params.status = manageArea.status.value;
        // obj.params.name = $scope.manageArea.name;
        // obj.params.description = $scope.manageArea.description;
        //obj.params.created = $scope.manageArea.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.statuses = result.status;
          $scope.manageArea = {};
          toastr.success('Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          console.log("sandip");
          console.log(result.status);
          $scope.initManageGames();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }

        gameService.saveGame(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showStatus = function (status) {
      var selected = [];
      if (typeof status === "object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : 'Not set';
      } else {
        return status;
      }

    };

    $scope.showGamecategory = function (gamecategory) {
      //console.log("Inside showGamecategory = "+JSON.stringify(state));
      //console.log(gamecategory);
      //console.log(item.gamecategory.id);
      if (gamecategory && $scope.manageGamecategoryList.length) {
        //console.log(gamecategory.id);
        //console.log(gamecategory.id);
        var selected = $filter('filter')($scope.manageGamecategoryList, {
          id: gamecategory.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games')
    .service('gameService', gameService);

  /** @ngInject */
  function gameService(Games) {

    var getGame = function (obj) {

      Games.find({
        filter: {
          include: "gamecat"
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var getOnlineGame = function (obj) {

      Games.find({
        filter: {
          where: {
            gamecatid: 1
          },
          include: "gamecat"
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var getMachineGame = function (obj) {

      Games.find({
        filter: {
          where: {
            gamecatid: 2
          },
          include: "gamecat"
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createGame = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Games.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        gamecatid: obj.params.gamecatid,
        status: obj.params.status

      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteGame = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Games.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveGame = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Games.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        gamecatid: obj.params.gamecatid,
        status: obj.params.status,
        lastupdated: date

      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGame: getGame,
      createGame: createGame,
      deleteGame: deleteGame,
      saveGame: saveGame,
      getOnlineGame: getOnlineGame,
      getMachineGame: getMachineGame
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine')
    .controller('MachinePageCtrl', MachinePageCtrl);

  /** @ngInject */
  function MachinePageCtrl($scope, $filter, editableOptions, editableThemes,
    machineService, toastr, $uibModal, gameService, machineShopService, zoneService, $state,
    supplierService,shopService) {
    console.log("Inside MachinePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size

      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachine(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });
    };

    $scope.smartTablePageSize = 10;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No"
    };




    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };


    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.manageActiveMachineList = [];
    $scope.initManageActiveMachine = function () {
      var obj = {};
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageActiveMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function(zoneid) {
      var obj = {};
      obj.params={};
      obj.params.zoneid = zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShopByZone(obj);

    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function (manageMachineid) {
      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};
        obj.params.machineid = manageMachineid;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageMachineShop");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshopByMachineId(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };

    $scope.manageMachine = {};
    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineList = result;
        $scope.initManageGames();
        $scope.initManageZones();
        $scope.initManageSupplier();
        $scope.initManageActiveMachine();
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initManageMachine();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageMachineList.push($scope.inserted);
    };

    $scope.createMachine = function (manageMachine) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createMachine");
      console.log(manageMachine);

      var obj = {};
      obj.params = {};
      obj.params.code = manageMachine.code;
      obj.params.gameid = manageMachine.game.id;
      obj.params.zoneid = manageMachine.zone.id;
      obj.params.supplierid = manageMachine.supplier? manageMachine.supplier.id:null;
      obj.params.isjackpot = manageMachine.isjackpot;
      obj.params.calby = manageMachine.calby;
      obj.params.cm_in = manageMachine.cmIn;
      obj.params.cm_out = manageMachine.cmOut;
      obj.params.bm_in = manageMachine.bmIn;
      obj.params.bm_out = manageMachine.bmOut;
      obj.params.cm_rate = manageMachine.cmRate;
      obj.params.bm_rate = manageMachine.bmRate;
      obj.params.status = manageMachine.status;
      obj.params.remarks = manageMachine.remarks;

      //obj.params.description = manageMachine.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachine = {};
        $scope.isEditSupplier = false;
        toastr.success('New Machine has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Machine successfully created.");
        $scope.initManageMachine();

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      machineService.createMachine(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/machine/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachine = function (res) {
      console.log("Inside deleteMachine");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageMachine();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.deleteMachine(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (machine) {
      console.log("Inside editMachine");
      console.log(machine);
      // $scope.manageMachine.id = $scope.manageMachine.id;
      // $scope.manageMachine.name = state.name;
      // $scope.manageMachine.description = state.description;
      // $scope.manageMachine.created = state.created;
      // $scope.manageMachine.lastupdated = state.lastupdated;
      $scope.manageMachine = machine;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveMachine = function (manageMachine) {

      console.log("Inside saveMachine");
      console.log(manageMachine);

      console.log(manageMachine.zones);
      console.log(manageMachine.games);

      if (manageMachine.id === undefined) {
        $scope.createMachine(manageMachine);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageMachine
        obj.params.id = manageMachine.id;
        obj.params.code = manageMachine.code;
        obj.params.gameid = manageMachine.game.id;
        obj.params.zoneid = manageMachine.zone.id;
        obj.params.supplierid = manageMachine.supplier?manageMachine.supplier.id:null;
        obj.params.isjackpot = manageMachine.isjackpot;
        obj.params.calby = manageMachine.calby;
        obj.params.cm_in = manageMachine.cmIn;
        obj.params.cm_out = manageMachine.cmOut;
        obj.params.bm_in = manageMachine.bmIn;
        obj.params.bm_out = manageMachine.bmOut;
        obj.params.cm_rate = manageMachine.cmRate;
        obj.params.bm_rate = manageMachine.bmRate;
        obj.params.status = manageMachine.status;
        obj.params.remarks = manageMachine.remarks;
        // obj.params.name = $scope.manageMachine.name;
        // obj.params.description = $scope.manageMachine.description;
        //obj.params.created = $scope.manageMachine.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachine = {};
          $scope.isEditSupplier = false;
          toastr.success('Machine has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.saveMachine(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    //manageActiveMachineList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveMachineList.length) {
        var selected = $filter('filter')($scope.manageActiveMachineList, {
          machineid: id
        },true);
        return selected.length ? selected[0] : null;
      }else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editMachine = function (manageMachine) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = manageMachine;
      console.log($scope.manageMachine);
      //$scope.manageMachine.shopDetails = $scope.showShopDetails(manageMachine.id)
      $scope.initManageMachineShop(manageMachine.id);
      $scope.initManageShop(manageMachine.zoneid);

    };

    $scope.addMachine = function () {
      console.log("Inside addMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = {};
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;    
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;    
    };

    $scope.saveSupplierDetails = function (manageSupplier) {
      console.log("Inside saveSupplierDetails");
      console.log($scope.manageSupplier);
        var obj = {};
        obj.params = {};
        obj.params = manageSupplier
        //obj.params.created = $scope.manageSupplier.created;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          $scope.initManageSupplier();          
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          $scope.isEditSupplier = false;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.createSupplier(obj);
    }

    $scope.qrString = "";
    $scope.viewQRcode = function (code){
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/system/machine/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function(){
      window.print();
    };

    $scope.addMachineShop = function() {
      $scope.inserted = {
        shopid: null,
        machineid: $scope.manageMachine.id,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function(supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showShop = function(shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shop.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop',manageMachineshop);

      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.saveMachineshop = function(manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code==="23505"){
            toastr.error('This Machine is already assigned.', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.openDeleteMachineshop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function(id) {
      $scope.openDeleteMachineshop('app/pages/system/machine/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function(res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        obj.params.status = false;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine')
    .service('machineService', machineService);

  /** @ngInject */
  function machineService(Machine) {
    var getMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAllMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachineByZone = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          where: {
            zoneid: obj.params.zoneid
          },
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.create({
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.prototype$updateAttributes({
        id: obj.params.id,
        //description: obj.params.description,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks,

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getMachine: getMachine,
      getAllMachine: getAllMachine,
      createMachine: createMachine,
      deleteMachine: deleteMachine,
      saveMachine: saveMachine,
      getMachineByZone: getMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .controller('ShopPageCtrl', ShopPageCtrl);

  /** @ngInject */
  function ShopPageCtrl($scope, $filter, editableOptions, editableThemes,
    shopService, toastr, $uibModal, partnerService, zoneService, $state,
    gameService, onlineShopService, machineShopService, machineService,
    suppliersalesreportService, supplierService, areaService,siteService) {
    console.log("Inside ShopPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteShop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.openDeleteOnlineShop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlineShop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.openDeleteMachineshop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;
    $scope.isEdit = false;


    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function() {
      if ($scope.manageShop.id){
      var obj = {};
      obj.params = {};
      obj.params.shopid = $scope.manageShop.id;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlineShopService.getOnlineshop(obj);
    }else{
      $scope.manageOnlineShopList = [];
    }
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageAreaList = [];
    $scope.initManageAreas = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSites = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshop(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };
    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };
    $scope.manageMachineList = [];
    $scope.initManageMachine = function() {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid)// ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result.result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //machineService.getMachineByZone(obj);
      suppliersalesreportService.getAvailableMachineByZone(obj);
    };

    $scope.manageMachineListZone = [];
    $scope.initManageMachineZone = function() {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid)// ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineListZone = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachineByZone(obj);
    };

    $scope.manageShop = {};
    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
        $scope.initManagePartner();
        $scope.initManageZones();
        $scope.initManageAreas();
        $scope.initManageGames();
        $scope.initManageSupplier();
        $scope.initManageSites();
        //$scope.initManageOnlineShop();
        $scope.isEdit = false;
        for (var i = 0; i < result.length; i++) {
          if ($scope.manageShopList[i].contact1) {
            $scope.manageShopList[i].contact1 = JSON.parse($scope.manageShopList[i].contact1);
          }
          if ($scope.manageShopList[i].contact2) {
            $scope.manageShopList[i].contact2 = JSON.parse($scope.manageShopList[i].contact2);
          }
          if ($scope.manageShopList[i].contact3) {
            $scope.manageShopList[i].contact3 = JSON.parse($scope.manageShopList[i].contact3);
          }

        }
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);

    };
    $scope.initManageShop();



    $scope.createShop = function(manageShop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createShop");
      console.log(manageShop);

      var obj = {};
      obj.params = {};
      obj.params.code = manageShop.code;
      obj.params.name = manageShop.name;
      obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;

      obj.params.zoneid = manageShop.zone?manageShop.zone.id:null;
      obj.params.areaid = manageShop.area?manageShop.area.id:null;
      obj.params.siteid = manageShop.site?manageShop.site.id:null;
      obj.params.onrate = manageShop.onrate;
      obj.params.macrate = manageShop.macrate;
      obj.params.onvirtual = manageShop.onvirtual;
      obj.params.ontips = manageShop.ontips;
      obj.params.creditlimit = manageShop.creditlimit;
      obj.params.shoptype = manageShop.shoptype;
      obj.params.address = manageShop.address;
      obj.params.status = manageShop.status;
      obj.params.contact1 = JSON.stringify(manageShop.contact1);
      obj.params.contact2 = JSON.stringify(manageShop.contact2);
      obj.params.contact3 = JSON.stringify(manageShop.contact3);
      obj.params.remarks = manageShop.remarks;
      obj.params.onrebate = manageShop.onrebate;
      obj.params.macrebate = manageShop.macrebate;
      obj.params.mactips = manageShop.mactips;
      obj.params.macvirtual = manageShop.macvirtual;

      //obj.params.description = manageShop.description;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShop = {};
        toastr.success('New Shop has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Shop successfully created.");
        $scope.initManageShop();

      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };
      shopService.createShop(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/shop/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteShop = function(res) {
      console.log("Inside deleteShop");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Shop has been deleted successfully!', 'SUCCESS');

          $scope.initManageShop();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        shopService.deleteShop(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(shop) {
      console.log("Inside editShop");
      console.log(shop);
      // $scope.manageShop.id = $scope.manageShop.id;
      // $scope.manageShop.name = state.name;
      // $scope.manageShop.description = state.description;
      // $scope.manageShop.created = state.created;
      // $scope.manageShop.lastupdated = state.lastupdated;
      $scope.manageShop = shop;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveShop = function(manageShop) {

      console.log("Inside saveShop");
      console.log(manageShop);

      console.log(manageShop.zone);
      console.log(manageShop.partner);

      if (manageShop.id === undefined) {
        $scope.createShop(manageShop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = manageShop.id;
        obj.params.code = manageShop.code;
        obj.params.name = manageShop.name;
        obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;
        obj.params.zoneid = manageShop.zone?manageShop.zone.id:null;
        obj.params.areaid = manageShop.area?manageShop.area.id:null;
        obj.params.siteid = manageShop.site?manageShop.site.id:null;
        obj.params.onrate = manageShop.onrate;
        obj.params.macrate = manageShop.macrate;
        obj.params.onvirtual = manageShop.onvirtual;
        obj.params.ontips = manageShop.ontips;
        obj.params.creditlimit = manageShop.creditlimit;
        obj.params.shoptype = manageShop.shoptype;
        obj.params.address = manageShop.address;
        obj.params.status = manageShop.status;
        obj.params.contact1 = JSON.stringify(manageShop.contact1);
        obj.params.contact2 = JSON.stringify(manageShop.contact2);
        obj.params.contact3 = JSON.stringify(manageShop.contact3);

        obj.params.remarks = manageShop.remarks;
        obj.params.onrebate = manageShop.onrebate;
        obj.params.macrebate = manageShop.macrebate;
        obj.params.mactips = manageShop.mactips;
        obj.params.macvirtual = manageShop.macvirtual;

        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageShop = {};
          toastr.success('Shop has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageShop();

        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        shopService.saveShop(obj);
      }

    };

    $scope.showPartner = function(partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    editableOptions.theme = 'bs3';
    editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editShop = function(manageShop) {
      console.log("Inside editShop");
      $scope.isEdit = true;
      $scope.manageShop = manageShop;
      $scope.initManageMachine();
      $scope.initManageMachineZone();
      $scope.initManageOnlineShop();
      $scope.initManageMachineShop();
      console.log($scope.manageShop);
    };

    $scope.addShop = function() {
      console.log("Inside addShop");
      $scope.isEdit = true;
      $scope.manageShop = {};
      $scope.manageOnlineShopList = [];
      $scope.manageMachineshopList = [];
      console.log($scope.manageZonesList);
    };

    $scope.showGames = function(game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    //Online Games

    $scope.addOnlineShop = function() {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        gameid: null,
        playtechid: null
      };
      $scope.manageOnlineShopList.push($scope.inserted);
    };

    $scope.saveOnlineShop = function(manageOnlineShop, id) {

      console.log("Inside saveOnlineShop");
      console.log(manageOnlineShop);
      console.log(id);

      if (id === undefined) {
        $scope.createOnlineShop(manageOnlineShop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Online Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageOnlineShop();

        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.saveOnlineshop(obj);
      }

    };

    $scope.createOnlineShop = function (manageOnlineShop) {

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been saved successfully!', 'SUCCESS');
          $scope.initManageOnlineShop();

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.createOnlineshop(obj);
      } else {
        $scope.initManageOnlineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Online Games.', 'Error');
      }
    };

    $scope.deleteOnlineShopId = null;
    $scope.confirmOnlineShopDelete = function(id) {
      $scope.openDeleteOnlineShop('app/pages/system/shop/modals/dangerOnlineGameModal.html');
      $scope.deleteOnlineShopId = id;
    };

    $scope.deleteOnlineShop = function(res) {
      console.log("Inside deleteOnlineShop");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteOnlineShopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteOnlineShopId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been deleted successfully!', 'SUCCESS');

          $scope.initManageOnlineShop();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.deleteOnlineshop(obj);
      }
    };

    //Machine Shop
    $scope.showMachine = function(machine) {
      if (machine && $scope.manageMachineListZone.length) {
        var selected = $filter('filter')($scope.manageMachineListZone, {
          id: machine.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.addMachineShop = function() {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        machineid: null,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.saveMachineshop = function(manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        //obj.params.supplierid = manageOnlineShop.supplier;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machineid;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();
          $scope.initManageMachineShop();

        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code==="23505"){
            toastr.error('This Machine is already assigned.', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop',manageMachineshop);

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop();
          $scope.initManageMachine();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function(id) {
      $scope.openDeleteMachineshop('app/pages/system/shop/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function(res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        //console.log($scope.deleteMachineshopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        // obj.params.shopid = $scope.manageShop.id;
        // obj.params.machineid = manageMachineshop.machineid;
        // obj.params.macrate = manageMachineshop.macrate;
        // obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = false;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.showSupplierCode = function(supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showSupplierComm = function(machine) {
      if (machine && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: machine.supplierid
        },true);
        return selected.length ? selected[0].rate : 'Not set';
      } else return 'Not set';
    };
  }

})();

/**
 * @author udit.jain
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('machineShopService', machineShopService);

  /** @ngInject */
  function machineShopService(Machineshop) {
    var getMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {shopid: obj.params.shopid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getMachineshopByMachineId = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {machineid: obj.params.machineid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            status: obj.params.status
          },
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshopWithoutStatus = function(obj) {
      
      Machineshop.find({
        filter: {
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var createMachineshop = function(obj) {
      var date = new Date();

      Machineshop.create({
        created: date,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    // var deleteMachineshop = function(obj) {

    //   Machineshop.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     obj.onSuccess(data);
    //   }, function(err) {
    //     obj.onFailure(err);
    //   });
    // };

    var deleteMachineshop = function(obj) {
      var date = new Date();
      Machineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        status: obj.params.status
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var saveMachineshop = function(obj) {

      var date = new Date();

      Machineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
        
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getMachineshop: getMachineshop,
      getAllMachineshop:getAllMachineshop,
      getAllMachineshopWithoutStatus: getAllMachineshopWithoutStatus,
      createMachineshop: createMachineshop,
      deleteMachineshop: deleteMachineshop,
      saveMachineshop: saveMachineshop,
      getMachineshopByMachineId: getMachineshopByMachineId
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('onlineShopService', onlineShopService);

  /** @ngInject */
  function onlineShopService(Onlineshop) {
    var getOnlineshop = function(obj) {

      Onlineshop.find({
        filter: {
          where:{
            shopid:obj.params.shopid
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllOnlineshop = function(obj) {
      
            Onlineshop.find({
              filter: {
                include: ["game", "shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });
          };
    var createOnlineshop = function(obj) {
      var date = new Date();

      Onlineshop.create({
        created: date,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var deleteOnlineshop = function(obj) {

      Onlineshop.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveOnlineshop = function(obj) {

      var date = new Date();

      Onlineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getOnlineshop: getOnlineshop,
      createOnlineshop: createOnlineshop,
      deleteOnlineshop: deleteOnlineshop,
      saveOnlineshop: saveOnlineshop,
      getAllOnlineshop:getAllOnlineshop
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('shopService', shopService);

  /** @ngInject */
  function shopService(Shop) {
    var getShop = function (obj) {
      Shop.find({
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopById = function (obj) {
      Shop.findById({
        id: obj.params.shopid,
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopByZone = function (obj) {
      Shop.find({
        filter: {
          where:{
            and:[
              {zoneid: obj.params.zoneid},
              {status: true}
            ]
          },
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createShop = function (obj) {
      var date = new Date();

      Shop.create({
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteShop = function (obj) {

      Shop.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveShop = function (obj) {
      var date = new Date();

      Shop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findAssignedShop = function (obj) {
      Shop.find({
        filter: {
          where:{
            id: {
              inq: obj.params.shopmap
            }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findNotAssignedShop = function (obj) {
      if (obj.params.shopmap){
        Shop.find({
          filter: {
            where:{
              and:[
                {id: { nin: obj.params.shopmap}},
                {shoptype: obj.params.shoptype},
                {zoneid: {inq: obj.params.zonemap}}
              ]
            }
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }else{
        Shop.find({
          filter: {
            where:{
              and:[
                {shoptype: obj.params.shoptype},
                {zoneid: {inq: obj.params.zonemap}}
              ]
            }
          }
        }
        ).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }

    };

    
    var findNotAssignedShopForAdmin = function (obj) {

      Shop.find({
        filter: {
          where: {
            id: { nin: obj.params.shopmap }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getShop: getShop,
      createShop: createShop,
      deleteShop: deleteShop,
      saveShop: saveShop,
      findAssignedShop: findAssignedShop,
      findNotAssignedShop: findNotAssignedShop,
      getShopById:getShopById,
      getShopByZone:getShopByZone,
      findNotAssignedShopForAdmin:findNotAssignedShopForAdmin
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.site')
    .controller('SitePageCtrl', SitePageCtrl);

  /** @ngInject */
  function SitePageCtrl($scope, $filter, editableOptions, editableThemes,
    siteService, toastr, $uibModal, stateService, areaService) {
    console.log("Inside SitePageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteSite(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    //Getting States
    $scope.manageStatesList = [];
    $scope.manageAreaList = [];

    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };

    $scope.initManageArea = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };




    $scope.manageSiteList = [];
    $scope.manageSite = {};
    $scope.initManageSite = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
        $scope.initManageStates();
        $scope.initManageArea();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    $scope.initManageSite();

    $scope.addSite = function() {
      //genericModalService.show('modules/modals/addSite.html',$scope);
      $scope.inserted = {
        name: null,
      };
      $scope.manageSiteList.push($scope.inserted);
    };

    $scope.createSite = function(manageSite) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createSite");
      console.log(manageSite);

      var obj = {};
      obj.params = {};
      obj.params = manageSite;
      // obj.params.name = manageSite.name;
      // obj.params.areaid = manageSite.area
      // obj.params.stateid = manageSite.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSite = {};
        toastr.success('New Site has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageSite();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      siteService.createSite(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/site/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteSite = function(res) {
      console.log("Inside deleteSite");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Site has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Site successfully deleted.");
          $scope.initManageSite();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        siteService.deleteSite(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editSite = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageSite.id = $scope.manageSite.id;
      // $scope.manageSite.name = state.name;
      // $scope.manageSite.description = state.description;
      // $scope.manageSite.created = state.created;
      // $scope.manageSite.lastupdated = state.lastupdated;
      $scope.manageSite = state;
      genericModalService.show('modules/modals/addSite.html', $scope);
    }

    $scope.saveSite = function(manageSite, id) {

      console.log("Inside saveSite");
      console.log(manageSite);
      console.log(id);

      console.log(manageSite.area);
      console.log(manageSite.state);


      if (id === undefined) {
        $scope.createSite(manageSite);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSite;
        obj.params.id = id;
        // obj.params.name = $scope.manageSite.name;
        // obj.params.description = $scope.manageSite.description;
        //obj.params.created = $scope.manageSite.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSite = {};
          toastr.success('Site has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageSite();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        siteService.saveSite(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showArea = function(area) {
      //console.log("Inside showState = "+JSON.stringify(area));
      if (area && $scope.manageAreaList.length) {
        var selected = $filter('filter')($scope.manageAreaList, {
          id: area.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.site')
    .service('siteService', siteService);

  /** @ngInject */
  function siteService(Site) {
    var getSite = function(obj) {

      Site.find({
        filter: {
          include: ["state", "area"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createSite = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Site.create({
        name: obj.params.name,
        stateid: obj.params.state,
        areaid: obj.params.area,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteSite = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Site.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveSite = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Site.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        stateid: obj.params.state,
        areaid: obj.params.area,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getSite: getSite,
      createSite: createSite,
      deleteSite: deleteSite,
      saveSite: saveSite
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states')
      .controller('StatesPageCtrl', StatesPageCtrl);

  /** @ngInject */
  function StatesPageCtrl($scope, $filter, editableOptions, editableThemes,
    stateService,toastr,$uibModal ) {
    console.log("Inside StatesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteState(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageState={};
    $scope.manageStatesList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageStatesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        stateService.getStates(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageStatesList.push($scope.inserted);
    };

    $scope.createState = function(manageState) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createState");
      console.log(manageState.name);
      console.log(manageState.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageState.name;
      obj.params.description = manageState.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageState = {};
        toastr.success('New State has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New State successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      stateService.createState(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/states/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteState = function (res){
      console.log("Inside deleteState");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('State has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            stateService.deleteState(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (state){
      console.log("Inside editState");
      console.log(state);
      // $scope.manageState.id = $scope.manageState.id;
      // $scope.manageState.name = state.name;
      // $scope.manageState.description = state.description;
      // $scope.manageState.created = state.created;
      // $scope.manageState.lastupdated = state.lastupdated;
      $scope.manageState = state;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveState = function (manageState, id){

      console.log("Inside saveState");
      console.log(manageState);
      console.log(id);

      if (id===undefined){
        $scope.createState(manageState);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageState
      obj.params.id = id;
      // obj.params.name = $scope.manageState.name;
      // obj.params.description = $scope.manageState.description;
      //obj.params.created = $scope.manageState.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageState = {};
        toastr.success('State has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      stateService.saveState(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states')
    .service('stateService', stateService);

  /** @ngInject */
  function stateService(State) {
    var getStates = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      State.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      State.create({
        name:obj.params.name,
        description:obj.params.description,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      State.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      State.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getStates: getStates,
      createState: createState,
      deleteState: deleteState,
      saveState: saveState
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones')
      .controller('ZonesPageCtrl', ZonesPageCtrl);
 
  /** @ngInject */
  function ZonesPageCtrl($scope, $filter, editableOptions, editableThemes,
    zoneService,toastr,$uibModal ) {
    console.log("Inside ZonesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteZones(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;
    $scope.status = [{value:'Active'},{value:'Inactive'}];

    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageZonesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
		status:null,
        //description:null,
      };
      $scope.manageZonesList.push($scope.inserted);
    };

    $scope.createZones = function(manageZones) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createZones");
	  console.log(manageZones);
      console.log(manageZones.name);
	  console.log(manageZones.code);
	  console.log(manageZones.status);
      //console.log(manageZones.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageZones.name;
	  obj.params.code = manageZones.code;
	  obj.params.status = manageZones.status.value;
      //obj.params.description = manageZones.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZones = {};
        toastr.success('New Zones has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Zones successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      zoneService.createZones(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/zones/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteZones = function (res){
      console.log("Inside deleteZones");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Zones has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            zoneService.deleteZones(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (zones){
      console.log("Inside editZones");
      console.log(zones);
      // $scope.manageZones.id = $scope.manageZones.id;
      // $scope.manageZones.name = state.name;
      // $scope.manageZones.description = state.description;
      // $scope.manageZones.created = state.created;
      // $scope.manageZones.lastupdated = state.lastupdated;
      $scope.manageZones = zones;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveZones = function (manageZones, id){

      console.log("Inside saveZones");
      console.log(manageZones);
      console.log(id);

      if (id===undefined){
        $scope.createZones(manageZones);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageZones
      obj.params.id = id;
	  obj.params.status = manageZones.status.value;
      // obj.params.name = $scope.manageZones.name;
      // obj.params.description = $scope.manageZones.description;
      //obj.params.created = $scope.manageZones.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZones = {};
        toastr.success('Zones has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
		console.log(result.status);
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      zoneService.saveZones(obj);

      //$scope.modal.hide();
    }

    }

	$scope.showStatus = function(status) {
      var selected = [];
      if(typeof status==="object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : 'Not set';
      }else{
          return status;
      }

    };
	
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones')
    .service('zoneService', zoneService); 

  /** @ngInject */
  function zoneService(Zones) {
    var getZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Zones.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Zones.create({
        name:obj.params.name,
       // description:obj.params.description,
        created: date,
        lastupdated: date,
		code: obj.params.code,
		status: obj.params.status
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Zones.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Zones.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        //description: obj.params.description,
        lastupdated: date,
		status: obj.params.status,
		code: obj.params.code
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getZones: getZones,
      createZones: createZones,
      deleteZones: deleteZones,
      saveZones: saveZones
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.collector')
    .controller('CollectorreportPageCtrl', CollectorreportPageCtrl);

  /** @ngInject */
  function CollectorreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    collectorreportService, zoneService, gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal,
    $rootScope) {
    console.log("Inside CollectorreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
           for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
             var zonelist = $filter('filter')(result, {
               id: $rootScope.userData.credentials.zonemap[index]
             }, true);
             console.log('zonelist',zonelist);
 
             $scope.manageZonesList.push(zonelist[0]);
           }
         }else{
           $scope.manageZonesList = result;
         }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.reportFilter={};
    $scope.searchSales = function (reportFilter) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        // console.log('dateList.zone',dateList.zone);
        // console.log('dateList.shoptype',dateList.shoptype);
        
        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone){
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        } else{
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value="";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0){
                value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
              }else{
                value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
              }
            }
            value = value+")";
            obj.params.zoneid=value;
          }else{
            obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
          }
        }
        
        if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
          obj.params.shoptype=$rootScope.userData.credentials.shopType;
        }else{
          obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
        }


        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          if (result.result){
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              var onmacTotal = parseFloat($scope.managePartnersalesList[i].ontotal)+ parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };

    $scope.initManageCollector = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
//     $scope.initManageStates = function() {
//       var obj = {};
//       obj.params = {};
//       obj.params.fromDt = $scope.dateList.from;
//       obj.params.toDt = $scope.dateList.to;

//       obj.onSuccess = function(result) {
//         console.log("Inside SUCCESS");
//         console.log(result);
//         $scope.initManagePartner();
//         $scope.initManageGames();
// //        $scope.initManageMachineShop();
//         //$scope.initManagePrevMachineReading();
//         $scope.managePartnersalesList = result;
//         $scope.isEdit = false;
//       };
//       obj.onFailure = function(err) {
//         console.log("Inside Failure");
//         console.log(err);
//       };
//       collectorreportService.getBetweenDatesMachinesales(obj);
//       //$scope.$broadcast('scroll.refreshComplete');
//     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/totalsales/partnersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     collectorreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(managePartnersales, id) {

      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      // if (managePartnersales.id === undefined) {
      //   $scope.createMachinesales(managePartnersales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = managePartnersales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.managePartnersales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   collectorreportService.saveMachinesales(obj);

      //   //$scope.modal.hide();
      // }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      console.log($scope.managePartnersales.sname);
      $scope.getSalesOfShop(managePartnersales.partnerid,managePartnersales.shopid );
    //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getSalesOfShop = function(partnerid,sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      };
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      };
      collectorreportService.getGrpSalesForShopInRange(obj);
    };

    $scope.getTotalmactotal = function (items) {
      if (items){
        return items
        .map(function (x) { return x.mactotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalontotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.ontotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotaltotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.total; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.collector')
    .service('collectorreportService', collectorreportService);

  /** @ngInject */
  function collectorreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.marketing')
    .controller('MarketingreportPageCtrl', MarketingreportPageCtrl);

  /** @ngInject */
  function MarketingreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    marketingreportService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal, zoneService, $rootScope) {
    console.log("Inside MarketingreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
           for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
             var zonelist = $filter('filter')(result, {
               id: $rootScope.userData.credentials.zonemap[index]
             }, true);
             console.log('zonelist',zonelist);
 
             $scope.manageZonesList.push(zonelist[0]);
           }
         }else{
           $scope.manageZonesList = result;
         }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.manageMarketingsales = {};
    $scope.manageMarketingsalesList = [];
    $scope.reportFilter={};
    $scope.searchSales = function (reportFilter) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone){
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        } else{
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value="";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0){
                value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
              }else{
                value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
              }
            }
            value = value+")";
            obj.params.zoneid=value;
          }else{
            obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
          }
        }
        
        if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
          obj.params.shoptype=$rootScope.userData.credentials.shopType;
        }else{
          obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          if (result.result){
            $scope.totalSalesLabel = 0;

            $scope.manageMarketingsalesList = result.result;
            for (var i = 0; i < result.result.length; i++) {
              var onmacTotal = parseFloat($scope.manageMarketingsalesList[i].ontotal)+ parseFloat($scope.manageMarketingsalesList[i].mactotal);
              $scope.manageMarketingsalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        marketingreportService.getGrpSalesInRange(obj)
      }
    };

    $scope.initManageMarketing = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
//     $scope.initManageStates = function() {
//       var obj = {};
//       obj.params = {};
//       obj.params.fromDt = $scope.dateList.from;
//       obj.params.toDt = $scope.dateList.to;

//       obj.onSuccess = function(result) {
//         console.log("Inside SUCCESS");
//         console.log(result);
//         $scope.initManagePartner();
//         $scope.initManageGames();
// //        $scope.initManageMachineShop();
//         //$scope.initManagePrevMachineReading();
//         $scope.manageMarketingsalesList = result;
//         $scope.isEdit = false;
//       };
//       obj.onFailure = function(err) {
//         console.log("Inside Failure");
//         console.log(err);
//       };
//       marketingreportService.getBetweenDatesMachinesales(obj);
//       //$scope.$broadcast('scroll.refreshComplete');
//     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/totalsales/marketing/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     marketingreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewSales");
      console.log(onlinesales);

      $scope.manageMarketingsales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveSales = function(manageMarketingsales, id) {

      console.log("Inside saveSales");
      console.log(manageMarketingsales);
      console.log(manageMarketingsales.id);

      // if (manageMarketingsales.id === undefined) {
      //   $scope.createMachinesales(manageMarketingsales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = manageMarketingsales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.manageMarketingsales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   marketingreportService.saveSales(obj);

      //   //$scope.modal.hide();
      // }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewSales = function (manageMarketingsales) {
      console.log("Inside viewSales");
      $scope.isEdit = true;
      $scope.manageMarketingsales = manageMarketingsales;
      console.log($scope.manageMarketingsales.partnerid);
      console.log($scope.manageMarketingsales.sname);
      $scope.getSalesOfShop(manageMarketingsales.partnerid,manageMarketingsales.shopid );
    //  $scope.getMachineSalesPrevReadings(manageMarketingsales.mid);
    };

    $scope.getSalesOfShop = function(partnerid,sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;

      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      };
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      };
      marketingreportService.getGrpSalesForShopInRange(obj);
    };

    $scope.getTotalmactotal = function (items) {
      if (items){
        return items
        .map(function (x) { return x.mactotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalontotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.ontotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotaltotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.total; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.marketing')
    .service('marketingreportService', marketingreportService);

  /** @ngInject */
  function marketingreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 300);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.roles')
      .controller('RolesPageCtrl', RolesPageCtrl);

  /** @ngInject */
  function RolesPageCtrl($scope, $filter, editableOptions, editableThemes,
    roleService,toastr,$uibModal ) {
    console.log("Inside RolesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteRole(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageRole={};
    $scope.manageRolesList=[];
    $scope.initManageRoles = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageRolesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        roleService.getRoles(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageRoles();

    $scope.addRole = function (){
      //genericModalService.show('modules/modals/addRole.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageRolesList.push($scope.inserted);
    };

    $scope.createRole = function(manageRole) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createRole");
      console.log(manageRole.name);
      console.log(manageRole.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageRole.name;
      obj.params.description = manageRole.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRole = {};
        toastr.success('New Role has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Role successfully created.");
          $scope.initManageRoles();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      roleService.createRole(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/usersetup/roles/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteRole = function (res){
      console.log("Inside deleteRole");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Role has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Role successfully deleted.");
              $scope.initManageRoles();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            roleService.deleteRole(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editRole = function (role){
      console.log("Inside editRole");
      console.log(role);
      // $scope.manageRole.id = $scope.manageRole.id;
      // $scope.manageRole.name = role.name;
      // $scope.manageRole.description = role.description;
      // $scope.manageRole.created = role.created;
      // $scope.manageRole.lastupdated = role.lastupdated;
      $scope.manageRole = role;
      genericModalService.show('modules/modals/addRole.html',$scope);
    }

    $scope.saveRole = function (manageRole, id){

      console.log("Inside saveRole");
      console.log(manageRole);
      console.log(id);

      if (id===undefined){
        $scope.createRole(manageRole);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageRole
      obj.params.id = id;
      // obj.params.name = $scope.manageRole.name;
      // obj.params.description = $scope.manageRole.description;
      //obj.params.created = $scope.manageRole.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRole = {};
        toastr.success('Role has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Role successfully Updated.");
        $scope.initManageRoles();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      roleService.saveRole(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.roles')
    .service('roleService', roleService);

  /** @ngInject */
  function roleService(Role) {
    var getRoles = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Role.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Role.create({
        name:obj.params.name,
        description:obj.params.description,
        created: date,
        modified: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Role.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Role.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        modified: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getRoles: getRoles,
      createRole: createRole,
      deleteRole: deleteRole,
      saveRole: saveRole
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.users')
    .controller('UsersPageCtrl', UsersPageCtrl);

  /** @ngInject */
  function UsersPageCtrl($scope, $filter, editableOptions, editableThemes,
    userService, toastr, $uibModal, zoneService, roleService, $rootScope, rolemappingService, partnerService, collectorService, shopService, supplierService) {
    console.log("Inside UsersPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUser(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;
    $scope.status = [{value:'Active'},{value:'Inactive'}];
    $scope.emailVerified = [{value:true,text:'Yes'},{value:false,text:'No'}];
    $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'},{value:''}];

    //Getting Zones
    $scope.manageZonesList = [];
    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    //Getting Roles
    $scope.manageRoleList=[];
    $scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
    //Getting Partners
    $scope.managePartnerList=[];
    $scope.initManagePartner = function (){
        var obj ={};
        obj.params={};
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=null;
        }
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnerList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        partnerService.getPartner(obj);
    };
    //Getting Users   
    $scope.manageUsersList = [];
    $scope.manageUser = {};
    $scope.initManageUsers = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsersList = result;
        $scope.initManageZones();
        $scope.initManageRole();
        $scope.initManagePartner();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsers(obj);
    };
    $scope.initManageUsers();

    $scope.addUser = function() {
      //genericModalService.show('modules/modals/addUser.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageUsersList.push($scope.inserted);
    };

    $scope.createUser = function(manageUser) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUser");
      console.log(manageUser);

      var obj = {};
      obj.params = {};
      obj.params = manageUser;
      // obj.params.name = manageUser.name;
      // obj.params.description = manageUser.description;
      // obj.params.zoneid = manageUser.zones
      // obj.params.stateid = manageUser.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('New User has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New User successfully created.");
        $scope.initManageUsers();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      userService.createUser(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.partnerRecordid = null;
    $scope.collectorRecordid = null;
    $scope.shopRecordid = null;
    $scope.supplierRecordid = null;
    $scope.confirmDelete = function(id,partnerRecordid,collectorRecordid,shopRecordid,supplierRecordid) {
      $scope.open('app/pages/usersetup/users/modals/dangerModal.html');
      console.log('partnerRecordid',partnerRecordid);
      console.log('collectorRecordid',collectorRecordid);
      console.log('shopRecordid',shopRecordid);
      console.log('supplierRecordid',supplierRecordid);
      
      $scope.deleteId = id;
      if (typeof partnerRecordid!=="undefined"){
        $scope.partnerRecordid = partnerRecordid;
      }
      if (typeof collectorRecordid!=="undefined"){
        $scope.collectorRecordid = collectorRecordid;
      }
      if (typeof shopRecordid!=="undefined"){
        $scope.shopRecordid = shopRecordid;
      }
      if (typeof supplierRecordid!=="undefined"){
        $scope.supplierRecordid = supplierRecordid;
      }
    };

    $scope.deleteUser = function(res) {
      console.log("Inside deleteUser");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        if ( $scope.partnerRecordid !== null ) {
          var objParnter = {};
          objParnter.params = {};
          objParnter.params.id = $scope.partnerRecordid;

          objParnter.onSuccess = function (result) {
            console.log("Inside SUCCESS");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Partner");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Partner");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objParnter.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          partnerService.unbindPartner(objParnter);

        } else if ($scope.collectorRecordid !== null) {

          var objCollector = {};
          objCollector.params = {};
          objCollector.params.id = $scope.collectorRecordid;

          objCollector.onSuccess = function (result) {
            console.log("Inside SUCCESS Collector");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Collector");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Collector");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objCollector.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          collectorService.unbindCollector(objCollector);

        } else if ($scope.shopRecordid !== null) {

          var objShop = {};
          objShop.params = {};
          objShop.params.id = $scope.shopRecordid;

          objShop.onSuccess = function (result) {
            console.log("Inside SUCCESS Collector");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Shop");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Shop");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objShop.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          shopService.unbindShopStaff(objShop);

        } else if ($scope.supplierRecordid !== null) {

          var objSupplier = {};
          objSupplier.params = {};
          objSupplier.params.id = $scope.supplierRecordid;

          objSupplier.onSuccess = function (result) {
            console.log("Inside SUCCESS Supplier");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Supplier");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Supplier");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objSupplier.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          supplierService.unbindSupplier(objSupplier);

        } else if (($scope.collectorRecordid === null) && ($scope.partnerRecordid === null) && ($scope.shopRecordid === null) && ($scope.supplierRecordid === null)) {
          var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function(result) {
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
            };
            userService.deleteUser(obj);
        }


      } else {
        console.log('Not sure!');
      }

    }

    $scope.editUser = function(state) {
      console.log("Inside editUser");
      console.log(state);
      // $scope.manageUser.id = $scope.manageUser.id;
      // $scope.manageUser.name = state.name;
      // $scope.manageUser.description = state.description;
      // $scope.manageUser.created = state.created;
      // $scope.manageUser.lastupdated = state.lastupdated;
      $scope.manageUser = state;
      genericModalService.show('modules/modals/addUser.html', $scope);
    }

    $scope.saveUser = function(manageUser, userid,item) {

      console.log("Inside saveUser");
      console.log(manageUser);
      console.log(userid);

      if (userid === undefined) {
        $scope.createUser(manageUser);
      } else {

        var objRoleMap = {};
        objRoleMap.params = {};
        objRoleMap.params.principalid = userid;
        objRoleMap.params.roleid = manageUser.role;

  
        objRoleMap.onSuccess = function(result) {
          console.log("Inside SUCCESS objRoleMap");
          console.log(result);
         
            var objUpdateRole = {};
            objUpdateRole.params = {};
            if (result[0]){
            objUpdateRole.params.id = result[0].id;
            }
            objUpdateRole.params.userid = userid;
            objUpdateRole.params.roleid = manageUser.role;
            objUpdateRole.onSuccess = function(result) {
              console.log("Inside SUCCESS objUpdateRole");
              console.log(result);

              var obj = {};
              obj.params = {};
              obj.params.id = userid;
              obj.params.credentials ={};
              obj.params.credentials.name = manageUser.name;
              obj.params.credentials.mobile = manageUser.mobile;
              obj.params.credentials.days = manageUser.days;
              obj.params.credentials.zonemap = manageUser.zonemap;
              obj.params.credentials.role = manageUser.role;
              obj.params.credentials.partner = manageUser.partner;
              if (manageUser.shopType!=''){
                obj.params.credentials.shopType = manageUser.shopType;
              }
              if (typeof item.credentials.shop !== "undefined") {
                obj.params.credentials.shop = item.credentials.shop;
              }
              if (typeof item.credentials.supplier !== "undefined") {
                obj.params.credentials.supplier = item.credentials.supplier;
              }
              obj.params.emailVerified = manageUser.emailVerified;

              console.log(obj.params);
      
              obj.onSuccess = function(result) {
                console.log("Inside SUCCESS");
                console.log(result);
                $scope.manageUser = {};
                toastr.success('User has been updated successfully!', 'SUCCESS');
                $scope.initManageUsers();
      
              }
              obj.onFailure = function(err) {
                console.log("Inside Failure");
                console.log(err);
                if (err.status === -1) {
                  toastr.error('NO INTERNET CONNECTION', 'Error');
                } else {
                  toastr.error(err.data.error.message, 'Error');
                }
              }
              userService.saveUser(obj);
            }
            objUpdateRole.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                toastr.error('NO INTERNET CONNECTION', 'Error');
              } else {
                toastr.error(err.data.error.message, 'Error');
              }
            };
            rolemappingService.saveRoleMapping(objUpdateRole);
        };
        objRoleMap.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(err.data.error.message, 'Error');
          }
        };
        rolemappingService.getRoleMappingsbyID(objRoleMap);
      }
    }

    $scope.showStatus = function(status) {
        var selected = [];
        if(typeof status==="object") {
          //selected = $filter('filter')($scope.status, {value: status.value});
          return status.value ? status.value : 'Not set';
        }else{
            return status;
        }
      };

      $scope.showAccess = function(emailVerified) {
          var selected = [];
          if(typeof emailVerified==="object") {
            //selected = $filter('filter')($scope.status, {value: status.value});
            return emailVerified.value? emailVerified.value : 'No';
          }else{
              return emailVerified?'Yes' : 'No';
          }
        };

        $scope.showRoles = function(role) {
          if (role && $scope.manageRoleList.length) {
            var selected = $filter('filter')($scope.manageRoleList, {
              id: role
            },true);
            return selected.length ? selected[0].name : 'Not set';
          } else return 'Not set';
        };

        $scope.showZones = function(zone) {
          if (zone && $scope.manageZonesList.length) {
            var selected = $filter('filter')($scope.manageZonesList, {
              id: zone
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.showPartners = function(partner) {
          if (partner && $scope.managePartnerList.length) {
            var selected = $filter('filter')($scope.managePartnerList, {
              id: partner
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.generatePassword = function() {
          var length = 8,
              charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
              retVal = "";
          for (var i = 0, n = charset.length; i < length; ++i) {
              retVal += charset.charAt(Math.floor(Math.random() * n));
          }
          return retVal;
      };

      $scope.newPassword="";

      $scope.openPassword = function(page, size) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope: $scope,
          size: size
        });
        modalInstance.result.then(function(selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteUser(selectedItem);
          console.log("hurry = " + selectedItem);
        }, function() {
          console.log('Modal dismissed at: ' + new Date());
        });
      };

    $scope.resetPassword = function (userid) {
      console.log('userid', userid);
      $scope.newPassword = $scope.generatePassword();
      console.log('newPassword',$scope.newPassword);

      var obj = {};
      obj.params = {};
      obj.params.id = userid;
      obj.params.password = $scope.newPassword;

      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('User has been updated successfully!', 'SUCCESS');
        $scope.initManageUsers();
        $scope.openPassword('app/pages/usersetup/users/modals/passwordModal.html');

      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          toastr.error(err.data.error.message, 'Error');
        }
      };
      userService.resetPassword(obj);

    };



    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService,$rootScope) {

    //$scope.menuItems = baSidebarService.getMenuItems();
    $scope.menuItems = baSidebarService.getAuthorizedMenuItems($rootScope.userData.roleId);
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.getAuthorizedMenuItems = function(role) {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0 && _.includes(item.authRoles, role);
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: ((s.name.match(/\./g) || []).length - 1),
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                authRoles:s.authRoles,
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/authSignIn/authSignIn.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign in to VIP Portal</h1><a ui-sref="authSignUp" class="auth-link">New to VIP Portal? Sign up!</a><form class="form-horizontal" ng-submit="login(user)"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" ng-model="user.username" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-model="user.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign in</button> <a href="" class="forgot-pass">Forgot password?</a></div></div></form></div></main></div>');
$templateCache.put('app/pages/authSignUp/authSignUp.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign up to VIP Portal</h1><a ui-sref="authSignIn" class="auth-link">Already have a VIP Portal account? Sign in!</a><form class="form-horizontal" ng-submit="validateRegistration(register)"><div class="form-group"><label for="inputName3" class="col-sm-3 control-label">Name</label><div class="col-sm-9"><input type="text" ng-model="register.name" class="form-control" id="inputName3" placeholder="Full Name"></div></div><div class="form-group"><label for="inputMobile3" class="col-sm-3 control-label">Mobile (+60)</label><div class="col-sm-9"><input type="tel" ng-model="register.mobile" class="form-control" id="inputMobile3" placeholder="Mobile Number"></div></div><div class="form-group"><label for="inputEmail3" class="col-sm-3 control-label">Username</label><div class="col-sm-9"><input type="text" ng-model="register.username" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" ng-model="register.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-3 col-sm-9"><button type="submit" class="btn btn-default btn-auth">Sign up</button></div></div></form></div></main></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row" ng-if="userData.roleId===1 || userData.roleId===3 || userData.roleId===5"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row" ng-repeat="group in dashboardV1List | groupBy: \'[zoneid]\'"><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app"><div class="popular-app-cost row" style="background-color:chocolate ;color:black"><div class="col-xs-9">{{group[0].zone}} - Revenue (\u6BCF\u65E5\u6536\u5165)</div></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="group"><thead><tr><th class="text-center bold-text">Shop Type</th><th class="text-center bold-text bg-warning" style="color:black">Machine (\u5927\u673A)</th><th class="text-center bold-text bg-info" style="color:black">Online (\u7F51\u673A)</th><th class="text-center bold-text bg-purple" style="color:black">Total (\u603B\u6570)</th></tr></thead><tbody><tr class="popular-app-info" ng-repeat="item in group | groupBy: \'[shoptype]\'"><td class="text-center">{{item[0].shoptype}}</td><td class="text-right bg-warning" style="color:black">{{item[0].mactotal | currency:\'\'}}</td><td class="text-right bg-info" style="color:black">{{item[0].ontotal | currency:\'\'}}</td><td class="text-right bg-purple" style="color:black">{{getTotaltotal(item) | currency:\'\'}}</td></tr><tr class="popular-app-info"><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalmactotal(group) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalontotal(group) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotaltotal(group) | currency:\'\'}}</td></tr></tbody></table></div></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12"><div ba-panel="" ba-panel-title="{{group[0].zone}} - 10 Days Report (10\u5929\u62A5\u544A)" ba-panel-class="horizontal-scroll"><div><canvas id="bar" class="chart chart-bar" chart-data="group[0].weeklyData" chart-labels="group[0].weekLabels" chart-series="weekSeries" chart-dataset-override="datasetOverride"></canvas></div></div></div></div></div></div><div class="row"><div class="col-xlg-12 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-right">Powered By Dufro Labs <i class="fa fa-bolt"></i></div><div class="al-footer-main clearfix"><div class="al-copy"><i class="fa fa-copyright"></i> VIP Portal 2018 | Version 6.8</div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Full Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" ng-model="manageProfile.credentials.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">System Role</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-3 control-label">{{ showRoles(manageProfile.credentials.role) }}</label></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" ng-model="manageProfile.password"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder="" ng-model="manageProfile.confirmPassword"></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" ng-model="manageProfile.credentials.mobile"></div></div></div></div><button type="button" class="btn btn-primary save-profile" ng-click="udpateProfile(manageProfile)">Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/account/collector/collector.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Collectors ({{manageCollectorList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/collector/widgets/collectorTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/partner/partner.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Partners ({{managePartnerList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/partner/widgets/partnerTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/supplier/supplier.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Suppliers ({{manageSupplierList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/supplier/widgets/supplierTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/usermapping/usermapping.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage User Mapping ({{manageUsermappingList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/usermapping/widgets/usermappingTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUsermapping()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/collectors/dailyinvoices/dailyinvoices.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Invoices ({{manageDailyinvoicesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoicesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageInvoice()" print-remove="">Close</button> <button type="button" class="btn btn-info save-profile" ng-click="saveShorts()" print-remove="">Save</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/collectors/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}<br>{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}<br>{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}<br>{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyMachinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/csync/assigncollector/assigncollector.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Assignment ({{manageCollectorsList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/csync/assigncollector/widgets/assigncollectorTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Collector and Shop Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="username" class="col-sm-3 control-label">Collector Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageCollector.credentials.firstName + " " + manageCollector.credentials.lastName}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"></div></div></div><h4>Assigned shops &nbsp; &nbsp;<button class="btn btn-primary btn-xs" ng-click="addShop()">Assign New</button></h4><table class="table table-striped table-condensed" st-safe-src="selectedShopList" st-table="selectedShopL"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="name">Shop Name</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in selectedShopL" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'Not Set\' }}</td><td>{{ item.name || \'Not Set\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="removeShop(item)">Remove</button></div></td></tr></tbody></table><div class="row" ng-show="isAssignNewShop"><h4>Unassigned shops</h4><table class="table table-striped table-condensed" st-safe-src="notSelectedShopList" st-table="notSelectedShopL"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="name">Shop Name</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in notSelectedShopL" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'Not Set\' }}</td><td>{{ item.name || \'Not Set\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="assignShop(item)">Assign</button></div></td></tr></tbody></table></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageOfficers()">Close</button></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/external/partnersales/partnersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Partner Sales ({{managePartnersalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/external/partnersales/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isEdit && !isInvoice"><div class="panel-content"><h3 class="with-line">Partner Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.name}}</label></div></div></div></div><hr><table ng-hide="isGroup" class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey) | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color:black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.netpurchase | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ocsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.totalsales | currency:\'\'}}</td><td><div class="buttons text-center"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody></table><table ng-show="isGroup" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[shopid]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td class="bg-warning" style="color:black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalnetpurhase(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalocsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><div class="buttons text-center"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(reportFilter)">Close</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="viewMachinesales(managePartnersales)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/external/suppliersales/suppliersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Sales By Supplier ({{manageSuppliersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/external/suppliersales/widgets/suppliersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Supplier Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Commission</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.rate}}%</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Supplier Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.contact}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfSupplierList.result" st-table="machineSalesOfSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="upload">Upload Date</th><th st-sort="commission">Commission</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey)}}</td><td>{{item.created | date: \'dd/MM/yyyy\'}}</td><td>{{(item.totalsales*manageSuppliersales.rate)/100 | currency:\'\' }}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/machinesales/machinesales.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Machine Sales ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/machinesales/widgets/machinesalesTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createMachinesales(manageMachinesales)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachinesales()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/onlinesales/onlinesales.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Uplpoad and Review Online Sales ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/onlinesales/widgets/onlinesalesTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createOnlinesales(manageOnlinesales)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageOnlinesales()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/allinvoices.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Invoices ({{manageAllinvoicesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageInvoice()" print-remove="">Close</button> <button type="button" class="btn btn-info save-profile" ng-click="saveShorts()" print-remove="">Save</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/dailyinvoices.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Invoices ({{manageDailyinvoicesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoicesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 30px;"><b>INVOICE</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageInvoice()" print-remove="">Close</button> <button type="button" class="btn btn-info save-profile" ng-click="saveShorts()" print-remove="">Save</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/machine/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/machine/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right"><span editable-text="manageMachinesales.cm_in" blur="cancel">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.cm_out" blur="cancel">{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_in" blur="cancel">{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_out" blur="cancel">{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}</span></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyMachinesales(reportFilter)">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="saveCorrection(manageMachinesales)">Save</button></div>');
$templateCache.put('app/pages/machine/dailymachineshop/dailymachineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machine Sales By Shop ({{manageDailymachineshopList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/machine/dailymachineshop/widgets/dailymachineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div include-with-scope="app/pages/machine/dailymachineshop/widgets/dailymachineshopLevel2.html"></div></div>');
$templateCache.put('app/pages/machine/machinesales/machinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/machine/machinesales/widgets/machinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right"><span editable-text="manageMachinesales.cm_in" blur="cancel">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.cm_out" blur="cancel">{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_in" blur="cancel">{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_out" blur="cancel">{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}</span></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(reportFilter)">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="saveCorrection(manageMachinesales)">Save</button></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/msync/importofficers/importofficers.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Uplpoad and Review Officer Details ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/msync/importofficers/widgets/importofficersTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createImportofficers()">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageImportofficers()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/msync/officers/officers.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Officers ({{manageOfficersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/msync/officers/widgets/officersTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addOfficer()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/msync/paylist/paylist.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Paylist ({{managePaylistList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/msync/paylist/widgets/paylistTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div include-with-scope="app/pages/msync/paylist/widgets/paylistAdd.html"></div></div>');
$templateCache.put('app/pages/online/dailyonlinesales/dailyonlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Online Sales ({{manageOnlinesalesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/dailyonlinesales/widgets/dailyonlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.gamename}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageOnlinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Kiosk</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-9 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Share</label><div class="col-sm-6"><label class="col-sm-3 control-label">{{manageOnlinesales.pshare | currency:\'\' }}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Wins</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pwin | currency:\'\' }}</label></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Purchase</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Gaming</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyOnlinesales(reportFilter)">Close</button></div></div>');
$templateCache.put('app/pages/online/dailyonlineshop/dailyonlineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlineshopList.result.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/dailyonlineshop/widgets/dailyonlineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{lookupDetails.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{lookupDetails.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/online/dailyonlineshop/widgets/viewOnlineShop.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner %</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div>');
$templateCache.put('app/pages/online/onlinesales/onlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/onlinesales/widgets/onlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div include-with-scope="app/pages/online/onlinesales/widgets/viewSale.html"></div></div></div>');
$templateCache.put('app/pages/operational/machine/machine.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machines ({{manageMachineList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/machine/widgets/machineTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addMachine()">Add New</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.code"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageMachine.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.status"> <span>{{manageMachine.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game</label><div class="col-sm-9"><ui-select ng-model="manageMachine.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">is Jackpot?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.isjackpot"> <span>{{manageMachine.isjackpot?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageMachine.remarks"></textarea></div></div></div></div></div><h3 class="with-line">Meter Reading</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">CM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmOut"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Calculate By?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.calby"> <span>{{manageMachine.calby?"CM":"BM"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmOut"></div></div></div></div><h3 class="with-line">Coversion Rates (CM to BM) {{(manageMachine.cmRate/manageMachine.bmRate)| currency: \'\'}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmRate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmRate"></div></div></div></div><div include-with-scope="app/pages/operational/machine/widgets/machineShopTable.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMachine(manageMachine)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachine(reportFilter)">Cancel</button></div>');
$templateCache.put('app/pages/operational/shop/shop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Shop ({{manageShopList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/shop/widgets/shopTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addShop()">Add New</button></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Shop Information" form="vm.personalInfoForm"><div include-with-scope="app/pages/operational/shop/widgets/shopInfo.html"></div></ba-wizard-step><ba-wizard-step title="Online Games" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/shop/widgets/onlineGames.html"></div></ba-wizard-step><ba-wizard-step title="Machines" form="vm.addressForm"><div include-with-scope="app/pages/operational/shop/widgets/machines.html"></div></ba-wizard-step><ba-wizard-step title="Partner & Contact"><div include-with-scope="app/pages/operational/shop/widgets/partner.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop(reportFilter)">Cancel</button></div></div></div>');
$templateCache.put('app/pages/partneraccount/partnerusers/partnerusers.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Users ({{manageUsersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/partneraccount/partnerusers/widgets/usersTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/partners/partnerinvoice/partnerinvoice.html','<div class="widgets" ng-hide="isInvoice"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Partner Sales ({{machineSalesOfPartnerList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/partners/partnerinvoice/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="getShopSalesOfPartner(shopSalesOfPartnerList)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/reports/collector/collector.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Collector ({{managePartnersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/collector/widgets/collectorTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ispaid" placeholder="Search Invoice Status" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageCollector()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/reports/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.machine.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.machine.cmRate}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cmIn==0?\'-\':(manageMachinesales.cmIn | currency: \'\':0) }}<br>{{manageMachinesales.cmOut==0?\'-\':(manageMachinesales.cmOut | currency: \'\':0) }}<br>{{manageMachinesales.bmIn==0?\'-\':(manageMachinesales.bmIn | currency: \'\':0) }}<br>{{manageMachinesales.bmOut==0?\'-\':(manageMachinesales.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cmInP==0?\'-\':(manageMachinesales.cmInP | currency: \'\':0) }}<br>{{manageMachinesales.cmOutP==0?\'-\':(manageMachinesales.cmOutP | currency: \'\':0) }}<br>{{manageMachinesales.bmInP==0?\'-\':(manageMachinesales.bmInP | currency: \'\':0) }}<br>{{manageMachinesales.bmOutP==0?\'-\':(manageMachinesales.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cmIn - manageMachinesales.cmInP)==0?\'-\':(manageMachinesales.cmIn - manageMachinesales.cmInP | currency: \'\':0) }}<br>{{(manageMachinesales.cmOut - manageMachinesales.cmOutP)==0?\'-\':(manageMachinesales.cmOut - manageMachinesales.cmOutP | currency: \'\':0) }}<br>{{(manageMachinesales.bmIn - manageMachinesales.bmInP)==0?\'-\':(manageMachinesales.bmIn - manageMachinesales.bmInP | currency: \'\':0) }}<br>{{(manageMachinesales.bmOut - manageMachinesales.bmOutP)==0?\'-\':(manageMachinesales.bmOut - manageMachinesales.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div>');
$templateCache.put('app/pages/reports/dailymachineshop/dailymachineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machine Sales By Shop ({{manageDailymachineshopList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailymachineshop/widgets/dailymachineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div include-with-scope="app/pages/reports/dailymachineshop/widgets/dailymachineshopLevel2.html"></div></div>');
$templateCache.put('app/pages/reports/dailyonlinesales/dailyonlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Online Sales ({{manageOnlinesalesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailyonlinesales/widgets/dailyonlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.game.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageOnlinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Kiosk</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Share</label><div class="col-sm-6"><label class="col-sm-3 control-label">{{manageOnlinesales.pshare | currency:\'\' }}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Wins</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pwin | currency:\'\' }}</label></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Purchase</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Gaming</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/dailyonlineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlineshopList.result.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailyonlineshop/widgets/dailyonlineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{lookupDetails.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{lookupDetails.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/reports/dailyonlineshop/widgets/viewOnlineShop.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner %</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div>');
$templateCache.put('app/pages/reports/machinesales/machinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/machinesales/widgets/machinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.machine.gameid)}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy\'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><h5><u>Current Readings</u></h5><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmIn}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmOut}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmIn}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmOut}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><h5><u>Previous Readings</u></h5><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmInP}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmOutP}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmInP}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmOutP}}</label></div></div><p><br></p></div></div><hr><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{showMachineShops(manageMachinesales.machineid, manageMachinesales.shopid)}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - showMachineShops(manageMachinesales.machineid, manageMachinesales.shopid)}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.psales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div>');
$templateCache.put('app/pages/reports/marketing/marketing.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Marketing ({{manageMarketingsalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/marketing/widgets/marketingTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageMarketing()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/reports/onlinesales/onlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/onlinesales/widgets/onlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div include-with-scope="app/pages/reports/onlinesales/widgets/viewSale.html"></div></div></div>');
$templateCache.put('app/pages/reports/partnersales/partnersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Partner Sales ({{managePartnersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/partnersales/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isEdit && !isInvoice"><div class="panel-content"><h3 class="with-line">Partner Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.name}}</label></div></div></div></div><hr><table ng-hide="isGroup" class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="3" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey) | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color:black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ocsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.totalsales | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody></table><table ng-show="isGroup" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="3" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[shopid]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td class="bg-warning" style="color:black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalocsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="viewMachinesales(managePartnersales)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/reports/suppliersales/suppliersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Sales By Supplier ({{manageSuppliersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/suppliersales/widgets/suppliersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Supplier Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Commission</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.rate}}%</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Supplier Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.contact}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfSupplierList.result" st-table="machineSalesOfSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="upload">Upload Date</th><th st-sort="commission">Commission</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey)}}</td><td>{{item.created | date: \'dd/MM/yyyy\'}}</td><td>{{(item.totalsales*manageSuppliersales.rate)/100 | currency:\'\' }}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/shopstaff/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}<br>{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}<br>{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}<br>{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyMachinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/supplier/machinesales/machinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Supplier Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/supplier/machinesales/widgets/machinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Supplier Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Rate%</th><th class="text-center">Commission</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}<br>{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}<br>{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}<br>{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td>{{manageMachinesales.suprate}}%</td><td>{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales*(manageMachinesales.suprate/100) | currency: \'\')}}</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/system/areas/areas.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Areas ({{manageAreasList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/areas/widgets/areasTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addArea()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/gamecategory/gamecategory.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Game Category ({{manageGamecategoryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/gamecategory/widgets/gamecategoryTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/games/games.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Games ({{manageGamesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/games/widgets/gamesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addArea()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/machine/machine.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machines ({{manageMachineList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/machine/widgets/machineTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addMachine()">Add New</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.code"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageMachine.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.status"> <span>{{manageMachine.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game</label><div class="col-sm-9"><ui-select ng-model="manageMachine.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">is Jackpot?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.isjackpot"> <span>{{manageMachine.isjackpot?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageMachine.remarks"></textarea></div></div></div></div></div><h3 class="with-line">Meter Reading</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">CM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmOut"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Calculate By?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.calby"> <span>{{manageMachine.calby?"CM":"BM"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmOut"></div></div></div></div><h3 class="with-line">Coversion Rates (CM to BM) {{(manageMachine.cmRate/manageMachine.bmRate)| currency: \'\'}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmRate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmRate"></div></div></div></div><div include-with-scope="app/pages/system/machine/widgets/machineShopTable.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMachine(manageMachine)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachine()">Cancel</button></div>');
$templateCache.put('app/pages/system/shop/old.html','<div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.shoptype"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.address"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Machine and Online %</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Online Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Online Game Tips%</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Comp Online Game %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Comp Online %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Mach Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Mach Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Comp Machine %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Comp Mach %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macvirtual"></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 1</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 2</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 3</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 1</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 2</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 3</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3"></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.remarks"></div></div></div></div><h3 class="with-line">Partner info</h3><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code"></span></ui-select-choices></ui-select></div></div><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop()">Cancel</button></div></div>');
$templateCache.put('app/pages/system/shop/shop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Shop ({{manageShopList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/shop/widgets/shopTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addShop()">Add New</button></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Shop Information" form="vm.personalInfoForm"><div include-with-scope="app/pages/system/shop/widgets/shopInfo.html"></div></ba-wizard-step><ba-wizard-step title="Online Games" form="vm.productInfoForm"><div include-with-scope="app/pages/system/shop/widgets/onlineGames.html"></div></ba-wizard-step><ba-wizard-step title="Machines" form="vm.addressForm"><div include-with-scope="app/pages/system/shop/widgets/machines.html"></div></ba-wizard-step><ba-wizard-step title="Partner & Contact"><div include-with-scope="app/pages/system/shop/widgets/partner.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop()">Cancel</button></div></div></div>');
$templateCache.put('app/pages/system/site/site.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Balai ({{manageSiteList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/site/widgets/siteTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addSite()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/states/states.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage States ({{manageStatesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/states/widgets/statesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/zones/zones.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Zones ({{manageZonesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/zones/widgets/zonesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/totalsales/collector/collector.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Collector ({{managePartnersalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/totalsales/collector/widgets/collectorTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ispaid" placeholder="Search Invoice Status" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageCollector()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/totalsales/marketing/marketing.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Marketing ({{manageMarketingsalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/totalsales/marketing/widgets/marketingTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageMarketing()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/pages/usersetup/roles/roles.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Roles ({{manageRolesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/usersetup/roles/widgets/rolesTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/usersetup/users/users.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Users ({{manageUsersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/usersetup/users/widgets/usersTable.html"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>VIP</span>-Portal</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="kameleon-icon with-round-bg danger"><img ng-src="assets/img/theme/icon/kameleon/Money-Increase.svg"></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/main/profile"><i class="fa fa-user"></i>Profile</a></li><li><a href=""><i class="fa fa-cog"></i>Settings</a></li><li><a href="#/authSignIn" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div><div class="user-profile clearfix" style="margin-top: 0px"><a href="" class="al-logo"><span>Greetings,</span>{{userData.credentials.name}}</a></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/account/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Collector!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/collector/widgets/collectorTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageCollector(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManageCollector(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCollectorList" st-table="manageCollector"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Collector Code</th><th st-sort="name">Collector Name</th><th st-sort="contact">Contact Details</th><th st-sort="isparent">Access Level</th><th st-sort="zone">Zone</th><th st-sort="parent.code">Parent Collector</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Collector Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Collector Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th><input st-search="parent.code" placeholder="Search Parent Code" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCollector" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td><span editable-checkbox="item.isparent" e-title="is this Parent?" e-name="isparent" e-form="rowform">{{ item.isparent && "Parent" || "Supervisor" }}</span></td><td class="select-td"><span editable-select="item.name" e-name="zones" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as (g.code +\', \' + g.name) for g in manageZonesList">{{ showZones(item.zoneid)}}</span></td><td class="select-td"><div ng-hide="item.isparent"><span editable-ui-select="item.parent" e-form="rowform" e-name="parent" name="parent" e-ng-model="item.parent" theme="bootstrap">{{ item.parent.code }}<editable-ui-select-match placeholder="Collector Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="parent in manageParentCollectorList | filter: $select.search track by $index">{{parent.code}}, {{parent.name}}</editable-ui-select-choices></span></div></td><td><form editable-form="" name="rowform" onbeforesave="saveCollector($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid || !item.isparent" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/partner/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/partner/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/account/partner/widgets/partnerTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManagePartner(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManagePartner(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnerList" st-table="managePartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="contact">Contact Details</th><th st-sort="isparent">Access Level</th><th st-sort="parent.code">Parent Partner</th><th st-sort="zones">Zone</th><th>Action</th><th></th><th></th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="parent.code" placeholder="Search Parent Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required=""></span> {{ item.code || \'empty\'}} <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td><span editable-checkbox="item.isparent" e-title="is this Parent?" e-name="isparent" e-form="rowform">{{ item.isparent && "Parent" || "Supervisor" }}</span></td><td class="select-td"><div ng-hide="item.isparent"><span editable-ui-select="item.parent" e-form="rowform" e-name="parent" name="parent" e-ng-model="item.parent" theme="bootstrap">{{ item.parent.code }}<editable-ui-select-match placeholder="Partner Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search track by $index">{{parent.code}}, {{parent.name}}</editable-ui-select-choices></span></div></td><td class="select-td"><span editable-select="item.zoneid" e-name="zoneid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as (g.code +\', \' + g.name) for g in manageZonesList">{{ showZones(item.zoneid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="savePartner($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/supplier/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/supplier/widgets/supplierTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageStates(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManageStates(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageSupplierList" st-table="manageSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="contact">Contact Details</th><th st-sort="zones">Zone</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.name" e-name="zones" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as (g.code +\', \' + g.name) for g in manageZonesList">{{ showZones(item.zoneid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSupplier($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/usermapping/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this User Mapping!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/usermapping/widgets/usermappingTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageUsermappingList" st-table="manageUsermappings"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="role.name">Role</th><th st-sort="user.username">User Name</th><th st-sort="zone.code">Zone</th><th st-sort="area.name">Area</th><th>Action</th></tr><tr><th></th><th><input st-search="role.name" placeholder="Search Role" class="input-sm form-control search-input" type="search"></th><th><input st-search="user.username" placeholder="Search User Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Area" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsermappings" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.role.id" e-name="role" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageRoleList">{{ showRoles(item.role) }}</span></td><td class="select-td"><span editable-select="item.user.id" e-name="user" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.username for g in manageUserList">{{ showUsers(item.user) }}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList">{{ showZones(item.zone) }}</span></td><td class="select-td"><span editable-select="item.area.id" e-name="area" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreaList">{{ showAreas(item.area) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUsermapping($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/modals/PayNowModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-cash modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to Pay this Invoice. Please make sure you have collected the payment.</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Invoice!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceFooter.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">TOTAL</th><th class="align-right">{{getTotal() | currency: \'\'}}</th></tr></thead></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceHeader.html','<table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px;"><thead><tr><th class="text-center" style="padding: 0px"><b>Partner</b></th><th class="text-center" style="padding: 0px"><b>Shop ID</b></th><th class="text-center" style="padding: 0px"><b>Shop Name</b></th><th class="text-center" style="padding: 0px"><b>Invoice Date</b></th><th class="text-center" style="padding: 0px"><b>Invoice No.</b></th></tr></thead><tbody><tr><td class="text-center" style="padding: 0px">{{shopInvoiceDetails.partner.code+\', \'+shopInvoiceDetails.partner.name}}</td><td class="text-center">{{shopInvoiceDetails.code}}</td><td class="text-center">{{shopInvoiceDetails.name}}</td><td class="text-center">{{manageDailyinvoices.invoicedate | date: \'dd/MM/yyyy\'}}</td><td class="text-center">{{manageDailyinvoices.invoiceid}}</td></tr></tbody></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceMachine.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br>{{item.created | date: \'hh:mm a\'}}</td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr><tr><td></td><td></td><td></td><td></td><td class="align-right">{{getTotaltotalsales(machineInvoiceDetails)==0?\'-\':(getTotaltotalsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalpsales(machineInvoiceDetails)==0?\'-\':(getTotalpsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalcsales(machineInvoiceDetails)==0?\'-\':(getTotalcsales(machineInvoiceDetails) | currency: \'\')}}</td><td></td><td></td></tr></tbody></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceOnline.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NP</th><th class="text-center">P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">Sales</th><th class="text-center">Shop ({{100-onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Company ({{onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td lass="text-right" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0"><span editable-text="manageDailyinvoices.onlineshorts" blur="cancel">{{ manageDailyinvoices.onlineshorts ==0?\'-\':(manageDailyinvoices.onlineshorts | currency: \'\' )}}</span></td><td class="text-center" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0">{{total.onlineST==0?\'-\':(total.onlineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoicesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Status</label><ui-select ng-model="reportFilter.ispaid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in paidFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchAllinvoices(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><hr><br><table class="table table-striped table-condensed" st-safe-src="manageDailyinvoicesList" st-table="manageDailyinvoices"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice No.</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="shopcode">Shop Code</th><th st-sort="shopname">Shop Name</th><th st-sort="mactotal" class="bg-warning" style="color:black">Machine</th><th st-sort="ontotal" class="bg-info" style="color:black">Online</th><th st-sort="" class="bg-purple" style="color:black">Total</th><th st-sort="ispaid">Status</th><th st-sort="pdate">Paid Date</th><th st-sort="agentid">Agent</th><th>Action</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Invoice Id" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageDailyinvoices" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.invoiceid || \'empty\'}}</td><td>{{ item.ikey | limitTo: -8}}</td><td>{{item.shopcode}}</td><td>{{item.shopname}}</td><td class="bg-warning" style="color:black">{{item.mcsales | currency: \'\'}}</td><td class="bg-info" style="color:black">{{item.ocsales | currency: \'\'}}</td><td class="bg-purple" style="color:black">{{item.totalsales | currency: \'\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }" style="color:black">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td>{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td>{{showUserById(item.agentid)}}</td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button> &nbsp;<button ng-if="!item.ispaid" class="btn btn-info editable-table-button btn-xs" ng-click="confirmPayNow(item.id)">Pay Now</button></div></td></tr><tr ng-if="totalSalesLabelFooter!=0"><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{getTotalmcsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{getTotalocsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{getTotaltotalsales(manageDailyinvoices) | currency:\'\'}}</td><td></td><td></td><td></td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceMachinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop</th><th st-sort="showGameById(item.gameid)">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/csync/assigncollector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Collector!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/csync/assigncollector/widgets/assigncollectorTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100, 200, 500, 1000]"></select></label></div><table ng-hide="isAgentView" class="table table-striped" st-safe-src="manageCollectorsList" st-table="manageOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Collector Head Name</th><th st-sort="shops">Agent count</th><th>Action</th></tr><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOfficers | groupBy: \'credentials.manager.id\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item[0].credentials.manager.credentials.firstName +" " + item[0].credentials.manager.credentials.lastName || \'empty\' }}</td><td>{{ item.length || \'empty\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveOfficer($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewAgents(item)">View</button> &nbsp;</div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><table ng-show="isAgentView" class="table table-striped" st-safe-src="manageCollectorsList" st-table="manageOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Collector Agent Name</th><th st-sort="shops">Shop count</th><th>Action</th></tr><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOfficers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.credentials.firstName +" " + item.credentials.lastName || \'empty\' }}</td><td>{{ item.credentials.shopmap.length || \'empty\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveOfficer($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewCollectorDetails(item)">Edit</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><button ng-show="isAgentView" type="button" class="btn btn-default save-profile" ng-click="initManageOfficers()">Back</button></div>');
$templateCache.put('app/pages/external/partnersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/external/partnersales/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.parent" class="col-sm-2"><label>Select Partner</label><ui-select ng-model="reportFilter.parent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.id}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search"><span ng-bind-html="parent.id+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="mactotal">Machine Total Sales</th><th st-sort="ontotal">Online Total Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/external/suppliersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/external/suppliersales/widgets/suppliersalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageSuppliersalesList.result" st-table="manageSuppliersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSuppliersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/form/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine Sales!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,500,1000]"></select></div><div class="col-sm-3"><label>Upload Machine Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/machinesales/widgets/sampleMachineUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageMachinesalesList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="machineid">Machine Code</th><th st-sort="cmin">CM IN</th><th st-sort="cmout">CM OUT</th><th st-sort="bmin">BM IN</th><th st-sort="bmout">BM OUT</th><th></th><th>Action</th></tr><tr><th></th><th><input st-search="machineid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesalesList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.machineid" e-name="machineid" e-form="rowform" e-required="">{{ item.machineid || \'empty\'}}</span></td><td><span editable-text="item.cmin" e-name="cmin" e-form="rowform" e-required="">{{item.cmin.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.cmout" e-name="cmout" e-form="rowform" e-required="">{{item.cmout.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.bmin" e-name="bmin" e-form="rowform" e-required="">{{item.bmin.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.bmout" e-name="bmout" e-form="rowform" e-required="">{{item.bmout.replace(\'MYR\',\'\') || 0 }}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Sales!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/onlinesales/widgets/onlinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,500,1000]"></select></div><div class="col-sm-2"><label>Select Online Game</label><ui-select ng-model="manageOnlinesales.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>Upload Online Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/onlinesales/widgets/sampleUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageOnlinesalesList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="Kiosk">Kiosk</th><th st-sort="PS">Progressive Share</th><th st-sort="PW">Progressive Wins</th><th st-sort="NP">Net Purchase</th><th st-sort="NG">Net Gaming</th><th></th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesalesList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.Kiosk" e-name="Kiosk" e-form="rowform" e-required="">{{ item.Kiosk || \'empty\'}}</span></td><td><span editable-text="item.PS" e-name="PS" e-form="rowform" e-required="">{{item.PS.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.PW" e-name="PW" e-form="rowform" e-required="">{{item.PW.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NP" e-name="NP" e-form="rowform" e-required="">{{item.NP.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NG" e-name="NG" e-form="rowform" e-required="">{{item.NG.replace(\'MYR\',\'\') || 0 }}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete($index)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/allinvoices/modals/PayNowModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-cash modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to Pay this Invoice. Please make sure you have collected the payment.</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Invoice!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-eye modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString.cm}}"> <img ng-src="{{imageString.bm}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesFooter.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">TOTAL</th><th class="align-right">{{getTotal() | currency: \'\'}}</th></tr></thead></table>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesHeader.html','<table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px;"><thead><tr><th class="text-center" style="padding: 0px"><b>Partner</b></th><th class="text-center" style="padding: 0px"><b>Shop ID</b></th><th class="text-center" style="padding: 0px"><b>Shop Name</b></th><th class="text-center" style="padding: 0px"><b>Invoice Date</b></th><th class="text-center" style="padding: 0px"><b>Invoice No.</b></th></tr></thead><tbody><tr><td class="text-center" style="padding: 0px">{{shopInvoiceDetails.partner.code+\', \'+shopInvoiceDetails.partner.name}}</td><td class="text-center">{{shopInvoiceDetails.code}}</td><td class="text-center">{{shopInvoiceDetails.name}}</td><td class="text-center">{{manageAllinvoices.invoicedate | date: \'dd/MM/yyyy\'}}</td><td class="text-center">{{manageAllinvoices.invoiceid}}</td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesMachine.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center" print-remove="">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br>{{item.created | date: \'hh:mm a\'}}</td><td print-remove=""><img ng-if="item.receipt.content.cm!==null" ng-src="{{item.receipt.content.cm}}" style="text-align: center; width:200px;height:200px"> <img ng-if="item.receipt.content.bm!==null" ng-src="{{item.receipt.content.bm}}" style="text-align: center; width:200px;height:200px"></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span editable-text="manageAllinvoices.machineshorts" blur="cancel">{{ manageAllinvoices.machineshorts==0?\'-\':(manageAllinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr><tr><td></td><td></td><td></td><td></td><td class="align-right">{{getTotaltotalsales(machineInvoiceDetails)==0?\'-\':(getTotaltotalsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalpsales(machineInvoiceDetails)==0?\'-\':(getTotalpsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalcsales(machineInvoiceDetails)==0?\'-\':(getTotalcsales(machineInvoiceDetails) | currency: \'\')}}</td><td></td><td></td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesOnline.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NP</th><th class="text-center">P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">Sales</th><th class="text-center">Shop ({{100-onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Company ({{onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td lass="text-right" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0"><span editable-text="manageAllinvoices.onlineshorts" blur="cancel">{{ manageAllinvoices.onlineshorts ==0?\'-\':(manageAllinvoices.onlineshorts | currency: \'\' )}}</span></td><td class="text-center" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0">{{total.onlineST==0?\'-\':(total.onlineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Status</label><ui-select ng-model="reportFilter.ispaid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in paidFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchAllinvoices(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><hr><br><table class="table table-striped table-condensed" st-safe-src="manageAllinvoicesList" st-table="manageAllinvoices"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice No.</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="shopcode">Shop Code</th><th st-sort="shopname">Shop Name</th><th st-sort="mactotal" class="bg-warning" style="color:black">Machine</th><th st-sort="ontotal" class="bg-info" style="color:black">Online</th><th st-sort="" class="bg-purple" style="color:black">Total</th><th st-sort="ispaid">Status</th><th st-sort="pdate">Paid Date</th><th st-sort="agentid">Agent</th><th>Action</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Invoice Id" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageAllinvoices" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.invoiceid || \'empty\'}}</td><td>{{item.ikey | limitTo: -8}}</td><td>{{item.shopcode}}</td><td>{{item.shopname}}</td><td class="bg-warning" style="color:black">{{item.mcsales | currency: \'\'}}</td><td class="bg-info" style="color:black">{{item.ocsales | currency: \'\'}}</td><td class="bg-purple" style="color:black">{{item.totalsales | currency: \'\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }" style="color:black">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td>{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td>{{showUserById(item.agentid)}}</td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-if="!item.ispaid" class="btn btn-info editable-table-button btn-xs" ng-click="confirmPayNow(item.id)">Pay Now</button></div></td></tr><tr ng-if="totalSalesLabelFooter!=0"><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{getTotalmcsales(manageAllinvoices) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{getTotalocsales(manageAllinvoices) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{getTotaltotalsales(manageAllinvoices) | currency:\'\'}}</td><td></td><td></td><td></td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/PayNowModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-cash modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to Pay this Invoice. Please make sure you have collected the payment.</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Invoice!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-eye modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString.cm}}"> <img ng-src="{{imageString.bm}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">TOTAL</th><th class="align-right">{{getTotal() | currency: \'\'}}</th></tr></thead></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html','<table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px;"><thead><tr><th class="text-center" style="padding: 0px"><b>Partner</b></th><th class="text-center" style="padding: 0px"><b>Shop ID</b></th><th class="text-center" style="padding: 0px"><b>Shop Name</b></th><th class="text-center" style="padding: 0px"><b>Invoice Date</b></th><th class="text-center" style="padding: 0px"><b>Invoice No.</b></th></tr></thead><tbody><tr><td class="text-center" style="padding: 0px">{{shopInvoiceDetails.partner.code+\', \'+shopInvoiceDetails.partner.name}}</td><td class="text-center">{{shopInvoiceDetails.code}}</td><td class="text-center">{{shopInvoiceDetails.name}}</td><td class="text-center">{{manageDailyinvoices.invoicedate | date: \'dd/MM/yyyy\'}}</td><td class="text-center">{{manageDailyinvoices.invoiceid}}</td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center" print-remove="">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br>{{item.created | date: \'hh:mm a\'}}</td><td print-remove=""><img ng-if="item.receipt.content.cm!==null" ng-src="{{item.receipt.content.cm}}" style="text-align: center; width:200px;height:200px"> <img ng-if="item.receipt.content.bm!==null" ng-src="{{item.receipt.content.bm}}" style="text-align: center; width:200px;height:200px"></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr><tr><td></td><td></td><td></td><td></td><td class="align-right">{{getTotaltotalsales(machineInvoiceDetails)==0?\'-\':(getTotaltotalsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalpsales(machineInvoiceDetails)==0?\'-\':(getTotalpsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalcsales(machineInvoiceDetails)==0?\'-\':(getTotalcsales(machineInvoiceDetails) | currency: \'\')}}</td><td></td><td></td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NP</th><th class="text-center">P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">Sales</th><th class="text-center">Shop ({{100-onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Company ({{onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td lass="text-right" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0"><span editable-text="manageDailyinvoices.onlineshorts" blur="cancel">{{ manageDailyinvoices.onlineshorts ==0?\'-\':(manageDailyinvoices.onlineshorts | currency: \'\' )}}</span></td><td class="text-center" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0">{{total.onlineST==0?\'-\':(total.onlineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoicesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Status</label><ui-select ng-model="reportFilter.ispaid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in paidFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchAllinvoices(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><hr><br><table class="table table-striped table-condensed" st-safe-src="manageDailyinvoicesList" st-table="manageDailyinvoices"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice No.</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="shopcode">Shop Code</th><th st-sort="shopname">Shop Name</th><th st-sort="mactotal" class="bg-warning" style="color:black">Machine</th><th st-sort="ontotal" class="bg-info" style="color:black">Online</th><th st-sort="" class="bg-purple" style="color:black">Total</th><th st-sort="ispaid">Status</th><th st-sort="pdate">Paid Date</th><th st-sort="agentid">Agent</th><th>Action</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Invoice Id" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageDailyinvoices" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.invoiceid || \'empty\'}}</td><td>{{ item.ikey | limitTo: -8}}</td><td>{{item.shopcode}}</td><td>{{item.shopname}}</td><td class="bg-warning" style="color:black">{{item.mcsales | currency: \'\'}}</td><td class="bg-info" style="color:black">{{item.ocsales | currency: \'\'}}</td><td class="bg-purple" style="color:black">{{item.totalsales | currency: \'\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }" style="color:black">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td>{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td>{{showUserById(item.agentid)}}</td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-if="!item.ispaid" class="btn btn-info editable-table-button btn-xs" ng-click="confirmPayNow(item.id)">Pay Now</button></div></td></tr><tr ng-if="totalSalesLabelFooter!=0"><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{getTotalmcsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{getTotalocsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{getTotaltotalsales(manageDailyinvoices) | currency:\'\'}}</td><td></td><td></td><td></td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/machine/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/machine/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceMachinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="showGameById(item.gameid)">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="shopid" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/machine/dailymachineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/machine/dailymachineshop/widgets/dailymachineView.html','<table class="table table-bordered"><thead><tr><th>Machine</th><th class="align-right">New Meter</th><th class="align-right">Previous Meter</th><th class="align-right">Difference</th><th class="align-right">Sales</th><th class="align-right">Shop</th><th class="align-right">Company</th></tr></thead><tbody><tr ng-repeat="item in machineSalesDetails"><td>{{item.mid}}</td><td class="align-right">{{item.cmIn}}<br>{{item.cmOut}}<br>{{item.bmIn}}<br>{{item.bmOut}}<br></td><td class="align-right">{{item.cmInP}}<br>{{item.cmOutP}}<br>{{item.bmInP}}<br>{{item.bmOutP}}<br></td><td class="align-right">{{item.cmIn - item.cmInP}}<br>{{item.cmOut - item.cmOutP}}<br>{{item.bmIn - item.bmInP}}<br>{{item.bmOut - item.bmOutP}}<br></td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}} ({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales | currency: \'\'}} ({{item.machineshop.macrate}}%)</td></tr></tbody></table>');
$templateCache.put('app/pages/machine/dailymachineshop/widgets/dailymachineshopLevel2.html','<div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{salesNumbers.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{machineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{salesNumbers.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Machine Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/machine/dailymachineshop/widgets/dailymachineView.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyGroupedMachinesales(reportFilter)">Close</button>');
$templateCache.put('app/pages/machine/dailymachineshop/widgets/dailymachineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyGroupedMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div><div class="col-sm-2"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales :</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageDailymachineshopList" st-table="manageDailymachineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop Code</th><th st-sort="shop.name">Shop Name</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="group in manageDailymachineshop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="group.code" e-name="code" e-form="rowform" e-required="">{{ group.code || \'empty\'}}</span></td><td><span editable-text="group.name" e-name="name" e-form="rowform" e-required="">{{ group.name || \'empty\' }}</span></td><td><span editable-text="group.csales" e-name="csales" e-form="rowform" e-required="">{{ group.csales | currency:\'\' }}</span></td><td><span editable-text="group.psales" e-name="psales" e-form="rowform" e-required="">{{ group.psales | currency:\'\'}}</span></td><td><span editable-text="group.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ group.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(group)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/machine/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="shopid" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/msync/importofficers/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Officer!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/importofficers/widgets/importofficersTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300,400]"></select></div><div class="col-sm-2"><label>Select Mobile User</label><ui-select ng-model="manageImportofficers.user" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.credentials.firstName +"("+$select.selected.credentials.mobile+")"}}</span></ui-select-match><ui-select-choices repeat="user in manageUserList | filter: $select.search"><span ng-bind-html="user.credentials.firstName + \'(\'+user.credentials.mobile+\')\'"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>Upload Online Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/msync/importofficers/widgets/officerUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageImportofficersList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="post">Pangkat</th><th st-sort="name">Officer Name</th><th st-sort="rate">Amount 1</th><th st-sort="rate1">Amount 2</th><th st-sort="department">Bahagian</th><th st-sort="area">Daerah</th><th st-sort="balai">Balai</th><th></th><th>Action</th></tr><tr><th></th><th><input st-search="post" placeholder="Search Post" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Office Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageImportofficersList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.post" e-name="post" e-form="rowform" e-required="">{{ item.post || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{item.name || \'empty\' }}</span></td><td><span editable-text="item.rate" e-name="rate" e-form="rowform" e-required="">{{item.rate || \'0\' }}</span></td><td><span editable-text="item.rate1" e-name="rate1" e-form="rowform" e-required="">{{item.rate1 || \'0\' }}</span></td><td><span editable-text="item.department" e-name="department" e-form="rowform" e-required="">{{item.department ||\'empty\' }}</span></td><td><span editable-text="item.area" e-name="area" e-form="rowform" e-required="">{{item.area || \'empty\' }}</span></td><td><span editable-text="item.balai" e-name="balai" e-form="rowform" e-required="">{{item.balai || \'empty\' }}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/msync/officers/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Officer!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/officers/widgets/officersTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300,400]"></select></div><div class="col-sm-2"><label>Select Mobile User</label><ui-select ng-model="manageOfficer.user" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.credentials.firstName +"("+$select.selected.credentials.mobile+")"}}</span></ui-select-match><ui-select-choices repeat="user in manageUserList | filter: $select.search"><span ng-bind-html="user.credentials.firstName + \'(\'+user.credentials.mobile+\')\'"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchOfficers(manageOfficer.user.id)">Search</button></div></div><div class="col-sm-3"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Amount 1:</strong></label> <label class="col-md-4 control-label">{{totalAmount.toFixed(2) | currency:\'\'}}</label></div></div><div class="col-sm-3"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Amount 2:</strong></label> <label class="col-md-4 control-label">{{totalAmount1.toFixed(2) | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped" st-safe-src="manageOfficersList" st-table="manageOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="emprate.name">Pangkat</th><th st-sort="firstname">Officer Name</th><th st-sort="sprate">Amount 1</th><th st-sort="sprate1">Amount 2</th><th st-sort="department.name">Bahagian</th><th st-sort="site.name">Balai</th><th st-sort="area.name">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="emprate.name" placeholder="Search Pangkat" class="input-sm form-control search-input" type="search"></th><th><input st-search="firstname" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate1" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="department.name" placeholder="Search Bahagian" class="input-sm form-control search-input" type="search"></th><th><input st-search="site.name" placeholder="Search Balai" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOfficers" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.emprateid" e-name="emprateid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageEmprateList | orderBy: \'name\'">{{ getEmprateId(item.emprateid) }}</span></td><td><span editable-text="item.firstname" e-name="firstname" e-form="rowform" e-required="">{{ item.firstname || \'empty\' }}</span></td><td><span editable-text="item.sprate" e-name="sprate" e-form="rowform" e-required="">{{ item.sprate || \'empty\' }}</span></td><td><span editable-text="item.sprate1" e-name="sprate1" e-form="rowform" e-required="">{{ item.sprate1 || \'empty\' }}</span></td><td class="select-td"><span editable-select="item.departmentid" e-name="departmentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageDepartmentList | orderBy: \'name\'">{{ getDepartmentId(item.departmentid) }}</span></td><td class="select-td"><span editable-select="item.siteid" e-name="siteid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageSiteList | orderBy: \'name\'">{{ getSiteId(item.siteid) }}</span></td><td class="select-td"><span editable-select="item.areaid" e-name="areaid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreasList | orderBy: \'name\'">{{ getAreaId(item.areaid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOfficer($data,item.id,item.ownerid)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/msync/paylist/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Paylist!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/paylist/widgets/paylistAdd.html','<div><h3 class="with-line">Paylist Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 bold-text"><strong>Paylist Name</strong></label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageOfficer.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label"><strong>Total Amount</strong></label><div class="col-sm-9"><label class="col-sm-3 control-label"><strong>{{manageOfficer.amount | currency:\'\'}}</strong></label></div></div></div></div><h4 class="with-line">Assigned Officers ({{manageOfficer.plist.length}}) &nbsp; &nbsp;<button class="btn btn-primary btn-xs" ng-click="addOfficer()">Assign New</button></h4><table class="table table-striped table-condensed" st-safe-src="manageOfficer.plist" st-table="plist"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="emprate.name">Pangkat</th><th st-sort="firstname">Officer Name</th><th st-sort="sprate">Amount 1</th><th st-sort="sprate1">Amount 2</th><th st-sort="department.name">Bahagian</th><th st-sort="site.name">Balai</th><th st-sort="area.name">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="emprate.name" placeholder="Search Pangkat" class="input-sm form-control search-input" type="search"></th><th><input st-search="firstname" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate1" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="department.name" placeholder="Search Bahagian" class="input-sm form-control search-input" type="search"></th><th><input st-search="site.name" placeholder="Search Balai" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in plist" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.emprateid" e-name="emprateid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageEmprateList | orderBy: \'name\'">{{ getEmprateId(item.emprateid) }}</span></td><td><span editable-text="item.firstname" e-name="firstname" e-form="rowform" e-required="">{{ item.firstname || \'empty\' }}</span></td><td ng-class="{\'bg-success\':item.issprate}" style="color:black"><span editable-text="item.sprate" e-name="sprate" e-form="rowform" e-required="">{{ item.sprate | currency:\'\'}}</span></td><td ng-class="{\'bg-success\':item.issprate1}" style="color:black"><span editable-text="item.sprate1" e-name="sprate1" e-form="rowform" e-required="">{{ item.sprate1 | currency:\'\'}}</span></td><td class="select-td"><span editable-select="item.departmentid" e-name="departmentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageDepartmentList | orderBy: \'name\'">{{ getDepartmentId(item.departmentid) }}</span></td><td class="select-td"><span editable-select="item.siteid" e-name="siteid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageSiteList | orderBy: \'name\'">{{ getSiteId(item.siteid) }}</span></td><td class="select-td"><span editable-select="item.areaid" e-name="areaid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreasList | orderBy: \'name\'">{{ getAreaId(item.areaid) }}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="removeOfficer(item)">Remove</button></div></td></tr></tbody></table><hr><br><h4 ng-show="isAssignNewOfficer">Unassigned Officers ({{notSelectedOfficerList.length}}) &nbsp; &nbsp;<button class="btn btn-default btn-xs" ng-click="closeOfficer()">Close</button></h4><table ng-show="isAssignNewOfficer" class="table table-striped table-condensed" st-safe-src="notSelectedOfficerList" st-table="notSelectedOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="emprate.name">Pangkat</th><th st-sort="firstname">Officer Name</th><th st-sort="sprate">Amount 1</th><th st-sort="sprate1">Amount 2</th><th st-sort="department.name">Bahagian</th><th st-sort="site.name">Balai</th><th st-sort="area.name">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="emprate.name" placeholder="Search Pangkat" class="input-sm form-control search-input" type="search"></th><th><input st-search="firstname" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate1" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="department.name" placeholder="Search Bahagian" class="input-sm form-control search-input" type="search"></th><th><input st-search="site.name" placeholder="Search Balai" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in notSelectedOfficers" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.emprateid" e-name="emprateid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageEmprateList | orderBy: \'name\'">{{ getEmprateId(item.emprateid) }}</span></td><td><span editable-text="item.firstname" e-name="firstname" e-form="rowform" e-required="">{{ item.firstname || \'empty\' }}</span></td><td ng-class="{\'bg-success\':item.issprate}" style="color:black" ng-click="selectAmount(item,true,false)"><span editable-text="item.sprate" e-name="sprate" e-form="rowform" e-required="">{{ item.sprate | currency:\'\'}}</span></td><td ng-class="{\'bg-success\':item.issprate1}" style="color:black" ng-click="selectAmount(item,false,true)"><span editable-text="item.sprate1" e-name="sprate1" e-form="rowform" e-required="">{{ item.sprate1 | currency:\'\'}}</span></td><td class="select-td"><span editable-select="item.departmentid" e-name="departmentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageDepartmentList | orderBy: \'name\'">{{ getDepartmentId(item.departmentid) }}</span></td><td class="select-td"><span editable-select="item.siteid" e-name="siteid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageSiteList | orderBy: \'name\'">{{ getSiteId(item.siteid) }}</span></td><td class="select-td"><span editable-select="item.areaid" e-name="areaid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreasList | orderBy: \'name\'">{{ getAreaId(item.areaid) }}</span></td><td><div ng-if="item.issprate==null || item.issprate1==null" class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="assignOfficer(item)">Assign</button></div></td></tr></tbody></table></div><button type="button" class="btn btn-primary save-profile" ng-click="savePaylist(manageOfficer)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="searchPaylist(manageOfficer.ownerid)">Close</button>');
$templateCache.put('app/pages/msync/paylist/widgets/paylistTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300,400]"></select></div><div class="col-sm-2"><label>Select Mobile User</label><ui-select ng-model="manageOfficer.user" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.credentials.firstName}}</span></ui-select-match><ui-select-choices repeat="user in manageUserList | filter: $select.search"><span ng-bind-html="user.credentials.firstName"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchPaylist(manageOfficer.user.id)">Search</button></div></div></div></div></div><div class="row"><div class="col-md-8"><table class="table table-striped" st-safe-src="managePaylistList" st-table="managePaylist"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="amount">Amount</th><th st-sort="account.name">Account</th><th st-sort="shared">Share To</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Paylist" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePaylist" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.name}}</td><td class="text-right">{{item.amount | currency:\'\'}}</td><td>{{item.account.name}}</td><td>{{item.shared.credentials.firstName}}</td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editPaylist(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr><tr><td style="background-color:chocolate ;color:black"></td><td style="background-color:chocolate ;color:black"></td><td ng-if="managePaylistList.length>0" class="text-right" style="background-color:chocolate ;color:black">{{ getTotaltotal(managePaylistList) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black"></td><td style="background-color:chocolate ;color:black"></td><td style="background-color:chocolate ;color:black"></td></tr></tbody><br><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/online/dailyonlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/dailyonlinesales/widgets/dailyonlinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div><div class="col-sm-2"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales :</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceOnlinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid">Kiosk</th><th st-sort="code">Shop</th><th st-sort="gamename">Game</th><th st-sort="ikey">Upload Date</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="pwin">PW</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamename" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.playtechid || \'empty\'}}</td><td>{{ item.code || \'empty\'}}</td><td>{{ item.gamename || \'empty\' }}</td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/dailyonlineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/dailyonlineshop/widgets/dailyonlineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getAllOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div><div class="col-sm-2"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales :</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlineshopList" st-table="manageOnlineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop</th><th st-sort="name">Name</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineshop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewOnlinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/dailyonlineshop/widgets/viewOnlineshop.html','<table class="table table-bordered"><thead><tr><th>Games</th><th class="align-right">Net Purchase</th><th class="align-right">P/S (-)</th><th class="align-right">P/W (+)</th><th class="align-right">Sales</th><th class="align-right">Shop ({{100-onlineSalesDetails[0].shop.onrate}}%)</th><th class="align-right">Company ({{onlineSalesDetails[0].shop.onrate}}%)</th></tr></thead><tbody><tr ng-repeat="item in onlineSalesDetails"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase | currency: \'\'}}</td><td class="align-right">{{item.pshare | currency: \'\'}}</td><td class="align-right">{{item.pwin | currency: \'\'}}</td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}}</td><td class="align-right">{{item.csales | currency: \'\'}}</td></tr></tbody></table>');
$templateCache.put('app/pages/online/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/onlinesales/widgets/onlinesalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid">Kiosk</th><th st-sort="code">Shop Code</th><th st-sort="code">Shop Name</th><th st-sort="gamename">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="ikey">Upload Date</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="pwin">PW</th><th st-sort="netgaming">NG</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamename" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netpurchase\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pshare\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pwin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netgaming\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'totalsales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'csales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'psales\') | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ item.gamename || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td>{{ item.netgaming | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr></tbody><tfoot><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><th class="bg-info">{{ getTotal(manageOnlinesales, \'netpurchase\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pshare\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pwin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netgaming\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'totalsales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'csales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'psales\') | currency:\'\'}}</th></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/onlinesales/widgets/viewSale.html','<h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.gamename}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Kiosk</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageOnlinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy\'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Share</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pshare | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Wins</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pwin | currency:\'\'}}</label></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Purchase</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Gaming</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="searchOnlinesales(reportFilter)">Close</button>');
$templateCache.put('app/pages/operational/machine/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/machine/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/machine/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/operational/machine/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/operational/machine/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ item.supplier.code }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/machine/widgets/machineTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageMachine(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachineList" st-table="manageMachine"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="games.name">Game List</th><th st-sort="zone.code">Zone</th><th st-sort="shop.code">Shop</th><th st-sort="isjackpot">is Jackpot?</th><th st-sort="calby">Calc By?</th><th st-sort="cm_rate">CM Rate</th><th st-sort="bm_rate">BM Rate</th><th st-sort="">CM to BM</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="games.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachine" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'empty\'}} <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td>{{item.game.name}}</td><td>{{item.zone.code}}</td><td>{{item.shop.code || \'Not Set\'}}</td><td>{{ item.isjackpot?\'Yes\':\'No\' || \'empty\'}}</td><td>{{ item.calby?\'CM\':\'BM\' || \'empty\'}}</td><td>{{ item.cmRate || \'empty\'}}</td><td>{{ item.bmRate || \'empty\'}}</td><td>{{(item.cmRate/item.bmRate)|currency: \'\'}}</td><td>{{ item.status?\'Active\':\'Inactive\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editMachine(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/operational/machine/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/operational/shop/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shop/modals/dangerOnlineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shop/modals/viewRemarks.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-star modal-icon"></i><span>Remarks</span></div><div class="modal-body text-center" ng-if="remarks"><div id="remarks"><span>{{remarks}}</span><br></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/machines.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div></div></div><h3 class="with-line">Machine Setup &nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Machine</button></h3><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Machine Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.machine" data-e-form="rowform" data-e-name="machine" e-name="machine" data-e-ng-model="machine" append-to-body="true">{{ showMachine(item.machine) }}<editable-ui-select-match placeholder="Machine Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="machine in manageMachineList | filter: $select.search track by $index">{{machine.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ item.supplier.code }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/onlineGames.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div></div></div><h3 class="with-line">Online Games Setup &nbsp; <button class="btn btn-primary editable-table-button btn-xs" ng-click="addOnlineShop()">Add</button></h3><div class="row"><div class="col-md-6"><table class="table" st-safe-src="manageOnlineShopList" st-table="manageOnlineShop"><thead><tr class="black-muted-bg"><th>Online Game</th><th>PlayTech ID</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineShop" class="editable-row"><td class="select-td"><span editable-select="item.game.id" e-name="games" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamesList">{{ showGames(item.game) }}</span></td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlineShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmOnlineShopDelete(item)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/partner.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code+\', \'+$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code+\', \'+partner.name"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Name & Contact</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-9 control-label">{{manageShop.partner.name+\' (\'+manageShop.partner.contact+\')\'}}</label></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">1. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">2. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">3. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">1. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">2. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">3. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.number"></div></div></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/shopInfo.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><ui-select ng-model="manageShop.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.address"></textarea></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.status"> <span>{{manageShop.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Area</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.area" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in manageAreaList | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Balai</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.site" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="site in manageSiteList | filter: $select.search"><span ng-bind-html="site.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Operational</label><div class="col-sm-9"><ui-select ng-model="manageShop.operational" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in operationalFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="float" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.remarks"></textarea></div></div></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/shopTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Status</label><ui-select ng-model="reportFilter.status" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in statusFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Operational</label><ui-select ng-model="reportFilter.operational" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in operationalFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageShop(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManageShop(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageShopList" st-table="manageShop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop ID</th><th st-sort="name">Shop Name</th><th st-sort="shoptype">Shop Type</th><th st-sort="partner.code">Partner</th><th st-sort="zone.code">Zone</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop ID" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="shoptype" placeholder="Search Shop Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="partner.code" placeholder="Search Partner" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShop" class="editable-row"><td class="table-id">{{$index+1}}</td><td ng-class="{\'bg-warning\':item.operational==\'Warning\',\'bg-success\':item.operational==\'Live\', \'bg-danger\':item.operational==\'Danger\'}" style="color:black;"><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}} <i ng-if="item.remarks" class="ion-star" ng-click="viewRemarks(item.remarks)"></i></span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.shoptype" e-name="shoptype" e-form="rowform" e-required="">{{ item.shoptype || \'empty\'}}</span></td><td class="select-td">{{item.partner.code+\', \'+item.partner.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editShop(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/partneraccount/partnerusers/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Users!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/partneraccount/partnerusers/widgets/usersTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageUsersList" st-table="manageUsers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="username">Username</th><th st-sort="credentials.name">Name</th><th st-sort="credentials.mobile">Mobile</th><th st-sort="emailVerified">Access?</th><th st-sort="credentials.role">Role</th><th st-sort="credentials.partnerid">Partner Code</th><th>Action</th></tr><tr><th></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.mobile" placeholder="Search Mobile" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.username}}</td><td><span editable-text="item.credentials.name" e-name="name" e-form="rowform" e-required="">{{ item.credentials.name || \'empty\'}}</span></td><td><span editable-text="item.credentials.mobile" e-name="mobile" e-form="rowform" e-required="">{{ item.credentials.mobile || \'empty\' }}</span></td><td><span editable-radiolist="item.emailVerified" e-ng-options="s.value for s in ::emailVerified track by s.value" e-name="emailVerified" e-form="rowform">{{ showAccess(item.emailVerified) }}</span></td><td class="select-td"><span editable-select="item.credentials.role" e-name="role" e-form="rowform" e-selectpicker="">{{ showRoles(item.credentials.role) }}</span></td><td class="select-td"><span editable-select="item.credentials.partner" e-name="partner" e-form="rowform" e-selectpicker="">{{ item.credentials.partner.code }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUser($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-warning editable-table-button btn-xs" ng-click="resetPassword(item.id)">Reset</button></div></td></tr></tbody><br><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/partners/partnerinvoice/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/partners/partnerinvoice/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-show="userData.roleId==9" class="col-sm-2"><label>Select Staff</label><ui-select ng-model="dateList.staff" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="staff in managePartnerList | filter: $select.search"><span ng-bind-html="staff.code"></span> <span ng-bind-html="staff.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getMachineSalesOfPartner()">Reset</button></div></div></div></div></div><div ng-if="isEdit"><table class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="indate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color:black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.netpurchase | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ocsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.totalsales | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><button type="button" class="btn btn-default save-profile" ng-click="dateList.from&&dateList.to?searchMachinesales(dateList):getMachineSalesOfPartner()" print-remove="">Close</button></div><table ng-hide="isEdit" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Partner</th><th st-sort="code">Shop Code</th><th st-sort="code">Shop Name</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[partnerid, shopid]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{showPartners(item[0].partnerid)}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td><span editable-text="item[0].name" e-name="name" e-form="rowform" e-required="">{{ item[0].name || \'empty\'}}</span></td><td class="bg-warning" style="color:black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalnetpurhase(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalocsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/collector/widgets/collectorTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2"><label>Select Zone</label><ui-select ng-model="dateList.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="dateList.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Grand Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList.result" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="sname">Shop Code</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sname" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.pname" e-name="pname" e-form="rowform" e-required="">{{ item.pname || \'empty\'}}</span></td><td><span editable-text="item.sname" e-name="sname" e-form="rowform" e-required="">{{ item.sname || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/reports/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel.toFixed(2) | currency:\'\'}}</label></div></div><div class="col-sm-6"><br><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="genIvoiceMachinesales()">Generate Machine Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="created">Upload Date</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.machine.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.machine.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/reports/dailymachineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailymachineshop/widgets/dailymachineView.html','<table class="table table-bordered"><thead><tr><th>Machine</th><th class="align-right">New Meter</th><th class="align-right">Previous Meter</th><th class="align-right">Difference</th><th class="align-right">Sales</th><th class="align-right">Shop</th><th class="align-right">Company</th></tr></thead><tbody><tr ng-repeat="item in machineSalesDetails"><td>{{item.mid}}</td><td class="align-right">{{item.cmIn}}<br>{{item.cmOut}}<br>{{item.bmIn}}<br>{{item.bmOut}}<br></td><td class="align-right">{{item.cmInP}}<br>{{item.cmOutP}}<br>{{item.bmInP}}<br>{{item.bmOutP}}<br></td><td class="align-right">{{item.cmIn - item.cmInP}}<br>{{item.cmOut - item.cmOutP}}<br>{{item.bmIn - item.bmInP}}<br>{{item.bmOut - item.bmOutP}}<br></td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}} ({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales | currency: \'\'}} ({{item.machineshop.macrate}}%)</td></tr></tbody></table>');
$templateCache.put('app/pages/reports/dailymachineshop/widgets/dailymachineshopLevel2.html','<div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{salesNumbers.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{machineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{salesNumbers.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Machine Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/reports/dailymachineshop/widgets/dailymachineView.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="viewDetailedMachinesales(group)">View</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button>');
$templateCache.put('app/pages/reports/dailymachineshop/widgets/dailymachineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel.toFixed(2) | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageDailymachineshopList" st-table="manageDailymachineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop Code</th><th st-sort="shop.name">Shop Name</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="group in manageDailymachineshop[0].result" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="group.code" e-name="code" e-form="rowform" e-required="">{{ group.code || \'empty\'}}</span></td><td><span editable-text="group.name" e-name="name" e-form="rowform" e-required="">{{ group.name || \'empty\' }}</span></td><td><span editable-text="group.csales" e-name="csales" e-form="rowform" e-required="">{{ group.csales | currency:\'\' }}</span></td><td><span editable-text="group.psales" e-name="psales" e-form="rowform" e-required="">{{ group.psales | currency:\'\'}}</span></td><td><span editable-text="group.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ group.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(group)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailyonlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailyonlinesales/widgets/dailyonlinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales :</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div><div class="col-md-6"><br><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="genIvoiceOnlinesales()">Generate Online Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid">Kiosk</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="ikey">Upload Date</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="pwin">PW</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="game.name" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.playtechid || \'empty\'}}</td><td>{{ item.shop.code || \'empty\'}}</td><td>{{ item.game.name || \'empty\' }}</td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/widgets/dailyonlineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales :</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlineshopList" st-table="manageOnlineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop</th><th st-sort="shop.name">Game</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineshop[0].result" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewOnlinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/widgets/viewOnlineshop.html','<table class="table table-bordered"><thead><tr><th>Games</th><th class="align-right">Net Purchase</th><th class="align-right">P/S (-)</th><th class="align-right">P/W (+)</th><th class="align-right">Sales</th><th class="align-right">Shop ({{100-onlineSalesDetails[0].shop.onrate}}%)</th><th class="align-right">Company ({{onlineSalesDetails[0].shop.onrate}}%)</th></tr></thead><tbody><tr ng-repeat="item in onlineSalesDetails"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase | currency: \'\'}}</td><td class="align-right">{{item.pshare | currency: \'\'}}</td><td class="align-right">{{item.pwin | currency: \'\'}}</td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}}</td><td class="align-right">{{item.csales | currency: \'\'}}</td></tr></tbody></table>');
$templateCache.put('app/pages/reports/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="created">Invoice Date</th><th st-sort="upload">Upload Date</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.machine.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.machine.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/marketing/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Marketing sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/marketing/widgets/marketingTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2"><label>Select Zone</label><ui-select ng-model="dateList.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="dateList.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Grand Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMarketingsalesList.result" st-table="manageMarketingsales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="sname">Shop Code</th><th st-sort="mactotal">Machine Total Sales</th><th st-sort="ontotal">Online Total Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sid" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMarketingsales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.pname" e-name="pname" e-form="rowform" e-required="">{{ item.pname || \'empty\'}}</span></td><td><span editable-text="item.sname" e-name="sname" e-form="rowform" e-required="">{{ item.sname || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewSales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/onlinesales/widgets/onlinesalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchOnlinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid">Kiosk</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="ikey">Upload Date</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="pwin">PW</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="game.name" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ item.game.name || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.created | date: \'dd/MM/yyyy\'}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/onlinesales/widgets/viewSale.html','<h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.game.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Kiosk</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageOnlinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy\'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Share</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pshare | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Wins</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pwin | currency:\'\'}}</label></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Purchase</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Gaming</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button>');
$templateCache.put('app/pages/reports/partnersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/partnersales/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Grand Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList.result" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="mactotal">Machine Total Sales</th><th st-sort="ontotal">Online Total Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/suppliersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/suppliersales/widgets/suppliersalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageSuppliersalesList.result" st-table="manageSuppliersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSuppliersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceMachinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop</th><th st-sort="showGameById(item.gameid)">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/supplier/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/supplier/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Commission:</strong></label> <label class="control-label"><strong>{{totalCommissionLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.supplier" class="col-sm-2"><label>Select Supplier</label><ui-select ng-model="reportFilter.supplier" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search"><span ng-bind-html="supplier.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="supcode">Supplier Code</th><th st-sort="supname">Supplier Name</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th st-sort="suprate">Rate%</th><th>Commission</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="supcode" placeholder="Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="supname" placeholder="Supplier Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="suprate" placeholder="Supplier Rates" class="input-sm form-control search-input" type="search"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcommission(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.supcode || \'empty\'}}</td><td>{{ item.supname || \'empty\'}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="shopid" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.suprate}}%</td><td>{{item.commission | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcommission(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/areas/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Area!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/areas/widgets/areasTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageAreasList" st-table="manageAreas"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="zone.code">Zone</th><th st-sort="state.name">State</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageAreas" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList">{{ showZones(item.zone) }}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveArea($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/gamecategory/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Game Category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/gamecategory/widgets/gamecategoryTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageGamecategoryList" st-table="manageGamecategory"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGamecategory" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGamecategory($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/games/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/games/widgets/gamesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageGamesList" st-table="manageGames"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="gamecategory.name">Game Category</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamecategory.name" placeholder="Search Game Category" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Game Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGames" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.gamecatid" e-name="gamecategory" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamecategoryList">{{ showGamecategory(item.gamecat) }}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGame($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/machine/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/machine/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/machine/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/system/machine/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/system/machine/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ showSupplierCode(item.supplier.id) }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/machine/widgets/machineTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageMachineList" st-table="manageMachine"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="games.name">Game List</th><th st-sort="zone.code">Zone</th><th st-sort="isjackpot">is Jackpot?</th><th st-sort="calby">Calc By?</th><th st-sort="cm_rate">CM Rate</th><th st-sort="bm_rate">BM Rate</th><th st-sort="">CM to BM</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="games.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachine" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span> <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td class="select-td">{{item.game.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.isjackpot" e-name="isjackpot" e-form="rowform" e-required="">{{ item.isjackpot?\'Yes\':\'No\' || \'empty\'}}</span></td><td><span editable-text="item.calby" e-name="calby" e-form="rowform" e-required="">{{ item.calby?\'CM\':\'BM\' || \'empty\'}}</span></td><td><span editable-text="item.cmRate" e-name="cm_rate" e-form="rowform" e-required="">{{ item.cmRate || \'empty\'}}</span></td><td><span editable-text="item.bmRate" e-name="bm_rate" e-form="rowform" e-required="">{{ item.bmRate || \'empty\'}}</span></td><td>{{(item.cmRate/item.bmRate)|currency: \'\'}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachine($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editMachine(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/machine/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/system/shop/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/modals/dangerOnlineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/widgets/machines.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div></div></div><h3 class="with-line">Machine Setup &nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Machine</button></h3><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Machine Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.machine" data-e-form="rowform" data-e-name="machine" e-name="machine" data-e-ng-model="machine" append-to-body="true">{{ showMachine(item.machine) }}<editable-ui-select-match placeholder="Machine Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="machine in manageMachineList | filter: $select.search track by $index">{{machine.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ showSupplierCode(item.supplier.id) }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/shop/widgets/onlineGames.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div></div></div><h3 class="with-line">Online Games Setup &nbsp; <button class="btn btn-primary editable-table-button btn-xs" ng-click="addOnlineShop()">Add</button></h3><div class="row"><div class="col-md-6"><table class="table" st-safe-src="manageOnlineShopList" st-table="manageOnlineShop"><thead><tr class="black-muted-bg"><th>Online Game</th><th>PlayTech ID</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineShop" class="editable-row"><td class="select-td"><span editable-select="item.game.id" e-name="games" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamesList">{{ showGames(item.game) }}</span></td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlineShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmOnlineShopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/shop/widgets/partner.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Name & Contact</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-9 control-label">{{manageShop.partner.name+\' (\'+manageShop.partner.contact+\')\'}}</label></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">1. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">2. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">3. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">1. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">2. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">3. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.number"></div></div></div></div>');
$templateCache.put('app/pages/system/shop/widgets/shopInfo.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><select class="form-control" ng-model="manageShop.shoptype" selectpicker=""><option selected="">100%</option><option>5/5</option></select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.address"></textarea></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.status"> <span>{{manageShop.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Area</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.area" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in manageAreaList | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Balai</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.site" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="site in manageSiteList | filter: $select.search"><span ng-bind-html="site.name"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="float" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.remarks"></textarea></div></div></div></div>');
$templateCache.put('app/pages/system/shop/widgets/shopTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageShopList" st-table="manageShop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop ID</th><th st-sort="name">Shop Name</th><th st-sort="shoptype">Shop Type</th><th st-sort="partner.name">Partner ID</th><th st-sort="zone.code">Zone</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop ID" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="shoptype" placeholder="Search Shop Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="partner.name" placeholder="Search Partner" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.shoptype" e-name="shoptype" e-form="rowform" e-required="">{{ item.shoptype || \'empty\'}}</span></td><td class="select-td">{{item.partner.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editShop(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/system/site/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Site!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/site/widgets/siteTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageSiteList" st-table="manageSites"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="area.name">Area</th><th st-sort="state.name">State</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Area" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSites" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.area.id" e-name="area" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreaList">{{ showArea(item.area) }}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveSite($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/states/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this State!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/states/widgets/statesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageStatesList" st-table="manageStates"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageStates" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveState($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/zones/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Zone!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/zones/widgets/zonesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageZonesList" st-table="manageZones"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Zone Code</th><th st-sort="name">Name</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Zone Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageZones" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveZones($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/totalsales/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/totalsales/collector/widgets/collectorTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="scode">Shop Code</th><th st-sort="sname">Shop Name</th><th st-sort="mactotal" class="text-center bg-warning" style="color:black">Machine</th><th st-sort="ontotal" class="text-center bg-info" style="color:black">Online</th><th st-sort="total" class="text-center bg-purple" style="color:black">Overall</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="scode" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="sname" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-if="managePartnersales.length>0" style="background-color:chocolate ;color:black">{{ getTotalmactotal(managePartnersales) | currency:\'\'}}</th><th ng-if="managePartnersales.length>0" style="background-color:chocolate ;color:black">{{ getTotalontotal(managePartnersales) | currency:\'\'}}</th><th ng-if="managePartnersales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotal(managePartnersales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code}}</td><td>{{ item.pname}}</td><td>{{ item.scode}}</td><td>{{ item.sname}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\' }}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.total | currency:\'\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if="managePartnersales.length>0" style="background-color:chocolate ;color:black">{{ getTotalmactotal(managePartnersales) | currency:\'\'}}</td><td ng-if="managePartnersales.length>0" style="background-color:chocolate ;color:black">{{ getTotalontotal(managePartnersales) | currency:\'\'}}</td><td ng-if="managePartnersales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotal(managePartnersales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/totalsales/marketing/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Marketing sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/totalsales/marketing/widgets/marketingTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Zone</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMarketingsalesList" st-table="manageMarketingsales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="scode">Shop Code</th><th st-sort="sname">Shop Name</th><th st-sort="mactotal" class="text-center bg-warning" style="color:black">Machine</th><th st-sort="ontotal" class="text-center bg-info" style="color:black">Online</th><th st-sort="total" class="text-center bg-purple" style="color:black">Overall</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="scode" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="sname" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-if="manageMarketingsales.length>0" style="background-color:chocolate ;color:black">{{ getTotalmactotal(manageMarketingsales) | currency:\'\'}}</th><th ng-if="manageMarketingsales.length>0" style="background-color:chocolate ;color:black">{{ getTotalontotal(manageMarketingsales) | currency:\'\'}}</th><th ng-if="manageMarketingsales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotal(manageMarketingsales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMarketingsales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code}}</td><td>{{ item.pname}}</td><td>{{ item.scode}}</td><td>{{ item.sname}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\' }}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.total | currency:\'\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewSales(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMarketingsales.length>0" style="background-color:chocolate ;color:black">{{ getTotalmactotal(manageMarketingsales) | currency:\'\'}}</td><td ng-if="manageMarketingsales.length>0" style="background-color:chocolate ;color:black">{{ getTotalontotal(manageMarketingsales) | currency:\'\'}}</td><td ng-if="manageMarketingsales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotal(manageMarketingsales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/usersetup/roles/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this State!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/usersetup/roles/widgets/rolesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageRolesList" st-table="manageRoles"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="created">Created</th><th st-sort="modified">Last Updated</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="modified" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in manageRoles" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.modified | date: \'dd/MM/yyyy hh:mm a\'}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/usersetup/users/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Users!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/usersetup/users/modals/passwordModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-locked modal-icon"></i><span>Password</span></div><div class="modal-body text-center"><div id="qrLabel"><span>{{newPassword}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/usersetup/users/widgets/usersTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageUsersList" st-table="manageUsers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="username">Username</th><th st-sort="credentials.name">Name</th><th st-sort="credentials.mobile">Mobile</th><th st-sort="emailVerified">Access?</th><th st-sort="credentials.role">Role</th><th st-sort="credentials.zonemap">Zone</th><th st-sort="credentials.shoptype">Shop Type</th><th st-sort="credentials.partnerid">Partner Code</th><th st-sort="credentials.days">Report Duration (in Days)</th><th>Action</th></tr><tr><th></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.mobile" placeholder="Search Mobile" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th><input st-search="credentials.days" placeholder="Search Duration" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.username}}</td><td><span editable-text="item.credentials.name" e-name="name" e-form="rowform" e-required="">{{ item.credentials.name || \'empty\'}}</span></td><td><span editable-text="item.credentials.mobile" e-name="mobile" e-form="rowform" e-required="">{{ item.credentials.mobile || \'empty\' }}</span></td><td><span editable-radiolist="item.emailVerified" e-ng-options="s.value as s.text for s in ::emailVerified track by s.value" e-name="emailVerified" e-form="rowform">{{ showAccess(item.emailVerified) }}</span></td><td class="select-td"><span editable-select="item.credentials.role" e-name="role" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageRoleList">{{ showRoles(item.credentials.role) }}</span></td><td class="select-td"><span editable-select="item.credentials.zonemap" e-name="zonemap" onshow="loadGroups()" e-form="rowform" e-multiple="" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList"><span ng-repeat="zoneitem in item.credentials.zonemap">{{ showZones(zoneitem) }},</span></span></td><td class="select-td"><span editable-select="item.credentials.shopType" e-name="shopType" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.value as g.value for g in shopTypeFilter">{{ item.credentials.shopType }}</span></td><td class="select-td"><span editable-ui-select="item.credentials.partner" data-e-form="rowform" data-e-name="partner" name="partner" data-e-ng-model="item.credentials.partner">{{ item.credentials.partner.code }}<editable-ui-select-match placeholder="Partner Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="partner in managePartnerList | filter: $select.search track by $index">{{partner.code}}, {{partner.name}}</editable-ui-select-choices></span></td><td><span editable-text="item.credentials.days" e-name="days" e-form="rowform" e-required="">{{ item.credentials.days || \'empty\' }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUser($data,item.id,item)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id,item.credentials.partner.id,item.credentials.collector.id,item.credentials.shop.id,item.credentials.supplier.id)">Delete</button> &nbsp;&nbsp; <button class="btn btn-warning editable-table-button btn-xs" ng-click="resetPassword(item.id)">Reset</button></div></td></tr></tbody><br><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);